var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};

// node_modules/ftdomdelegate/main.js
function Delegate(root) {
  this.listenerMap = [{}, {}];
  if (root) {
    this.root(root);
  }
  this.handle = Delegate.prototype.handle.bind(this);
  this._removedListeners = [];
}
Delegate.prototype.root = function(root) {
  const listenerMap = this.listenerMap;
  let eventType;
  if (this.rootElement) {
    for (eventType in listenerMap[1]) {
      if (listenerMap[1].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, true);
      }
    }
    for (eventType in listenerMap[0]) {
      if (listenerMap[0].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, false);
      }
    }
  }
  if (!root || !root.addEventListener) {
    if (this.rootElement) {
      delete this.rootElement;
    }
    return this;
  }
  this.rootElement = root;
  for (eventType in listenerMap[1]) {
    if (listenerMap[1].hasOwnProperty(eventType)) {
      this.rootElement.addEventListener(eventType, this.handle, true);
    }
  }
  for (eventType in listenerMap[0]) {
    if (listenerMap[0].hasOwnProperty(eventType)) {
      this.rootElement.addEventListener(eventType, this.handle, false);
    }
  }
  return this;
};
Delegate.prototype.captureForType = function(eventType) {
  return ["blur", "error", "focus", "load", "resize", "scroll"].indexOf(eventType) !== -1;
};
Delegate.prototype.on = function(eventType, selector, handler, useCapture) {
  let root;
  let listenerMap;
  let matcher;
  let matcherParam;
  if (!eventType) {
    throw new TypeError("Invalid event type: " + eventType);
  }
  if (typeof selector === "function") {
    useCapture = handler;
    handler = selector;
    selector = null;
  }
  if (useCapture === void 0) {
    useCapture = this.captureForType(eventType);
  }
  if (typeof handler !== "function") {
    throw new TypeError("Handler must be a type of Function");
  }
  root = this.rootElement;
  listenerMap = this.listenerMap[useCapture ? 1 : 0];
  if (!listenerMap[eventType]) {
    if (root) {
      root.addEventListener(eventType, this.handle, useCapture);
    }
    listenerMap[eventType] = [];
  }
  if (!selector) {
    matcherParam = null;
    matcher = matchesRoot.bind(this);
  } else if (/^[a-z]+$/i.test(selector)) {
    matcherParam = selector;
    matcher = matchesTag;
  } else if (/^#[a-z0-9\-_]+$/i.test(selector)) {
    matcherParam = selector.slice(1);
    matcher = matchesId;
  } else {
    matcherParam = selector;
    matcher = Element.prototype.matches;
  }
  listenerMap[eventType].push({
    selector,
    handler,
    matcher,
    matcherParam
  });
  return this;
};
Delegate.prototype.off = function(eventType, selector, handler, useCapture) {
  let i;
  let listener;
  let listenerMap;
  let listenerList;
  let singleEventType;
  if (typeof selector === "function") {
    useCapture = handler;
    handler = selector;
    selector = null;
  }
  if (useCapture === void 0) {
    this.off(eventType, selector, handler, true);
    this.off(eventType, selector, handler, false);
    return this;
  }
  listenerMap = this.listenerMap[useCapture ? 1 : 0];
  if (!eventType) {
    for (singleEventType in listenerMap) {
      if (listenerMap.hasOwnProperty(singleEventType)) {
        this.off(singleEventType, selector, handler);
      }
    }
    return this;
  }
  listenerList = listenerMap[eventType];
  if (!listenerList || !listenerList.length) {
    return this;
  }
  for (i = listenerList.length - 1; i >= 0; i--) {
    listener = listenerList[i];
    if ((!selector || selector === listener.selector) && (!handler || handler === listener.handler)) {
      this._removedListeners.push(listener);
      listenerList.splice(i, 1);
    }
  }
  if (!listenerList.length) {
    delete listenerMap[eventType];
    if (this.rootElement) {
      this.rootElement.removeEventListener(eventType, this.handle, useCapture);
    }
  }
  return this;
};
Delegate.prototype.handle = function(event) {
  let i;
  let l;
  const type = event.type;
  let root;
  let phase;
  let listener;
  let returned;
  let listenerList = [];
  let target;
  const eventIgnore = "ftLabsDelegateIgnore";
  if (event[eventIgnore] === true) {
    return;
  }
  target = event.target;
  if (target.nodeType === 3) {
    target = target.parentNode;
  }
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }
  root = this.rootElement;
  phase = event.eventPhase || (event.target !== event.currentTarget ? 3 : 2);
  switch (phase) {
    case 1:
      listenerList = this.listenerMap[1][type];
      break;
    case 2:
      if (this.listenerMap[0] && this.listenerMap[0][type]) {
        listenerList = listenerList.concat(this.listenerMap[0][type]);
      }
      if (this.listenerMap[1] && this.listenerMap[1][type]) {
        listenerList = listenerList.concat(this.listenerMap[1][type]);
      }
      break;
    case 3:
      listenerList = this.listenerMap[0][type];
      break;
  }
  let toFire = [];
  l = listenerList.length;
  while (target && l) {
    for (i = 0; i < l; i++) {
      listener = listenerList[i];
      if (!listener) {
        break;
      }
      if (target.tagName && ["button", "input", "select", "textarea"].indexOf(target.tagName.toLowerCase()) > -1 && target.hasAttribute("disabled")) {
        toFire = [];
      } else if (listener.matcher.call(target, listener.matcherParam, target)) {
        toFire.push([event, target, listener]);
      }
    }
    if (target === root) {
      break;
    }
    l = listenerList.length;
    target = target.parentElement || target.parentNode;
    if (target instanceof HTMLDocument) {
      break;
    }
  }
  let ret;
  for (i = 0; i < toFire.length; i++) {
    if (this._removedListeners.indexOf(toFire[i][2]) > -1) {
      continue;
    }
    returned = this.fire.apply(this, toFire[i]);
    if (returned === false) {
      toFire[i][0][eventIgnore] = true;
      toFire[i][0].preventDefault();
      ret = false;
      break;
    }
  }
  return ret;
};
Delegate.prototype.fire = function(event, target, listener) {
  return listener.handler.call(target, event, target);
};
function matchesTag(tagName, element) {
  return tagName.toLowerCase() === element.tagName.toLowerCase();
}
function matchesRoot(selector, element) {
  if (this.rootElement === window) {
    return (
      // Match the outer document (dispatched from document)
      element === document || // The <html> element (dispatched from document.body or document.documentElement)
      element === document.documentElement || // Or the window itself (dispatched from window)
      element === window
    );
  }
  return this.rootElement === element;
}
function matchesId(id, element) {
  return id === element.id;
}
Delegate.prototype.destroy = function() {
  this.off();
  this.root();
};
var main_default = Delegate;

// js/components/input-binding-manager.js
var InputBindingManager = class {
  constructor() {
    this.delegateElement = new main_default(document.body);
    this.delegateElement.on("change", "[data-bind-value]", this._onValueChanged.bind(this));
  }
  _onValueChanged(event, target) {
    const boundElement = document.getElementById(target.getAttribute("data-bind-value"));
    if (boundElement) {
      if (target.tagName === "SELECT") {
        target = target.options[target.selectedIndex];
      }
      boundElement.innerHTML = target.hasAttribute("title") ? target.getAttribute("title") : target.value;
    }
  }
};

// js/helper/event.js
function triggerEvent(element, name, data = {}) {
  element.dispatchEvent(new CustomEvent(name, {
    bubbles: true,
    detail: data
  }));
}
function triggerNonBubblingEvent(element, name, data = {}) {
  element.dispatchEvent(new CustomEvent(name, {
    bubbles: false,
    detail: data
  }));
}

// js/custom-element/custom-html-element.js
var CustomHTMLElement = class extends HTMLElement {
  constructor() {
    super();
    this._hasSectionReloaded = false;
    if (Shopify.designMode) {
      this.rootDelegate.on("shopify:section:select", (event) => {
        const parentSection = this.closest(".shopify-section");
        if (event.target === parentSection && event.detail.load) {
          this._hasSectionReloaded = true;
        }
      });
    }
  }
  get rootDelegate() {
    return this._rootDelegate = this._rootDelegate || new main_default(document.documentElement);
  }
  get delegate() {
    return this._delegate = this._delegate || new main_default(this);
  }
  showLoadingBar() {
    triggerEvent(document.documentElement, "theme:loading:start");
  }
  hideLoadingBar() {
    triggerEvent(document.documentElement, "theme:loading:end");
  }
  untilVisible(intersectionObserverOptions = { rootMargin: "30px 0px", threshold: 0 }) {
    const onBecameVisible = () => {
      this.classList.add("became-visible");
      this.style.opacity = "1";
    };
    return new Promise((resolve) => {
      if (window.IntersectionObserver) {
        this.intersectionObserver = new IntersectionObserver((event) => {
          if (event[0].isIntersecting) {
            this.intersectionObserver.disconnect();
            requestAnimationFrame(() => {
              resolve();
              onBecameVisible();
            });
          }
        }, intersectionObserverOptions);
        this.intersectionObserver.observe(this);
      } else {
        resolve();
        onBecameVisible();
      }
    });
  }
  disconnectedCallback() {
    this.delegate.destroy();
    this.rootDelegate.destroy();
    this.intersectionObserver?.disconnect();
    delete this._delegate;
    delete this._rootDelegate;
  }
};

// node_modules/tabbable/dist/index.esm.js
var candidateSelectors = ["input:not([inert])", "select:not([inert])", "textarea:not([inert])", "a[href]:not([inert])", "button:not([inert])", "[tabindex]:not(slot):not([inert])", "audio[controls]:not([inert])", "video[controls]:not([inert])", '[contenteditable]:not([contenteditable="false"]):not([inert])', "details>summary:first-of-type:not([inert])", "details:not([inert])"];
var candidateSelector = /* @__PURE__ */ candidateSelectors.join(",");
var NoElement = typeof Element === "undefined";
var matches = NoElement ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var getRootNode = !NoElement && Element.prototype.getRootNode ? function(element) {
  var _element$getRootNode;
  return element === null || element === void 0 ? void 0 : (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0 ? void 0 : _element$getRootNode.call(element);
} : function(element) {
  return element === null || element === void 0 ? void 0 : element.ownerDocument;
};
var isInert = function isInert2(node, lookUp) {
  var _node$getAttribute;
  if (lookUp === void 0) {
    lookUp = true;
  }
  var inertAtt = node === null || node === void 0 ? void 0 : (_node$getAttribute = node.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node, "inert");
  var inert = inertAtt === "" || inertAtt === "true";
  var result = inert || lookUp && node && isInert2(node.parentNode);
  return result;
};
var isContentEditable = function isContentEditable2(node) {
  var _node$getAttribute2;
  var attValue = node === null || node === void 0 ? void 0 : (_node$getAttribute2 = node.getAttribute) === null || _node$getAttribute2 === void 0 ? void 0 : _node$getAttribute2.call(node, "contenteditable");
  return attValue === "" || attValue === "true";
};
var getCandidates = function getCandidates2(el, includeContainer, filter) {
  if (isInert(el)) {
    return [];
  }
  var candidates = Array.prototype.slice.apply(el.querySelectorAll(candidateSelector));
  if (includeContainer && matches.call(el, candidateSelector)) {
    candidates.unshift(el);
  }
  candidates = candidates.filter(filter);
  return candidates;
};
var getCandidatesIteratively = function getCandidatesIteratively2(elements, includeContainer, options) {
  var candidates = [];
  var elementsToCheck = Array.from(elements);
  while (elementsToCheck.length) {
    var element = elementsToCheck.shift();
    if (isInert(element, false)) {
      continue;
    }
    if (element.tagName === "SLOT") {
      var assigned = element.assignedElements();
      var content = assigned.length ? assigned : element.children;
      var nestedCandidates = getCandidatesIteratively2(content, true, options);
      if (options.flatten) {
        candidates.push.apply(candidates, nestedCandidates);
      } else {
        candidates.push({
          scopeParent: element,
          candidates: nestedCandidates
        });
      }
    } else {
      var validCandidate = matches.call(element, candidateSelector);
      if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) {
        candidates.push(element);
      }
      var shadowRoot = element.shadowRoot || // check for an undisclosed shadow
      typeof options.getShadowRoot === "function" && options.getShadowRoot(element);
      var validShadowRoot = !isInert(shadowRoot, false) && (!options.shadowRootFilter || options.shadowRootFilter(element));
      if (shadowRoot && validShadowRoot) {
        var _nestedCandidates = getCandidatesIteratively2(shadowRoot === true ? element.children : shadowRoot.children, true, options);
        if (options.flatten) {
          candidates.push.apply(candidates, _nestedCandidates);
        } else {
          candidates.push({
            scopeParent: element,
            candidates: _nestedCandidates
          });
        }
      } else {
        elementsToCheck.unshift.apply(elementsToCheck, element.children);
      }
    }
  }
  return candidates;
};
var hasTabIndex = function hasTabIndex2(node) {
  return !isNaN(parseInt(node.getAttribute("tabindex"), 10));
};
var getTabIndex = function getTabIndex2(node) {
  if (!node) {
    throw new Error("No node provided");
  }
  if (node.tabIndex < 0) {
    if ((/^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || isContentEditable(node)) && !hasTabIndex(node)) {
      return 0;
    }
  }
  return node.tabIndex;
};
var getSortOrderTabIndex = function getSortOrderTabIndex2(node, isScope) {
  var tabIndex = getTabIndex(node);
  if (tabIndex < 0 && isScope && !hasTabIndex(node)) {
    return 0;
  }
  return tabIndex;
};
var sortOrderedTabbables = function sortOrderedTabbables2(a, b) {
  return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var isInput = function isInput2(node) {
  return node.tagName === "INPUT";
};
var isHiddenInput = function isHiddenInput2(node) {
  return isInput(node) && node.type === "hidden";
};
var isDetailsWithSummary = function isDetailsWithSummary2(node) {
  var r = node.tagName === "DETAILS" && Array.prototype.slice.apply(node.children).some(function(child) {
    return child.tagName === "SUMMARY";
  });
  return r;
};
var getCheckedRadio = function getCheckedRadio2(nodes, form) {
  for (var i = 0; i < nodes.length; i++) {
    if (nodes[i].checked && nodes[i].form === form) {
      return nodes[i];
    }
  }
};
var isTabbableRadio = function isTabbableRadio2(node) {
  if (!node.name) {
    return true;
  }
  var radioScope = node.form || getRootNode(node);
  var queryRadios = function queryRadios2(name) {
    return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
  };
  var radioSet;
  if (typeof window !== "undefined" && typeof window.CSS !== "undefined" && typeof window.CSS.escape === "function") {
    radioSet = queryRadios(window.CSS.escape(node.name));
  } else {
    try {
      radioSet = queryRadios(node.name);
    } catch (err) {
      console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", err.message);
      return false;
    }
  }
  var checked = getCheckedRadio(radioSet, node.form);
  return !checked || checked === node;
};
var isRadio = function isRadio2(node) {
  return isInput(node) && node.type === "radio";
};
var isNonTabbableRadio = function isNonTabbableRadio2(node) {
  return isRadio(node) && !isTabbableRadio(node);
};
var isNodeAttached = function isNodeAttached2(node) {
  var _nodeRoot;
  var nodeRoot = node && getRootNode(node);
  var nodeRootHost = (_nodeRoot = nodeRoot) === null || _nodeRoot === void 0 ? void 0 : _nodeRoot.host;
  var attached = false;
  if (nodeRoot && nodeRoot !== node) {
    var _nodeRootHost, _nodeRootHost$ownerDo, _node$ownerDocument;
    attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && (_nodeRootHost$ownerDo = _nodeRootHost.ownerDocument) !== null && _nodeRootHost$ownerDo !== void 0 && _nodeRootHost$ownerDo.contains(nodeRootHost) || node !== null && node !== void 0 && (_node$ownerDocument = node.ownerDocument) !== null && _node$ownerDocument !== void 0 && _node$ownerDocument.contains(node));
    while (!attached && nodeRootHost) {
      var _nodeRoot2, _nodeRootHost2, _nodeRootHost2$ownerD;
      nodeRoot = getRootNode(nodeRootHost);
      nodeRootHost = (_nodeRoot2 = nodeRoot) === null || _nodeRoot2 === void 0 ? void 0 : _nodeRoot2.host;
      attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && (_nodeRootHost2$ownerD = _nodeRootHost2.ownerDocument) !== null && _nodeRootHost2$ownerD !== void 0 && _nodeRootHost2$ownerD.contains(nodeRootHost));
    }
  }
  return attached;
};
var isZeroArea = function isZeroArea2(node) {
  var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
  return width === 0 && height === 0;
};
var isHidden = function isHidden2(node, _ref) {
  var displayCheck = _ref.displayCheck, getShadowRoot = _ref.getShadowRoot;
  if (getComputedStyle(node).visibility === "hidden") {
    return true;
  }
  var isDirectSummary = matches.call(node, "details>summary:first-of-type");
  var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
  if (matches.call(nodeUnderDetails, "details:not([open]) *")) {
    return true;
  }
  if (!displayCheck || displayCheck === "full" || displayCheck === "legacy-full") {
    if (typeof getShadowRoot === "function") {
      var originalNode = node;
      while (node) {
        var parentElement = node.parentElement;
        var rootNode = getRootNode(node);
        if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true) {
          return isZeroArea(node);
        } else if (node.assignedSlot) {
          node = node.assignedSlot;
        } else if (!parentElement && rootNode !== node.ownerDocument) {
          node = rootNode.host;
        } else {
          node = parentElement;
        }
      }
      node = originalNode;
    }
    if (isNodeAttached(node)) {
      return !node.getClientRects().length;
    }
    if (displayCheck !== "legacy-full") {
      return true;
    }
  } else if (displayCheck === "non-zero-area") {
    return isZeroArea(node);
  }
  return false;
};
var isDisabledFromFieldset = function isDisabledFromFieldset2(node) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
    var parentNode = node.parentElement;
    while (parentNode) {
      if (parentNode.tagName === "FIELDSET" && parentNode.disabled) {
        for (var i = 0; i < parentNode.children.length; i++) {
          var child = parentNode.children.item(i);
          if (child.tagName === "LEGEND") {
            return matches.call(parentNode, "fieldset[disabled] *") ? true : !child.contains(node);
          }
        }
        return true;
      }
      parentNode = parentNode.parentElement;
    }
  }
  return false;
};
var isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable2(options, node) {
  if (node.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  isInert(node) || isHiddenInput(node) || isHidden(node, options) || // For a details element with a summary, the summary element gets the focus
  isDetailsWithSummary(node) || isDisabledFromFieldset(node)) {
    return false;
  }
  return true;
};
var isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable2(options, node) {
  if (isNonTabbableRadio(node) || getTabIndex(node) < 0 || !isNodeMatchingSelectorFocusable(options, node)) {
    return false;
  }
  return true;
};
var isValidShadowRootTabbable = function isValidShadowRootTabbable2(shadowHostNode) {
  var tabIndex = parseInt(shadowHostNode.getAttribute("tabindex"), 10);
  if (isNaN(tabIndex) || tabIndex >= 0) {
    return true;
  }
  return false;
};
var sortByOrder = function sortByOrder2(candidates) {
  var regularTabbables = [];
  var orderedTabbables = [];
  candidates.forEach(function(item, i) {
    var isScope = !!item.scopeParent;
    var element = isScope ? item.scopeParent : item;
    var candidateTabindex = getSortOrderTabIndex(element, isScope);
    var elements = isScope ? sortByOrder2(item.candidates) : element;
    if (candidateTabindex === 0) {
      isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
    } else {
      orderedTabbables.push({
        documentOrder: i,
        tabIndex: candidateTabindex,
        item,
        isScope,
        content: elements
      });
    }
  });
  return orderedTabbables.sort(sortOrderedTabbables).reduce(function(acc, sortable) {
    sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
    return acc;
  }, []).concat(regularTabbables);
};
var tabbable = function tabbable2(container, options) {
  options = options || {};
  var candidates;
  if (options.getShadowRoot) {
    candidates = getCandidatesIteratively([container], options.includeContainer, {
      filter: isNodeMatchingSelectorTabbable.bind(null, options),
      flatten: false,
      getShadowRoot: options.getShadowRoot,
      shadowRootFilter: isValidShadowRootTabbable
    });
  } else {
    candidates = getCandidates(container, options.includeContainer, isNodeMatchingSelectorTabbable.bind(null, options));
  }
  return sortByOrder(candidates);
};
var focusable = function focusable2(container, options) {
  options = options || {};
  var candidates;
  if (options.getShadowRoot) {
    candidates = getCandidatesIteratively([container], options.includeContainer, {
      filter: isNodeMatchingSelectorFocusable.bind(null, options),
      flatten: true,
      getShadowRoot: options.getShadowRoot
    });
  } else {
    candidates = getCandidates(container, options.includeContainer, isNodeMatchingSelectorFocusable.bind(null, options));
  }
  return candidates;
};
var isTabbable = function isTabbable2(node, options) {
  options = options || {};
  if (!node) {
    throw new Error("No node provided");
  }
  if (matches.call(node, candidateSelector) === false) {
    return false;
  }
  return isNodeMatchingSelectorTabbable(options, node);
};
var focusableCandidateSelector = /* @__PURE__ */ candidateSelectors.concat("iframe").join(",");
var isFocusable = function isFocusable2(node, options) {
  options = options || {};
  if (!node) {
    throw new Error("No node provided");
  }
  if (matches.call(node, focusableCandidateSelector) === false) {
    return false;
  }
  return isNodeMatchingSelectorFocusable(options, node);
};

// node_modules/focus-trap/dist/focus-trap.esm.js
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
var activeFocusTraps = {
  activateTrap: function activateTrap(trapStack, trap) {
    if (trapStack.length > 0) {
      var activeTrap = trapStack[trapStack.length - 1];
      if (activeTrap !== trap) {
        activeTrap.pause();
      }
    }
    var trapIndex = trapStack.indexOf(trap);
    if (trapIndex === -1) {
      trapStack.push(trap);
    } else {
      trapStack.splice(trapIndex, 1);
      trapStack.push(trap);
    }
  },
  deactivateTrap: function deactivateTrap(trapStack, trap) {
    var trapIndex = trapStack.indexOf(trap);
    if (trapIndex !== -1) {
      trapStack.splice(trapIndex, 1);
    }
    if (trapStack.length > 0) {
      trapStack[trapStack.length - 1].unpause();
    }
  }
};
var isSelectableInput = function isSelectableInput2(node) {
  return node.tagName && node.tagName.toLowerCase() === "input" && typeof node.select === "function";
};
var isEscapeEvent = function isEscapeEvent2(e) {
  return (e === null || e === void 0 ? void 0 : e.key) === "Escape" || (e === null || e === void 0 ? void 0 : e.key) === "Esc" || (e === null || e === void 0 ? void 0 : e.keyCode) === 27;
};
var isTabEvent = function isTabEvent2(e) {
  return (e === null || e === void 0 ? void 0 : e.key) === "Tab" || (e === null || e === void 0 ? void 0 : e.keyCode) === 9;
};
var isKeyForward = function isKeyForward2(e) {
  return isTabEvent(e) && !e.shiftKey;
};
var isKeyBackward = function isKeyBackward2(e) {
  return isTabEvent(e) && e.shiftKey;
};
var delay = function delay2(fn) {
  return setTimeout(fn, 0);
};
var findIndex = function findIndex2(arr, fn) {
  var idx = -1;
  arr.every(function(value, i) {
    if (fn(value)) {
      idx = i;
      return false;
    }
    return true;
  });
  return idx;
};
var valueOrHandler = function valueOrHandler2(value) {
  for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    params[_key - 1] = arguments[_key];
  }
  return typeof value === "function" ? value.apply(void 0, params) : value;
};
var getActualTarget = function getActualTarget2(event) {
  return event.target.shadowRoot && typeof event.composedPath === "function" ? event.composedPath()[0] : event.target;
};
var internalTrapStack = [];
var createFocusTrap = function createFocusTrap2(elements, userOptions) {
  var doc = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.document) || document;
  var trapStack = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.trapStack) || internalTrapStack;
  var config = _objectSpread2({
    returnFocusOnDeactivate: true,
    escapeDeactivates: true,
    delayInitialFocus: true,
    isKeyForward,
    isKeyBackward
  }, userOptions);
  var state = {
    // containers given to createFocusTrap()
    // @type {Array<HTMLElement>}
    containers: [],
    // list of objects identifying tabbable nodes in `containers` in the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    // @type {Array<{
    //   container: HTMLElement,
    //   tabbableNodes: Array<HTMLElement>, // empty if none
    //   focusableNodes: Array<HTMLElement>, // empty if none
    //   posTabIndexesFound: boolean,
    //   firstTabbableNode: HTMLElement|undefined,
    //   lastTabbableNode: HTMLElement|undefined,
    //   firstDomTabbableNode: HTMLElement|undefined,
    //   lastDomTabbableNode: HTMLElement|undefined,
    //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
    // }>}
    containerGroups: [],
    // same order/length as `containers` list
    // references to objects in `containerGroups`, but only those that actually have
    //  tabbable nodes in them
    // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
    //  the same length
    tabbableGroups: [],
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: false,
    paused: false,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: void 0,
    // the most recent KeyboardEvent for the configured nav key (typically [SHIFT+]TAB), if any
    recentNavEvent: void 0
  };
  var trap;
  var getOption = function getOption2(configOverrideOptions, optionName, configOptionName) {
    return configOverrideOptions && configOverrideOptions[optionName] !== void 0 ? configOverrideOptions[optionName] : config[configOptionName || optionName];
  };
  var findContainerIndex = function findContainerIndex2(element, event) {
    var composedPath = typeof (event === null || event === void 0 ? void 0 : event.composedPath) === "function" ? event.composedPath() : void 0;
    return state.containerGroups.findIndex(function(_ref) {
      var container = _ref.container, tabbableNodes = _ref.tabbableNodes;
      return container.contains(element) || // fall back to explicit tabbable search which will take into consideration any
      //  web components if the `tabbableOptions.getShadowRoot` option was used for
      //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
      //  look inside web components even if open)
      (composedPath === null || composedPath === void 0 ? void 0 : composedPath.includes(container)) || tabbableNodes.find(function(node) {
        return node === element;
      });
    });
  };
  var getNodeForOption = function getNodeForOption2(optionName) {
    var optionValue = config[optionName];
    if (typeof optionValue === "function") {
      for (var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        params[_key2 - 1] = arguments[_key2];
      }
      optionValue = optionValue.apply(void 0, params);
    }
    if (optionValue === true) {
      optionValue = void 0;
    }
    if (!optionValue) {
      if (optionValue === void 0 || optionValue === false) {
        return optionValue;
      }
      throw new Error("`".concat(optionName, "` was specified but was not a node, or did not return a node"));
    }
    var node = optionValue;
    if (typeof optionValue === "string") {
      node = doc.querySelector(optionValue);
      if (!node) {
        throw new Error("`".concat(optionName, "` as selector refers to no known node"));
      }
    }
    return node;
  };
  var getInitialFocusNode = function getInitialFocusNode2() {
    var node = getNodeForOption("initialFocus");
    if (node === false) {
      return false;
    }
    if (node === void 0 || !isFocusable(node, config.tabbableOptions)) {
      if (findContainerIndex(doc.activeElement) >= 0) {
        node = doc.activeElement;
      } else {
        var firstTabbableGroup = state.tabbableGroups[0];
        var firstTabbableNode = firstTabbableGroup && firstTabbableGroup.firstTabbableNode;
        node = firstTabbableNode || getNodeForOption("fallbackFocus");
      }
    }
    if (!node) {
      throw new Error("Your focus-trap needs to have at least one focusable element");
    }
    return node;
  };
  var updateTabbableNodes = function updateTabbableNodes2() {
    state.containerGroups = state.containers.map(function(container) {
      var tabbableNodes = tabbable(container, config.tabbableOptions);
      var focusableNodes = focusable(container, config.tabbableOptions);
      var firstTabbableNode = tabbableNodes.length > 0 ? tabbableNodes[0] : void 0;
      var lastTabbableNode = tabbableNodes.length > 0 ? tabbableNodes[tabbableNodes.length - 1] : void 0;
      var firstDomTabbableNode = focusableNodes.find(function(node) {
        return isTabbable(node);
      });
      var lastDomTabbableNode = focusableNodes.slice().reverse().find(function(node) {
        return isTabbable(node);
      });
      var posTabIndexesFound = !!tabbableNodes.find(function(node) {
        return getTabIndex(node) > 0;
      });
      return {
        container,
        tabbableNodes,
        focusableNodes,
        /** True if at least one node with positive `tabindex` was found in this container. */
        posTabIndexesFound,
        /** First tabbable node in container, __tabindex__ order; `undefined` if none. */
        firstTabbableNode,
        /** Last tabbable node in container, __tabindex__ order; `undefined` if none. */
        lastTabbableNode,
        // NOTE: DOM order is NOT NECESSARILY "document position" order, but figuring that out
        //  would require more than just https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
        //  because that API doesn't work with Shadow DOM as well as it should (@see
        //  https://github.com/whatwg/dom/issues/320) and since this first/last is only needed, so far,
        //  to address an edge case related to positive tabindex support, this seems like a much easier,
        //  "close enough most of the time" alternative for positive tabindexes which should generally
        //  be avoided anyway...
        /** First tabbable node in container, __DOM__ order; `undefined` if none. */
        firstDomTabbableNode,
        /** Last tabbable node in container, __DOM__ order; `undefined` if none. */
        lastDomTabbableNode,
        /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */
        nextTabbableNode: function nextTabbableNode(node) {
          var forward = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
          var nodeIdx = tabbableNodes.indexOf(node);
          if (nodeIdx < 0) {
            if (forward) {
              return focusableNodes.slice(focusableNodes.indexOf(node) + 1).find(function(el) {
                return isTabbable(el);
              });
            }
            return focusableNodes.slice(0, focusableNodes.indexOf(node)).reverse().find(function(el) {
              return isTabbable(el);
            });
          }
          return tabbableNodes[nodeIdx + (forward ? 1 : -1)];
        }
      };
    });
    state.tabbableGroups = state.containerGroups.filter(function(group) {
      return group.tabbableNodes.length > 0;
    });
    if (state.tabbableGroups.length <= 0 && !getNodeForOption("fallbackFocus")) {
      throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
    }
    if (state.containerGroups.find(function(g) {
      return g.posTabIndexesFound;
    }) && state.containerGroups.length > 1) {
      throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
    }
  };
  var getActiveElement = function getActiveElement2(el) {
    var activeElement = el.activeElement;
    if (!activeElement) {
      return;
    }
    if (activeElement.shadowRoot && activeElement.shadowRoot.activeElement !== null) {
      return getActiveElement2(activeElement.shadowRoot);
    }
    return activeElement;
  };
  var tryFocus = function tryFocus2(node) {
    if (node === false) {
      return;
    }
    if (node === getActiveElement(document)) {
      return;
    }
    if (!node || !node.focus) {
      tryFocus2(getInitialFocusNode());
      return;
    }
    node.focus({
      preventScroll: !!config.preventScroll
    });
    state.mostRecentlyFocusedNode = node;
    if (isSelectableInput(node)) {
      node.select();
    }
  };
  var getReturnFocusNode = function getReturnFocusNode2(previousActiveElement) {
    var node = getNodeForOption("setReturnFocus", previousActiveElement);
    return node ? node : node === false ? false : previousActiveElement;
  };
  var findNextNavNode = function findNextNavNode2(_ref2) {
    var target = _ref2.target, event = _ref2.event, _ref2$isBackward = _ref2.isBackward, isBackward = _ref2$isBackward === void 0 ? false : _ref2$isBackward;
    target = target || getActualTarget(event);
    updateTabbableNodes();
    var destinationNode = null;
    if (state.tabbableGroups.length > 0) {
      var containerIndex = findContainerIndex(target, event);
      var containerGroup = containerIndex >= 0 ? state.containerGroups[containerIndex] : void 0;
      if (containerIndex < 0) {
        if (isBackward) {
          destinationNode = state.tabbableGroups[state.tabbableGroups.length - 1].lastTabbableNode;
        } else {
          destinationNode = state.tabbableGroups[0].firstTabbableNode;
        }
      } else if (isBackward) {
        var startOfGroupIndex = findIndex(state.tabbableGroups, function(_ref3) {
          var firstTabbableNode = _ref3.firstTabbableNode;
          return target === firstTabbableNode;
        });
        if (startOfGroupIndex < 0 && (containerGroup.container === target || isFocusable(target, config.tabbableOptions) && !isTabbable(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target, false))) {
          startOfGroupIndex = containerIndex;
        }
        if (startOfGroupIndex >= 0) {
          var destinationGroupIndex = startOfGroupIndex === 0 ? state.tabbableGroups.length - 1 : startOfGroupIndex - 1;
          var destinationGroup = state.tabbableGroups[destinationGroupIndex];
          destinationNode = getTabIndex(target) >= 0 ? destinationGroup.lastTabbableNode : destinationGroup.lastDomTabbableNode;
        } else if (!isTabEvent(event)) {
          destinationNode = containerGroup.nextTabbableNode(target, false);
        }
      } else {
        var lastOfGroupIndex = findIndex(state.tabbableGroups, function(_ref4) {
          var lastTabbableNode = _ref4.lastTabbableNode;
          return target === lastTabbableNode;
        });
        if (lastOfGroupIndex < 0 && (containerGroup.container === target || isFocusable(target, config.tabbableOptions) && !isTabbable(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target))) {
          lastOfGroupIndex = containerIndex;
        }
        if (lastOfGroupIndex >= 0) {
          var _destinationGroupIndex = lastOfGroupIndex === state.tabbableGroups.length - 1 ? 0 : lastOfGroupIndex + 1;
          var _destinationGroup = state.tabbableGroups[_destinationGroupIndex];
          destinationNode = getTabIndex(target) >= 0 ? _destinationGroup.firstTabbableNode : _destinationGroup.firstDomTabbableNode;
        } else if (!isTabEvent(event)) {
          destinationNode = containerGroup.nextTabbableNode(target);
        }
      }
    } else {
      destinationNode = getNodeForOption("fallbackFocus");
    }
    return destinationNode;
  };
  var checkPointerDown = function checkPointerDown2(e) {
    var target = getActualTarget(e);
    if (findContainerIndex(target, e) >= 0) {
      return;
    }
    if (valueOrHandler(config.clickOutsideDeactivates, e)) {
      trap.deactivate({
        // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
        //  which will result in the outside click setting focus to the node
        //  that was clicked (and if not focusable, to "nothing"); by setting
        //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
        //  on activation (or the configured `setReturnFocus` node), whether the
        //  outside click was on a focusable node or not
        returnFocus: config.returnFocusOnDeactivate
      });
      return;
    }
    if (valueOrHandler(config.allowOutsideClick, e)) {
      return;
    }
    e.preventDefault();
  };
  var checkFocusIn = function checkFocusIn2(event) {
    var target = getActualTarget(event);
    var targetContained = findContainerIndex(target, event) >= 0;
    if (targetContained || target instanceof Document) {
      if (targetContained) {
        state.mostRecentlyFocusedNode = target;
      }
    } else {
      event.stopImmediatePropagation();
      var nextNode;
      var navAcrossContainers = true;
      if (state.mostRecentlyFocusedNode) {
        if (getTabIndex(state.mostRecentlyFocusedNode) > 0) {
          var mruContainerIdx = findContainerIndex(state.mostRecentlyFocusedNode);
          var tabbableNodes = state.containerGroups[mruContainerIdx].tabbableNodes;
          if (tabbableNodes.length > 0) {
            var mruTabIdx = tabbableNodes.findIndex(function(node) {
              return node === state.mostRecentlyFocusedNode;
            });
            if (mruTabIdx >= 0) {
              if (config.isKeyForward(state.recentNavEvent)) {
                if (mruTabIdx + 1 < tabbableNodes.length) {
                  nextNode = tabbableNodes[mruTabIdx + 1];
                  navAcrossContainers = false;
                }
              } else {
                if (mruTabIdx - 1 >= 0) {
                  nextNode = tabbableNodes[mruTabIdx - 1];
                  navAcrossContainers = false;
                }
              }
            }
          }
        } else {
          if (!state.containerGroups.some(function(g) {
            return g.tabbableNodes.some(function(n) {
              return getTabIndex(n) > 0;
            });
          })) {
            navAcrossContainers = false;
          }
        }
      } else {
        navAcrossContainers = false;
      }
      if (navAcrossContainers) {
        nextNode = findNextNavNode({
          // move FROM the MRU node, not event-related node (which will be the node that is
          //  outside the trap causing the focus escape we're trying to fix)
          target: state.mostRecentlyFocusedNode,
          isBackward: config.isKeyBackward(state.recentNavEvent)
        });
      }
      if (nextNode) {
        tryFocus(nextNode);
      } else {
        tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
      }
    }
    state.recentNavEvent = void 0;
  };
  var checkKeyNav = function checkKeyNav2(event) {
    var isBackward = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    state.recentNavEvent = event;
    var destinationNode = findNextNavNode({
      event,
      isBackward
    });
    if (destinationNode) {
      if (isTabEvent(event)) {
        event.preventDefault();
      }
      tryFocus(destinationNode);
    }
  };
  var checkKey = function checkKey2(event) {
    if (isEscapeEvent(event) && valueOrHandler(config.escapeDeactivates, event) !== false) {
      event.preventDefault();
      trap.deactivate();
      return;
    }
    if (config.isKeyForward(event) || config.isKeyBackward(event)) {
      checkKeyNav(event, config.isKeyBackward(event));
    }
  };
  var checkClick = function checkClick2(e) {
    var target = getActualTarget(e);
    if (findContainerIndex(target, e) >= 0) {
      return;
    }
    if (valueOrHandler(config.clickOutsideDeactivates, e)) {
      return;
    }
    if (valueOrHandler(config.allowOutsideClick, e)) {
      return;
    }
    e.preventDefault();
    e.stopImmediatePropagation();
  };
  var addListeners = function addListeners2() {
    if (!state.active) {
      return;
    }
    activeFocusTraps.activateTrap(trapStack, trap);
    state.delayInitialFocusTimer = config.delayInitialFocus ? delay(function() {
      tryFocus(getInitialFocusNode());
    }) : tryFocus(getInitialFocusNode());
    doc.addEventListener("focusin", checkFocusIn, true);
    doc.addEventListener("mousedown", checkPointerDown, {
      capture: true,
      passive: false
    });
    doc.addEventListener("touchstart", checkPointerDown, {
      capture: true,
      passive: false
    });
    doc.addEventListener("click", checkClick, {
      capture: true,
      passive: false
    });
    doc.addEventListener("keydown", checkKey, {
      capture: true,
      passive: false
    });
    return trap;
  };
  var removeListeners = function removeListeners2() {
    if (!state.active) {
      return;
    }
    doc.removeEventListener("focusin", checkFocusIn, true);
    doc.removeEventListener("mousedown", checkPointerDown, true);
    doc.removeEventListener("touchstart", checkPointerDown, true);
    doc.removeEventListener("click", checkClick, true);
    doc.removeEventListener("keydown", checkKey, true);
    return trap;
  };
  var checkDomRemoval = function checkDomRemoval2(mutations) {
    var isFocusedNodeRemoved = mutations.some(function(mutation) {
      var removedNodes = Array.from(mutation.removedNodes);
      return removedNodes.some(function(node) {
        return node === state.mostRecentlyFocusedNode;
      });
    });
    if (isFocusedNodeRemoved) {
      tryFocus(getInitialFocusNode());
    }
  };
  var mutationObserver = typeof window !== "undefined" && "MutationObserver" in window ? new MutationObserver(checkDomRemoval) : void 0;
  var updateObservedNodes = function updateObservedNodes2() {
    if (!mutationObserver) {
      return;
    }
    mutationObserver.disconnect();
    if (state.active && !state.paused) {
      state.containers.map(function(container) {
        mutationObserver.observe(container, {
          subtree: true,
          childList: true
        });
      });
    }
  };
  trap = {
    get active() {
      return state.active;
    },
    get paused() {
      return state.paused;
    },
    activate: function activate(activateOptions) {
      if (state.active) {
        return this;
      }
      var onActivate = getOption(activateOptions, "onActivate");
      var onPostActivate = getOption(activateOptions, "onPostActivate");
      var checkCanFocusTrap = getOption(activateOptions, "checkCanFocusTrap");
      if (!checkCanFocusTrap) {
        updateTabbableNodes();
      }
      state.active = true;
      state.paused = false;
      state.nodeFocusedBeforeActivation = doc.activeElement;
      onActivate === null || onActivate === void 0 || onActivate();
      var finishActivation = function finishActivation2() {
        if (checkCanFocusTrap) {
          updateTabbableNodes();
        }
        addListeners();
        updateObservedNodes();
        onPostActivate === null || onPostActivate === void 0 || onPostActivate();
      };
      if (checkCanFocusTrap) {
        checkCanFocusTrap(state.containers.concat()).then(finishActivation, finishActivation);
        return this;
      }
      finishActivation();
      return this;
    },
    deactivate: function deactivate(deactivateOptions) {
      if (!state.active) {
        return this;
      }
      var options = _objectSpread2({
        onDeactivate: config.onDeactivate,
        onPostDeactivate: config.onPostDeactivate,
        checkCanReturnFocus: config.checkCanReturnFocus
      }, deactivateOptions);
      clearTimeout(state.delayInitialFocusTimer);
      state.delayInitialFocusTimer = void 0;
      removeListeners();
      state.active = false;
      state.paused = false;
      updateObservedNodes();
      activeFocusTraps.deactivateTrap(trapStack, trap);
      var onDeactivate = getOption(options, "onDeactivate");
      var onPostDeactivate = getOption(options, "onPostDeactivate");
      var checkCanReturnFocus = getOption(options, "checkCanReturnFocus");
      var returnFocus = getOption(options, "returnFocus", "returnFocusOnDeactivate");
      onDeactivate === null || onDeactivate === void 0 || onDeactivate();
      var finishDeactivation = function finishDeactivation2() {
        delay(function() {
          if (returnFocus) {
            tryFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation));
          }
          onPostDeactivate === null || onPostDeactivate === void 0 || onPostDeactivate();
        });
      };
      if (returnFocus && checkCanReturnFocus) {
        checkCanReturnFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation)).then(finishDeactivation, finishDeactivation);
        return this;
      }
      finishDeactivation();
      return this;
    },
    pause: function pause(pauseOptions) {
      if (state.paused || !state.active) {
        return this;
      }
      var onPause = getOption(pauseOptions, "onPause");
      var onPostPause = getOption(pauseOptions, "onPostPause");
      state.paused = true;
      onPause === null || onPause === void 0 || onPause();
      removeListeners();
      updateObservedNodes();
      onPostPause === null || onPostPause === void 0 || onPostPause();
      return this;
    },
    unpause: function unpause(unpauseOptions) {
      if (!state.paused || !state.active) {
        return this;
      }
      var onUnpause = getOption(unpauseOptions, "onUnpause");
      var onPostUnpause = getOption(unpauseOptions, "onPostUnpause");
      state.paused = false;
      onUnpause === null || onUnpause === void 0 || onUnpause();
      updateTabbableNodes();
      addListeners();
      updateObservedNodes();
      onPostUnpause === null || onPostUnpause === void 0 || onPostUnpause();
      return this;
    },
    updateContainerElements: function updateContainerElements(containerElements) {
      var elementsAsArray = [].concat(containerElements).filter(Boolean);
      state.containers = elementsAsArray.map(function(element) {
        return typeof element === "string" ? doc.querySelector(element) : element;
      });
      if (state.active) {
        updateTabbableNodes();
      }
      updateObservedNodes();
      return this;
    }
  };
  trap.updateContainerElements(elements);
  return trap;
};

// js/helper/section.js
function filterShopifyEvent(event, domElement, callback) {
  let executeCallback = false;
  if (event.type.includes("shopify:section")) {
    if (domElement.hasAttribute("section") && domElement.getAttribute("section") === event.detail.sectionId) {
      executeCallback = true;
    }
  } else if (event.type.includes("shopify:block") && event.target === domElement) {
    executeCallback = true;
  }
  if (executeCallback) {
    callback(event);
  }
}

var CartGiftSection = class extends CustomHTMLElement {
  
}
window.customElements.define("cart-gift-section", CartGiftSection);

// js/custom-element/behavior/openable-element.js
var OpenableElement = class extends CustomHTMLElement {
  static get observedAttributes() {
    return ["open"];
  }
  constructor() {
    super();
    if (Shopify.designMode) {
      this.rootDelegate.on("shopify:section:select", (event) => filterShopifyEvent(event, this, () => this.open = true));
      this.rootDelegate.on("shopify:section:deselect", (event) => filterShopifyEvent(event, this, () => this.open = false));
    }
    if (this.hasAttribute("append-body")) {
      const existingNode = document.getElementById(this.id);
      this.removeAttribute("append-body");
      if (existingNode && existingNode !== this) {
        existingNode.replaceWith(this.cloneNode(true));
        this.remove();
      } else {
        document.body.appendChild(this);
      }
    }
    if (this.hasAttribute("parent-boundaries")) {
      if (window.innerWidth < 1000) {
        const parent = document.querySelector(`${this.getAttribute("parent-boundaries")}`);
        if (parent) {
          const boundaries = 16;
          const parentRect = parent.getBoundingClientRect();
          const boundariesRect = this.getBoundingClientRect();
          if (boundariesRect.left < parentRect.left + boundaries) {
            const offset = parentRect.left + boundaries - boundariesRect.left;
            this.style.left = `calc(var(--left) + ${offset}px)`;
          } else if (boundariesRect.right > parentRect.right - boundaries) {
            const offset = boundariesRect.right - parentRect.right + boundaries;
            this.style.left = `calc(var(--left) - ${offset}px)`;
          }
        }
      }
    }
  }
  connectedCallback() {
    this.delegate.on("click", ".openable__overlay", () => this.open = false);
    this.delegate.on("data-action:close", () => this.open = false);
    this.delegate.on("click", '[data-action="close"]', (event) => {
      event.stopPropagation();
      this.open = false;
    });
  }
  get requiresLoading() {
    return this.hasAttribute("href");
  }
  get open() {
    return this.hasAttribute("open");
  }
  set open(value) {
    if (value) {
      (async () => {
        await this._load();
        this.clientWidth;
        this.setAttribute("open", "");
      })();
    } else {
      this.removeAttribute("open");
    }
  }
  get shouldTrapFocus() {
    return true;
  }
  get returnFocusOnDeactivate() {
    return !this.hasAttribute("return-focus") || this.getAttribute("return-focus") === "true";
  }
  get focusTrap() {
    return this._focusTrap = this._focusTrap || createFocusTrap(this, {
      fallbackFocus: this,
      initialFocus: this.hasAttribute("initial-focus-selector") ? this.getAttribute("initial-focus-selector") : void 0,
      clickOutsideDeactivates: (event) => !(event.target.hasAttribute("aria-controls") && event.target.getAttribute("aria-controls") === this.id),
      allowOutsideClick: (event) => event.target.hasAttribute("aria-controls") && event.target.getAttribute("aria-controls") === this.id,
      returnFocusOnDeactivate: this.returnFocusOnDeactivate,
      onDeactivate: () => this.open = false,
      preventScroll: true
    });
  }
  attributeChangedCallback(name, oldValue, newValue) {
    switch (name) {
      case "open":
        if (oldValue === null && newValue === "") {
          if (this.shouldTrapFocus) {
            setTimeout(() => this.focusTrap.activate(), 150);
          }
          triggerEvent(this, "openable-element:open");
        } else if (newValue === null) {
          if (this.shouldTrapFocus) {
            this.focusTrap.deactivate();
          }
          triggerEvent(this, "openable-element:close");
        }
    }
  }
  async _load() {
    if (!this.requiresLoading) {
      return;
    }
    triggerNonBubblingEvent(this, "openable-element:load:start");
    const response = await fetch(this.getAttribute("href"));
    const element = document.createElement("div");
    element.innerHTML = await response.text();
    this.innerHTML = element.querySelector(`${this.tagName.toLowerCase()}:not([href])`).innerHTML;
    this.removeAttribute("href");
    triggerNonBubblingEvent(this, "openable-element:load:end");
  }
};
window.customElements.define("openable-element", OpenableElement);

// js/custom-element/behavior/collapsible-content.js
var CollapsibleContent = class extends OpenableElement {
  constructor() {
    super();
    this.ignoreNextTransition = this.open;
    this.addEventListener("shopify:block:select", () => this.open = true);
    this.addEventListener("shopify:block:deselect", () => this.open = false);
  }
  get animateItems() {
    return this.hasAttribute("animate-items");
  }
  attributeChangedCallback(name) {
    if (this.ignoreNextTransition) {
      return this.ignoreNextTransition = false;
    }
    switch (name) {
      case "open":
        this.style.overflow = "hidden";
        const keyframes = {
          height: ["0px", `${this.scrollHeight}px`],
          visibility: ["hidden", "visible"]
        };
        if (this.animateItems) {
          keyframes["opacity"] = this.open ? [0, 0] : [0, 1];
        }
        this.animate(keyframes, {
          duration: 500,
          direction: this.open ? "normal" : "reverse",
          easing: "cubic-bezier(0.75, 0, 0.175, 1)"
        }).onfinish = () => {
          this.style.overflow = this.open ? "visible" : "hidden";
        };
        if (this.animateItems && this.open) {
          this.animate({
            opacity: [0, 1],
            transform: ["translateY(10px)", "translateY(0)"]
          }, {
            duration: 250,
            delay: 250,
            easing: "cubic-bezier(0.75, 0, 0.175, 1)"
          });
        }
        triggerEvent(this, this.open ? "openable-element:open" : "openable-element:close");
    }
  }
};
window.customElements.define("collapsible-content", CollapsibleContent);

// js/custom-element/behavior/confirm-button.js
var ConfirmButton = class extends HTMLButtonElement {
  connectedCallback() {
    this.addEventListener("click", (event) => {
      if (!window.confirm(this.getAttribute("data-message") || "Are you sure you wish to do this?")) {
        event.preventDefault();
      }
    });
  }
};
window.customElements.define("confirm-button", ConfirmButton, { extends: "button" });

// js/mixin/loader-button.js
var LoaderButtonMixin = {
  _prepareButton() {
    this.originalContent = this.innerHTML;
    this._startTransitionPromise = null;
    this.innerHTML = `
      <span class="loader-button__text">${this.innerHTML}</span>
      <span class="loader-button__loader" hidden>
        <div class="spinner">
          <svg focusable="false" width="24" height="24" class="icon icon--spinner" viewBox="25 25 50 50">
            <circle cx="50" cy="50" r="20" fill="none" stroke="currentColor" stroke-width="5"></circle>
          </svg>
        </div>
      </span>
    `;
    this.textElement = this.firstElementChild;
    this.spinnerElement = this.lastElementChild;
    window.addEventListener("pagehide", () => this.removeAttribute("aria-busy"));
  },
  _startTransition() {
    const textAnimation = this.textElement.animate({
      opacity: [1, 0],
      transform: ["translateY(0)", "translateY(-10px)"]
    }, {
      duration: 75,
      easing: "ease",
      fill: "forwards"
    });
    this.spinnerElement.hidden = false;
    const spinnerAnimation = this.spinnerElement.animate({
      opacity: [0, 1],
      transform: ["translate(-50%, 0%)", "translate(-50%, -50%)"]
    }, {
      duration: 75,
      delay: 75,
      easing: "ease",
      fill: "forwards"
    });
    this._startTransitionPromise = Promise.all([
      new Promise((resolve) => textAnimation.onfinish = () => resolve()),
      new Promise((resolve) => spinnerAnimation.onfinish = () => resolve())
    ]);
  },
  async _endTransition() {
    if (!this._startTransitionPromise) {
      return;
    }
    await this._startTransitionPromise;
    this.spinnerElement.animate({
      opacity: [1, 0],
      transform: ["translate(-50%, -50%)", "translate(-50%, -100%)"]
    }, {
      duration: 75,
      delay: 100,
      easing: "ease",
      fill: "forwards"
    }).onfinish = () => this.spinnerElement.hidden = true;
    this.textElement.animate({
      opacity: [0, 1],
      transform: ["translateY(10px)", "translateY(0)"]
    }, {
      duration: 75,
      delay: 175,
      easing: "ease",
      fill: "forwards"
    });
    this._startTransitionPromise = null;
  }
};

var ScrollTopButton = class extends HTMLButtonElement {
  constructor() {
    super();
    const width = this.getBoundingClientRect().width;
    this.style.setProperty("--width", `${width}px`);
    this.text = this.querySelector(".scroll-top-button__text");
    const textWidth = this.text.getBoundingClientRect().width;
    this.text.style.minWidth = `${textWidth}px`;
    this.hidden = window.scrollY < window.innerHeight;
    this.classList.remove("no-init");
    setTimeout(() => this.classList.add("init"), 100);
  }
  connectedCallback() {
    this.addEventListener("click", () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    });
    window.addEventListener("scroll", () => {
      this.hidden = window.scrollY < window.innerHeight;
    });
  }
}
window.customElements.define("scroll-top-button", ScrollTopButton, { extends: "button" });

// js/custom-element/behavior/loader-button.js
var LoaderButton = class extends HTMLButtonElement {
  static get observedAttributes() {
    return ["aria-busy"];
  }
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      if (this.type === "submit" && this.form && this.form.checkValidity() && !this.form.hasAttribute("is")) {
        if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
          event.preventDefault();
          this.setAttribute("aria-busy", "true");
          setTimeout(() => this.form.submit(), 250);
        } else {
          this.setAttribute("aria-busy", "true");
        }
      }
    });
  }
  connectedCallback() {
    this._prepareButton();
  }
  disconnectedCallback() {
    this.innerHTML = this.originalContent;
  }
  attributeChangedCallback(property, oldValue, newValue) {
    if (property === "aria-busy") {
      if (newValue === "true") {
        this._startTransition();
      } else {
        this._endTransition();
      }
    }
  }
};
Object.assign(LoaderButton.prototype, LoaderButtonMixin);
window.customElements.define("loader-button", LoaderButton, { extends: "button" });

// js/custom-element/behavior/page-pagination.js
var PagePagination = class extends CustomHTMLElement {
  connectedCallback() {
    if (this.hasAttribute("ajax")) {
      this.delegate.on("click", "a", this._onLinkClicked.bind(this));
    }
  }
  _onLinkClicked(event, target) {
    event.preventDefault();
    const url = new URL(window.location.href);
    url.searchParams.set("page", target.getAttribute("data-page"));
    triggerEvent(this, "pagination:page-changed", { url: url.toString() });
  }
};
window.customElements.define("page-pagination", PagePagination);

// js/custom-element/behavior/toggle-button.js
var ToggleButton = class extends HTMLButtonElement {
  static get observedAttributes() {
    return ["aria-expanded", "aria-busy"];
  }
  constructor() {
    super();
    if (this.hasAttribute("loader")) {
      this._prepareButton();
    }
    this.addEventListener("click", this._onButtonClick.bind(this));
    this.rootDelegate = new main_default(document.documentElement);
  }
  _onButtonClick() {
    this.isExpanded = !this.isExpanded;
  }
  connectedCallback() {
    document.addEventListener("openable-element:close", (event) => {
      if (this.controlledElement === event.target) {
        this.isExpanded = false;
        event.stopPropagation();
      }
    });
    document.addEventListener("openable-element:open", (event) => {
      if (this.controlledElement === event.target) {
        this.isExpanded = true;
        event.stopPropagation();
      }
    });
    this.rootDelegate.on("openable-element:load:start", `#${this.getAttribute("aria-controls")}`, () => {
      if (this.classList.contains("button")) {
        this.setAttribute("aria-busy", "true");
      } else if (this.offsetParent !== null) {
        triggerEvent(document.documentElement, "theme:loading:start");
      }
    }, true);
    this.rootDelegate.on("openable-element:load:end", `#${this.getAttribute("aria-controls")}`, () => {
      if (this.classList.contains("button")) {
        this.removeAttribute("aria-busy");
      } else if (this.offsetParent !== null) {
        triggerEvent(document.documentElement, "theme:loading:end");
      }
    }, true);

    // --- auto-open bei passenden Hash-/Anker-Navigationen ---
    window.addEventListener('hashchange', this._onHashChange);
    // capture=true, damit gleiche Hash-Klicks (kein hashchange) auch erkannt werden
    document.addEventListener('click', this._onAnchorClick, true);
    // initialer Check beim Mount
    this._expandIfHashMatches(false);
  }
  disconnectedCallback() {
    this.rootDelegate.destroy();

    // Cleanup für Auto-open-Listener
    window.removeEventListener('hashchange', this._onHashChange);
    document.removeEventListener('click', this._onAnchorClick, true);
  }
  get isExpanded() {
    return this.getAttribute("aria-expanded") === "true";
  }
  set isExpanded(value) {
    this.setAttribute("aria-expanded", value ? "true" : "false");
  }
  get controlledElement() {
    return document.getElementById(this.getAttribute("aria-controls"));
  }
  attributeChangedCallback(name, oldValue, newValue) {
    switch (name) {
      case "aria-expanded":
        if (oldValue === "false" && newValue === "true") {
          this.controlledElement.open = true;
        } else if (oldValue === "true" && newValue === "false") {
          this.controlledElement.open = false;
        }
        break;
      case "aria-busy":
        if (this.hasAttribute("loader")) {
          if (newValue === "true") {
            this._startTransition();
          } else {
            this._endTransition();
          }
        }
        break;
    }
  }
  _expandIfHashMatches(fromHashChange) {
    const rawAnchor = this.getAttribute('anchor');
    if (!rawAnchor) return;

    if (window.location.hash === '#' + rawAnchor) {
      if (this.getAttribute('aria-expanded') !== 'true') {
        try { this.scrollIntoView({ block: 'nearest' }); } catch (e) {}
        this.click(); // nutzt vorhandene Toggle-Logik
      }
      try { this.focus({ preventScroll: true }); } catch (e) {}
    }
  }

  _onHashChange = () => {
    this._expandIfHashMatches(true);
  };

  _onAnchorClick = (evt) => {
    var anchor = evt.target && evt.target.closest ? evt.target.closest('a[href^="#"]') : null;
    if (!anchor || !this.getAttribute('anchor')) return;
    if (anchor.hash === ('#' + this.getAttribute('anchor'))) {
      this._expandIfHashMatches(false);
    }
  };
};
Object.assign(ToggleButton.prototype, LoaderButtonMixin);
window.customElements.define("toggle-button", ToggleButton, { extends: "button" });

// js/custom-element/behavior/toggle-link.js
var ToggleLink = class extends HTMLAnchorElement {
  static get observedAttributes() {
    return ["aria-expanded"];
  }
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      this.isExpanded = !this.isExpanded;
    });
    window.addEventListener(`toggle-link:${this.ariaControls}:open`, () => {
      this.isExpanded = true
    });
    this.rootDelegate = new main_default(document.documentElement);
  }
  connectedCallback() {
    this.rootDelegate.on("openable-element:close", `#${this.getAttribute("aria-controls")}`, (event) => {
      if (this.controlledElement === event.target) {
        this.isExpanded = false;
      }
    }, true);
    this.rootDelegate.on("openable-element:open", `#${this.getAttribute("aria-controls")}`, (event) => {
      if (this.controlledElement === event.target) {
        this.isExpanded = true;
      }
    }, true);
  }
  disconnectedCallback() {
    this.rootDelegate.destroy();
  }
  get isExpanded() {
    return this.getAttribute("aria-expanded") === "true";
  }
  set isExpanded(value) {
    this.setAttribute("aria-expanded", value ? "true" : "false");
  }
  get controlledElement() {
    return document.querySelector(`#${this.getAttribute("aria-controls")}`);
  }
  get ariaControls() {
    return this.getAttribute("aria-controls");
  }
  attributeChangedCallback(name, oldValue, newValue) {
    switch (name) {
      case "aria-expanded":
        if (oldValue === "false" && newValue === "true") {
          this.controlledElement.open = true;
        } else if (oldValue === "true" && newValue === "false") {
          this.controlledElement.open = false;
        }
    }
  }
};
window.customElements.define("toggle-link", ToggleLink, { extends: "a" });

// js/custom-element/behavior/page-dots.js
var PageDots = class extends CustomHTMLElement {
  connectedCallback() {
    this.buttons = Array.from(this.querySelectorAll("button"));
    // console.log("buttons", this.buttons);
    this.delegate.on("click", "button", (event, target) => {
      // // console.log("dispatch event", target);
      this._dispatchEvent(this.buttons.indexOf(target));
    });
    if (this.hasAttribute("animation-timer")) {
      this.delegate.on("animationend", (event) => {
        if (event.elapsedTime > 0) {
          this._dispatchEvent((this.selectedIndex + 1 + this.buttons.length) % this.buttons.length);
        }
      });
    }
  }
  get selectedIndex() {
    return this.buttons.findIndex((button) => button.getAttribute("aria-current") === "true");
  }
  set selectedIndex(selectedIndex) {
    this.buttons.forEach((button, index) => button.setAttribute("aria-current", selectedIndex === index ? "true" : "false"));
    if (this.hasAttribute("align-selected")) {
      const selectedItem = this.buttons[selectedIndex], windowHalfWidth = window.innerWidth / 2, boundingRect = selectedItem.getBoundingClientRect(), scrollableElement = this._findFirstScrollableElement(this.parentElement);
      if (scrollableElement) {
        scrollableElement.scrollTo({
          behavior: "smooth",
          left: scrollableElement.scrollLeft + (boundingRect.left - windowHalfWidth) + boundingRect.width / 2
        });
      }
    }
  }
  _dispatchEvent(index) {
    // // console.log("dispatch event", index, this.selectedIndex, index !== this.selectedIndex);
    if (index !== this.selectedIndex) {
      this.dispatchEvent(new CustomEvent("page-dots:changed", {
        bubbles: true,
        detail: {
          index
        }
      }));
    }
  }
  _findFirstScrollableElement(item, currentDepth = 0) {
    if (item === null || currentDepth > 3) {
      return null;
    }
    return item.scrollWidth > item.clientWidth ? item : this._findFirstScrollableElement(item.parentElement, currentDepth + 1);
  }
};
window.customElements.define("page-dots", PageDots);

class ProductCardImage extends HTMLImageElement {
  constructor() {
    super();
    
    this._observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this._loadImage();
            this._observer.disconnect();
          }
        });
      },
      {
        root: null,
        rootMargin: this.dataset.offset || '500px',
        threshold: 0.1 // Adjust as needed to trigger the loading earlier or later
      }
    );

    // this.onLoadHandler = this._onLoad.bind(this);
  }
  connectedCallback() {
    this._observer.observe(this);
    // this.addEventListener("load", this.onLoadHandler);
  }
  disconnectedCallback() {
    this._observer.disconnect();
    // this.removeEventListener("load", this.onLoadHandler);
  }
  get id() {
    return this.getAttribute("id");
  }
  _loadImage() {
    if (this.dataset.src) {
      this.src = this.dataset.src;
    }
    if (this.dataset.srcset) {
      this.srcset = this.dataset.srcset;
    }
    if (this.dataset.sizes) {
      this.sizes = this.dataset.sizes;
    }

    /*
    * =========
    * START: AB-Test
    * Replaced old querySelector and added Loop
    * PT-15
    * PT-16
    * ========= 
    */

    // const secondaryImage = this.parentElement.querySelector(`[for="${this.id}"]`);
    // const secondaryImages = this.parentElement.querySelectorAll(`[for="${this.id}"]`);
    // secondaryImages.forEach((secondaryImage) => {
    //   if (secondaryImage) {
    //     if (secondaryImage.dataset.src) {
    //       secondaryImage.src = secondaryImage.dataset.src;
    //     }
    //     if (secondaryImage.dataset.srcset) {
    //       secondaryImage.srcset = secondaryImage.dataset.srcset;
    //     }
    //     if (secondaryImage.dataset.sizes) {
    //       secondaryImage.sizes = secondaryImage.dataset.sizes;
    //     }
    //   }
    // });

    /*
    * =========
    * END: AB-Test
    * PT-15
    * PT-16
    * ========= 
    */
  }
};
window.customElements.define("product-card-image", ProductCardImage, { extends: "img" });

// js/custom-element/behavior/prev-next-buttons.js
var PrevNextButtons = class extends HTMLElement {
  connectedCallback() {
    this.prevButton = this.querySelector("button:first-of-type");
    this.nextButton = this.querySelector("button:last-of-type");
    this.prevButton.addEventListener("click", () => this.prevButton.dispatchEvent(new CustomEvent("prev-next:prev", { bubbles: true })));
    this.nextButton.addEventListener("click", () => this.nextButton.dispatchEvent(new CustomEvent("prev-next:next", { bubbles: true })));
    this._init();
    window.addEventListener("resize", () => this._init());
    this.addEventListener("prev-next:init", () => this._init());
  }
  set isPrevDisabled(value) {
    this.prevButton.disabled = value;
  }
  set isNextDisabled(value) {
    this.nextButton.disabled = value;
  } 
  _init() {
    if (this.classList.contains("product-list__prev-next")) {
      const productList = this.closest(".product-list__inner");
      if (productList) {
        const productCardImageWrapper = productList.querySelector(".product-card__image");
        if (productCardImageWrapper) {
          const imageWrapperHeight = productCardImageWrapper.offsetHeight;
          this.style.top = `calc(${imageWrapperHeight / 2}px + var(--padding-offset))`;
        } else {
          const imageWrapper = productList.querySelector("img");
          if (imageWrapper) {
            const imageWrapperHeight = imageWrapper.offsetHeight;
            this.style.top = `calc(${imageWrapperHeight / 2}px + var(--padding-offset))`;
          }
        }
      }
    }
  }
};
var PrevButton = class extends HTMLButtonElement {
  connectedCallback() {
    this.addEventListener("click", () => this.dispatchEvent(new CustomEvent("prev-next:prev", { bubbles: true })));
  }
};
var NextButton = class extends HTMLButtonElement {
  connectedCallback() {
    this.addEventListener("click", () => this.dispatchEvent(new CustomEvent("prev-next:next", { bubbles: true })));
  }
};
window.customElements.define("prev-next-buttons", PrevNextButtons);
window.customElements.define("prev-button", PrevButton, { extends: "button" });
window.customElements.define("next-button", NextButton, { extends: "button" });

// js/helper/dimensions.js
function getStickyHeaderOffset() {
  const documentStyles = getComputedStyle(document.documentElement);
  return parseInt(documentStyles.getPropertyValue("--header-height") || 0) * parseInt(documentStyles.getPropertyValue("--enable-sticky-header") || 0) + parseInt(documentStyles.getPropertyValue("--announcement-bar-height") || 0) * parseInt(documentStyles.getPropertyValue("--enable-sticky-announcement-bar") || 0);
}

// js/custom-element/behavior/safe-sticky.js
var SafeSticky = class extends HTMLElement {
  connectedCallback() {
    this.lastKnownY = window.scrollY;
    this.currentTop = 0;
    this.hasPendingRaf = false;
    window.addEventListener("scroll", this._checkPosition.bind(this));
  }
  get initialTopOffset() {
    return getStickyHeaderOffset() + (parseInt(this.getAttribute("offset")) || 0);
  }
  _checkPosition() {
    if (this.hasPendingRaf) {
      return;
    }
    this.hasPendingRaf = true;
    requestAnimationFrame(() => {
      let bounds = this.getBoundingClientRect(), maxTop = bounds.top + window.scrollY - this.offsetTop + this.initialTopOffset, minTop = this.clientHeight - window.innerHeight;
      if (window.scrollY < this.lastKnownY) {
        this.currentTop -= window.scrollY - this.lastKnownY;
      } else {
        this.currentTop += this.lastKnownY - window.scrollY;
      }
      this.currentTop = Math.min(Math.max(this.currentTop, -minTop), maxTop, this.initialTopOffset);
      this.lastKnownY = window.scrollY;
      this.style.top = `${this.currentTop}px`;
      this.hasPendingRaf = false;
    });
  }
};
window.customElements.define("safe-sticky", SafeSticky);

// js/helper/throttle.js
function throttle(callback, delay3 = 15) {
  let throttleTimeout = null, storedEvent = null;
  const throttledEventHandler = (event) => {
    storedEvent = event;
    const shouldHandleEvent = !throttleTimeout;
    if (shouldHandleEvent) {
      callback(storedEvent);
      storedEvent = null;
      throttleTimeout = setTimeout(() => {
        throttleTimeout = null;
        if (storedEvent) {
          throttledEventHandler(storedEvent);
        }
      }, delay3);
    }
  };
  return throttledEventHandler;
}

// js/custom-element/behavior/scroll-spy.js
var ScrollSpy = class extends HTMLElement {
  connectedCallback() {
    this._createSvg();
    this.elementsToObserve = Array.from(this.querySelectorAll("a")).map((linkElement) => document.querySelector(linkElement.getAttribute("href")));
    this.navListItems = Array.from(this.querySelectorAll("li"));
    this.navItems = this.navListItems.map((listItem) => {
      const anchor = listItem.firstElementChild, targetID = anchor && anchor.getAttribute("href").slice(1), target = document.getElementById(targetID);
      return { listItem, anchor, target };
    }).filter((item) => item.target);
    this.drawPath();
    window.addEventListener("scroll", throttle(this.markVisibleSection.bind(this), 25));
    window.addEventListener("orientationchange", () => {
      window.addEventListener("resize", () => {
        this.drawPath();
        this.markVisibleSection();
      }, { once: true });
    });
    this.markVisibleSection();
  }
  /**
   * Dynamically create the SVG element that will be used to "spy" the scroll
   */
  _createSvg() {
    this.navPath = document.createElementNS("http://www.w3.org/2000/svg", "path");
    const svgElement = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svgElement.insertAdjacentElement("beforeend", this.navPath);
    this.insertAdjacentElement("beforeend", svgElement);
    this.lastPathStart = this.lastPathEnd = null;
  }
  drawPath() {
    let path = [], pathIndent;
    this.navItems.forEach((item, i) => {
      const x = item.anchor.offsetLeft - 5, y = item.anchor.offsetTop, height = item.anchor.offsetHeight;
      if (i === 0) {
        path.push("M", x, y, "L", x, y + height);
        item.pathStart = 0;
      } else {
        if (pathIndent !== x) {
          path.push("L", pathIndent, y);
        }
        path.push("L", x, y);
        this.navPath.setAttribute("d", path.join(" "));
        item.pathStart = this.navPath.getTotalLength() || 0;
        path.push("L", x, y + height);
      }
      pathIndent = x;
      this.navPath.setAttribute("d", path.join(" "));
      item.pathEnd = this.navPath.getTotalLength();
    });
  }
  syncPath() {
    const someElsAreVisible = () => this.querySelectorAll(".is-visible").length > 0, thisElIsVisible = (el) => el.classList.contains("is-visible"), pathLength = this.navPath.getTotalLength();
    let pathStart = pathLength, pathEnd = 0;
    this.navItems.forEach((item) => {
      if (thisElIsVisible(item.listItem)) {
        pathStart = Math.min(item.pathStart, pathStart);
        pathEnd = Math.max(item.pathEnd, pathEnd);
      }
    });
    if (someElsAreVisible() && pathStart < pathEnd) {
      if (pathStart !== this.lastPathStart || pathEnd !== this.lastPathEnd) {
        const dashArray = `1 ${pathStart} ${pathEnd - pathStart} ${pathLength}`;
        this.navPath.style.setProperty("stroke-dashoffset", "1");
        this.navPath.style.setProperty("stroke-dasharray", dashArray);
        this.navPath.style.setProperty("opacity", "1");
      }
    } else {
      this.navPath.style.setProperty("opacity", "0");
    }
    this.lastPathStart = pathStart;
    this.lastPathEnd = pathEnd;
  }
  markVisibleSection() {
    this.navListItems.forEach((item) => item.classList.remove("is-visible"));
    for (const [index, elementToObserve] of this.elementsToObserve.entries()) {
      const boundingClientRect = elementToObserve.getBoundingClientRect();
      if (boundingClientRect.top > getStickyHeaderOffset() || index === this.elementsToObserve.length - 1) {
        this.querySelector(`a[href="#${elementToObserve.id}"]`).parentElement.classList.add("is-visible");
        break;
      }
    }
    this.syncPath();
  }
};
window.customElements.define("scroll-spy", ScrollSpy);

// js/custom-element/behavior/scroll-shadow.js
var template = `
  <style>
    :host {
      display: inline-block;
      contain: layout;
      position: relative;
    }
    
    :host([hidden]) {
      display: none;
    }
    
    s {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      pointer-events: none;
      background-image:
        var(--scroll-shadow-top, radial-gradient(farthest-side at 50% 0%, rgba(0,0,0,.2), rgba(0,0,0,0))),
        var(--scroll-shadow-bottom, radial-gradient(farthest-side at 50% 100%, rgba(0,0,0,.2), rgba(0,0,0,0))),
        var(--scroll-shadow-left, radial-gradient(farthest-side at 0%, rgba(0,0,0,.2), rgba(0,0,0,0))),
        var(--scroll-shadow-right, radial-gradient(farthest-side at 100%, rgba(0,0,0,.2), rgba(0,0,0,0)));
      background-position: top, bottom, left, right;
      background-repeat: no-repeat;
      background-size: 100% var(--top, 0), 100% var(--bottom, 0), var(--left, 0) 100%, var(--right, 0) 100%;
    }
  </style>
  <slot></slot>
  <s></s>
`;
var Updater = class {
  constructor(targetElement) {
    this.scheduleUpdate = throttle(() => this.update(targetElement, getComputedStyle(targetElement)));
    this.resizeObserver = new ResizeObserver(this.scheduleUpdate.bind(this));
  }
  start(element) {
    if (this.element) {
      this.stop();
    }
    if (element) {
      element.addEventListener("scroll", this.scheduleUpdate);
      this.resizeObserver.observe(element);
      this.element = element;
    }
  }
  stop() {
    if (!this.element) {
      return;
    }
    this.element.removeEventListener("scroll", this.scheduleUpdate);
    this.resizeObserver.unobserve(this.element);
    this.element = null;
  }
  update(targetElement, style) {
    if (!this.element) {
      return;
    }
    const maxSize = style.getPropertyValue("--scroll-shadow-size") ? parseInt(style.getPropertyValue("--scroll-shadow-size")) : 0;
    const scroll = {
      top: Math.max(this.element.scrollTop, 0),
      bottom: Math.max(this.element.scrollHeight - this.element.offsetHeight - this.element.scrollTop, 0),
      left: Math.max(this.element.scrollLeft, 0),
      right: Math.max(this.element.scrollWidth - this.element.offsetWidth - this.element.scrollLeft, 0)
    };
    requestAnimationFrame(() => {
      for (const position of ["top", "bottom", "left", "right"]) {
        targetElement.style.setProperty(
          `--${position}`,
          `${scroll[position] > maxSize ? maxSize : scroll[position]}px`
        );
      }
    });
  }
};
var ScrollShadow = class extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" }).innerHTML = template;
    this.updater = new Updater(this.shadowRoot.lastElementChild);
  }
  connectedCallback() {
    this.shadowRoot.querySelector("slot").addEventListener("slotchange", () => this.start());
    this.start();
  }
  disconnectedCallback() {
    this.updater.stop();
  }
  start() {
    this.updater.start(this.firstElementChild);
  }
};
if ("ResizeObserver" in window) {
  window.customElements.define("scroll-shadow", ScrollShadow);
}

// js/custom-element/behavior/share-toggle-button.js
var ShareToggleButton = class extends ToggleButton {
  _onButtonClick() {
    if (window.matchMedia(window.themeVariables.breakpoints.phone).matches && navigator.share) {
      navigator.share({
        title: this.hasAttribute("share-title") ? this.getAttribute("share-title") : document.title,
        url: this.hasAttribute("share-url") ? this.getAttribute("share-url") : window.location.href
      });
    } else {
      super._onButtonClick();
    }
  }
};
window.customElements.define("share-toggle-button", ShareToggleButton, { extends: "button" });

var AllStores = class extends CustomHTMLElement {
  connectedCallback() {
    this.filterButtons.forEach((button) => button.addEventListener("click", this._onFilterButtonClick.bind(this)));
  }
  get filterButtons() {
    return Array.from(this.querySelectorAll(".filterButton"));
  }
  get storeItems() {
    return Array.from(this.querySelectorAll(".hasFilter"));
  }
  _onFilterButtonClick(event) {
    const button = event.currentTarget;
    const filter_tag = button.getAttribute("data-filter");

    this.filterButtons.forEach((button) => {
      if (button.classList.contains("button--selected")) {
        button.classList.remove("button--selected");
      }
    });
    button.classList.add("button--selected");

    var counter = 0;
    this.storeItems.forEach((storeItem) => {
      // wenn counte gerade links ansosnten rechts
      var image_position = "";
      if (counter % 2 === 0) {
        image_position = "Left";
      } else {
        image_position = "Right";
      }

      if (filter_tag === "all") {
        storeItem.hidden = false;
        storeItem.setAttribute("direction", image_position);
        counter++;
      } else {
        if (storeItem.classList.contains(filter_tag)) {
          storeItem.hidden = false;
          storeItem.setAttribute("direction", image_position);
          counter++;
        } else {
          storeItem.hidden = true;
        }
      }
    });
  }
}
window.customElements.define("all-stores", AllStores);

// === PT Confetti Wrapper Web Component ===
// Transforms previous inline confetti script (formerly in pt-product-info.liquid) into a reusable component.
// Usage example in Liquid/HTML:
// <pt-confetti-wrapper data-confetti-count="120" data-confetti-colors="#ff0000,#00ff00,#0000ff">
//   <label>
//     <div class="confetti-layer" data-confetti-layer></div>
//     <div class="confetti-foreground">
//       <input type="checkbox" class="upsell-checkbox">
//       ...
//     </div>
//   </label>
// </pt-confetti-wrapper>
// When the (first) checkbox inside becomes checked, an explosion fires. Multiple wrappers can coexist.
var PTConfettiWrapper = class extends HTMLElement {
  connectedCallback() {
    this._boundOnChange = this._onChange.bind(this);
    this._init();
  }
  disconnectedCallback() {
    this.checkbox && this.checkbox.removeEventListener('change', this._boundOnChange);
  }
  _init() {
    // Layer element (container where particles are appended)
    this.layer = this.querySelector('[data-confetti-layer]') || this.querySelector('.confetti-layer');
    // Trigger checkbox (first checkbox inside by default)
    this.checkbox = this.querySelector('.upsell-checkbox[type="checkbox"]') || this.querySelector('input[type="checkbox"]');
    if (!this.layer || !this.checkbox) return;
    this.checkbox.addEventListener('change', this._boundOnChange);
  }
  get config() {
    const d = this.dataset;
    const parseFloatAttr = (name, def) => d[name] ? parseFloat(d[name]) : def;
    const parseIntAttr = (name, def) => d[name] ? parseInt(d[name], 10) : def;
    return {
      count: parseIntAttr('confettiCount', 100),
      maxSpeed: parseFloatAttr('confettiMaxSpeed', 6),
      upwardBias: parseFloatAttr('confettiUpwardBias', 0),
      spread: parseFloatAttr('confettiSpread', Math.PI * 2),
      gravity: parseFloatAttr('confettiGravity', 0.05),
      drag: parseFloatAttr('confettiDrag', 0.985),
      rotateSpeed: parseFloatAttr('confettiRotateSpeed', 0.15),
      colors: (d.confettiColors ? d.confettiColors.split(',').map(c => c.trim()).filter(Boolean) : ['#00C2FF','#FF5A5F','#FFD166','#06D6A0','#8338EC','#FF006E','#3A86FF','#FB5607'])
    };
  }
  _onChange() {
    if (this.checkbox.checked) this._explode();
  }
  /* Public method: fire confetti programmatically from a given origin element (or center of layer). */
  fire(originEl) {
    if (!this.layer) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const cfg = this.config;
    const layerRect = this.layer.getBoundingClientRect();
    let originX, originY;
    if (originEl) {
      const elRect = originEl.getBoundingClientRect();
      originX = (elRect.left + elRect.width / 2) - layerRect.left;
      originY = (elRect.top + elRect.height / 2) - layerRect.top;
    } else {
      originX = layerRect.width / 2;
      originY = layerRect.height / 2;
    }
    this._spawnParticles(cfg, originX, originY);
  }
  _explode() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const cfg = this.config;
    const layerRect = this.layer.getBoundingClientRect();
    const label = this.checkbox.closest('label') || this;
    const labelRect = label.getBoundingClientRect();
    const originX = (labelRect.left + labelRect.width / 2) - layerRect.left;
    const originY = (labelRect.top + labelRect.height / 2) - layerRect.top;
    this._spawnParticles(cfg, originX, originY);
  }
  _spawnParticles(cfg, originX, originY) {
    let particles = [];
    const rand = (min, max) => Math.random() * (max - min) + min;
    const choose = (arr) => arr[(Math.random() * arr.length) | 0];
    class Particle {
      constructor(layer, x, y, cfg) {
        this.el = document.createElement('div');
        this.el.className = 'confetti';
        this.el.style.background = choose(cfg.colors);
        this.x = x; this.y = y;
        const angle = cfg.upwardBias + rand(-cfg.spread / 2, cfg.spread / 2);
        const speed = rand(2, cfg.maxSpeed);
        this.vx = Math.cos(angle) * speed;
        this.vy = Math.sin(angle) * speed;
        this.life = rand(50, 95);
        this.opacity = 1;
        this.r = rand(0, Math.PI * 2);
        this.vr = (Math.random() > .5 ? 1 : -1) * cfg.rotateSpeed;
        layer.appendChild(this.el);
      }
      update(cfg) {
        this.vx *= cfg.drag;
        this.vy = this.vy * cfg.drag + cfg.gravity;
        this.x += this.vx; this.y += this.vy; this.r += this.vr; this.life--;
        if (this.life < 20) this.opacity = Math.max(0, this.life / 20);
        this.el.style.opacity = this.opacity.toFixed(2);
        this.el.style.transform = `translate(${this.x}px,${this.y}px) rotate(${this.r}rad)`;
        if (this.opacity <= 0) { this.el.remove(); return false; }
        return true;
      }
    }
    for (let i = 0; i < cfg.count; i++) particles.push(new Particle(this.layer, originX, originY, cfg));
    const tick = () => {
      particles = particles.filter(p => p.update(cfg));
      if (particles.length) requestAnimationFrame(tick);
      else this.dispatchEvent(new CustomEvent('pt-confetti-finished', { bubbles: true }));
    };
    requestAnimationFrame(tick);
    this.dispatchEvent(new CustomEvent('pt-confetti-fired', { bubbles: true }));
  }
};
window.customElements.define('pt-confetti-wrapper', PTConfettiWrapper);

// js/custom-element/ui/carousel.js
var NativeCarousel = class extends CustomHTMLElement {
  connectedCallback() {
    this.items = Array.from(this.querySelectorAll("native-carousel-item"));
    this.pageDotsElements = Array.from(this.querySelectorAll("page-dots"));
    this.prevNextButtonsElements = Array.from(this.querySelectorAll("prev-next-buttons"));
    if (this.items.length > 1) {
      this.addEventListener("prev-next:prev", this.prev.bind(this));
      this.addEventListener("prev-next:next", this.next.bind(this));
      this.addEventListener("page-dots:changed", (event) => this.select(event.detail.index, true));
      if (Shopify.designMode) {
        this.addEventListener("shopify:block:select", (event) => this.select(event.target.index, !event.detail.load));
      }
    }
    const scrollerElement = this.items[0].parentElement;
    this.intersectionObserver = new IntersectionObserver(this._onVisibilityChanged.bind(this), { root: scrollerElement, rootMargin: `${scrollerElement.clientHeight}px 0px`, threshold: 0.8 });
    this.items.forEach((item) => this.intersectionObserver.observe(item));
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.intersectionObserver.disconnect();
  }
  get selectedIndex() {
    return this.items.findIndex((item) => item.selected);
  }
  prev(shouldAnimate = true) {
    this.select(Math.max(this.selectedIndex - 1, 0), shouldAnimate);
  }
  next(shouldAnimate = true) {
    this.select(Math.min(this.selectedIndex + 1, this.items.length - 1), shouldAnimate);
  }
  select(index, shouldAnimate = true) {
    const clampIndex = Math.max(0, Math.min(index, this.items.length));
    const selectedElement = this.items[clampIndex];
    this._adjustNavigationForElement(selectedElement);
    if (shouldAnimate) {
      this.items.forEach((item) => this.intersectionObserver.unobserve(item));
      setInterval(() => {
        this.items.forEach((item) => this.intersectionObserver.observe(item));
      }, 800);
    }
    this.items.forEach((item, loopIndex) => item.selected = loopIndex === clampIndex);
    const direction = window.themeVariables.settings.direction === "ltr" ? 1 : -1;
    selectedElement.parentElement.scrollTo({ left: direction * (selectedElement.clientWidth * clampIndex), behavior: shouldAnimate ? "smooth" : "auto" });
  }
  _adjustNavigationForElement(selectedElement) {
    this.items.forEach((item) => item.selected = selectedElement === item);
    this.pageDotsElements.forEach((pageDot) => pageDot.selectedIndex = selectedElement.index);
    this.prevNextButtonsElements.forEach((prevNextButton) => {
      prevNextButton.isPrevDisabled = selectedElement.index === 0;
      prevNextButton.isNextDisabled = selectedElement.index === this.items.length - 1;
    });
  }
  _onVisibilityChanged(entries) {
    for (let entry of entries) {
      if (entry.isIntersecting) {
        this._adjustNavigationForElement(entry.target);
        break;
      }
    }
  }
};
var NativeCarouselItem = class extends CustomHTMLElement {
  static get observedAttributes() {
    return ["hidden"];
  }
  get index() {
    return [...this.parentNode.children].indexOf(this);
  }
  get selected() {
    return !this.hasAttribute("hidden");
  }
  set selected(value) {
    this.hidden = !value;
  }
};
window.customElements.define("native-carousel-item", NativeCarouselItem);
window.customElements.define("native-carousel", NativeCarousel);

// js/custom-element/ui/drag-cursor.js
var DragCursor = class extends HTMLElement {
  connectedCallback() {
    this.scrollableElement = this.parentElement;
    this.scrollableElement.addEventListener("mouseenter", this._onMouseEnter.bind(this));
    this.scrollableElement.addEventListener("mousemove", this._onMouseMove.bind(this));
    this.scrollableElement.addEventListener("mouseleave", this._onMouseLeave.bind(this));
    this.innerHTML = `
      <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120">
        <path d="M0 60C0 26.863 26.863 0 60 0s60 26.863 60 60-26.863 60-60 60S0 93.137 0 60z" fill="rgb(var(--text-color))"/>
        <path d="M46 50L36 60l10 10M74 50l10 10-10 10" stroke="rgb(var(--section-background))" stroke-width="4"/>
      </svg>
    `;
  }
  _onMouseEnter(event) {
    this.removeAttribute("hidden");
    this._positionCursor(event);
  }
  _onMouseLeave() {
    this.setAttribute("hidden", "");
  }
  _onMouseMove(event) {
    this.toggleAttribute("hidden", event.target.tagName === "BUTTON" || event.target.tagName === "A");
    this._positionCursor(event);
  }
  _positionCursor(event) {
    const elementBoundingRect = this.scrollableElement.getBoundingClientRect();
    const x = event.clientX - elementBoundingRect.x;
    const y = event.clientY - elementBoundingRect.y;
    this.style.transform = `translate(${x - this.clientWidth / 2}px, ${y - this.clientHeight / 2}px)`;
  }
};
window.customElements.define("drag-cursor", DragCursor);

// js/custom-element/ui/scrollable-content.js
var ScrollableContent = class extends CustomHTMLElement {
  connectedCallback() {
    if (this.draggable) {
      this._setupDraggability();
    }
    this._checkScrollability();
    window.addEventListener("resize", this._checkScrollability.bind(this));
    this.addEventListener("scroll", throttle(this._calculateProgress.bind(this), 15));
  }
  get draggable() {
    return this.hasAttribute("draggable");
  }
  _setupDraggability() {
    this.insertAdjacentHTML("afterend", '<drag-cursor hidden class="custom-drag-cursor"></drag-cursor>');
    const mediaQuery = matchMedia("(hover: none)");
    mediaQuery.addListener(this._onMediaChanges.bind(this));
    if (!mediaQuery.matches) {
      this._attachDraggableListeners();
    }
  }
  _attachDraggableListeners() {
    this.delegate.on("mousedown", this._onMouseDown.bind(this));
    this.delegate.on("mousemove", this._onMouseMove.bind(this));
    this.delegate.on("mouseup", this._onMouseUp.bind(this));
  }
  _removeDraggableListeners() {
    this.delegate.off("mousedown");
    this.delegate.off("mousemove");
    this.delegate.off("mouseup");
  }
  _checkScrollability() {
    this.classList.toggle("is-scrollable", this.scrollWidth > this.offsetWidth);
  }
  _calculateProgress() {
    const scrollLeft = this.scrollLeft * (window.themeVariables.settings.direction === "ltr" ? 1 : -1);
    const progress = Math.max(0, Math.min(1, scrollLeft / (this.scrollWidth - this.clientWidth))) * 100;
    triggerEvent(this, "scrollable-content:progress", { progress });
  }
  _onMediaChanges(event) {
    if (!event.matches) {
      this._attachDraggableListeners();
    } else {
      this._removeDraggableListeners();
    }
  }
  _onMouseDown(event) {
    if (event.target && event.target.nodeName === "IMG") {
      event.preventDefault();
    }
    this.startX = event.clientX + this.scrollLeft;
    this.diffX = 0;
    this.drag = true;
  }
  _onMouseMove(event) {
    if (this.drag) {
      this.diffX = this.startX - (event.clientX + this.scrollLeft);
      this.scrollLeft += this.diffX;
    }
  }
  _onMouseUp() {
    this.drag = false;
    let start = 1;
    let animate = () => {
      let step = Math.sinh(start);
      if (step <= 0) {
        window.cancelAnimationFrame(animate);
      } else {
        this.scrollLeft += this.diffX * step;
        start -= 0.03;
        window.requestAnimationFrame(animate);
      }
    };
    animate();
  }
};
window.customElements.define("scrollable-content", ScrollableContent);

// js/custom-element/ui/loading-bar.js
var LoadingBar = class extends CustomHTMLElement {
  constructor() {
    super();
    this.rootDelegate.on("theme:loading:start", this.show.bind(this));
    this.rootDelegate.on("theme:loading:end", this.hide.bind(this));
    this.delegate.on("transitionend", this._onTransitionEnd.bind(this));
  }
  show() {
    this.classList.add("is-visible");
    this.style.transform = "scaleX(0.4)";
  }
  hide() {
    this.style.transform = "scaleX(1)";
    this.classList.add("is-finished");
  }
  _onTransitionEnd(event) {
    if (event.propertyName === "transform" && this.classList.contains("is-finished")) {
      this.classList.remove("is-visible");
      this.classList.remove("is-finished");
      this.style.transform = "scaleX(0)";
    }
  }
};
window.customElements.define("loading-bar", LoadingBar);

// js/custom-element/ui/split-lines.js
var SplitLines = class extends HTMLElement {
  connectedCallback() {
    this.originalContent = this.textContent;
    this.lastWidth = window.innerWidth;
    this.hasBeenSplitted = false;
    window.addEventListener("resize", this._onResize.bind(this));
  }
  [Symbol.asyncIterator]() {
    return {
      splitPromise: this.split.bind(this),
      index: 0,
      async next() {
        const lines = await this.splitPromise();
        if (this.index !== lines.length) {
          return { done: false, value: lines[this.index++] };
        } else {
          return { done: true };
        }
      }
    };
  }
  split(force = false) {
    if (this.childElementCount > 0 && !force) {
      return Promise.resolve(Array.from(this.children));
    }
    this.hasBeenSplitted = true;
    return new Promise((resolve) => {
      requestAnimationFrame(() => {
        this.innerHTML = this.originalContent.replace(/./g, "<span>$&</span>").replace(/\s/g, " ");
        const bounds = {};
        Array.from(this.children).forEach((child) => {
          const rect = parseInt(child.getBoundingClientRect().top);
          bounds[rect] = (bounds[rect] || "") + child.textContent;
        });
        this.innerHTML = Object.values(bounds).map(
          (item) => `<span ${this.hasAttribute("reveal") && !force ? "reveal" : ""} ${this.hasAttribute("reveal-visibility") && !force ? "reveal-visibility" : ""} style="display: block">${item.trim()}</span>`
        ).join("");
        this.style.opacity = this.hasAttribute("reveal") ? 1 : null;
        this.style.visibility = this.hasAttribute("reveal-visibility") ? "visible" : null;
        resolve(Array.from(this.children));
      });
    });
  }
  async _onResize() {
    if (this.lastWidth === window.innerWidth || !this.hasBeenSplitted) {
      return;
    }
    await this.split(true);
    this.dispatchEvent(new CustomEvent("split-lines:re-split", { bubbles: true }));
    this.lastWidth = window.innerWidth;
  }
};
window.customElements.define("split-lines", SplitLines);

// js/custom-element/ui/popover.js
var PopoverContent = class extends OpenableElement {
  connectedCallback() {
    super.connectedCallback();
    this.delegate.on("click", ".popover__overlay", () => this.open = false);
  }
  attributeChangedCallback(name, oldValue, newValue) {
    switch (name) {
      case "open":
        if (oldValue === null && newValue === "") {
          if (this.shouldTrapFocus) {
            setTimeout(() => this.focusTrap.activate(), 150);
          }
          if (this.getAttribute("parent")) {
            const parent = document.getElementById(this.getAttribute("parent"));
            const parent_rect = parent.getBoundingClientRect();
            let rect = this.getBoundingClientRect();
            if (parent_rect.left > rect.left) {
                this.style.left = `calc(50% + ${parent_rect.left - rect.left}px)`;
            } else if (parent_rect.right < rect.right) {
                this.style.left = `calc(50% - ${rect.right - parent_rect.right}px)`;
            }
          }
          if (this.hasAttribute("disappear-delay")) {
            setTimeout(() => this.open = false, this.getAttribute("disappear-delay"));
          }
          triggerEvent(this, "openable-element:open");
        } else if (newValue === null) {
          if (this.shouldTrapFocus) {
            this.focusTrap.deactivate();
          }
          triggerEvent(this, "openable-element:close");
        }
        document.documentElement.classList.toggle("lock-mobile", this.open);
    }
  }
};
window.customElements.define("popover-content", PopoverContent);

// js/custom-element/ui/tabs-nav.js
var TabsNav = class extends HTMLElement {
  connectedCallback() {
    this.buttons = Array.from(this.querySelectorAll("button[aria-controls]"));
    this.scrollerElement = this.querySelector(".tabs-nav__scroller");
    this.buttons.forEach((button) => button.addEventListener("click", () => this.selectButton(button)));
    this.addEventListener("shopify:block:select", (event) => this.selectButton(event.target, !event.detail.load));
    this.positionElement = document.createElement("span");
    this.positionElement.classList.add("tabs-nav__position");
    this.buttons[0].parentElement.insertAdjacentElement("afterend", this.positionElement);
    window.addEventListener("resize", this._onWindowResized.bind(this));
    this._adjustNavigationPosition();
    if (this.hasArrows) {
      this._handleArrows();
    }
  }
  get hasArrows() {
    return this.hasAttribute("arrows");
  }
  get selectedTabIndex() {
    return this.buttons.findIndex((button) => button.getAttribute("aria-expanded") === "true");
  }
  get selectedButton() {
    return this.buttons.find((button) => button.getAttribute("aria-expanded") === "true");
  }
  selectButton(button, animate = true) {
    if (!this.buttons.includes(button) || this.selectedButton === button) {
      return;
    }
    const from = document.getElementById(this.selectedButton.getAttribute("aria-controls")), to = document.getElementById(button.getAttribute("aria-controls"));
    if (animate) {
      this._transitionContent(from, to);
    } else {
      from.hidden = true;
      to.hidden = false;
    }
    this.selectedButton.setAttribute("aria-expanded", "false");
    button.setAttribute("aria-expanded", "true");
    triggerEvent(this, "tabs-nav:changed", { button });
    this._adjustNavigationPosition();
  }
  addButton(button) {
    button.addEventListener("click", () => this.selectButton(button));
    button.setAttribute("aria-expanded", "false");
    this.buttons[this.buttons.length - 1].insertAdjacentElement("afterend", button);
    this.buttons.push(button);
    this._adjustNavigationPosition(false);
  }
  _transitionContent(from, to) {
    from.animate({
      opacity: [1, 0]
    }, {
      duration: 250,
      easing: "ease"
    }).onfinish = () => {
      from.hidden = true;
      to.hidden = false;
      to.animate({
        opacity: [0, 1]
      }, {
        duration: 250,
        easing: "ease"
      });
    };
  }
  _onWindowResized() {
    this._adjustNavigationPosition();
  }
  _adjustNavigationPosition(shouldAnimate = true) {
    const scale = this.selectedButton.clientWidth / this.positionElement.parentElement.clientWidth, translate = this.selectedButton.offsetLeft / this.positionElement.parentElement.clientWidth / scale, windowHalfWidth = this.scrollerElement.clientWidth / 2;
    this.scrollerElement.scrollTo({
      behavior: shouldAnimate ? "smooth" : "auto",
      left: this.selectedButton.offsetLeft - windowHalfWidth + this.selectedButton.clientWidth / 2
    });
    if (!shouldAnimate) {
      this.positionElement.style.transition = "none";
    }
    this.positionElement.style.setProperty("--scale", scale);
    this.positionElement.style.setProperty("--translate", `${translate * 100}%`);
    this.positionElement.clientWidth;
    requestAnimationFrame(() => {
      this.positionElement.classList.add("is-initialized");
      this.positionElement.style.transition = null;
    });
  }
  /**
   * When the tabs nav can have lot of tab items (for instance on product page), the custom element can add
   * extra arrows to make navigation easier
   */
  _handleArrows() {
    const arrowsContainer = this.querySelector(".tabs-nav__arrows");
    arrowsContainer.firstElementChild.addEventListener("click", () => {
      this.selectButton(this.buttons[Math.max(this.selectedTabIndex - 1, 0)]);
    });
    arrowsContainer.lastElementChild.addEventListener("click", () => {
      this.selectButton(this.buttons[Math.min(this.selectedTabIndex + 1, this.buttons.length - 1)]);
    });
  }
};
window.customElements.define("tabs-nav", TabsNav);

// js/helper/library-loader.js
var LibraryLoader = class {
  static load(libraryName) {
    const STATUS_REQUESTED = "requested", STATUS_LOADED = "loaded";
    const library = this.libraries[libraryName];
    if (!library) {
      return;
    }
    if (library.status === STATUS_REQUESTED) {
      return library.promise;
    }
    if (library.status === STATUS_LOADED) {
      return Promise.resolve();
    }
    let promise;
    if (library.type === "script") {
      promise = new Promise((resolve, reject) => {
        let tag = document.createElement("script");
        tag.id = library.tagId;
        tag.src = library.src;
        tag.onerror = reject;
        tag.onload = () => {
          library.status = STATUS_LOADED;
          resolve();
        };
        document.body.appendChild(tag);
      });
    } else {
      promise = new Promise((resolve, reject) => {
        let tag = document.createElement("link");
        tag.id = library.tagId;
        tag.href = library.src;
        tag.rel = "stylesheet";
        tag.type = "text/css";
        tag.onerror = reject;
        tag.onload = () => {
          library.status = STATUS_LOADED;
          resolve();
        };
        document.body.appendChild(tag);
      });
    }
    library.promise = promise;
    library.status = STATUS_REQUESTED;
    return promise;
  }
};
__publicField(LibraryLoader, "libraries", {
  flickity: {
    tagId: "flickity",
    src: window.themeVariables.libs.flickity,
    type: "script"
  },
  photoswipe: {
    tagId: "photoswipe",
    src: window.themeVariables.libs.photoswipe,
    type: "script"
  },
  qrCode: {
    tagId: "qrCode",
    src: window.themeVariables.libs.qrCode,
    type: "script"
  },
  modelViewerUiStyles: {
    tagId: "shopify-model-viewer-ui-styles",
    src: "https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css",
    type: "link"
  }
});

// js/custom-element/ui/qr-code.js
var QrCode = class extends HTMLElement {
  async connectedCallback() {
    await LibraryLoader.load("qrCode");
    new window.QRCode(this, {
      text: this.getAttribute("identifier"),
      width: 200,
      height: 200
    });
  }
};
window.customElements.define("qr-code", QrCode);

// js/custom-element/ui/country-selector.js
var CountrySelector = class extends HTMLSelectElement {
  connectedCallback() {
    this.provinceElement = document.getElementById(this.getAttribute("aria-owns"));
    this.addEventListener("change", this._updateProvinceVisibility.bind(this));
    if (this.hasAttribute("data-default")) {
      for (let i = 0; i !== this.options.length; ++i) {
        if (this.options[i].text === this.getAttribute("data-default")) {
          this.selectedIndex = i;
          break;
        }
      }
    }
    this._updateProvinceVisibility();
    const provinceSelectElement = this.provinceElement.tagName === "SELECT" ? this.provinceElement : this.provinceElement.querySelector("select");
    if (provinceSelectElement.hasAttribute("data-default")) {
      for (let i = 0; i !== provinceSelectElement.options.length; ++i) {
        if (provinceSelectElement.options[i].text === provinceSelectElement.getAttribute("data-default")) {
          provinceSelectElement.selectedIndex = i;
          break;
        }
      }
    }
  }
  _updateProvinceVisibility() {
    const selectedOption = this.options[this.selectedIndex];
    if (!selectedOption) {
      return;
    }
    let provinces = JSON.parse(selectedOption.getAttribute("data-provinces") || "[]"), provinceSelectElement = this.provinceElement.tagName === "SELECT" ? this.provinceElement : this.provinceElement.querySelector("select");
    provinceSelectElement.innerHTML = "";
    if (provinces.length === 0) {
      this.provinceElement.hidden = true;
      return;
    }
    provinces.forEach((data) => {
      provinceSelectElement.options.add(new Option(data[1], data[0]));
    });
    this.provinceElement.hidden = false;
  }
};
window.customElements.define("country-selector", CountrySelector, { extends: "select" });

// js/custom-element/ui/modal.js
var ModalContent = class extends OpenableElement {
  connectedCallback() {
    super.connectedCallback();
    if (this.appearAfterDelay && !(this.onlyOnce && this.hasAppearedOnce)) {
      setTimeout(() => this.open = true, this.apparitionDelay);
    }
    this.delegate.on("click", ".modal__overlay", () => this.open = false);
  }
  get appearAfterDelay() {
    return this.hasAttribute("apparition-delay");
  }
  get apparitionDelay() {
    return parseInt(this.getAttribute("apparition-delay") || 0) * 1e3;
  }
  get onlyOnce() {
    return this.hasAttribute("only-once");
  }
  get hasAppearedOnce() {
    return localStorage.getItem("theme:popup-appeared") !== null;
  }
  attributeChangedCallback(name, oldValue, newValue) {
    super.attributeChangedCallback(name, oldValue, newValue);
    switch (name) {
      case "open":
        document.documentElement.classList.toggle("lock-all", this.open);
        if (this.open) {
          localStorage.setItem("theme:popup-appeared", true);
        }
    }
  }
};
window.customElements.define("modal-content", ModalContent);

var CountryPopup = class extends ModalContent {
  connectedCallback() {
    super.connectedCallback();

    this.discardButton.addEventListener("click", this._discardSuggestion.bind(this));
    this._initCountryPopup();
  }
  get discardButton() {
    return this.querySelector("[discard-button]");
  }
  get availableCountries() {
    const countries = this.querySelector("[available-countries]").innerHTML;
    return JSON.parse(countries);
  }
  get labels() {
    const labels = this.querySelector("[labels]").innerHTML;
    return JSON.parse(labels);
  }
  get shouldTrapFocus() {
    return false;
  }
  _discardSuggestion() {
    this._setCookie("locationValidated", "true", 7);
    this.open = false;
  }
  _localizeLabels(langCode) {
    const labels = this.labels[langCode];
    const heading = this.querySelector(".heading");
    const content = this.querySelector(".country-modal__content");
    const discardButton = this.querySelector("[discard-button]");

    if (heading) {
      heading.innerHTML = labels.heading;
    }
    if (content) {
      content.innerHTML = labels.text;
    }
    if (discardButton) {
      discardButton.innerHTML = labels.discard;
    }
  }
  _capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
  _initCountryPopup() {
    const apiKey = "ekdpqd8nbdxu6os6";
    const url = "https://eu.api.ipregistry.co";
    const cookieName = "locationValidated";
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    if (this._getCookie(cookieName) == "" || this._getCookie(cookieName) == "false") {
      if (urlParams.get("locationValid") != null && urlParams.get("locationValid") == "true") {
        this._setCookie(cookieName, "true", 7);
      } else {
        fetch(`${url}/?key=${apiKey}`)
        .then(response => response.json())
        .then(async (response) =>{
          // Detected User Country by API
          const detectedCountry = response.location.country.name.toLowerCase();
          // const detectedCountry = "netherlands";
          const detectedCountryISOCode = response.location.country.code;
          // const detectedCountryISOCode = "NL";
          
          // Detected User Language
          var userLangCode = "en";
          if (window.navigator.language.slice(0,2) == "de") {
            userLangCode = "de";
          }

          if (Shopify.country == detectedCountryISOCode) {
            // User is in the correct country shop
            this._setCookie(cookieName, "true", 7);
          } else {
            // Check if the user is in a country where we have a shop
            if (Object.keys(this.availableCountries).includes(detectedCountryISOCode)) {
              // User is in a country where we have a shop
              var translatedCountry = detectedCountry;
              if (userLangCode == "de") {
                const response = await fetch(`https://restcountries.com/v3.1/alpha/${detectedCountryISOCode}`);
                const json = await response.json();
                if (json) {
                  translatedCountry = json[0].translations?.deu?.common;
                }
              }
              // const button = this.querySelector('[type="submit"]');
              // button.value = detectedCountryISOCode;
              // button.innerHTML = `${this._capitalizeFirstLetter(translatedCountry)} Shop`;
              this._localizeLabels(userLangCode);
              this._updateLocaleInForm(detectedCountryISOCode, translatedCountry);
              this.open = true;
            } else {
              // User is in a country where we don't have a shop
              // Check if international shop is currently active
              if (window.location.origin.includes("paperandtea.com")) {
                // International shop is active
                this._setCookie(cookieName, "true", 7);
              } else {
                // Redirect to international shop
                this._updateLocaleInForm("US", "International");
                this._localizeLabels(userLangCode);
                this.open = true;
              }
            }
          }
        });
      }
    }
  }
  _updateLocaleInForm(isoCode, countryName) {
    const country = this.availableCountries[isoCode];
    const a = this.querySelector('a[href]');
    a.href = `${country.root_url}${a.getAttribute("request-path")}?country=${country.iso_code}`;
    a.innerHTML = `${this._capitalizeFirstLetter(countryName)} Shop`;
  }
  _setCookie(cookieName, cookieValue, expiringDays) {
    const d = new Date();
    d.setTime(d.getTime() + (expiringDays*24*60*60*1000));
    let expires = "expires="+ d.toUTCString();
    document.cookie = cookieName + "=" + cookieValue + ";" + expires + ";path=/;SameSite=Strict";
  }
  _getCookie(cookieName) {
    let name = cookieName + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
};
window.customElements.define("country-popup", CountryPopup);

// js/custom-element/ui/price-range.js
var PriceRange = class extends HTMLElement {
  connectedCallback() {
    this.rangeLowerBound = this.querySelector(".price-range__range-group input:first-child");
    this.rangeHigherBound = this.querySelector(".price-range__range-group input:last-child");
    this.textInputLowerBound = this.querySelector(".price-range__input:first-child input");
    this.textInputHigherBound = this.querySelector(".price-range__input:last-child input");
    this.textInputLowerBound.addEventListener("focus", () => this.textInputLowerBound.select());
    this.textInputHigherBound.addEventListener("focus", () => this.textInputHigherBound.select());
    this.textInputLowerBound.addEventListener("change", (event) => {
      event.target.value = Math.max(Math.min(parseInt(event.target.value), parseInt(this.textInputHigherBound.value || event.target.max) - 1), event.target.min);
      this.rangeLowerBound.value = event.target.value;
      this.rangeLowerBound.parentElement.style.setProperty("--range-min", `${parseInt(this.rangeLowerBound.value) / parseInt(this.rangeLowerBound.max) * 100}%`);
    });
    this.textInputHigherBound.addEventListener("change", (event) => {
      event.target.value = Math.min(Math.max(parseInt(event.target.value), parseInt(this.textInputLowerBound.value || event.target.min) + 1), event.target.max);
      this.rangeHigherBound.value = event.target.value;
      this.rangeHigherBound.parentElement.style.setProperty("--range-max", `${parseInt(this.rangeHigherBound.value) / parseInt(this.rangeHigherBound.max) * 100}%`);
    });
    this.rangeLowerBound.addEventListener("change", (event) => {
      this.textInputLowerBound.value = event.target.value;
      this.textInputLowerBound.dispatchEvent(new Event("change", { bubbles: true }));
    });
    this.rangeHigherBound.addEventListener("change", (event) => {
      this.textInputHigherBound.value = event.target.value;
      this.textInputHigherBound.dispatchEvent(new Event("change", { bubbles: true }));
    });
    this.rangeLowerBound.addEventListener("input", (event) => {
      triggerEvent(this, "facet:abort-loading");
      event.target.value = Math.min(parseInt(event.target.value), parseInt(this.textInputHigherBound.value || event.target.max) - 1);
      event.target.parentElement.style.setProperty("--range-min", `${parseInt(event.target.value) / parseInt(event.target.max) * 100}%`);
      this.textInputLowerBound.value = event.target.value;
    });
    this.rangeHigherBound.addEventListener("input", (event) => {
      triggerEvent(this, "facet:abort-loading");
      event.target.value = Math.max(parseInt(event.target.value), parseInt(this.textInputLowerBound.value || event.target.min) + 1);
      event.target.parentElement.style.setProperty("--range-max", `${parseInt(event.target.value) / parseInt(event.target.max) * 100}%`);
      this.textInputHigherBound.value = event.target.value;
    });
  }
};
window.customElements.define("price-range", PriceRange);

// js/custom-element/ui/link-bar.js
var LinkBar = class extends HTMLElement {
  connectedCallback() {
    const selectedItem = this.querySelector(".link-bar__link-item--selected");
    if (selectedItem) {
      requestAnimationFrame(() => {
        selectedItem.style.scrollSnapAlign = "none";
      });
    }
  }
};
window.customElements.define("link-bar", LinkBar);

// js/helper/media-features.js
var MediaFeatures = class {
  static prefersReducedMotion() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }
  static supportsHover() {
    return window.matchMedia("(pointer: fine)").matches;
  }
};

// js/custom-element/ui/flickity-carousel.js
var FlickityCarousel = class extends CustomHTMLElement {
  constructor() {
    super();
    if (this.childElementCount === 1) {
      return;
    }
    this.addEventListener("flickity:ready", this._preloadNextImage.bind(this));
    this.addEventListener("flickity:slide-changed", this._preloadNextImage.bind(this));
    this._createFlickity();
  }
  async disconnectedCallback() {
    if (this.flickity) {
      const flickityInstance = await this.flickity;
      flickityInstance.destroy();
    }
  }
  get flickityConfig() {
    return JSON.parse(this.getAttribute("flickity-config"));
  }
  get flickityInstance() {
    return this.flickity;
  }
  async next() {
    (await this.flickityInstance).next();
  }
  async previous() {
    (await this.flickityInstance).previous();
  }
  async select(indexOrSelector) {
    (await this.flickityInstance).selectCell(indexOrSelector);
  }
  async setDraggable(draggable) {
    const flickityInstance = await this.flickity;
    flickityInstance.options.draggable = draggable;
    flickityInstance.updateDraggable();
  }
  async reload() {
    const flickityInstance = await this.flickity;
    flickityInstance.destroy();
    if (this.flickityConfig["cellSelector"]) {
      Array.from(this.children).sort((a, b) => parseInt(a.getAttribute("data-original-position")) > parseInt(b.getAttribute("data-original-position")) ? 1 : -1).forEach((node) => this.appendChild(node));
    }
    this._createFlickity();
  }
  async _createFlickity() {
    this.flickity = new Promise(async (resolve) => {
      await LibraryLoader.load("flickity");
      await this.untilVisible({ rootMargin: "400px", threshold: 0 });
      const flickityInstance = new window.ThemeFlickity(this, { ...this.flickityConfig, ...{
        rightToLeft: window.themeVariables.settings.direction === "rtl",
        accessibility: MediaFeatures.supportsHover(),
        // Flickity cause the carousel to scroll when focused, which is annoying on mobile
        on: {
          ready: (event) => triggerEvent(this, "flickity:ready", event),
          change: (event) => triggerEvent(this, "flickity:slide-changed", event),
          settle: (event) => triggerEvent(this, "flickity:slide-settled", event)
        }
      } });
      resolve(flickityInstance);
    });
    if (this.hasAttribute("click-nav")) {
      const flickityInstance = await this.flickityInstance;
      flickityInstance.on("staticClick", this._onStaticClick.bind(this));
      this.addEventListener("mousemove", this._onMouseMove.bind(this));
    }
  }
  /**
   * If the "click-nav" option is passed, desktop device can switch from one slide to the other
   */
  async _onStaticClick(event, pointer, cellElement) {
    const flickityInstance = await this.flickityInstance, isVideoOrModelType = flickityInstance.selectedElement.hasAttribute("data-media-type") && ["video", "external_video", "model"].includes(flickityInstance.selectedElement.getAttribute("data-media-type"));
    if (!cellElement || isVideoOrModelType || window.matchMedia(window.themeVariables.breakpoints.phone).matches) {
      return;
    }
    const flickityViewport = flickityInstance.viewport, boundingRect = flickityViewport.getBoundingClientRect(), halfEdge = Math.floor(boundingRect.right - boundingRect.width / 2);
    if (pointer.clientX > halfEdge) {
      flickityInstance.next();
    } else {
      flickityInstance.previous();
    }
  }
  /**
   * Add the class "is-hovering-right" or "is-hovering-left" depending on the part we're hovering
   */
  async _onMouseMove(event) {
    const flickityInstance = await this.flickityInstance, isVideoOrModelType = flickityInstance.selectedElement.hasAttribute("data-media-type") && ["video", "external_video", "model"].includes(flickityInstance.selectedElement.getAttribute("data-media-type"));
    this.classList.toggle("is-hovering-right", event.offsetX > this.clientWidth / 2 && !isVideoOrModelType);
    this.classList.toggle("is-hovering-left", event.offsetX <= this.clientWidth / 2 && !isVideoOrModelType);
  }
  /**
   * To give a feeling of faster browsing, we always preload the next image once we settle on a slide
   */
  async _preloadNextImage() {
    const flickityInstance = await this.flickity;
    if (flickityInstance.selectedElement.nextElementSibling) {
      flickityInstance.selectedElement.nextElementSibling.querySelector("img")?.setAttribute("loading", "eager");
    }
  }
};
window.customElements.define("flickity-carousel", FlickityCarousel);

// js/helper/dom.js
function getSiblings(element, filter, includeSelf = false) {
  let siblings = [];
  let currentElement = element;
  while (currentElement = currentElement.previousElementSibling) {
    if (!filter || currentElement.matches(filter)) {
      siblings.push(currentElement);
    }
  }
  if (includeSelf) {
    siblings.push(element);
  }
  currentElement = element;
  while (currentElement = currentElement.nextElementSibling) {
    if (!filter || currentElement.matches(filter)) {
      siblings.push(currentElement);
    }
  }
  return siblings;
}
async function resolveAsyncIterator(target) {
  const processedTarget = [];
  if (!(target != null && typeof target[Symbol.iterator] === "function")) {
    target = [target];
  }
  for (const targetItem of target) {
    if (typeof targetItem[Symbol.asyncIterator] === "function") {
      for await (const awaitTarget of targetItem) {
        processedTarget.push(awaitTarget);
      }
    } else {
      processedTarget.push(targetItem);
    }
  }
  return processedTarget;
}

var OrganicBadge = class extends HTMLElement {
  constructor() {
    super();
    
    this.variantData = JSON.parse(this.querySelector("[organic-info]").innerHTML);
  }
  connectedCallback() {
    document.getElementById(this.getAttribute("form-id"))?.addEventListener("variant:changed", this._onVariantChanged.bind(this));
  }
  _onVariantChanged(event) {
    const inspectionBody = this.querySelector("[legal-organic-inspection-body]");
    inspectionBody.innerHTML = this.variantData[event.detail.newVariant.id].inspection_body;
  }
}
window.customElements.define("organic-badge", OrganicBadge);

var ProductInfoBubble = class extends HTMLElement {
  constructor() {
    super();
    
    this.variantData = JSON.parse(this.querySelector("[data-variant-info]").innerHTML);
    this.bubble = this.querySelector(".product_info__info-bubble");
    this.textElement = this.querySelector(".product_info__info-bubble--text");

    this._init();
  }
  connectedCallback() {
    document.getElementById(this.getAttribute("form-id"))?.addEventListener("variant:changed", this._onVariantChanged.bind(this));
  }
  _init() {
    const currentVariantId = this.getAttribute("default-variant");
    this._updateText(currentVariantId);
    this._updateColor(currentVariantId);
  }
  _onVariantChanged(event) {
    this._updateText(event.detail.newVariant.id);
  }
  _updateColor(variantID) {
    const color = this.variantData[variantID].info_bubble_background;
    if (color != undefined) {
      this.bubble.style.backgroundColor = color;
    } else {
      // Remove inline style
      this.bubble.style.backgroundColor = "";
    }
  }
  _updateText(variantID) {
    const text = this.variantData[variantID].info_bubble;

    if (text != undefined) {
      this.textElement.innerHTML = this._formatText(text, this.variantData[variantID].stock);
      this._toggleVisibility(true);
    } else {
      const text = this.variantData["default"];
      if (text != undefined) {
        this.textElement.innerHTML = this._formatText(text, this.variantData[variantID].stock);
        this._toggleVisibility(true);
      } else {
        this.textElement.innerHTML = "";
        this._toggleVisibility(false);
      }
    }
  }
  _toggleVisibility(visible) {
    if (visible) {
      this.hidden = false;
      document.querySelector(`.product__media[form-id="${this.getAttribute("form-id")}"]`).classList.add("info-bubble--visible");
    } else {
      this.hidden = true;
      document.querySelector(`.product__media[form-id="${this.getAttribute("form-id")}"]`).classList.remove("info-bubble--visible");
    }
  }
  _formatText(text, stock) {
    const text_parts = text.split("§§");
    if (text_parts.length > 1) {
      const stock_replacement = text_parts[1].split("§");
      let delta = 0;
      if (stock_replacement.length > 1) {
        delta = parseInt(stock_replacement[1]);
      }
      text = text_parts[0] + (stock - delta) + text_parts[2];
    }
    const words = text.split("br");
    let formatted_text = "";
    for (let i = 0; i < words.length; i++) {
      const word = words[i].replace("< /", "").replace("/>", "").replace("/ >" ,"").replace("<", "").replace(">", "");
      formatted_text += `<span line-${i + 1}>${word}</span>`;
      if (i + 1 < words.length) {
        formatted_text += "<br/>";
      }
    }
    return formatted_text;
  }
}
window.customElements.define("product-info-bubble", ProductInfoBubble);

const FlavorWheel = class extends CustomHTMLElement {
  constructor() {
    super();

    this.jsonData = JSON.parse(this.querySelector("[json-data]").innerHTML);
    if (typeof this.jsonData !== "object") {
      this.jsonData = JSON.parse(this.jsonData);
    }

    this._updateFlavorWheel();
  }
  _updateFlavorWheel() {
    Object.keys(this.jsonData).forEach((key) => {
      if (this.jsonData[key] > 0) {
        for(let i = 1; i <= this.jsonData[key]; i++) {
          const path = this.querySelector(`[taste="${key}"][value="${i}"]`);
          path.classList.add("fill");
        }
      }
    });
  }
};
window.customElements.define("flavor-wheel", FlavorWheel);

// js/custom-element/ui/flickity-controls.js
var FlickityControls = class extends CustomHTMLElement {
  async connectedCallback() {
    this.flickityCarousel.addEventListener("flickity:ready", this._onSlideChanged.bind(this, false));
    this.flickityCarousel.addEventListener("flickity:slide-changed", this._onSlideChanged.bind(this, true));
    this.delegate.on("click", '[data-action="prev"]', () => this.flickityCarousel.previous());
    this.delegate.on("click", '[data-action="next"]', () => this.flickityCarousel.next());
    this.delegate.on("click", '[data-action="select"]', (event, target) => this.flickityCarousel.select(`#${target.getAttribute("aria-controls")}`));
  }
  get flickityCarousel() {
    return this._flickityCarousel = this._flickityCarousel || document.getElementById(this.getAttribute("controls"));
  }
  async _onSlideChanged(animate = true) {
    let flickityInstance = await this.flickityCarousel.flickityInstance, activeItems = Array.from(this.querySelectorAll(`[aria-controls="${flickityInstance.selectedElement.id}"]`));
    activeItems.forEach((activeItem) => {   
      if (activeItem.dataset.index) {
        const siblings = getSiblings(activeItem, `:not(.is-filtered)`);
        const activeItemIndex = parseInt(activeItem.dataset.index);
        let firstItemIndex = activeItemIndex;
        let lastItemIndex = activeItemIndex;
        for (let i = 0; i < siblings.length; i++) {
          const siblingIndex = parseInt(siblings[i].dataset.index);
          if (siblingIndex < firstItemIndex || firstItemIndex == -1) {
            firstItemIndex = siblingIndex;
          }
          if (siblingIndex > lastItemIndex || lastItemIndex == -1) {
            lastItemIndex = siblingIndex;
          }
        }

        const prevButton = this.querySelector(".product__media-prev-button");
        const nextButton = this.querySelector(".product__media-next-button");
        if (activeItemIndex === firstItemIndex) {
          prevButton.hidden = true;
          nextButton.hidden = false;
        } else if (activeItemIndex === lastItemIndex) {
          prevButton.hidden = false;
          nextButton.hidden = true;
        } else {
          prevButton.hidden = false;
          nextButton.hidden = false;
        }
      }

      activeItem.setAttribute("aria-current", "true");
      getSiblings(activeItem).forEach((sibling) => sibling.removeAttribute("aria-current"));
      requestAnimationFrame(() => {
        if (activeItem.offsetParent && activeItem.offsetParent !== this) {
          const windowHalfHeight = activeItem.offsetParent.clientHeight / 2, windowHalfWidth = activeItem.offsetParent.clientWidth / 2;
          activeItem.offsetParent.scrollTo({
            behavior: animate ? "smooth" : "auto",
            top: activeItem.offsetTop - windowHalfHeight + activeItem.clientHeight / 2,
            left: activeItem.offsetLeft - windowHalfWidth + activeItem.clientWidth / 2
          });
        }
      });
    });
  }
};
window.customElements.define("flickity-controls", FlickityControls);

// js/custom-element/ui/external-video.js
var ExternalVideo = class extends CustomHTMLElement {
  /**
   * This must be done in the constructor and not connectedCallback because the element will be re-added
   * at run-time by Flickity
   */
  constructor() {
    super();
    this.hasLoaded = false;
    (async () => {
      if (this.autoPlay) {
        await this.untilVisible({ rootMargin: "300px", threshold: 0 });
        this.play();
      } else {
        this.addEventListener("click", this.play.bind(this), { once: true });
      }
    })();
  }
  get autoPlay() {
    return this.hasAttribute("autoplay");
  }
  get provider() {
    return this.getAttribute("provider");
  }
  async play() {
    if (!this.hasLoaded) {
      await this._setupPlayer();
    }
    if (this.provider === "youtube") {
      setTimeout(() => {
        this.querySelector("iframe").contentWindow.postMessage(JSON.stringify({ event: "command", func: "playVideo", args: "" }), "*");
      }, 150);
    } else if (this.provider === "vimeo") {
      this.querySelector("iframe").contentWindow.postMessage(JSON.stringify({ method: "play" }), "*");
    }
  }
  pause() {
    if (!this.hasLoaded) {
      return;
    }
    if (this.provider === "youtube") {
      this.querySelector("iframe").contentWindow.postMessage(JSON.stringify({ event: "command", func: "pauseVideo", args: "" }), "*");
    } else if (this.provider === "vimeo") {
      this.querySelector("iframe").contentWindow.postMessage(JSON.stringify({ method: "pause" }), "*");
    }
  }
  _setupPlayer() {
    if (this._setupPromise) {
      return this._setupPromise;
    }
    return this._setupPromise = new Promise((resolve) => {
      const template2 = this.querySelector("template"), node = template2.content.firstElementChild.cloneNode(true);
      node.onload = () => {
        this.hasLoaded = true;
        resolve();
      };
      if (this.autoPlay) {
        template2.replaceWith(node);
      } else {
        this.innerHTML = "";
        this.appendChild(node);
      }
    });
  }
};
window.customElements.define("external-video", ExternalVideo);

// js/helper/product-loader.js
var ProductLoader = class {
  static load(productHandle) {
    if (!productHandle) {
      return;
    }
    if (this.loadedProducts[productHandle]) {
      return this.loadedProducts[productHandle];
    }
    this.loadedProducts[productHandle] = new Promise(async (resolve) => {
      const response = await fetch(`${window.themeVariables.routes.rootUrlWithoutSlash}/products/${productHandle}.js`);
      if (!response.ok) {
        resolve();
        return;
      }
      const responseAsJson = await response.json();
      resolve(responseAsJson);
    });
    return this.loadedProducts[productHandle];
  }
};
__publicField(ProductLoader, "loadedProducts", {});

// js/custom-element/ui/model-media.js
var ModelMedia = class extends HTMLElement {
  /**
   * This must be done in the constructor and not connectedCallback because the element will be re-added
   * at run-time by Flickity
   */
  constructor() {
    super();
    LibraryLoader.load("modelViewerUiStyles");
    window.Shopify.loadFeatures([
      {
        name: "shopify-xr",
        version: "1.0",
        onLoad: this._setupShopifyXr.bind(this)
      },
      {
        name: "model-viewer-ui",
        version: "1.0",
        onLoad: () => {
          this.modelUi = new window.Shopify.ModelViewerUI(this.firstElementChild, { focusOnPlay: false });
          const modelViewer = this.querySelector("model-viewer");
          modelViewer.addEventListener("shopify_model_viewer_ui_toggle_play", () => {
            modelViewer.dispatchEvent(new CustomEvent("model:played", { bubbles: true }));
          });
          modelViewer.addEventListener("shopify_model_viewer_ui_toggle_pause", () => {
            modelViewer.dispatchEvent(new CustomEvent("model:paused", { bubbles: true }));
          });
        }
      }
    ]);
  }
  disconnectedCallback() {
    this.modelUi?.destroy();
  }
  play() {
    if (this.modelUi) {
      this.modelUi.play();
    }
  }
  pause() {
    if (this.modelUi) {
      this.modelUi.pause();
    }
  }
  async _setupShopifyXr() {
    if (!window.ShopifyXR) {
      document.addEventListener("shopify_xr_initialized", this._setupShopifyXr.bind(this));
    } else {
      const product = await ProductLoader.load(this.getAttribute("product-handle"));
      const models = product["media"].filter((media) => media["media_type"] === "model");
      window.ShopifyXR.addModels(models);
      window.ShopifyXR.setupXRElements();
    }
  }
};
window.customElements.define("model-media", ModelMedia);

// js/custom-element/ui/native-video.js
var NativeVideo = class extends HTMLElement {
  /**
   * This must be done in the constructor and not connectedCallback because the element will be re-added
   * at run-time by Flickity
   */
  constructor() {
    super();
    this.hasLoaded = false;
    this.windowSizeHandler = this._handleWindowSize.bind(this);
    if (this.autoPlayLazy) {
      this._handleWindowSize();
    } else {
      if (this.autoPlay) {
        this.play();
      } else {
        this.addEventListener("click", this.play.bind(this), { once: true });
      }
    }
  }
  get maxWidth() {
    return this.getAttribute("max-width") ? parseInt(this.getAttribute("max-width")) : -1;
  }
  get minWidth() {
    return this.getAttribute("min-width") ? parseInt(this.getAttribute("min-width")) : -1;
  }
  get autoPlay() {
    return this.hasAttribute("autoplay");
  }
  get autoPlayLazy() {
    return this.hasAttribute("autoplaylazy");
  }
  play() {
    if (!this.hasLoaded) {
      this._replaceContent();
    }
    this.querySelector("video").play();
  }
  pause() {
    if (this.hasLoaded) {
      this.querySelector("video").pause();
    }
  }
  _handleWindowSize() {
    if (this.maxWidth < 0 || window.innerWidth < this.maxWidth) {
      if (this.minWidth < 0 || window.innerWidth > this.minWidth) {
        this._loadVideo();
        window.removeEventListener("resize", this.windowSizeHandler);
      } else {
        window.addEventListener("resize", this.windowSizeHandler);
      }
    } else {
      window.addEventListener("resize", this.windowSizeHandler);
    }
  }
  _loadVideo() {
    if (!this.hasLoaded) {
      this._replaceContent();
    }

    const poster = this.querySelector(".video-wrapper__poster");
    const video = this.querySelector("video");
    this.querySelector("video").addEventListener("loadeddata", () => {
      poster.hidden = true;
    });
    this.querySelectorAll("video source").forEach(source => {
      source.src = source.getAttribute("data-src");
    });
    
    // Läd das Video neu, nachdem die Quellen gesetzt wurden
    video.load();

  }
  _replaceContent() {
    let node = this.querySelector("template");
    if (!node) {
      return;
    }
    node = node.content.firstElementChild.cloneNode(true);
    if (!this.hasAttribute("autoplay")) {
      this.innerHTML = "";
    }
    this.appendChild(node);
    this.firstElementChild.addEventListener("play", () => {
      this.dispatchEvent(new CustomEvent("video:played", { bubbles: true }));
    });
    this.firstElementChild.addEventListener("pause", () => {
      this.dispatchEvent(new CustomEvent("video:paused", { bubbles: true }));
    });
    this.hasLoaded = true;
  }
};
window.customElements.define("native-video", NativeVideo);

// js/custom-element/ui/combo-box.js
var ComboBox = class extends OpenableElement {
  connectedCallback() {
    super.connectedCallback();
    this.options = Array.from(this.querySelectorAll('[role="option"]'));
    this.delegate.on("click", '[role="option"]', this._onValueClicked.bind(this));
    this.delegate.on("keydown", '[role="listbox"]', this._onKeyDown.bind(this));
    this.delegate.on("change", "select", this._onValueChanged.bind(this));
    this.delegate.on("click", ".combo-box__overlay", () => this.open = false);
    if (this.hasAttribute("fit-toggle")) {
      const maxWidth = Math.max(...this.options.map((item) => item.clientWidth)), control = document.querySelector(`[aria-controls="${this.id}"]`);
      if (control) {
        control.style.setProperty("--largest-option-width", `${maxWidth + 2}px`);
      }
    }
  }
  get nativeSelect() {
    return this.querySelector("select");
  }
  set selectedValue(value) {
    this.options.forEach((option) => {
      option.setAttribute("aria-selected", option.getAttribute("value") === value ? "true" : "false");
    });
  }
  attributeChangedCallback(name, oldValue, newValue) {
    super.attributeChangedCallback(name, oldValue, newValue);
    switch (name) {
      case "open":
        if (this.open) {
          const boundingRect = this.getBoundingClientRect();
          this.classList.toggle("combo-box--top", boundingRect.top >= window.innerHeight / 2 * 1.5);
          setTimeout(() => this.focusTrap.activate(), 150);
        } else {
          this.focusTrap.deactivate();
          setTimeout(() => this.classList.remove("combo-box--top"), 200);
        }
        document.documentElement.classList.toggle("lock-mobile", this.open);
    }
  }
  // Called when the option of the custom select is clicked
  _onValueClicked(event, target) {
    this.selectedValue = target.value;
    this.nativeSelect.value = target.value;
    this.nativeSelect.dispatchEvent(new Event("change", { bubbles: true }));
    this.open = false;
  }
  // Called when the option of the underlying native select is changed (for instance by external code)
  _onValueChanged(event, target) {
    Array.from(this.nativeSelect.options).forEach((option) => option.toggleAttribute("selected", target.value === option.value));
    this.selectedValue = target.value;
  }
  // Improves accessibility with arrow up/down
  _onKeyDown(event) {
    if (event.key === "ArrowDown" || event.key === "ArrowUp") {
      event.preventDefault();
      if (event.key === "ArrowDown") {
        document.activeElement.nextElementSibling?.focus();
      } else {
        document.activeElement.previousElementSibling?.focus();
      }
    }
  }
};
window.customElements.define("combo-box", ComboBox);

var QuantitySelector = class extends HTMLElement {
  constructor() {
    super();

    this._onQuantitySelectorButtonClicked = this._onQuantitySelectorButtonClicked.bind(this);
  }
  connectedCallback() {
    document.addEventListener("quantity-selector:button:clicked", this._onQuantitySelectorButtonClicked.bind(this));
  }
  disconnectedCallback() {
    document.removeEventListener("quantity-selector:button:clicked", this._onQuantitySelectorButtonClicked.bind(this));
  }
  _onQuantitySelectorButtonClicked(event) {
    this.querySelector("input").value = event.detail.value;
    this.querySelector(".product_quantity_selector__value").innerHTML = event.detail.value;
  }

}
window.customElements.define("quantity-selector", QuantitySelector);

var QuantitySelectorButton = class extends HTMLElement {
  constructor() {
    super();

    this.buttonClickHandler = this._onButtonClick.bind(this);
    this.form = document.getElementById(this.getAttribute("form-id"));
    this.shippingConfig = document.querySelector(".product_info__shipping [config]");
    this.shippingData = null;
    if (this.shippingConfig) {
      this.shippingData = JSON.parse(this.shippingConfig.innerHTML);
    }

    this.onVariantChangeHandler = this._onVariantChanged.bind(this);
  }
  connectedCallback() {
    this.addEventListener("click", this.buttonClickHandler);
    if (this.form && this.shippingConfig) {
      this.form.addEventListener("variant:changed", this.onVariantChangeHandler);
    }
  }
  disconnectedCallback() {
    this.removeEventListener("click", this.buttonClickHandler);
  }
  get value() {
    return parseInt(this.getAttribute("value"));
  }
  get popover_id() {
    return this.getAttribute("aria-controls");
  }
  _onVariantChanged(event) {
    const variant = event.detail.newVariant;
    const variantShippingInfo = this.shippingData.variants[variant.id];
    if (!variant || !variantShippingInfo) {
      this.hidden = false;
      return;
    }

    if (variant.inventory_management) {
      if (variantShippingInfo.inventory_quantity >= this.value) {
        this.hidden = false;
      } else {
        this.hidden = true;
      }
    } else {
      this.hidden = false;
    }
  }
  _onButtonClick() {
    document.dispatchEvent(new CustomEvent("quantity-selector:button:clicked", {
      bubbles: true,
      detail: {
        value: this.value
      }
    }));

    const popover = document.querySelector(`#${this.popover_id}`);
    if (popover) {
      popover.querySelectorAll("quantity-selector-button").forEach(button => {
        button.removeAttribute("aria-current");
      });
      popover.removeAttribute("open");
    }

    this.setAttribute("aria-current", "true");
  }
}
window.customElements.define("quantity-selector-button", QuantitySelectorButton);

// // js/custom-element/ui/quantity-selector.js
// var QuantitySelector = class extends CustomHTMLElement {
//   connectedCallback() {
//     this.inputElement = this.querySelector("input");
//     this.delegate.on("click", "button:first-child", () => this.inputElement.quantity = this.inputElement.quantity - 1);
//     this.delegate.on("click", "button:last-child", () => this.inputElement.quantity = this.inputElement.quantity + 1);
//   }
// };
// window.customElements.define("quantity-selector", QuantitySelector);

// js/custom-element/ui/input-number.js
var InputNumber = class extends HTMLInputElement {
  connectedCallback() {
    this.addEventListener("input", this._onValueInput.bind(this));
    this.addEventListener("change", this._onValueChanged.bind(this));
    this.addEventListener("keydown", this._onKeyDown.bind(this));
  }
  get quantity() {
    return parseInt(this.value);
  }
  set quantity(quantity) {
    const isNumeric = (typeof quantity === "number" || typeof quantity === "string" && quantity.trim() !== "") && !isNaN(quantity);
    if (quantity === "") {
      return;
    }
    if (!isNumeric || quantity < 0) {
      quantity = parseInt(quantity) || 1;
    }
    this.value = Math.max(this.min || 1, Math.min(quantity, this.max || Number.MAX_VALUE)).toString();
    this.size = Math.max(this.value.length + 1, 2);
  }
  _onValueInput() {
    this.quantity = this.value;
  }
  _onValueChanged() {
    if (this.value === "") {
      this.quantity = 1;
    }
  }
  _onKeyDown(event) {
    event.stopPropagation();
    if (event.key === "ArrowUp") {
      this.quantity = this.quantity + 1;
    } else if (event.key === "ArrowDown") {
      this.quantity = this.quantity - 1;
    }
  }
};
window.customElements.define("input-number", InputNumber, { extends: "input" });

// js/custom-element/section/announcement-bar/announcement-bar.js
var AnnouncementBar = class extends CustomHTMLElement {
  async connectedCallback() {
    await customElements.whenDefined("announcement-bar-item");
    this.items = Array.from(this.querySelectorAll("announcement-bar-item"));
    this.hasPendingTransition = false;
    this.delegate.on("click", '[data-action="prev"]', this.previous.bind(this));
    this.delegate.on("click", '[data-action="next"]', this.next.bind(this));
    if (this.autoPlay) {
      this.delegate.on("announcement-bar:content:open", this._pausePlayer.bind(this));
      this.delegate.on("announcement-bar:content:close", this._startPlayer.bind(this));
    }
    if (window.ResizeObserver) {
      this.resizeObserver = new ResizeObserver(this._updateCustomProperties.bind(this));
      this.resizeObserver.observe(this);
    }
    if (this.autoPlay) {
      this._startPlayer();
    }
    if (Shopify.designMode) {
      this.delegate.on("shopify:block:select", (event) => this.select(event.target.index, false));
    }
  }
  get autoPlay() {
    return this.hasAttribute("auto-play");
  }
  get selectedIndex() {
    return this.items.findIndex((item) => item.selected);
  }
  previous() {
    this.select((this.selectedIndex - 1 + this.items.length) % this.items.length, true, "up");
  }
  next() {
    this.select((this.selectedIndex + 1 + this.items.length) % this.items.length, true, "down");
  }
  async select(index, animate = true, direction = "down") {
    if (this.selectedIndex === index || this.hasPendingTransition) {
      return;
    }
    if (this.autoPlay) {
      this._pausePlayer();
    }
    this.hasPendingTransition = true;
    await Promise.all([
      this.items[this.selectedIndex].deselect(animate, direction),
      this.items[index].select(animate, direction)
    ]);
    this.hasPendingTransition = false;
    if (this.autoPlay) {
      this._startPlayer();
    }
  }
  _pausePlayer() {
    clearInterval(this._interval);
  }
  _startPlayer() {
    clearInterval(this._interval);
    this._interval = setInterval(this.next.bind(this), parseInt(this.getAttribute("cycle-speed")) * 1e3);
  }
  _updateCustomProperties(entries) {
    entries.forEach((entry) => {
      if (entry.target === this) {
        const height = entry.borderBoxSize ? entry.borderBoxSize.length > 0 ? entry.borderBoxSize[0].blockSize : entry.borderBoxSize.blockSize : entry.target.clientHeight;
        document.documentElement.style.setProperty("--announcement-bar-height", `${height}px`);
      }
    });
  }
};
window.customElements.define("announcement-bar", AnnouncementBar);

// js/custom-element/section/announcement-bar/item.js
var AnnouncementBarItem = class extends CustomHTMLElement {
  connectedCallback() {
    if (this.hasContent) {
      this.contentElement = this.querySelector(".announcement-bar__content");
      this.delegate.on("click", '[data-action="open-content"]', this.openContent.bind(this));
      this.delegate.on("click", '[data-action="close-content"]', this.closeContent.bind(this));
      if (Shopify.designMode) {
        this.addEventListener("shopify:block:select", this.openContent.bind(this));
        this.addEventListener("shopify:block:deselect", this.closeContent.bind(this));
      }
    }
  }
  get index() {
    return [...this.parentNode.children].indexOf(this);
  }
  get hasContent() {
    return this.hasAttribute("has-content");
  }
  get selected() {
    return !this.hasAttribute("hidden");
  }
  get focusTrap() {
    return this._trapFocus = this._trapFocus || createFocusTrap(this.contentElement.querySelector(".announcement-bar__content-inner"), {
      fallbackFocus: this,
      clickOutsideDeactivates: (event) => !(event.target.tagName === "BUTTON"),
      allowOutsideClick: (event) => event.target.tagName === "BUTTON",
      onDeactivate: this.closeContent.bind(this),
      preventScroll: true
    });
  }
  get prefersReducedMotion() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }
  async select(animate = true, direction = "down") {
    this.removeAttribute("hidden");
    const from = direction === "up" ? "translateY(100%)" : "translateY(-100%)";
    await new Promise((resolve) => {
      this.animate({
        transform: [from, "translateY(0)"]
      }, {
        duration: animate && !this.prefersReducedMotion ? 400 : 0,
        easing: "ease-in-out"
      }).onfinish = resolve;
    });
  }
  async deselect(animate = true, direction = "down") {
    await this.closeContent();
    const to = direction === "up" ? "translateY(-100%)" : "translateY(100%)";
    await new Promise((resolve) => {
      this.animate({
        transform: ["translateY(0)", to]
      }, {
        duration: animate && !this.prefersReducedMotion ? 400 : 0,
        easing: "ease-in-out"
      }).onfinish = resolve;
    });
    this.setAttribute("hidden", "");
  }
  async openContent() {
    if (this.hasContent) {
      this.contentElement.addEventListener("transitionend", () => this.focusTrap.activate(), { once: true });
      this.contentElement.removeAttribute("hidden");
      document.documentElement.classList.add("lock-all");
      this.dispatchEvent(new CustomEvent("announcement-bar:content:open", { bubbles: true }));
    }
  }
  async closeContent() {
    if (!this.hasContent || this.contentElement.hasAttribute("hidden")) {
      return Promise.resolve();
    }
    await new Promise((resolve) => {
      this.contentElement.addEventListener("transitionend", () => resolve(), { once: true });
      this.contentElement.setAttribute("hidden", "");
      this.focusTrap.deactivate();
      document.documentElement.classList.remove("lock-all");
      this.dispatchEvent(new CustomEvent("announcement-bar:content:close", { bubbles: true }));
    });
  }
};
window.customElements.define("announcement-bar-item", AnnouncementBarItem);

// js/custom-element/section/search/search-page.js
var SearchPage = class extends HTMLElement {
  connectedCallback() {
    // this.facetToolbar = document.getElementById("mobile-facet-toolbar");
    this.tabsNav = document.getElementById("search-tabs-nav");
    // this.tabsNav.addEventListener("tabs-nav:changed", this._onCategoryChanged.bind(this));
    this._completeSearch();
  }
  get terms() {
    return this.getAttribute("terms");
  }
  get completeFor() {
    return this.getAttribute("complete-for").split(",");
  }
  async _completeSearch() {
    const promisesList = [];
    this.completeFor.forEach((item) => {
      promisesList.push(fetch(`${window.themeVariables.routes.searchUrl}?section_id=${this.getAttribute("section-id")}&q=${this.terms}&type=${item}&options[prefix]=last`));
    });
    const responses = await Promise.all(promisesList);
    await Promise.all(responses.map(async (response) => {
      const div = document.createElement("div");
      div.innerHTML = await response.text();
      const categoryResultDiv = div.querySelector(".main-search__category-result"), tabNavItem = div.querySelector("#search-tabs-nav .tabs-nav__item");
      if (categoryResultDiv && tabNavItem) {
        categoryResultDiv.setAttribute("hidden", "");
        this.insertAdjacentElement("beforeend", categoryResultDiv);
        this.tabsNav.addButton(tabNavItem);
      }
    }));
  }
  // _onCategoryChanged(event) {
  //   debugger;
  //   const button = event.detail.button;
  //   // this.facetToolbar.classList.toggle("is-collapsed", button.getAttribute("data-type") !== "product");
  // }
};
window.customElements.define("search-page", SearchPage);

// js/custom-element/section/footer/cookie-bar.js
var CookieBar = class extends CustomHTMLElement {
  connectedCallback() {
    if (window.Shopify && window.Shopify.designMode) {
      this.rootDelegate.on("shopify:section:select", (event) => filterShopifyEvent(event, this, () => this.open = true));
      this.rootDelegate.on("shopify:section:deselect", (event) => filterShopifyEvent(event, this, () => this.open = false));
    }
    this.delegate.on("click", '[data-action~="accept-policy"]', this._acceptPolicy.bind(this));
    this.delegate.on("click", '[data-action~="decline-policy"]', this._declinePolicy.bind(this));
    window.Shopify.loadFeatures([{
      name: "consent-tracking-api",
      version: "0.1",
      onLoad: this._onCookieBarSetup.bind(this)
    }]);
  }
  set open(value) {
    this.toggleAttribute("hidden", !value);
  }
  _onCookieBarSetup() {
    if (window.Shopify.customerPrivacy.shouldShowGDPRBanner()) {
      this.open = true;
    }
  }
  _acceptPolicy() {
    window.Shopify.customerPrivacy.setTrackingConsent(true, () => this.open = false);
  }
  _declinePolicy() {
    window.Shopify.customerPrivacy.setTrackingConsent(false, () => this.open = false);
  }
};
window.customElements.define("cookie-bar", CookieBar);

// js/custom-element/section/product-recommendations/product-recommendations.js
var ProductRecommendations = class extends HTMLElement {
  async connectedCallback() {
    const response = await fetch(`${window.themeVariables.routes.productRecommendationsUrl}?product_id=${this.productId}&limit=${this.recommendationsCount}&section_id=${this.sectionId}&intent=${this.intent}`);
    const div = document.createElement("div");
    div.innerHTML = await response.text();
    const productRecommendationsElement = div.querySelector("product-recommendations");
    if (productRecommendationsElement != null && productRecommendationsElement.hasChildNodes()) {
      this.innerHTML = productRecommendationsElement.innerHTML;
    }

    // „Ähnlich“ hat eine eigene Sektion. Leere Plätze werden darum nicht mit ähnlichen Produkten aufgefüllt, sondern ausgeblendet.
    if (this.intent == "complementary") {
      this.querySelectorAll(".product-card--empty").forEach((empty_product_card) => {
        empty_product_card.hidden = true;
      });
    }

  }
  get productId() {
    return this.getAttribute("product-id");
  }
  get sectionId() {
    return this.getAttribute("section-id");
  }
  get recommendationsCount() {
    return parseInt(this.getAttribute("recommendations-count") || 4);
  }
  get intent() {
    return this.getAttribute("intent");
  }
};
window.customElements.define("product-recommendations", ProductRecommendations);

// js/custom-element/section/product-recommendations/recently-viewed-products.js
var RecentlyViewedProducts = class extends HTMLElement {
  async connectedCallback() {
    if (this.searchQueryString === "") {
      return;
    }
    const response = await fetch(`${window.themeVariables.routes.searchUrl}?type=product&q=${this.searchQueryString}&section_id=${this.sectionId}`);
    const div = document.createElement("div");
    div.innerHTML = await response.text();
    const recentlyViewedProductsElement = div.querySelector("recently-viewed-products");
    if (recentlyViewedProductsElement.hasChildNodes()) {
      this.innerHTML = recentlyViewedProductsElement.innerHTML;
    }
  }
  get searchQueryString() {
    const items = JSON.parse(localStorage.getItem("theme:recently-viewed-products") || "[]");
    if (this.hasAttribute("exclude-product-id") && items.includes(parseInt(this.getAttribute("exclude-product-id")))) {
      items.splice(items.indexOf(parseInt(this.getAttribute("exclude-product-id"))), 1);
    }
    return items.map((item) => "id:" + item).slice(0, this.productsCount).join(" OR ");
  }
  get sectionId() {
    return this.getAttribute("section-id");
  }
  get productsCount() {
    return this.getAttribute("products-count") || 4;
  }
};
window.customElements.define("recently-viewed-products", RecentlyViewedProducts);

// js/helper/image.js
function getSizedMediaUrl(media, size) {
  let src = typeof media === "string" ? media : media["preview_image"] ? media["preview_image"]["src"] : media["url"];
  if (size === null) {
    return src;
  }
  if (size === "master") {
    return src.replace(/http(s)?:/, "");
  }
  const match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif|webp)(\?v=\d+)?$/i);
  if (match) {
    const prefix = src.split(match[0]);
    const suffix = match[0];
    return (prefix[0] + "_" + size + suffix).replace(/http(s)?:/, "");
  } else {
    return null;
  }
}
function getMediaSrcset(media, sizeList) {
  let srcset = [], supportedSizes = typeof media === "string" ? sizeList : getSupportedSizes(media, sizeList);
  supportedSizes.forEach((supportedSize) => {
    srcset.push(`${getSizedMediaUrl(media, supportedSize + "x")} ${supportedSize}w`);
  });
  return srcset.join(",");
}
function getSupportedSizes(media, desiredSizes) {
  let supportedSizes = [], mediaWidth = media["preview_image"]["width"];
  desiredSizes.forEach((width) => {
    if (mediaWidth >= width) {
      supportedSizes.push(width);
    }
  });
  return supportedSizes;
}
function imageLoaded(image) {
  return new Promise((resolve) => {
    if (!image || image.tagName !== "IMG" || image.complete) {
      resolve();
    } else {
      image.onload = () => resolve();
    }
  });
}

// js/helper/animation.js
var CustomAnimation = class {
  constructor(effect) {
    this._effect = effect;
    this._playState = "idle";
    this._finished = Promise.resolve();
  }
  get finished() {
    return this._finished;
  }
  get animationEffects() {
    return this._effect instanceof CustomKeyframeEffect ? [this._effect] : this._effect.animationEffects;
  }
  cancel() {
    this.animationEffects.forEach((animationEffect) => animationEffect.cancel());
  }
  finish() {
    this.animationEffects.forEach((animationEffect) => animationEffect.finish());
  }
  play() {
    this._playState = "running";
    this._effect.play();
    this._finished = this._effect.finished;
    this._finished.then(() => {
      this._playState = "finished";
    }, (rejection) => {
      this._playState = "idle";
    });
  }
};
var CustomKeyframeEffect = class {
  constructor(target, keyframes, options = {}) {
    if (!target) {
      return;
    }
    if ("Animation" in window) {
      this._animation = new Animation(new KeyframeEffect(target, keyframes, options));
    } else {
      options["fill"] = "forwards";
      this._animation = target.animate(keyframes, options);
      this._animation.pause();
    }
    this._animation.addEventListener("finish", () => {
      target.style.opacity = keyframes.hasOwnProperty("opacity") ? keyframes["opacity"][keyframes["opacity"].length - 1] : null;
      target.style.visibility = keyframes.hasOwnProperty("visibility") ? keyframes["visibility"][keyframes["visibility"].length - 1] : null;
    });
  }
  get finished() {
    if (!this._animation) {
      return Promise.resolve();
    }
    return this._animation.finished ? this._animation.finished : new Promise((resolve) => this._animation.onfinish = resolve);
  }
  play() {
    if (this._animation) {
      this._animation.startTime = null;
      this._animation.play();
    }
  }
  cancel() {
    if (this._animation) {
      this._animation.cancel();
    }
  }
  finish() {
    if (this._animation) {
      this._animation.finish();
    }
  }
};
var GroupEffect = class {
  constructor(childrenEffects) {
    this._childrenEffects = childrenEffects;
    this._finished = Promise.resolve();
  }
  get finished() {
    return this._finished;
  }
  get animationEffects() {
    return this._childrenEffects.flatMap((effect) => {
      return effect instanceof CustomKeyframeEffect ? effect : effect.animationEffects;
    });
  }
};
var ParallelEffect = class extends GroupEffect {
  play() {
    const promises = [];
    for (const effect of this._childrenEffects) {
      effect.play();
      promises.push(effect.finished);
    }
    this._finished = Promise.all(promises);
  }
};
var SequenceEffect = class extends GroupEffect {
  play() {
    this._finished = new Promise(async (resolve, reject) => {
      try {
        for (const effect of this._childrenEffects) {
          effect.play();
          await effect.finished;
        }
        resolve();
      } catch (exception) {
        reject();
      }
    });
  }
};

// js/custom-element/section/slideshow/slideshow-item.js
var SlideshowItem = class extends HTMLElement {
  async connectedCallback() {
    this._pendingAnimations = [];
    this.addEventListener("split-lines:re-split", (event) => {
      Array.from(event.target.children).forEach((line) => line.style.visibility = this.selected ? "visible" : "hidden");
    });
    if (MediaFeatures.prefersReducedMotion()) {
      this.setAttribute("reveal-visibility", "");
      Array.from(this.querySelectorAll("[reveal], [reveal-visibility]")).forEach((item) => {
        item.removeAttribute("reveal");
        item.removeAttribute("reveal-visibility");
      });
    }
  }
  get index() {
    // console.log("item get index", this.parentNode, this.parentNode.children);
    return [...this.parentNode.children].indexOf(this);
  }
  get selected() {
    return !this.hasAttribute("hidden");
  }
  async transitionToLeave(transitionType, shouldAnimate = true) {
    if (transitionType !== "reveal") {
      this.setAttribute("hidden", "");
    }
    this._pendingAnimations.forEach((animation2) => animation2.cancel());
    this._pendingAnimations = [];
    let animation = null, textElements = await resolveAsyncIterator(this.querySelectorAll("split-lines, .button-group, .button-wrapper")), imageElements = Array.from(this.querySelectorAll(".slideshow__image-wrapper"));
    switch (transitionType) {
      case "sweep":
        animation = new CustomAnimation(new SequenceEffect([
          new CustomKeyframeEffect(this, { visibility: ["visible", "hidden"] }, { duration: 500 }),
          new ParallelEffect(textElements.map((item) => {
            return new CustomKeyframeEffect(item, { opacity: [1, 0], visibility: ["visible", "hidden"] });
          }))
        ]));
        break;
      case "fade":
        animation = new CustomAnimation(new CustomKeyframeEffect(this, { opacity: [1, 0], visibility: ["visible", "hidden"] }, { duration: 250, easing: "ease-in-out" }));
        break;
      case "reveal":
        animation = new CustomAnimation(new SequenceEffect([
          new ParallelEffect(textElements.reverse().map((item) => {
            return new CustomKeyframeEffect(item, { opacity: [1, 0], visibility: ["visible", "hidden"] }, { duration: 250, easing: "ease-in-out" });
          })),
          new ParallelEffect(imageElements.map((item) => {
            if (!item.classList.contains("slideshow__image-wrapper--secondary")) {
              return new CustomKeyframeEffect(item, { visibility: ["visible", "hidden"], clipPath: ["inset(0 0 0 0)", "inset(0 0 100% 0)"] }, { duration: 450, easing: "cubic-bezier(0.99, 0.01, 0.50, 0.94)" });
            } else {
              return new CustomKeyframeEffect(item, { visibility: ["visible", "hidden"], clipPath: ["inset(0 0 0 0)", "inset(100% 0 0 0)"] }, { duration: 450, easing: "cubic-bezier(0.99, 0.01, 0.50, 0.94)" });
            }
          }))
        ]));
        break;
    }
    await this._executeAnimation(animation, shouldAnimate);
    if (transitionType === "reveal") {
      this.setAttribute("hidden", "");
    }
  }
  async transitionToEnter(transitionType, shouldAnimate = true, reverseDirection = false) {
    this.removeAttribute("hidden");
    // The re-split handler hides lines of inactive slides; "fade" and "none" don't animate the lines back in, so reset them here
    if (transitionType !== "sweep" && transitionType !== "reveal") {
      this.querySelectorAll("split-lines > span").forEach((line) => line.style.visibility = "");
    }
    await this._untilReady();
    let animation = null, textElements = await resolveAsyncIterator(this.querySelectorAll("split-lines, .button-group, .button-wrapper")), imageElements = Array.from(this.querySelectorAll(".slideshow__image-wrapper"));
    switch (transitionType) {
      case "sweep":
        animation = new CustomAnimation(new SequenceEffect([
          new CustomKeyframeEffect(this, { visibility: ["hidden", "visible"], clipPath: reverseDirection ? ["inset(0 100% 0 0)", "inset(0 0 0 0)"] : ["inset(0 0 0 100%)", "inset(0 0 0 0)"] }, { duration: 500, easing: "cubic-bezier(1, 0, 0, 1)" }),
          new ParallelEffect(textElements.map((item, index) => {
            return new CustomKeyframeEffect(item, { opacity: [0, 1], visibility: ["hidden", "visible"], clipPath: ["inset(0 0 100% 0)", "inset(0 0 0 0)"], transform: ["translateY(100%)", "translateY(0)"] }, { duration: 450, delay: 100 * index, easing: "cubic-bezier(0.5, 0.06, 0.01, 0.99)" });
          }))
        ]));
        break;
      case "fade":
        animation = new CustomAnimation(new CustomKeyframeEffect(this, { opacity: [0, 1], visibility: ["hidden", "visible"] }, { duration: 250, easing: "ease-in-out" }));
        break;
      case "reveal":
        animation = new CustomAnimation(new SequenceEffect([
          new ParallelEffect(imageElements.map((item) => {
            if (!item.classList.contains("slideshow__image-wrapper--secondary")) {
              return new CustomKeyframeEffect(item, { visibility: ["hidden", "visible"], clipPath: ["inset(0 0 100% 0)", "inset(0 0 0 0)"] }, { duration: 450, delay: 100, easing: "cubic-bezier(0.5, 0.06, 0.01, 0.99)" });
            } else {
              return new CustomKeyframeEffect(item, { visibility: ["hidden", "visible"], clipPath: ["inset(100% 0 0 0)", "inset(0 0 0 0)"] }, { duration: 450, delay: 100, easing: "cubic-bezier(0.5, 0.06, 0.01, 0.99)" });
            }
          })),
          new ParallelEffect(textElements.map((item, index) => {
            return new CustomKeyframeEffect(item, { opacity: [0, 1], visibility: ["hidden", "visible"], clipPath: ["inset(0 0 100% 0)", "inset(0 0 0 0)"], transform: ["translateY(100%)", "translateY(0)"] }, { duration: 450, delay: 100 * index, easing: "cubic-bezier(0.5, 0.06, 0.01, 0.99)" });
          }))
        ]));
        break;
    }
    return this._executeAnimation(animation, shouldAnimate);
  }
  async _executeAnimation(animation, shouldAnimate) {
    if (!animation) {
      return;
    }
    this._pendingAnimations.push(animation);
    shouldAnimate ? animation.play() : animation.finish();
    return animation.finished;
  }
  async _untilReady() {
    return Promise.all(this._getVisibleImages().map((image) => imageLoaded(image)));
  }
  _preloadImages() {
    this._getVisibleImages().forEach((image) => {
      image.setAttribute("loading", "eager");
    });
  }
  _getVisibleImages() {
    return Array.from(this.querySelectorAll("img")).filter((image) => {
      return getComputedStyle(image.parentElement).display !== "none";
    });
  }
};
window.customElements.define("slide-show-item", SlideshowItem);

// js/mixin/vertical-scroll-blocker.js
var VerticalScrollBlockerMixin = {
  _blockVerticalScroll(threshold = 18) {
    this.addEventListener("touchstart", (event) => {
      this.firstTouchClientX = event.touches[0].clientX;
    });
    this.addEventListener("touchmove", (event) => {
      const touchClientX = event.touches[0].clientX - this.firstTouchClientX;
      if (Math.abs(touchClientX) > threshold) {
        event.preventDefault();
      }
    }, { passive: false });
  }
};

// js/custom-element/section/slideshow/slideshow.js
var Slideshow = class extends CustomHTMLElement {
  connectedCallback() {
    this.items = Array.from(this.querySelectorAll("slide-show-item"));
    this.pageDots = this.querySelector("page-dots");
    this.isTransitioning = false;
    if (this.items.length > 1) {
      if (Shopify.designMode) {
        this.addEventListener("shopify:block:deselect", this.startPlayer.bind(this));
        this.addEventListener("shopify:block:select", (event) => {
          this.pausePlayer();
          this.intersectionObserver.disconnect();
          if (!(!event.detail.load && event.target.selected)) {
            this.select(event.target.index, !event.detail.load);
          }
        });
      }
      this.addEventListener("swiperight", this.previous.bind(this));
      this.addEventListener("swipeleft", this.next.bind(this));
      this.addEventListener("page-dots:changed", (event) => this.select(event.detail.index));
      this._blockVerticalScroll();
    }
    this._setupVisibility();
  }
  get selectedIndex() {
    return this.items.findIndex((item) => item.selected);
  }
  get transitionType() {
    return MediaFeatures.prefersReducedMotion() ? "fade" : this.getAttribute("transition-type");
  }
  async _setupVisibility() {
    // console.log("Slideshow _setupVisibility", this.items);
    await this.untilVisible();
    await this.items[this.selectedIndex].transitionToEnter(this.transitionType).catch((error) => {
    });
    this.startPlayer();
  }
  previous() {
    this.select((this.selectedIndex - 1 + this.items.length) % this.items.length, true, true);
  }
  next() {
    this.select((this.selectedIndex + 1 + this.items.length) % this.items.length, true, false);
  }
  async select(index, shouldTransition = true, reverseDirection = false) {
    // console.log("select", index, shouldTransition, reverseDirection);
    if (this.transitionType === "reveal" && this.isTransitioning) {
      return;
    }
    this.isTransitioning = true;
    const previousItem = this.items[this.selectedIndex], newItem = this.items[index];
    this.items[(newItem.index + 1) % this.items.length]._preloadImages();
    if (previousItem && previousItem !== newItem) {
      if (this.transitionType !== "reveal") {
        previousItem.transitionToLeave(this.transitionType, shouldTransition);
      } else {
        await previousItem.transitionToLeave(this.transitionType, shouldTransition);
      }
    }
    // console.log(this.pageDots);
    if (this.pageDots) {
      // console.log("newItem.index", newItem.index);
      this.pageDots.selectedIndex = newItem.index;
    }
    await newItem.transitionToEnter(this.transitionType, shouldTransition, reverseDirection).catch((error) => {
    });
    this.isTransitioning = false;
  }
  pausePlayer() {
    this.style.setProperty("--section-animation-play-state", "paused");
  }
  startPlayer() {
    if (this.hasAttribute("auto-play")) {
      this.style.setProperty("--section-animation-play-state", "running");
    }
  }
};
Object.assign(Slideshow.prototype, VerticalScrollBlockerMixin);
window.customElements.define("slide-show", Slideshow);

// js/custom-element/section/image-with-text/image-with-text-item.js
var ImageWithTextItem = class extends HTMLElement {
  get index() {
    return [...this.parentNode.children].indexOf(this);
  }
  get selected() {
    return !this.hasAttribute("hidden");
  }
  get hasAttachedImage() {
    return this.hasAttribute("attached-image");
  }
  async transitionToEnter(shouldAnimate = true) {
    this.removeAttribute("hidden");
    const textWrapper = this.querySelector(".image-with-text__text-wrapper"), headings = await resolveAsyncIterator(this.querySelectorAll(".image-with-text__content split-lines"));
    const animation = new CustomAnimation(new SequenceEffect([
      new ParallelEffect(headings.map((item, index) => {
        return new CustomKeyframeEffect(item, {
          opacity: [0, 0.2, 1],
          transform: ["translateY(100%)", "translateY(0)"],
          clipPath: ["inset(0 0 100% 0)", "inset(0 0 0 0)"]
        }, {
          duration: 350,
          delay: 120 * index,
          easing: "cubic-bezier(0.5, 0.06, 0.01, 0.99)"
        });
      })),
      new CustomKeyframeEffect(textWrapper, { opacity: [0, 1] }, { duration: 300 })
    ]));
    shouldAnimate ? animation.play() : animation.finish();
    return animation.finished;
  }
  async transitionToLeave(shouldAnimate = true) {
    const elements = await resolveAsyncIterator(this.querySelectorAll(".image-with-text__text-wrapper, .image-with-text__content split-lines"));
    const animation = new CustomAnimation(new ParallelEffect(elements.map((item) => {
      return new CustomKeyframeEffect(item, { opacity: [1, 0] }, { duration: 200 });
    })));
    shouldAnimate ? animation.play() : animation.finish();
    await animation.finished;
    this.setAttribute("hidden", "");
  }
};
window.customElements.define("image-with-text-item", ImageWithTextItem);

// js/custom-element/section/image-with-text/image-with-text.js
var ImageWithText = class extends CustomHTMLElement {
  connectedCallback() {
    this.items = Array.from(this.querySelectorAll("image-with-text-item"));
    this.imageItems = Array.from(this.querySelectorAll(".image-with-text__image"));
    this.pageDots = this.querySelector("page-dots");
    this.hasPendingTransition = false;
    if (this.items.length > 1) {
      this.addEventListener("page-dots:changed", (event) => this.select(event.detail.index));
      if (Shopify.designMode) {
        this.addEventListener("shopify:block:deselect", this.startPlayer.bind(this));
        this.addEventListener("shopify:block:select", (event) => {
          this.intersectionObserver.disconnect();
          this.pausePlayer();
          this.select(event.target.index, !event.detail.load);
        });
      }
    }
    this._setupVisibility();
  }
  async _setupVisibility() {
    await this.untilVisible();
    if (this.hasAttribute("reveal-on-scroll")) {
      await this.transitionImage(this.selectedIndex);
      this.select(this.selectedIndex);
    }
    this.startPlayer();
  }
  get selectedIndex() {
    return this.items.findIndex((item) => item.selected);
  }
  async select(index, shouldAnimate = true) {
    if (this.hasPendingTransition) {
      return;
    }
    this.hasPendingTransition = true;
    if (this.items[index].hasAttachedImage || !shouldAnimate) {
      await this.transitionImage(index, shouldAnimate);
    }
    if (this.selectedIndex !== index) {
      await this.items[this.selectedIndex].transitionToLeave(shouldAnimate);
    }
    if (this.pageDots) {
      this.pageDots.selectedIndex = index;
    }
    await this.items[index].transitionToEnter(shouldAnimate);
    this.hasPendingTransition = false;
  }
  async transitionImage(index, shouldAnimate = true) {
    const activeImage = this.imageItems.find((item) => !item.hasAttribute("hidden")), nextImage = this.imageItems.find((item) => item.id === this.items[index].getAttribute("attached-image")) || activeImage;
    activeImage.setAttribute("hidden", "");
    nextImage.removeAttribute("hidden");
    await imageLoaded(nextImage);
    const animation = new CustomAnimation(new CustomKeyframeEffect(nextImage, {
      visibility: ["hidden", "visible"],
      clipPath: ["inset(0 0 0 100%)", "inset(0 0 0 0)"]
    }, {
      duration: 600,
      easing: "cubic-bezier(1, 0, 0, 1)"
    }));
    shouldAnimate ? animation.play() : animation.finish();
  }
  pausePlayer() {
    this.style.setProperty("--section-animation-play-state", "paused");
  }
  startPlayer() {
    this.style.setProperty("--section-animation-play-state", "running");
  }
};
window.customElements.define("image-with-text", ImageWithText);

// js/custom-element/section/testimonials/testimonial-item.js
var TestimonialItem = class extends CustomHTMLElement {
  connectedCallback() {
    this.addEventListener("split-lines:re-split", (event) => {
      Array.from(event.target.children).forEach((line) => line.style.visibility = this.selected ? "visible" : "hidden");
    });
  }
  get index() {
    return [...this.parentNode.children].indexOf(this);
  }
  get selected() {
    return !this.hasAttribute("hidden");
  }
  async transitionToLeave(shouldAnimate = true) {
    const textLines = await resolveAsyncIterator(this.querySelectorAll("split-lines, .testimonial__author")), animation = new CustomAnimation(new ParallelEffect(textLines.reverse().map((item, index) => {
      return new CustomKeyframeEffect(item, {
        visibility: ["visible", "hidden"],
        clipPath: ["inset(0 0 0 0)", "inset(0 0 100% 0)"],
        transform: ["translateY(0)", "translateY(100%)"]
      }, {
        duration: 350,
        delay: 60 * index,
        easing: "cubic-bezier(0.68, 0.00, 0.77, 0.00)"
      });
    })));
    shouldAnimate ? animation.play() : animation.finish();
    await animation.finished;
    this.setAttribute("hidden", "");
  }
  async transitionToEnter(shouldAnimate = true) {
    const textLines = await resolveAsyncIterator(this.querySelectorAll("split-lines, .testimonial__author")), animation = new CustomAnimation(new ParallelEffect(textLines.map((item, index) => {
      return new CustomKeyframeEffect(item, {
        visibility: ["hidden", "visible"],
        clipPath: ["inset(0 0 100% 0)", "inset(0 0 0px 0)"],
        transform: ["translateY(100%)", "translateY(0)"]
      }, {
        duration: 550,
        delay: 120 * index,
        easing: "cubic-bezier(0.23, 1, 0.32, 1)"
      });
    })));
    this.removeAttribute("hidden");
    shouldAnimate ? animation.play() : animation.finish();
    return animation.finished;
  }
};
window.customElements.define("testimonial-item", TestimonialItem);

// js/custom-element/section/testimonials/testimonial-list.js
var TestimonialList = class extends CustomHTMLElement {
  connectedCallback() {
    this.items = Array.from(this.querySelectorAll("testimonial-item"));
    this.pageDots = this.querySelector("page-dots");
    this.hasPendingTransition = false;
    if (this.items.length > 1) {
      this.addEventListener("swiperight", this.previous.bind(this));
      this.addEventListener("swipeleft", this.next.bind(this));
      this.addEventListener("prev-next:prev", this.previous.bind(this));
      this.addEventListener("prev-next:next", this.next.bind(this));
      this.addEventListener("page-dots:changed", (event) => this.select(event.detail.index));
      if (Shopify.designMode) {
        this.addEventListener("shopify:block:select", (event) => {
          this.intersectionObserver?.disconnect();
          if (event.detail.load || !event.target.selected) {
            this.select(event.target.index, !event.detail.load);
          }
        });
      }
      this._blockVerticalScroll();
    }
    if (this.hasAttribute("reveal-on-scroll")) {
      this._setupVisibility();
    }
  }
  get selectedIndex() {
    return this.items.findIndex((item) => item.selected);
  }
  async _setupVisibility() {
    await this.untilVisible();
    this.items[this.selectedIndex].transitionToEnter();
  }
  previous() {
    this.select((this.selectedIndex - 1 + this.items.length) % this.items.length);
  }
  next() {
    this.select((this.selectedIndex + 1 + this.items.length) % this.items.length);
  }
  async select(index, shouldAnimate = true) {
    if (this.hasPendingTransition) {
      return;
    }
    this.hasPendingTransition = true;
    await this.items[this.selectedIndex].transitionToLeave(shouldAnimate);
    if (this.pageDots) {
      this.pageDots.selectedIndex = index;
    }
    await this.items[index].transitionToEnter(shouldAnimate);
    this.hasPendingTransition = false;
  }
};
Object.assign(TestimonialList.prototype, VerticalScrollBlockerMixin);
window.customElements.define("testimonial-list", TestimonialList);

// js/custom-element/section/shop-the-look/shop-the-look-item.js
var ShopTheLookItem = class extends HTMLElement {
  get index() {
    return [...this.parentNode.children].indexOf(this);
  }
  get selected() {
    return !this.hasAttribute("hidden");
  }
  async transitionToLeave(shouldAnimate = true) {
    this.setAttribute("hidden", "");
    const animation = new CustomAnimation(new CustomKeyframeEffect(this, { visibility: ["visible", "hidden"] }, { duration: 500 }));
    shouldAnimate ? animation.play() : animation.finish();
    return animation.finished;
  }
  async transitionToEnter(shouldAnimate = true) {
    this.removeAttribute("hidden");
    const dots = Array.from(this.querySelectorAll(".shop-the-look__dot"));
    dots.forEach((dot) => dot.style.opacity = 0);
    const animation = new CustomAnimation(new SequenceEffect([
      new ParallelEffect(Array.from(this.querySelectorAll(".shop-the-look__image")).map((item) => {
        return new CustomKeyframeEffect(item, { opacity: [1, 1] }, { duration: 0 });
      })),
      new CustomKeyframeEffect(this, { visibility: ["hidden", "visible"], zIndex: [0, 1], clipPath: ["inset(0 0 0 100%)", "inset(0 0 0 0)"] }, { duration: 500, easing: "cubic-bezier(1, 0, 0, 1)" }),
      new ParallelEffect(dots.map((item, index) => {
        return new CustomKeyframeEffect(item, { opacity: [0, 1], transform: ["scale(0)", "scale(1)"] }, { duration: 120, delay: 75 * index, easing: "ease-in-out" });
      }))
    ]));
    shouldAnimate ? animation.play() : animation.finish();
    await animation.finished;

    const firstPopover = this.querySelector(".shop-the-look__product-wrapper .shop-the-look__dot");
    firstPopover?.setAttribute("aria-expanded", "true");
  }
};
window.customElements.define("shop-the-look-item", ShopTheLookItem);

// js/custom-element/section/shop-the-look/shop-the-look-nav.js
var ShopTheLookNav = class extends CustomHTMLElement {
  connectedCallback() {
    this.shopTheLook = this.closest("shop-the-look");
    this.inTransition = false;
    this.pendingTransition = false;
    this.pendingTransitionTo = null;
    this.delegate.on("click", '[data-action="prev"]', () => this.shopTheLook.previous());
    this.delegate.on("click", '[data-action="next"]', () => this.shopTheLook.next());
  }
  transitionToIndex(selectedIndex, nextIndex, shouldAnimate = true) {
    const indexElements = Array.from(this.querySelectorAll(".shop-the-look__counter-page-transition")), currentElement = indexElements[selectedIndex], nextElement = indexElements[nextIndex];
    if (this.inTransition) {
      this.pendingTransition = true;
      this.pendingTransitionTo = nextIndex;
      return;
    }
    this.inTransition = true;
    currentElement.animate({ transform: ["translateY(0)", "translateY(-100%)"] }, { duration: shouldAnimate ? 1e3 : 0, easing: "cubic-bezier(1, 0, 0, 1)" }).onfinish = () => {
      currentElement.setAttribute("hidden", "");
      this.inTransition = false;
      if (this.pendingTransition && this.pendingTransitionTo !== nextIndex) {
        this.pendingTransition = false;
        this.transitionToIndex(nextIndex, this.pendingTransitionTo, shouldAnimate);
        this.pendingTransitionTo = null;
      }
    };
    nextElement.removeAttribute("hidden");
    nextElement.animate({ transform: ["translateY(100%)", "translateY(0)"] }, { duration: shouldAnimate ? 1e3 : 0, easing: "cubic-bezier(1, 0, 0, 1)" });
  }
};
window.customElements.define("shop-the-look-nav", ShopTheLookNav);

// js/custom-element/section/shop-the-look/shop-the-look.js
var ShopTheLook = class extends CustomHTMLElement {
  connectedCallback() {
    this.lookItems = Array.from(this.querySelectorAll("shop-the-look-item"));
    this.nav = this.querySelector("shop-the-look-nav");
    this.hasPendingTransition = false;
    if (this.hasAttribute("reveal-on-scroll")) {
      this._setupVisibility();
    }
    if (this.lookItems.length > 1 && Shopify.designMode) {
      this.addEventListener("shopify:block:select", async (event) => {
        this.intersectionObserver.disconnect();
        await this.select(event.target.index, !event.detail.load);
        this.nav.animate({ opacity: [0, 1], transform: ["translateY(30px)", "translateY(0)"] }, { duration: 0, fill: "forwards", easing: "ease-in-out" });
      });
    }
  }
  get selectedIndex() {
    return this.lookItems.findIndex((item) => item.selected);
  }
  async _setupVisibility() {
    await this.untilVisible();
    const images = Array.from(this.lookItems[this.selectedIndex].querySelectorAll(".shop-the-look__image"));
    for (let image of images) {
      if (image.offsetParent !== null) {
        await imageLoaded(image);
      }
    }
    await this.lookItems[this.selectedIndex].transitionToEnter();
    if (this.nav) {
      this.nav.animate({ opacity: [0, 1], transform: ["translateY(30px)", "translateY(0)"] }, { duration: 150, fill: "forwards", easing: "ease-in-out" });
    }
  }
  previous() {
    this.select((this.selectedIndex - 1 + this.lookItems.length) % this.lookItems.length);
  }
  next() {
    this.select((this.selectedIndex + 1 + this.lookItems.length) % this.lookItems.length);
  }
  async select(index, animate = true) {
    const currentLook = this.lookItems[this.selectedIndex], nextLook = this.lookItems[index];
    if (this.hasPendingTransition) {
      return;
    }
    this.hasPendingTransition = true;
    if (currentLook !== nextLook) {
      this.nav.transitionToIndex(this.selectedIndex, index, animate);
      currentLook.transitionToLeave();
    }
    nextLook.transitionToEnter(animate);
    this.hasPendingTransition = false;
  }
};
window.customElements.define("shop-the-look", ShopTheLook);

// js/custom-element/section/collection-list/collection-list.js
var CollectionList = class extends CustomHTMLElement {
  async connectedCallback() {
    this.items = Array.from(this.querySelectorAll(".list-collections__item"));
    this.listInner = this.querySelector(".list-collections__scroller");
    this.items.length == 0 ? this.items = Array.from(this.querySelectorAll(".list-collection-circles__item")) : this.items = [];
    this.scrollBarElement = this.querySelector(".list-collections__progress-bar");
    if (this.scrollBarElement) {
      this.addEventListener("scrollable-content:progress", this._updateProgressBar.bind(this));
    }
    if (this.hasAttribute("scrollable")) {
      this.scroller = this.querySelector(".list-collections__scroller");
      this.addEventListener("prev-next:prev", this.previous.bind(this));
      this.addEventListener("prev-next:next", this.next.bind(this));
      this.addEventListener("shopify:block:select", (event) => event.target.scrollIntoView({ block: "nearest", inline: "center", behavior: event.detail.load ? "auto" : "smooth" }));
    }
    if (this.hasAttribute("reveal-on-scroll")) {
      this._setupVisibility();
    }
    this.initPrevNext();
  }
  _checkScrollability() {
    if (this.listInner) {
      return this.listInner.clientWidth < this.listInner.querySelector("*").clientWidth;
    } else {
      return false;
    }
  }
  _updateProgressBar(event) {
    this.scrollBarElement?.style.setProperty("--transform", `${event.detail.progress}%`);
  }
  async _setupVisibility() {
    await this.untilVisible();
    const prefersReducedMotion = MediaFeatures.prefersReducedMotion();
    const animation = new CustomAnimation(new ParallelEffect(this.items.map((item, index) => {
      return new SequenceEffect([
        new CustomKeyframeEffect(item.querySelector(".list-collections__item-image"), {
          opacity: [0, 1],
          transform: [`scale(${prefersReducedMotion ? 1 : 1.1})`, "scale(1)"]
        }, {
          duration: 250,
          delay: prefersReducedMotion ? 0 : 150 * index,
          easing: "cubic-bezier(0.65, 0, 0.35, 1)"
        }),
        new ParallelEffect(Array.from(item.querySelectorAll(".list-collections__item-info [reveal]")).map((textItem, subIndex) => {
          return new CustomKeyframeEffect(textItem, {
            opacity: [0, 1],
            clipPath: [`inset(${prefersReducedMotion ? "0 0 0 0" : "0 0 100% 0"})`, "inset(0 0 0 0)"],
            transform: [`translateY(${prefersReducedMotion ? 0 : "100%"})`, "translateY(0)"]
          }, {
            duration: 200,
            delay: prefersReducedMotion ? 0 : 150 * index + 150 * subIndex,
            easing: "cubic-bezier(0.5, 0.06, 0.01, 0.99)"
          });
        }))
      ]);
    })));
    this._hasSectionReloaded ? animation.finish() : animation.play();
  }
  initPrevNext() {
    const next = this.querySelector(".prev-next-button--next");
    if (next) {
      if (this._checkScrollability()) {
        next.removeAttribute("disabled");
      } else {
        next.setAttribute("disabled", true);
      }
    }
  }
  previous(event) {
    const directionFlip = window.themeVariables.settings.direction === "ltr" ? 1 : -1;
    const columnGap = 0;
    event.target.nextElementSibling.removeAttribute("disabled");
    event.target.toggleAttribute("disabled", this.listInner.scrollLeft * directionFlip - (this.listInner.clientWidth + columnGap) <= 0);
    this.scroller.scrollBy({
      left: -this.listInner.clientWidth * directionFlip,
      behavior: "smooth"
    });
  }
  next(event) {
    const directionFlip = window.themeVariables.settings.direction === "ltr" ? 1 : -1;
    const columnGap = 0;
    event.target.previousElementSibling.removeAttribute("disabled");
    event.target.toggleAttribute("disabled", this.listInner.scrollLeft * directionFlip + (this.listInner.clientWidth + columnGap) * 2 >= this.listInner.scrollWidth);
    this.scroller.scrollBy({
      left: this.listInner.clientWidth * directionFlip,
      behavior: "smooth"
    });
  }
};
window.customElements.define("collection-list", CollectionList);

class ScrollToTopButton extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector('#scrollToTop');
    this.minScroll = parseInt(this.getAttribute('min-scroll') || '500', 10);
    this.maxScroll = parseInt(this.getAttribute('max-scroll') || '800', 10);
    this.delay = parseInt(this.getAttribute('delay') || '3000', 10);

    this.isScrolling = false;
    this.isHovered = false;
    this.scrollTimeout = null;

    // Event-Listener hinzufügen
    this.button.addEventListener('click', this.scrollToTop.bind(this));
    this.button.addEventListener('mouseenter', this.handleMouseEnter.bind(this));
    this.button.addEventListener('mouseleave', this.handleMouseLeave.bind(this));
    window.addEventListener('scroll', this.handleScroll.bind(this));

    // Initial maxScroll berechnen
    this.updateMaxScroll();

    this.handleScroll();
  }

  updateMaxScroll() {
    const documentHeight = document.documentElement.scrollHeight;
    const windowHeight = window.innerHeight;
    this.maxScroll = documentHeight - windowHeight - this.maxScroll;
  }

  handleScroll() {
    const scrollY = window.scrollY;

    // Button ein- oder ausblenden basierend auf Scrolltiefe
    if (scrollY > this.minScroll && scrollY < this.maxScroll) {
      this.showButton();
    } else {
      this.hideButton();
    }

    // Scroll-Aktivität prüfen
    this.isScrolling = true;
    clearTimeout(this.scrollTimeout);
    this.scrollTimeout = setTimeout(() => {
      this.isScrolling = false;
      if (!this.isHovered) {
        this.hideButton();
      }
    }, this.delay);
  }

  handleMouseEnter() {
    this.isHovered = true;
    this.showButton();
  }

  handleMouseLeave() {
    this.isHovered = false;
    if (!this.isScrolling) {
      this.hideButton();
    }
  }

  showButton() {
    if (this.isScrolling) {
      this.hidden = false;
    }
  }

  hideButton() {
    this.hidden = true;
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}

// Web Component registrieren
customElements.define('scroll-to-top-button', ScrollToTopButton);

var HeaderUspBar = class extends CustomHTMLElement {
  async connectedCallback() {
    await customElements.whenDefined("header-usp-item");
    this.items = Array.from(this.querySelectorAll("header-usp-item"));
    this.hasPendingTransition = false;

    this._startPlayer();
  }
  get selectedIndex() {
    return this.items.findIndex((item) => item.selected);
  }
  previous() {
    this.select((this.selectedIndex - 1 + this.items.length) % this.items.length);
  }
  next() {
    this.select((this.selectedIndex + 1 + this.items.length) % this.items.length);
  }
  async select(index, animate = true) {
    if (this.selectedIndex === index || this.hasPendingTransition) {
      return;
    }
    if (this.autoPlay) {
      this._pausePlayer();
    }
    this.hasPendingTransition = true;
    await this.items[this.selectedIndex].deselect(animate);
    await this.items[index].select(animate);
    this.hasPendingTransition = false;
    if (this.autoPlay) {
      this._startPlayer();
    }
  }
  _pausePlayer() {
    clearInterval(this._interval);
  }
  _startPlayer() {
    clearInterval(this._interval);
    this._interval = setInterval(this.next.bind(this), parseInt(this.getAttribute("cycle-speed")) * 1e3);
  }
};
window.customElements.define("header-usp-bar", HeaderUspBar);

var HeaderUspItem = class extends CustomHTMLElement {
  // connectedCallback() {
  //   if (this.hasContent) {
  //     this.contentElement = this.querySelector(".announcement-bar__content");
  //     this.delegate.on("click", '[data-action="open-content"]', this.openContent.bind(this));
  //     this.delegate.on("click", '[data-action="close-content"]', this.closeContent.bind(this));
  //     if (Shopify.designMode) {
  //       this.addEventListener("shopify:block:select", this.openContent.bind(this));
  //       this.addEventListener("shopify:block:deselect", this.closeContent.bind(this));
  //     }
  //   }
  // }
  get index() {
    return [...this.parentNode.children].indexOf(this);
  }
  get hasContent() {
    return this.hasAttribute("has-content");
  }
  get selected() {
    return !this.hasAttribute("hidden");
  }
  get focusTrap() {
    return this._trapFocus = this._trapFocus || createFocusTrap(this.contentElement.querySelector(".announcement-bar__content-inner"), {
      fallbackFocus: this,
      clickOutsideDeactivates: (event) => !(event.target.tagName === "BUTTON"),
      allowOutsideClick: (event) => event.target.tagName === "BUTTON",
      onDeactivate: this.closeContent.bind(this),
      preventScroll: true
    });
  }
  async select(animate = true) {
    this.removeAttribute("hidden");
    await new Promise((resolve) => {
      this.animate({
        transform: ["translateY(8px)", "translateY(0)"],
        opacity: [0, 1]
      }, {
        duration: animate ? 150 : 0,
        easing: "ease-in-out"
      }).onfinish = resolve;
    });
  }
  async deselect(animate = true) {
    // await this.closeContent();
    await new Promise((resolve) => {
      this.animate({
        transform: ["translateY(0)", "translateY(-8px)"],
        opacity: [1, 0]
      }, {
        duration: animate ? 150 : 0,
        easing: "ease-in-out"
      }).onfinish = resolve;
    });
    this.setAttribute("hidden", "");
  }
  // async openContent() {
  //   if (this.hasContent) {
  //     this.contentElement.addEventListener("transitionend", () => this.focusTrap.activate(), { once: true });
  //     this.contentElement.removeAttribute("hidden");
  //     document.documentElement.classList.add("lock-all");
  //     this.dispatchEvent(new CustomEvent("announcement-bar:content:open", { bubbles: true }));
  //   }
  // }
  // async closeContent() {
  //   if (!this.hasContent || this.contentElement.hasAttribute("hidden")) {
  //     return Promise.resolve();
  //   }
  //   await new Promise((resolve) => {
  //     this.contentElement.addEventListener("transitionend", () => resolve(), { once: true });
  //     this.contentElement.setAttribute("hidden", "");
  //     this.focusTrap.deactivate();
  //     document.documentElement.classList.remove("lock-all");
  //     this.dispatchEvent(new CustomEvent("announcement-bar:content:close", { bubbles: true }));
  //   });
  // }
};
window.customElements.define("header-usp-item", HeaderUspItem);

// js/custom-element/section/product-list/product-list.js
var ProductList = class extends CustomHTMLElement {
  constructor() {
    super();
    this.productListInner = this.querySelector(".product-list__inner");
    this.productItems = Array.from(this.querySelectorAll("product-item"));
    this.scrollBarElement = this.querySelector(".list-collections__progress-bar");
    this.scroller = this.querySelector(".scroller");
    if (this.scroller && this.scrollBarElement) {
      this._checkScrollability();
      window.addEventListener("resize", this._checkScrollability.bind(this));
      this.scroller.addEventListener("scroll", this._updateProgressBar.bind(this));
    }
  }
  connectedCallback() {
    this.addEventListener("prev-next:prev", this.previous.bind(this));
    this.addEventListener("prev-next:next", this.next.bind(this));
    if (!this.hidden && this.staggerApparition) {
      this._staggerProductsApparition();
    }
  }
  get staggerApparition() {
    return this.hasAttribute("stagger-apparition");
  }
  get apparitionAnimation() {
    return this._animation = this._animation || new CustomAnimation(new ParallelEffect(this.productItems.map((item, index) => {
      return new CustomKeyframeEffect(item, {
        opacity: [0, 1],
        transform: [`translateY(${MediaFeatures.prefersReducedMotion() ? 0 : window.innerWidth < 1e3 ? 35 : 60}px)`, "translateY(0)"]
      }, {
        duration: 600,
        delay: MediaFeatures.prefersReducedMotion() ? 0 : 100 * index - Math.min(3 * index * index, 100 * index),
        easing: "ease"
      });
    })));
  }
  // Move to previous products (if any)
  previous(event) {
    const directionFlip = window.themeVariables.settings.direction === "ltr" ? 1 : -1, columnGap = parseInt(getComputedStyle(this).getPropertyValue("--product-list-column-gap"));
    event.target.nextElementSibling.removeAttribute("disabled");
    event.target.toggleAttribute("disabled", this.productListInner.scrollLeft * directionFlip - (this.productListInner.clientWidth + columnGap) <= 0);
    this.productListInner.scrollBy({ left: -(this.productListInner.clientWidth + columnGap) * directionFlip, behavior: "smooth" });
  }
  // Move to next products (if any)
  next(event) {
    const directionFlip = window.themeVariables.settings.direction === "ltr" ? 1 : -1, columnGap = parseInt(getComputedStyle(this).getPropertyValue("--product-list-column-gap"));
    event.target.previousElementSibling.removeAttribute("disabled");
    event.target.toggleAttribute("disabled", this.productListInner.scrollLeft * directionFlip + (this.productListInner.clientWidth + columnGap) * 2 >= this.productListInner.scrollWidth);
    this.productListInner.scrollBy({ left: (this.productListInner.clientWidth + columnGap) * directionFlip, behavior: "smooth" });
  }
  _checkScrollability() {
    this.classList.toggle("is-scrollable", this.scroller.scrollWidth > this.scroller.offsetWidth);

    this.scrollBarElement.style.setProperty("--divider", `${1 / (this.scroller.offsetWidth / this.scroller.scrollWidth)}`);
  }
  _updateProgressBar(event) {
    const scrollLeft = this.scroller.scrollLeft * (window.themeVariables.settings.direction === "ltr" ? 1 : -1);
    const progress = Math.max(0, Math.min(1, scrollLeft / (this.scroller.scrollWidth - this.scroller.clientWidth))) * 100;

    this.scrollBarElement?.style.setProperty("--transform", `${progress}%`);
  }
  attributeChangedCallback(name) {
    if (!this.staggerApparition) {
      return;
    }
    switch (name) {
      case "hidden":
        if (!this.hidden) {
          this.productListInner.scrollLeft = 0;
          this.productListInner.parentElement.scrollLeft = 0;
          this.querySelector(".prev-next-button--prev")?.setAttribute("disabled", "");
          this.querySelector(".prev-next-button--next")?.removeAttribute("disabled");
          this._staggerProductsApparition();
        } else {
          this.apparitionAnimation.finish();
        }
    }
  }
  async _staggerProductsApparition() {
    this.productItems.forEach((item) => item.style.opacity = 0);
    await this.untilVisible({ threshold: this.clientHeight > 0 ? Math.min(50 / this.clientHeight, 1) : 0 });
    this.apparitionAnimation.play();
  }
};
__publicField(ProductList, "observedAttributes", ["hidden"]);
window.customElements.define("product-list", ProductList);

// js/custom-element/section/logo-list/logo-list.js
var LogoList = class extends CustomHTMLElement {
  async connectedCallback() {
    this.items = Array.from(this.querySelectorAll(".logo-list__item"));
    this.logoListScrollable = this.querySelector(".logo-list__list");
    if (this.items.length > 1) {
      this.addEventListener("prev-next:prev", this.previous.bind(this));
      this.addEventListener("prev-next:next", this.next.bind(this));
    }
    if (this.hasAttribute("reveal-on-scroll")) {
      this._setupVisibility();
    }
  }
  async _setupVisibility() {
    await this.untilVisible({ rootMargin: "50px 0px", threshold: 0 });
    const animation = new CustomAnimation(new ParallelEffect(this.items.map((item, index) => {
      return new CustomKeyframeEffect(item, {
        opacity: [0, 1],
        transform: [`translateY(${MediaFeatures.prefersReducedMotion() ? 0 : "30px"})`, "translateY(0)"]
      }, {
        duration: 300,
        delay: MediaFeatures.prefersReducedMotion() ? 0 : 100 * index,
        easing: "ease"
      });
    })));
    this._hasSectionReloaded ? animation.finish() : animation.play();
  }
  previous(event) {
    const directionFlip = window.themeVariables.settings.direction === "ltr" ? 1 : -1;
    event.target.nextElementSibling.removeAttribute("disabled");
    event.target.toggleAttribute("disabled", this.logoListScrollable.scrollLeft * directionFlip - (this.logoListScrollable.clientWidth + 24) <= 0);
    this.logoListScrollable.scrollBy({ left: -(this.logoListScrollable.clientWidth + 24) * directionFlip, behavior: "smooth" });
  }
  next(event) {
    const directionFlip = window.themeVariables.settings.direction === "ltr" ? 1 : -1;
    event.target.previousElementSibling.removeAttribute("disabled");
    event.target.toggleAttribute("disabled", this.logoListScrollable.scrollLeft * directionFlip + (this.logoListScrollable.clientWidth + 24) * 2 >= this.logoListScrollable.scrollWidth);
    this.logoListScrollable.scrollBy({ left: (this.logoListScrollable.clientWidth + 24) * directionFlip, behavior: "smooth" });
  }
};
window.customElements.define("logo-list", LogoList);

// js/custom-element/section/blog/blog-post-navigation.js
var BlogPostNavigation = class extends HTMLElement {
  connectedCallback() {
    window.addEventListener("scroll", throttle(this._updateProgressBar.bind(this), 15));
  }
  get hasNextArticle() {
    return this.hasAttribute("has-next-article");
  }
  _updateProgressBar() {
    const stickyHeaderOffset = getStickyHeaderOffset(), marginCompensation = window.matchMedia(window.themeVariables.breakpoints.pocket).matches ? 40 : 80, articleNavBoundingBox = this.getBoundingClientRect(), articleMainPartBoundingBox = this.parentElement.getBoundingClientRect(), difference = articleMainPartBoundingBox.bottom - (articleNavBoundingBox.bottom - marginCompensation), progress = Math.max(-1 * (difference / (articleMainPartBoundingBox.height + marginCompensation) - 1), 0);
    this.classList.toggle("is-visible", articleMainPartBoundingBox.top < stickyHeaderOffset && articleMainPartBoundingBox.bottom > stickyHeaderOffset + this.clientHeight - marginCompensation);
    if (this.hasNextArticle) {
      if (progress > 0.8) {
        this.classList.add("article__nav--show-next");
      } else {
        this.classList.remove("article__nav--show-next");
      }
    }
    this.style.setProperty("--transform", `${progress}`);
  }
};
window.customElements.define("blog-post-navigation", BlogPostNavigation);

// js/custom-element/section/multi-column/multi-column.js
var MultiColumn = class extends CustomHTMLElement {
  connectedCallback() {
    if (!this.hasAttribute("stack")) {
      this.multiColumnInner = this.querySelector(".multi-column__inner");
      this.scrollBarElement = this.querySelector(".multi-column__progress-bar");
      this.addEventListener("prev-next:prev", this.previous.bind(this));
      this.addEventListener("prev-next:next", this.next.bind(this));
      this.addEventListener("scrollable-content:progress", this._updateProgressBar.bind(this));
      if (Shopify.designMode) {
        this.addEventListener("shopify:block:select", (event) => {
          event.target.scrollIntoView({ inline: "center", block: "nearest", behavior: event.detail.load ? "auto" : "smooth" });
        });
      }
    }
    if (this.hasAttribute("stagger-apparition")) {
      this._setupVisibility();
    }
  }
  async _setupVisibility() {
    await this.untilVisible({ threshold: Math.min(50 / this.clientHeight, 1) });
    const prefersReducedMotion = MediaFeatures.prefersReducedMotion();
    const animation = new CustomAnimation(new ParallelEffect(Array.from(this.querySelectorAll(".multi-column__item")).map((item, index) => {
      return new CustomKeyframeEffect(item, {
        opacity: [0, 1],
        transform: [`translateY(${MediaFeatures.prefersReducedMotion() ? 0 : window.innerWidth < 1e3 ? 35 : 60}px)`, "translateY(0)"]
      }, {
        duration: 600,
        delay: prefersReducedMotion ? 0 : 100 * index,
        easing: "ease"
      });
    })));
    this._hasSectionReloaded ? animation.finish() : animation.play();
  }
  _updateProgressBar(event) {
    this.scrollBarElement?.style.setProperty("--transform", `${event.detail.progress}%`);
  }
  // Move to previous products (if any)
  previous(event) {
    const directionFlip = window.themeVariables.settings.direction === "ltr" ? 1 : -1, columnGap = parseInt(getComputedStyle(this).getPropertyValue("--multi-column-column-gap"));
    event.target.nextElementSibling.removeAttribute("disabled");
    event.target.toggleAttribute("disabled", this.multiColumnInner.scrollLeft * directionFlip - (this.multiColumnInner.clientWidth + columnGap) <= 0);
    this.multiColumnInner.scrollBy({ left: -(this.multiColumnInner.clientWidth + columnGap) * directionFlip, behavior: "smooth" });
  }
  // Move to next products (if any)
  next(event) {
    const directionFlip = window.themeVariables.settings.direction === "ltr" ? 1 : -1, columnGap = parseInt(getComputedStyle(this).getPropertyValue("--multi-column-column-gap"));
    event.target.previousElementSibling.removeAttribute("disabled");
    event.target.toggleAttribute("disabled", this.multiColumnInner.scrollLeft * directionFlip + (this.multiColumnInner.clientWidth + columnGap) * 2 >= this.multiColumnInner.scrollWidth);
    this.multiColumnInner.scrollBy({ left: (this.multiColumnInner.clientWidth + columnGap) * directionFlip, behavior: "smooth" });
  }
};
window.customElements.define("multi-column", MultiColumn);

// js/custom-element/section/gallery/gallery-list.js
var GalleryList = class extends HTMLElement {
  connectedCallback() {
    this.listItems = Array.from(this.querySelectorAll("gallery-item"));
    this.scrollBarElement = this.querySelector(".gallery__progress-bar");
    this.listWrapperElement = this.querySelector(".gallery__list-wrapper");
    if (this.listItems.length > 1) {
      this.addEventListener("scrollable-content:progress", this._updateProgressBar.bind(this));
      this.addEventListener("prev-next:prev", this.previous.bind(this));
      this.addEventListener("prev-next:next", this.next.bind(this));
      if (Shopify.designMode) {
        this.addEventListener("shopify:block:select", (event) => this.select(event.target.index, !event.detail.load));
      }
    }
  }
  previous() {
    this.select([...this.listItems].reverse().find((item) => item.isOnLeftHalfPartOfScreen).index);
  }
  next() {
    this.select(this.listItems.findIndex((item) => item.isOnRightHalfPartOfScreen));
  }
  select(index, animate = true) {
    const boundingRect = this.listItems[index].getBoundingClientRect();
    this.listWrapperElement.scrollBy({
      behavior: animate ? "smooth" : "auto",
      left: Math.floor(boundingRect.left - window.innerWidth / 2 + boundingRect.width / 2)
    });
  }
  _updateProgressBar(event) {
    this.scrollBarElement?.style.setProperty("--transform", `${event.detail.progress}%`);
  }
};
window.customElements.define("gallery-list", GalleryList);

// js/custom-element/section/gallery/gallery-item.js
var GalleryItem = class extends HTMLElement {
  get index() {
    return [...this.parentNode.children].indexOf(this);
  }
  get isOnRightHalfPartOfScreen() {
    if (window.themeVariables.settings.direction === "ltr") {
      return this.getBoundingClientRect().left > window.innerWidth / 2;
    } else {
      return this.getBoundingClientRect().right < window.innerWidth / 2;
    }
  }
  get isOnLeftHalfPartOfScreen() {
    if (window.themeVariables.settings.direction === "ltr") {
      return this.getBoundingClientRect().right < window.innerWidth / 2;
    } else {
      return this.getBoundingClientRect().left > window.innerWidth / 2;
    }
  }
};
window.customElements.define("gallery-item", GalleryItem);

// js/custom-element/section/image-with-text-overlay/image-with-text-overlay.js
var ImageWithTextOverlay = class extends CustomHTMLElement {
  connectedCallback() {
    if (this.hasAttribute("parallax") && !MediaFeatures.prefersReducedMotion()) {
      this._hasPendingRaF = false;
      this._onScrollListener = this._onScroll.bind(this);
      window.addEventListener("scroll", this._onScrollListener);
    }
    if (this.hasAttribute("reveal-on-scroll")) {
      this._setupVisibility();
    }
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    if (this._onScrollListener) {
      window.removeEventListener("scroll", this._onScrollListener);
    }
  }
  async _setupVisibility() {
    await this.untilVisible();
    const image = this.querySelector(".image-overlay__image"), headings = await resolveAsyncIterator(this.querySelectorAll("split-lines")), prefersReducedMotion = MediaFeatures.prefersReducedMotion();
    await imageLoaded(image);
    const innerEffect = [
      new CustomKeyframeEffect(image, { opacity: [0, 1], transform: [`scale(${prefersReducedMotion ? 1 : 1.1})`, "scale(1)"] }, { duration: 500, easing: "cubic-bezier(0.65, 0, 0.35, 1)" }),
      new ParallelEffect(headings.map((item, index) => {
        return new CustomKeyframeEffect(item, {
          opacity: [0, 0.2, 1],
          transform: [`translateY(${prefersReducedMotion ? 0 : "100%"})`, "translateY(0)"],
          clipPath: [`inset(${prefersReducedMotion ? "0 0 0 0" : "0 0 100% 0"})`, "inset(0 0 0 0)"]
        }, {
          duration: 300,
          delay: prefersReducedMotion ? 0 : 120 * index,
          easing: "cubic-bezier(0.5, 0.06, 0.01, 0.99)"
        });
      })),
      new CustomKeyframeEffect(this.querySelector(".image-overlay__text-container"), { opacity: [0, 1] }, { duration: 300 })
    ];
    const animation = prefersReducedMotion ? new CustomAnimation(new ParallelEffect(innerEffect)) : new CustomAnimation(new SequenceEffect(innerEffect));
    this._hasSectionReloaded ? animation.finish() : animation.play();
  }
  _onScroll() {
    if (this._hasPendingRaF) {
      return;
    }
    this._hasPendingRaF = true;
    requestAnimationFrame(() => {
      const boundingRect = this.getBoundingClientRect(), speedFactor = 3, contentElement = this.querySelector(".image-overlay__content-wrapper"), imageElement = this.querySelector(".image-overlay__image"), boundingRectBottom = boundingRect.bottom, boundingRectHeight = boundingRect.height, stickyHeaderOffset = getStickyHeaderOffset();
      if (contentElement) {
        contentElement.style.opacity = Math.max(1 - speedFactor * (1 - Math.min(boundingRectBottom / boundingRectHeight, 1)), 0).toString();
      }
      if (imageElement) {
        imageElement.style.transform = `translateY(${100 - Math.max(1 - (1 - Math.min(boundingRectBottom / (boundingRectHeight + stickyHeaderOffset), 1)), 0) * 100}px)`;
      }
      this._hasPendingRaF = false;
    });
  }
};
window.customElements.define("image-with-text-overlay", ImageWithTextOverlay);

var StickyMedia = class extends CustomHTMLElement {
  // constructor() {
  //   super();
  //   this.style.top = this.offsetTop + "px";
  // }
  connectedCallback() {
    this.updateTop();

    window.addEventListener("pageshow", (event) => {
      if (event.persisted) {
        document.querySelectorAll("sticky-media").forEach(el => el.updateTop());
      }
    });
  }

  updateTop() {
    const parentTop = this.parentElement.offsetTop;
    const parentTopPadding = parseFloat(window.getComputedStyle(this.parentElement).getPropertyValue("padding-top"));
    this.style.top = `${parentTop + parentTopPadding}px`;
  }
}
window.customElements.define("sticky-media", StickyMedia);

// js/custom-element/section/image-with-text-block/image-with-text-block.js
var ImageWithTextBlock = class extends CustomHTMLElement {
  async connectedCallback() {
    if (this.hasAttribute("reveal-on-scroll")) {
      this._setupVisibility();
    }
  }
  async _setupVisibility() {
    await this.untilVisible();
    const images = Array.from(this.querySelectorAll(".image-with-text-block__image[reveal]")), headings = await resolveAsyncIterator(this.querySelectorAll("split-lines")), prefersReducedMotion = MediaFeatures.prefersReducedMotion();
    for (const image of images) {
      if (image.offsetParent !== null) {
        await imageLoaded(image);
      }
    }
    const innerEffect = [
      new ParallelEffect(images.map((item) => {
        return new CustomKeyframeEffect(item, { opacity: [0, 1], transform: [`scale(${prefersReducedMotion ? 1 : 1.1})`, "scale(1)"] }, { duration: 500, easing: "cubic-bezier(0.65, 0, 0.35, 1)" });
      })),
      new CustomKeyframeEffect(this.querySelector(".image-with-text-block__content"), { opacity: [0, 1], transform: [`translateY(${prefersReducedMotion ? 0 : "60px"})`, "translateY(0)"] }, { duration: 150, easing: "ease-in-out" }),
      new ParallelEffect(headings.map((item, index) => {
        return new CustomKeyframeEffect(item, {
          opacity: [0, 0.2, 1],
          transform: [`translateY(${prefersReducedMotion ? 0 : "100%"})`, "translateY(0)"],
          clipPath: [`inset(${prefersReducedMotion ? "0 0 0 0" : "0 0 100% 0"})`, "inset(0 0 0 0)"]
        }, {
          duration: 300,
          delay: prefersReducedMotion ? 0 : 120 * index,
          easing: "cubic-bezier(0.5, 0.06, 0.01, 0.99)"
        });
      })),
      new CustomKeyframeEffect(this.querySelector(".image-with-text-block__text-container"), { opacity: [0, 1] }, { duration: 300 })
    ];
    const animation = prefersReducedMotion ? new CustomAnimation(new ParallelEffect(innerEffect)) : new CustomAnimation(new SequenceEffect(innerEffect));
    this._hasSectionReloaded ? animation.finish() : animation.play();
  }
};
window.customElements.define("image-with-text-block", ImageWithTextBlock);

// js/custom-element/section/blog/article-list.js
var ArticleList = class extends CustomHTMLElement {
  async connectedCallback() {
    this.articleItems = Array.from(this.querySelectorAll(".article-item"));
    if (this.staggerApparition) {
      await this.untilVisible({ threshold: this.clientHeight > 0 ? Math.min(50 / this.clientHeight, 1) : 0 });
      const animation = new CustomAnimation(new ParallelEffect(this.articleItems.map((item, index) => {
        return new CustomKeyframeEffect(item, {
          opacity: [0, 1],
          transform: [`translateY(${MediaFeatures.prefersReducedMotion() ? 0 : window.innerWidth < 1e3 ? 35 : 60}px)`, "translateY(0)"]
        }, {
          duration: 600,
          delay: MediaFeatures.prefersReducedMotion() ? 0 : 100 * index - Math.min(3 * index * index, 100 * index),
          easing: "ease"
        });
      })));
      this._hasSectionReloaded ? animation.finish() : animation.play();
    }
  }
  get staggerApparition() {
    return this.hasAttribute("stagger-apparition");
  }
};
window.customElements.define("article-list", ArticleList);

var ArticleSliderList = class extends CustomHTMLElement {
  constructor() {
    super();
    this.articleListInner = this.querySelector(".article-list__inner");
    this.articleItems = Array.from(this.querySelectorAll(".article-item"));
  }
  async connectedCallback() {
    this.addEventListener("prev-next:prev", this.previous.bind(this));
    this.addEventListener("prev-next:next", this.next.bind(this));
    if (!this.hidden && this.staggerApparition) {
      await this.untilVisible({ threshold: this.clientHeight > 0 ? Math.min(50 / this.clientHeight, 1) : 0 });
      const animation = new CustomAnimation(new ParallelEffect(this.articleItems.map((item, index) => {
        return new CustomKeyframeEffect(item, {
          opacity: [0, 1],
          transform: [`translateY(${MediaFeatures.prefersReducedMotion() ? 0 : window.innerWidth < 1e3 ? 35 : 60}px)`, "translateY(0)"]
        }, {
          duration: 600,
          delay: MediaFeatures.prefersReducedMotion() ? 0 : 100 * index - Math.min(3 * index * index, 100 * index),
          easing: "ease"
        });
      })));
      this._hasSectionReloaded ? animation.finish() : animation.play();
    }
  }
  get staggerApparition() {
    return this.hasAttribute("stagger-apparition");
  }
  // Move to previous products (if any)
  previous(event) {
    const directionFlip = window.themeVariables.settings.direction === "ltr" ? 1 : -1, columnGap = parseInt(getComputedStyle(this).getPropertyValue("--product-list-column-gap"));
    event.target.nextElementSibling.removeAttribute("disabled");
    event.target.toggleAttribute("disabled", this.articleListInner.scrollLeft * directionFlip - (this.articleListInner.clientWidth + columnGap) <= 0);
    this.articleListInner.scrollBy({ left: -(this.articleListInner.clientWidth + columnGap) * directionFlip, behavior: "smooth" });
  }
  // Move to next products (if any)
  next(event) {
    const directionFlip = window.themeVariables.settings.direction === "ltr" ? 1 : -1, columnGap = parseInt(getComputedStyle(this).getPropertyValue("--product-list-column-gap"));
    event.target.previousElementSibling.removeAttribute("disabled");
    event.target.toggleAttribute("disabled", this.articleListInner.scrollLeft * directionFlip + (this.articleListInner.clientWidth + columnGap) * 2 >= this.articleListInner.scrollWidth);
    this.articleListInner.scrollBy({ left: (this.articleListInner.clientWidth + columnGap) * directionFlip, behavior: "smooth" });
  }
  attributeChangedCallback(name) {
    if (!this.staggerApparition) {
      return;
    }
    switch (name) {
      case "hidden":
        if (!this.hidden) {
          this.articleListInner.scrollLeft = 0;
          this.articleListInner.parentElement.scrollLeft = 0;
          this.querySelector(".prev-next-button--prev")?.setAttribute("disabled", "");
          this.querySelector(".prev-next-button--next")?.removeAttribute("disabled");
          this._staggerProductsApparition();
        } else {
          this.apparitionAnimation.finish();
        }
    }
  }
  async _staggerProductsApparition() {
    this.articleItems.forEach((item) => item.style.opacity = 0);
    await this.untilVisible({ threshold: this.clientHeight > 0 ? Math.min(50 / this.clientHeight, 1) : 0 });
    this.apparitionAnimation.play();
  }
};
window.customElements.define("article-slider-list", ArticleSliderList);

// js/custom-element/section/blog/article-item-click.js

// js/custom-element/section/blog/blog-post-header.js
var BlogPostHeader = class extends HTMLElement {
  async connectedCallback() {
    const image = this.querySelector(".article__image");
    if (MediaFeatures.prefersReducedMotion()) {
      image.removeAttribute("reveal");
    } else {
      await imageLoaded(image);
      image.animate({ opacity: [0, 1], transform: ["scale(1.1)", "scale(1)"] }, { duration: 500, fill: "forwards", easing: "cubic-bezier(0.65, 0, 0.35, 1)" });
    }
  }
};
window.customElements.define("blog-post-header", BlogPostHeader);

// js/custom-element/section/search/predictive-search-input.js
var PredictiveSearchInput = class extends HTMLInputElement {
  connectedCallback() {
    this.addEventListener("click", () => document.getElementById(this.getAttribute("aria-controls")).open = true);
  }
};
window.customElements.define("predictive-search-input", PredictiveSearchInput, { extends: "input" });

// js/custom-element/ui/drawer.js
var DrawerContent = class extends OpenableElement {
  connectedCallback() {
    super.connectedCallback();
    if (this.hasAttribute("reverse-breakpoint")) {
      this.originalDirection = this.classList.contains("drawer--from-left") ? "left" : "right";
      const matchMedia2 = window.matchMedia(this.getAttribute("reverse-breakpoint"));
      matchMedia2.addListener(this._checkReverseOpeningDirection.bind(this));
      this._checkReverseOpeningDirection(matchMedia2);
    }
    this.delegate.on("click", ".drawer__overlay", () => this.open = false);
  }
  attributeChangedCallback(name, oldValue, newValue) {
    super.attributeChangedCallback(name, oldValue, newValue);
    switch (name) {
      case "open":
        document.documentElement.classList.toggle("lock-all", this.open);
    }
  }
  _checkReverseOpeningDirection(match) {
    this.classList.remove("drawer--from-left");
    if (this.originalDirection === "left" && !match.matches || this.originalDirection !== "left" && match.matches) {
      this.classList.add("drawer--from-left");
    }
  }
};
window.customElements.define("drawer-content", DrawerContent);

// js/custom-element/section/search/predictive-search-drawer.js
var PredictiveSearchDrawer = class extends DrawerContent {
  connectedCallback() {
    super.connectedCallback();
    this.inputElement = this.querySelector('[name="q"]');
    this.drawerContentElement = this.querySelector(".drawer__content");
    this.drawerFooterElement = this.querySelector(".drawer__footer");
    this.loadingStateElement = this.querySelector(".predictive-search__loading-state");
    this.resultsElement = this.querySelector(".predictive-search__results");
    this.menuListElement = this.querySelector(".predictive-search__menu-list");
    this.delegate.on("input", '[name="q"]', this._debounce(this._onSearch.bind(this), 200));
    this.delegate.on("click", '[data-action="reset-search"]', this._startNewSearch.bind(this));
  }
  async _onSearch(event, target) {
    if (event.key === "Enter") {
      return;
    }
    if (this.abortController) {
      this.abortController.abort();
    }
    this.drawerContentElement.classList.remove("drawer__content--center");
    if (this.drawerFooterElement) this.drawerFooterElement.hidden = true;
    if (target.value === "") {
      this.loadingStateElement.hidden = true;
      this.resultsElement.hidden = true;
      this.menuListElement ? this.menuListElement.hidden = false : "";
    } else {
      this.drawerContentElement.classList.add("drawer__content--center");
      this.loadingStateElement.hidden = false;
      this.resultsElement.hidden = true;
      this.menuListElement ? this.menuListElement.hidden = true : "";
      let searchResults = {};
      try {
        this.abortController = new AbortController();
        if (this._supportPredictiveApi()) {
          searchResults = await this._doPredictiveSearch(target.value);
        } else {
          searchResults = await this._doLiquidSearch(target.value);
        }
      } catch (e) {
        if (e.name === "AbortError") {
          return;
        }
      }
      this.loadingStateElement.hidden = true;
      this.resultsElement.hidden = false;
      this.menuListElement ? this.menuListElement.hidden = true : "";
      if (searchResults.hasResults) {
        if (this.drawerFooterElement) this.drawerFooterElement.hidden = false;
        this.drawerContentElement.classList.remove("drawer__content--center");
      }
      this.resultsElement.innerHTML = searchResults.html;
    }
  }
  async _doPredictiveSearch(term) {
    const response = await fetch(`${window.themeVariables.routes.predictiveSearchUrl}?q=${encodeURIComponent(term)}&resources[limit]=10&resources[limit_scope]=each&section_id=predictive-search&&resources[options][fields]=author,body,product_type,title`, {
      signal: this.abortController.signal
    });
    const div = document.createElement("div");
    div.innerHTML = await response.text();
    return { hasResults: div.querySelector(".predictive-search__results-categories") !== null, html: div.firstElementChild.innerHTML };
  }
  /* Some languages do not support predictive search API so we fallback to the Liquid search */
  async _doLiquidSearch(term) {
    const response = await fetch(`${window.themeVariables.routes.searchUrl}?q=${encodeURIComponent(term)}&resources[limit]=50&section_id=predictive-search-compatibility`, {
      signal: this.abortController.signal
    });
    const div = document.createElement("div");
    div.innerHTML = await response.text();
    return { hasResults: div.querySelector(".predictive-search__results-categories") !== null, html: div.firstElementChild.innerHTML };
  }
  _startNewSearch() {
    this.inputElement.value = "";
    this.inputElement.focus();
    const event = new Event("input", {
      bubbles: true,
      cancelable: true
    });
    this.inputElement.dispatchEvent(event);
  }
  _supportPredictiveApi() {
    const shopifyFeatureRequests = JSON.parse(document.getElementById("shopify-features").innerHTML);
    return shopifyFeatureRequests["predictiveSearch"];
  }
  /**
   * Simple function that allows to debounce
   */
  _debounce(fn, delay3) {
    let timer = null;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        fn.apply(this, args);
      }, delay3);
    };
  }
};
window.customElements.define("predictive-search-drawer", PredictiveSearchDrawer);

// js/custom-element/section/timeline/timeline.js
var Timeline = class extends HTMLElement {
  connectedCallback() {
    this.prevNextButtons = this.querySelector("prev-next-buttons");
    this.pageDots = this.querySelector("page-dots");
    this.scrollBarElement = this.querySelector(".timeline__progress-bar");
    this.listWrapperElement = this.querySelector(".timeline__list-wrapper");
    this.listItemElements = Array.from(this.querySelectorAll(".timeline__item"));
    this.isScrolling = false;
    if (this.listItemElements.length > 1) {
      this.addEventListener("prev-next:prev", this.previous.bind(this));
      this.addEventListener("prev-next:next", this.next.bind(this));
      this.addEventListener("page-dots:changed", (event) => this.select(event.detail.index));
      if (Shopify.designMode) {
        this.addEventListener("shopify:block:select", (event) => {
          this.select([...event.target.parentNode.children].indexOf(event.target), !event.detail.load);
        });
      }
      this.itemIntersectionObserver = new IntersectionObserver(this._onItemObserved.bind(this), { threshold: 0.4 });
      const mediaQuery = window.matchMedia(window.themeVariables.breakpoints.pocket);
      mediaQuery.addListener(this._onMediaChanged.bind(this));
      this._onMediaChanged(mediaQuery);
    }
  }
  get selectedIndex() {
    return this.listItemElements.findIndex((item) => !item.hasAttribute("hidden"));
  }
  previous() {
    this.select(Math.max(0, this.selectedIndex - 1));
  }
  next() {
    this.select(Math.min(this.selectedIndex + 1, this.listItemElements.length - 1));
  }
  select(index, animate = true) {
    const listItemElement = this.listItemElements[index], boundingRect = listItemElement.getBoundingClientRect();
    if (animate) {
      this.isScrolling = true;
      setTimeout(() => this.isScrolling = false, 800);
    }
    if (window.matchMedia(window.themeVariables.breakpoints.pocket).matches) {
      this.listWrapperElement.scrollTo({
        behavior: animate ? "smooth" : "auto",
        left: this.listItemElements[0].clientWidth * index
        /* Note: the last element does not contain extra margin so we use the first element width */
      });
    } else {
      this.listWrapperElement.scrollBy({
        behavior: animate ? "smooth" : "auto",
        left: Math.floor(boundingRect.left - window.innerWidth / 2 + boundingRect.width / 2)
      });
    }
    this._onItemSelected(index);
  }
  _onItemSelected(index) {
    const listItemElement = this.listItemElements[index];
    listItemElement.removeAttribute("hidden", "false");
    getSiblings(listItemElement).forEach((item) => item.setAttribute("hidden", ""));
    this.prevNextButtons.isPrevDisabled = index === 0;
    this.prevNextButtons.isNextDisabled = index === this.listItemElements.length - 1;
    this.pageDots.selectedIndex = index;
    this.scrollBarElement?.style.setProperty("--transform", `${100 / (this.listItemElements.length - 1) * index}%`);
  }
  _onItemObserved(entries) {
    if (this.isScrolling) {
      return;
    }
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        this._onItemSelected([...entry.target.parentNode.children].indexOf(entry.target));
      }
    });
  }
  _onMediaChanged(event) {
    if (event.matches) {
      this.listItemElements.forEach((item) => this.itemIntersectionObserver.observe(item));
    } else {
      this.listItemElements.forEach((item) => this.itemIntersectionObserver.unobserve(item));
    }
  }
};
window.customElements.define("time-line", Timeline);

// js/custom-element/section/press/press-list.js
var PressList = class extends CustomHTMLElement {
  connectedCallback() {
    this.pressItemsWrapper = this.querySelector(".press-list__wrapper");
    this.pressItems = Array.from(this.querySelectorAll("press-item"));
    this.pageDots = this.querySelector("page-dots");
    if (this.pressItems.length > 1) {
      if (Shopify.designMode) {
        this.addEventListener("shopify:block:select", (event) => {
          this.intersectionObserver?.disconnect();
          if (event.detail.load || !event.target.selected) {
            this.select(event.target.index, !event.detail.load);
          }
        });
      }
      this.pressItemsWrapper.addEventListener("swiperight", this.previous.bind(this));
      this.pressItemsWrapper.addEventListener("swipeleft", this.next.bind(this));
      this.addEventListener("page-dots:changed", (event) => this.select(event.detail.index));
      this._blockVerticalScroll();
    }
    if (this.hasAttribute("reveal-on-scroll")) {
      this._setupVisibility();
    }
  }
  async _setupVisibility() {
    await this.untilVisible();
    this.pressItems[this.selectedIndex].transitionToEnter();
  }
  get selectedIndex() {
    return this.pressItems.findIndex((item) => item.selected);
  }
  previous() {
    this.select((this.selectedIndex - 1 + this.pressItems.length) % this.pressItems.length);
  }
  next() {
    this.select((this.selectedIndex + 1 + this.pressItems.length) % this.pressItems.length);
  }
  async select(index, shouldAnimate = true) {
    const previousItem = this.pressItems[this.selectedIndex], newItem = this.pressItems[index];
    await previousItem.transitionToLeave(shouldAnimate);
    this.pageDots.selectedIndex = index;
    await newItem.transitionToEnter(shouldAnimate);
  }
};
Object.assign(PressList.prototype, VerticalScrollBlockerMixin);
window.customElements.define("press-list", PressList);

// js/custom-element/section/press/press-item.js
var PressItem = class extends HTMLElement {
  connectedCallback() {
    this.addEventListener("split-lines:re-split", (event) => {
      Array.from(event.target.children).forEach((line) => line.style.visibility = this.selected ? "visible" : "hidden");
    });
  }
  get index() {
    return [...this.parentNode.children].indexOf(this);
  }
  get selected() {
    return !this.hasAttribute("hidden");
  }
  async transitionToLeave(shouldAnimate = true) {
    const textLines = await resolveAsyncIterator(this.querySelectorAll("split-lines")), animation = new CustomAnimation(new ParallelEffect(textLines.reverse().map((item, index) => {
      return new CustomKeyframeEffect(item, {
        visibility: ["visible", "hidden"],
        clipPath: ["inset(0 0 0 0)", "inset(0 0 100% 0)"],
        transform: ["translateY(0)", "translateY(100%)"]
      }, {
        duration: 350,
        delay: 60 * index,
        easing: "cubic-bezier(0.68, 0.00, 0.77, 0.00)"
      });
    })));
    shouldAnimate ? animation.play() : animation.finish();
    await animation.finished;
    this.setAttribute("hidden", "");
  }
  async transitionToEnter(shouldAnimate = true) {
    this.removeAttribute("hidden");
    const textLines = await resolveAsyncIterator(this.querySelectorAll("split-lines, .testimonial__author")), animation = new CustomAnimation(new ParallelEffect(textLines.map((item, index) => {
      return new CustomKeyframeEffect(item, {
        visibility: ["hidden", "visible"],
        clipPath: ["inset(0 0 100% 0)", "inset(0 0 0px 0)"],
        transform: ["translateY(100%)", "translateY(0)"]
      }, {
        duration: 550,
        delay: 120 * index,
        easing: "cubic-bezier(0.23, 1, 0.32, 1)"
      });
    })));
    shouldAnimate ? animation.play() : animation.finish();
    return animation.finished;
  }
};
window.customElements.define("press-item", PressItem);

// js/custom-element/section/header/desktop-navigation.js
var DesktopNavigation = class extends CustomHTMLElement {
  connectedCallback() {
    this.openingTimeout = null;
    this.currentMegaMenu = null;
    this.delegate.on("mouseenter", ".has-dropdown", (event, target) => {
      if (event.target === target && event.relatedTarget !== null) {
        this.openDropdown(target);
      }
    }, true);
    this.delegate.on("click", ".header__linklist-link[aria-expanded], .nav-dropdown__link[aria-expanded]", (event, target) => {
      if (window.matchMedia("(hover: hover)").matches || target.getAttribute("aria-expanded") === "true") {
        return;
      }
      event.preventDefault();
      this.openDropdown(target.parentElement);
    });
    this.delegate.on("click", ".mega-menu-v2__third-layer-link", (event, target) => {
      this.switchMenuLayer(target);
    });
    this.delegate.on("shopify:block:select", (event) => this.openDropdown(event.target.parentElement));
    this.delegate.on("shopify:block:deselect", (event) => this.closeDropdown(event.target.parentElement));
  }
  switchMenuLayer(button) {
    const wrapperId = button.getAttribute('aria-controls');
    const inner = button.closest('.mega-menu-v2__inner');
    if (!inner || !wrapperId) return;

    inner.querySelectorAll('.mega-menu-v2__third-layer-link').forEach(function(btn) {
      btn.setAttribute('aria-expanded', 'false');
    });

    inner.querySelectorAll('.mega-menu-v2__links-wrapper').forEach(function(wrapper) {
      wrapper.hidden = true;
    });

    const targetWrapper = document.getElementById(wrapperId);
    if (targetWrapper) targetWrapper.hidden = false;

    button.setAttribute('aria-expanded', 'true');
  }
  openDropdown(parentElement) {
    console.log("parentElement", parentElement);
    const menuItem = parentElement.querySelector("[aria-controls]");
    console.log("menuItem", menuItem);
    const dropdown = parentElement.querySelector(`#${menuItem.getAttribute("aria-controls")}`);
    console.log("dropdown", dropdown);
    this.currentMegaMenu = dropdown.classList.contains("mega-menu") ? dropdown : null;
    let openingTimeout = setTimeout(() => {
      if (menuItem.getAttribute("aria-expanded") === "true") {
        return;
      }
      menuItem.setAttribute("aria-expanded", "true");
      dropdown.removeAttribute("hidden");
      if (dropdown.classList.contains("mega-menu") && !MediaFeatures.prefersReducedMotion()) {
        const items = Array.from(dropdown.querySelectorAll(".mega-menu__column, .mega-menu__image-push"));
        items.forEach((item) => {
          item.getAnimations().forEach((animation2) => animation2.cancel());
          item.style.opacity = 0;
        });
        const animation = new CustomAnimation(new ParallelEffect(items.map((item, index) => {
          return new CustomKeyframeEffect(item, {
            opacity: [0, 1],
            transform: ["translateY(20px)", "translateY(0)"]
          }, {
            duration: 250,
            delay: 100 + 60 * index,
            easing: "cubic-bezier(0.65, 0, 0.35, 1)"
          });
        })));
        animation.play();
      }
      const leaveListener = (event) => {
        if (event.relatedTarget !== null) {
          this.closeDropdown(parentElement);
          parentElement.removeEventListener("mouseleave", leaveListener);
        }
      };
      const leaveDocumentListener = () => {
        this.closeDropdown(parentElement);
        document.documentElement.removeEventListener("mouseleave", leaveDocumentListener);
      };
      parentElement.addEventListener("mouseleave", leaveListener);
      document.documentElement.addEventListener("mouseleave", leaveDocumentListener);
      openingTimeout = null;
      this.dispatchEvent(new CustomEvent("desktop-nav:dropdown:open", { bubbles: true }));
    }, 100);
    parentElement.addEventListener("mouseleave", () => {
      if (openingTimeout) {
        clearTimeout(openingTimeout);
      }
    }, { once: true });
  }
  closeDropdown(parentElement) {
    const menuItem = parentElement.querySelector("[aria-controls]"), dropdown = parentElement.querySelector(`#${menuItem.getAttribute("aria-controls")}`);
    requestAnimationFrame(() => {
      dropdown.classList.add("is-closing");
      menuItem.setAttribute("aria-expanded", "false");
      setTimeout(() => {
        dropdown.setAttribute("hidden", "");
        clearTimeout(this.openingTimeout);
        dropdown.classList.remove("is-closing");
      }, dropdown.classList.contains("mega-menu") && this.currentMegaMenu !== dropdown ? 250 : 0);
      this.dispatchEvent(new CustomEvent("desktop-nav:dropdown:close", { bubbles: true }));
    });
  }
};
window.customElements.define("desktop-navigation", DesktopNavigation);

// js/custom-element/section/header/mobile-navigation.js
var MobileNavigation = class extends DrawerContent {
  get apparitionAnimation() {
    if (this._apparitionAnimation) {
      return this._apparitionAnimation;
    }
    if (!MediaFeatures.prefersReducedMotion()) {
      const navItems = Array.from(this.querySelectorAll('.mobile-nav__item[data-level="1"]')), effects = [];
      effects.push(new ParallelEffect(navItems.map((item, index) => {
        return new CustomKeyframeEffect(item, {
          opacity: [0, 1],
          transform: ["translateX(-40px)", "translateX(0)"]
        }, {
          duration: 150,
          delay: 150 + 60 * index - Math.min(2 * index * index, 120 * index),
          easing: "cubic-bezier(0.25, 1, 0.5, 1)"
        });
      })));
      const bottomBar = this.querySelector(".drawer__footer");
      if (bottomBar) {
        effects.push(new CustomKeyframeEffect(
          bottomBar,
          {
            opacity: [0, 1],
            transform: ["translateY(100%)", "translateY(0)"]
          },
          {
            duration: 300,
            delay: 500 + Math.max(125 * navItems.length - 25 * navItems.length, 25),
            easing: "cubic-bezier(0.25, 1, 0.5, 1)"
          }
        ));
      }
      return this._apparitionAnimation = new CustomAnimation(new ParallelEffect(effects));
    }
  }
  attributeChangedCallback(name, oldValue, newValue) {
    super.attributeChangedCallback(name, oldValue, newValue);
    switch (name) {
      case "open":
        if (this.open && this.apparitionAnimation) {
          Array.from(this.querySelectorAll('.mobile-nav__item[data-level="1"], .drawer__footer')).forEach((item) => item.style.opacity = 0);
          this.apparitionAnimation.play();
        }
        triggerEvent(this, this.open ? "mobile-nav:open" : "mobile-nav:close");
        if (this.open) {
          const searchButton = this.querySelector('[aria-controls="search-drawer"]');
          if (searchButton) {
            searchButton.setAttribute("aria-expanded", "false");
          }
        }
    }
  }
};
window.customElements.define("mobile-navigation", MobileNavigation);

// js/custom-element/section/header/store-header.js
var StoreHeader = class extends CustomHTMLElement {
  connectedCallback() {
    if (window.ResizeObserver) {
      this.resizeObserver = new ResizeObserver(this._updateCustomProperties.bind(this));
      this.resizeObserver.observe(this);
      this.resizeObserver.observe(this.querySelector(".header__wrapper"));
    }
    this._onWindowScrollListener = this._handleScroll.bind(this);
    window.addEventListener("scroll", this._onWindowScrollListener);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    if (window.ResizeObserver) {
      this.resizeObserver.disconnect();
    }
    if (this.isTransparent && this.isSticky) {
      window.removeEventListener("scroll", this._onWindowScrollListener);
    }
  }
  get isSticky() {
    return this.hasAttribute("sticky");
  }
  get isTransparent() {
    return this.hasAttribute("transparent");
  }
  get transparentHeaderThreshold() {
    return 25;
  }
  set lockTransparency(value) {
    this.isTransparencyDetectionLocked = value;
    this._checkTransparentHeader();
  }
  /**
   * This method allows to keep in sync various CSS variables that are used to size various elements
   */
  _updateCustomProperties(entries) {
    entries.forEach((entry) => {
      if (entry.target === this) {
        const height = entry.borderBoxSize ? entry.borderBoxSize.length > 0 ? entry.borderBoxSize[0].blockSize : entry.borderBoxSize.blockSize : entry.target.clientHeight;
        document.documentElement.style.setProperty("--header-height", `${height}px`);
      }
      if (entry.target.classList.contains("header__wrapper")) {
        const heightWithoutNav = entry.borderBoxSize ? entry.borderBoxSize.length > 0 ? entry.borderBoxSize[0].blockSize : entry.borderBoxSize.blockSize : entry.target.clientHeight;
        document.documentElement.style.setProperty("--header-height-without-bottom-nav", `${heightWithoutNav}px`);
      }
    });
  }
  _handleScroll(event) {
    const halfWindowHeight = window.innerHeight / 6;

    if (window.scrollY > halfWindowHeight + 100) {
      this.classList.add("header--scrolled");
    } else if (window.scrollY < halfWindowHeight - 100) {
      this.classList.remove("header--scrolled");
    }
  }
  _checkTransparentHeader(event) {
    if (this.isTransparencyDetectionLocked || window.scrollY > this.transparentHeaderThreshold || event && event.type === "mouseenter") {
      this.classList.remove("header--transparent");
    } else {
      this.classList.add("header--transparent");
    }
  }
};
window.customElements.define("store-header", StoreHeader);

// js/custom-element/section/product/gift-card-recipient.js
var GiftCardRecipient = class extends HTMLElement {
  connectedCallback() {
    const properties = Array.from(this.querySelectorAll('[name*="properties"]')), checkboxPropertyName = "properties[__shopify_send_gift_card_to_recipient]";
    this.recipientCheckbox = properties.find((input) => input.name === checkboxPropertyName);
    this.recipientOtherProperties = properties.filter((input) => input.name !== checkboxPropertyName);
    this.recipientFieldsContainer = this.querySelector(".gift-card-recipient__fields");
    this.recipientCheckbox?.addEventListener("change", this._synchronizeProperties.bind(this));
    this.offsetProperty = this.querySelector('[name="properties[__shopify_offset]"]');
    if (this.offsetProperty) {
      this.offsetProperty.value = (/* @__PURE__ */ new Date()).getTimezoneOffset().toString();
    }
    this.recipientSendOnProperty = this.querySelector('[name="properties[Send on]"]');
    const minDate = /* @__PURE__ */ new Date();
    const maxDate = /* @__PURE__ */ new Date();
    maxDate.setDate(minDate.getDate() + 90);
    this.recipientSendOnProperty?.setAttribute("min", this._formatDate(minDate));
    this.recipientSendOnProperty?.setAttribute("max", this._formatDate(maxDate));
    this._synchronizeProperties();
  }
  _synchronizeProperties() {
    this.recipientOtherProperties.forEach((property) => property.disabled = !this.recipientCheckbox.checked);
    this.recipientFieldsContainer.classList.toggle("js:hidden", !this.recipientCheckbox.checked);
  }
  _formatDate(date) {
    const offset = date.getTimezoneOffset();
    const offsetDate = new Date(date.getTime() - offset * 60 * 1e3);
    return offsetDate.toISOString().split("T")[0];
  }
};
if (!window.customElements.get("gift-card-recipient")) {
  window.customElements.define("gift-card-recipient", GiftCardRecipient);
}

// js/custom-element/section/product/image-zoom.js
var PhotoSwipeUi = class {
  constructor(pswp) {
    this.photoSwipeInstance = pswp;
    this.delegate = new main_default(this.photoSwipeInstance.scrollWrap);
    this.maxSpreadZoom = window.themeVariables.settings.mobileZoomFactor || 2;
    this.pswpUi = this.photoSwipeInstance.scrollWrap.querySelector(".pswp__ui");
    this.delegate.on("click", '[data-action="pswp-close"]', this._close.bind(this));
    this.delegate.on("click", '[data-action="pswp-prev"]', this._goToPrev.bind(this));
    this.delegate.on("click", '[data-action="pswp-next"]', this._goToNext.bind(this));
    this.delegate.on("click", '[data-action="pswp-move-to"]', this._moveTo.bind(this));
    this.photoSwipeInstance.listen("close", this._onPswpClosed.bind(this));
    this.photoSwipeInstance.listen("doubleTap", this._onPswpDoubleTap.bind(this));
    this.photoSwipeInstance.listen("beforeChange", this._onPswpBeforeChange.bind(this));
    this.photoSwipeInstance.listen("initialZoomInEnd", this._onPswpInitialZoomInEnd.bind(this));
    this.photoSwipeInstance.listen("initialZoomOut", this._onPswpInitialZoomOut.bind(this));
    this.photoSwipeInstance.listen("parseVerticalMargin", this._onPswpParseVerticalMargin.bind(this));
    this.delegate.on("pswpTap", ".pswp__img", this._onPswpTap.bind(this));
  }
  init() {
    const prevNextButtons = this.pswpUi.querySelector(".pswp__prev-next-buttons"), dotsNavWrapper = this.pswpUi.querySelector(".pswp__dots-nav-wrapper");
    if (this.photoSwipeInstance.items.length <= 1) {
      prevNextButtons.style.display = "none";
      dotsNavWrapper.style.display = "none";
      return;
    }
    prevNextButtons.style.display = "";
    dotsNavWrapper.style.display = "";
    let dotsNavHtml = "";
    this.photoSwipeInstance.items.forEach((item, index) => {
      dotsNavHtml += `
        <button class="dots-nav__item tap-area" ${index === 0 ? 'aria-current="true"' : ""} data-action="pswp-move-to">
          <span class="visually-hidden">Go to slide ${index}</span>
        </button>
      `;
    });
    dotsNavWrapper.querySelector(".pswp__dots-nav-wrapper .dots-nav").innerHTML = dotsNavHtml;
  }
  _close() {
    this.photoSwipeInstance.close();
  }
  _goToPrev() {
    this.photoSwipeInstance.prev();
  }
  _goToNext() {
    this.photoSwipeInstance.next();
  }
  _moveTo(event, target) {
    this.photoSwipeInstance.goTo([...target.parentNode.children].indexOf(target));
  }
  _onPswpClosed() {
    this.delegate.off("pswpTap");
  }
  _onPswpDoubleTap(point) {
    const initialZoomLevel = this.photoSwipeInstance.currItem.initialZoomLevel;
    if (this.photoSwipeInstance.getZoomLevel() !== initialZoomLevel) {
      this.photoSwipeInstance.zoomTo(initialZoomLevel, point, 333);
    } else {
      this.photoSwipeInstance.zoomTo(initialZoomLevel < 0.7 ? 1 : this.maxSpreadZoom, point, 333);
    }
  }
  _onPswpTap(event) {
    if (event.detail.pointerType === "mouse") {
      this.photoSwipeInstance.toggleDesktopZoom(event.detail.releasePoint);
    }
  }
  _onPswpBeforeChange() {
    if (this.photoSwipeInstance.items.length <= 1) {
      return;
    }
    const activeDot = this.photoSwipeInstance.scrollWrap.querySelector(`.dots-nav__item:nth-child(${this.photoSwipeInstance.getCurrentIndex() + 1})`);
    activeDot.setAttribute("aria-current", "true");
    getSiblings(activeDot).forEach((item) => item.removeAttribute("aria-current"));
  }
  _onPswpInitialZoomInEnd() {
    this.pswpUi?.classList.remove("pswp__ui--hidden");
  }
  _onPswpInitialZoomOut() {
    this.pswpUi?.classList.add("pswp__ui--hidden");
  }
  _onPswpParseVerticalMargin(item) {
    item.vGap.bottom = this.photoSwipeInstance.items.length <= 1 || window.matchMedia(window.themeVariables.breakpoints.lapAndUp).matches ? 0 : 60;
  }
};
var ProductImageZoom = class extends OpenableElement {
  connectedCallback() {
    super.connectedCallback();
    this.mediaElement = this.closest(".product__media");
    this.maxSpreadZoom = window.themeVariables.settings.mobileZoomFactor || 2;
    LibraryLoader.load("photoswipe");
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.photoSwipeInstance?.destroy();
  }
  async attributeChangedCallback(name, oldValue, newValue) {
    super.attributeChangedCallback(name, oldValue, newValue);
    switch (name) {
      case "open":
        if (this.open) {
          await LibraryLoader.load("photoswipe");
          this._openPhotoSwipe();
        }
    }
  }
  async _openPhotoSwipe() {
    const items = await this._buildItems();
    this.photoSwipeInstance = new window.ThemePhotoSwipe(this, PhotoSwipeUi, items, {
      index: items.findIndex((item) => item.selected),
      maxSpreadZoom: this.maxSpreadZoom,
      loop: false,
      allowPanToNext: false,
      closeOnScroll: false,
      closeOnVerticalDrag: MediaFeatures.supportsHover(),
      showHideOpacity: true,
      arrowKeys: true,
      history: false,
      getThumbBoundsFn: () => {
        const thumbnail = this.mediaElement.querySelector(".product__media-item.is-selected"), pageYScroll = window.pageYOffset || document.documentElement.scrollTop, rect = thumbnail.getBoundingClientRect();
        return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
      },
      getDoubleTapZoom: (isMouseClick, item) => {
        if (isMouseClick) {
          return item.w > item.h ? 1.6 : 1;
        } else {
          return item.initialZoomLevel < 0.7 ? 1 : 1.33;
        }
      }
    });
    let lastWidth = null;
    this.photoSwipeInstance.updateSize = new Proxy(this.photoSwipeInstance.updateSize, {
      apply: (target, thisArg, argArray) => {
        if (lastWidth !== window.innerWidth) {
          target(arguments);
          lastWidth = window.innerWidth;
        }
      }
    });
    this.photoSwipeInstance.listen("close", () => {
      this.open = false;
    });
    this.photoSwipeInstance.init();
  }
  async _buildItems() {
    const activeImages = Array.from(this.mediaElement.querySelectorAll('.product__media-item[data-media-type="image"]:not(.is-filtered)')), product = await ProductLoader.load(this.getAttribute("product-handle"));
    return Promise.resolve(activeImages.map((item) => {
      const matchedMedia = product["media"].find((media) => media.id === parseInt(item.getAttribute("data-media-id"))), supportedSizes = getSupportedSizes(matchedMedia, [200, 300, 400, 500, 600, 700, 800, 1e3, 1200, 1400, 1600, 1800, 2e3, 2200, 2400, 2600, 2800, 3e3]), desiredWidth = Math.min(supportedSizes[supportedSizes.length - 1], window.innerWidth);
      return {
        selected: item.classList.contains("is-selected"),
        src: getSizedMediaUrl(matchedMedia, `${Math.ceil(Math.min(desiredWidth * window.devicePixelRatio * this.maxSpreadZoom, 3e3))}x`),
        msrc: item.firstElementChild.currentSrc,
        originalMedia: matchedMedia,
        w: desiredWidth,
        h: parseInt(desiredWidth / matchedMedia["aspect_ratio"])
      };
    }));
  }
};
window.customElements.define("product-image-zoom", ProductImageZoom);

// js/custom-element/section/product/inventory.js
var ProductInventory = class extends HTMLElement {
  connectedCallback() {
    const scriptTag = this.querySelector("script");
    if (!scriptTag) {
      return;
    }
    this.inventories = JSON.parse(scriptTag.innerHTML);
    document.getElementById(this.getAttribute("form-id"))?.addEventListener("variant:changed", this._onVariantChanged.bind(this));
  }
  _onVariantChanged(event) {
    this.querySelector("span")?.remove();
    if (event.detail.variant && this.inventories[event.detail.variant["id"]] !== "") {
      this.hidden = false;
      this.insertAdjacentHTML("afterbegin", this.inventories[event.detail.variant["id"]]);
    } else {
      this.hidden = true;
    }
  }
};
window.customElements.define("product-inventory", ProductInventory);

// js/custom-element/section/product/payment-container.js
var PaymentContainer = class extends HTMLElement {
  connectedCallback() {
    document.getElementById(this.getAttribute("form-id"))?.addEventListener("variant:changed", this._onVariantChanged.bind(this));
    if (Shopify.designMode && Shopify.PaymentButton) {
      Shopify.PaymentButton.init();
    }
  }
  get bis_active () {
    return this.getAttribute("enable-back-in-stock") == "true" ? true : false;
  }
  _onVariantChanged(event) {
    this._updateAddToCartButton(event.detail.newVariant);
    // this._updateDynamicCheckoutButton(event.detail.variant);
  }
  _updateAddToCartButton(variant) {
    let addToCartButtonElement = this.querySelector("[data-product-add-to-cart-button]");
    const bisTrigger = this.querySelector("#BIS_trigger");
    const quantitySelector = this.querySelector(".product_quantity_selector__toggle_button");
    if (!addToCartButtonElement) {
      return;
    }
    let addToCartButtonText = "";
    addToCartButtonElement.classList.remove("button--primary", "button--secondary", "button--ternary");
    if (!variant) {
      addToCartButtonElement.setAttribute("disabled", "disabled");
      addToCartButtonElement.classList.add("button--ternary");
      addToCartButtonText = window.themeVariables.strings.productFormUnavailable;
    } else {
      if (variant["available"]) {
        addToCartButtonElement.removeAttribute("disabled");
        addToCartButtonElement.classList.add(addToCartButtonElement.hasAttribute("data-use-primary") ? "button--primary" : "button--secondary");
        addToCartButtonText = addToCartButtonElement.getAttribute("data-button-content");
        if (this.bis_active) {
          if (bisTrigger) {
            bisTrigger.hidden = true;
          }
          if (quantitySelector) {
            quantitySelector.hidden = false;
          }
          addToCartButtonElement.hidden = false;
        }
      } else {
        addToCartButtonElement.setAttribute("disabled", "disabled");
        addToCartButtonElement.classList.add("button--ternary");
        addToCartButtonText = window.themeVariables.strings.productFormSoldOut;
        if (this.bis_active) {
          addToCartButtonElement.hidden = true;
          bisTrigger.hidden = false;
          bisTrigger.dataset.variantId = variant["id"];
          if (quantitySelector) {
            quantitySelector.hidden = true;
          }
        }
      }
    }
    if (addToCartButtonElement.getAttribute("is") === "loader-button") {
      addToCartButtonElement.firstElementChild.innerHTML = addToCartButtonText;
    } else {
      addToCartButtonElement.innerHTML = addToCartButtonText;
    }
  }
  // _updateDynamicCheckoutButton(variant) {
  //   let paymentButtonElement = this.querySelector(".shopify-payment-button");
  //   if (!paymentButtonElement) {
  //     return;
  //   }
  //   paymentButtonElement.style.display = !variant || !variant["available"] ? "none" : "block";
  // }
};
window.customElements.define("product-payment-container", PaymentContainer);

var SaleBadge = class extends CustomHTMLElement {
  connectedCallback() {
    document.getElementById(this.getAttribute("form-id"))?.addEventListener("variant:changed", this._onVariantChanged.bind(this));
  }
  get variantId() {
    return parseInt(this.saleBadge.getAttribute("data-variant-id"));
  }
  get saleBadge() {
    return this.querySelector(".sale-badge");
  }
  _onVariantChanged(event) {
    const variant = event.detail.newVariant;
    const newVariantId = variant ? parseInt(variant["id"]) : null;
    if (this.variantId === newVariantId) {
      this.hidden = false;
      this.saleBadge.hidden = false;
    } else {
      this.hidden = true;
    }
  }
};
window.customElements.define("sale-badge", SaleBadge);

// js/custom-element/section/product/payment-terms.js
var PaymentTerms = class extends CustomHTMLElement {
  connectedCallback() {
    document.getElementById(this.getAttribute("form-id"))?.addEventListener("variant:changed", this._onVariantChanged.bind(this));
  }
  _onVariantChanged(event) {
    const variant = event.detail.variant;
    if (variant) {
      const idElement = this.querySelector('[name="id"]');
      idElement.value = variant["id"];
      idElement.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }
};
window.customElements.define("product-payment-terms", PaymentTerms);

// js/custom-element/section/product/product-form.js
var ProductForm = class extends HTMLFormElement {
  connectedCallback() {
    // console.log("ProductForm connected", this);
    this.id.disabled = false;
    this.addEventListener("submit", this._onSubmit.bind(this));
  }
  async _onSubmit(event) {
    event.preventDefault();
    if (!this.checkValidity()) {
      this.reportValidity();
      return;
    }
    const submitButtons = Array.from(this.elements).filter((button) => button.type === "submit");
    submitButtons.forEach((submitButton) => {
      submitButton.setAttribute("disabled", "disabled");
      submitButton.setAttribute("aria-busy", "true");
    });
    const productForm = new FormData(this);

    productForm.append("sections", ["mini-cart", "cart-notification-popup", "product-recommendations"]);
    // productForm.append("section_url", "https://www.paperandtea.de/products/matcha-starter-kit");
    productForm.delete("option1");
    productForm.delete("option2");
    productForm.delete("option3");
    const response = await fetch(`${window.themeVariables.routes.cartAddUrl}.js`, {
      body: productForm,
      method: "POST",
      headers: {
        "X-Requested-With": "XMLHttpRequest"
        // This is needed for the endpoint to properly return 422
      }
    });
    console.log("Add to cart response", response);
    submitButtons.forEach((submitButton) => {
      submitButton.removeAttribute("disabled");
      submitButton.removeAttribute("aria-busy");
    });
    const responseJson = await response.json();
    console.log("Add to cart response", responseJson);
    if (response.ok) {
      if (window.themeVariables.settings.cartType === "page" || window.themeVariables.settings.pageType === "cart") {
        return window.location.href = `${Shopify.routes.root}cart`;
      }
      this.dispatchEvent(new CustomEvent("variant:added", {
        bubbles: true,
        detail: {
          variant: responseJson.hasOwnProperty("items") ? responseJson["items"][0] : responseJson
        }
      }));
      fetch(`${window.themeVariables.routes.cartUrl}.js`).then(async (response2) => {
        const cartContent = await response2.json();
        document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
          bubbles: true,
          detail: {
            cart: cartContent
          }
        }));
        // cartContent["sections"] = responseJson["sections"];
        document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
          bubbles: true,
          detail: {
            cart: cartContent,
            openMiniCart: window.themeVariables.settings.cartType === "drawer" && this.closest(".drawer") === null
          }
        }));
        document.dispatchEvent(new CustomEvent("cart-notification:show", {
          bubbles: true,
          cancelable: true,
          detail: {
            variant: responseJson.hasOwnProperty("items") ? responseJson["items"][0] : responseJson,
            status: response.ok ? "success" : "error",
            error: responseJson["description"] || ""
          }
        }));
      });
    } else {
      document.dispatchEvent(new CustomEvent("cart-notification:show", {
        bubbles: true,
        cancelable: true,
        detail: {
          status: response.ok ? "success" : "error",
          error: responseJson["description"] || ""
        }
      }));
    }
  }
};
window.customElements.define("product-form", ProductForm, { extends: "form" });

// js/custom-element/section/product/sticky-form.js
var BundleProductForm = class extends ProductForm {
  constructor() {
    super();
    
    this.data = JSON.parse(this.querySelector("script[bundle-data]").innerHTML);
    
    this.variants = [];
    this.selectedVariants = {};
    this.bundleVariantData = {
      firstVariantId: this.data.firstVariant
    };
    this.data.variants.forEach((variant) => {
      this.selectedVariants[variant.id] = [];
      this.bundleVariantData[variant.id] = variant;
    });
    this.curProdVariant = this.data.firstVariant;

    this.formId = this.getAttribute("id");

    // this.totalElementCount = this.bundleVariantData[this.data.firstVariant].totalElementCount;
    this.selectedVariantsWrappers = document.querySelectorAll(`.selected-variants[form="${this.formId}"]`);

    this._onQuantityChangedHandler = this._onBundleQuantityChanged.bind(this);
    this._onTotalQuantityChangedHandler = this._onTotalQuantityChanged.bind(this);
    this._onProductVariantChangedHandler = this._onProductVariantChanged.bind(this);

    this._initFixedProductData = null;
    // this._refreshSelectedVariants();
    // this._initPositions();
  }
  connectedCallback() {
    super.connectedCallback();
    
    this.addEventListener("bundle:quantity:changed", this._onQuantityChangedHandler);
    this.addEventListener("bundle:step:changed", this._onTotalQuantityChangedHandler);
    this.addEventListener("bundle:product_variant:changed", this._onProductVariantChangedHandler);
    // document.addEventListener("bundle:quantity:changed", this._onQuantityChangedHandler);
    this._initFixedProducts();

    this.dispatchEvent(new CustomEvent("bundle-data-ready", {
      bubbles: true,
      composed: true, // wichtig, damit das Event Shadow DOM durchdringt
    }));
  }
  disconnectedCallback() {
    this.removeEventListener("bundle:quantity:changed", this._onQuantityChangedHandler);
    this.removeEventListener("bundle:step:changed", this._onTotalQuantityChangedHandler);
    this.removeEventListener("bundle:product_variant:changed", this._onProductVariantChangedHandler);
  }
  get bundleData() {
    return this.bundleVariantData;
  }
  get totalQuantity() {
    return parseInt(this.getAttribute("total-element-count"));
  }
  set totalQuantity(value) {
    this.setAttribute("total-element-count", value);
  }
  set curProdVariant(value) {
    this.setAttribute("cur-product-variant-id", value);
  }
  get curProdVariant() {
    return parseInt(this.getAttribute("cur-product-variant-id"));
  }
  get initFixedProductData() {
    return this._initFixedProductData;
  }
  _initFixedProducts() {
    this.data.variants.forEach((variant) => {
      this.selectedVariants[variant.id] = this.bundleVariantData[variant.id].fixedParts.items.map((fixedPart) => {
        return {
          variantId: fixedPart.variantId,
          quantity: 1,
          imageUrl: fixedPart.imageUrl,
          imageAlt: fixedPart.imageAlt,
          stepHandle: fixedPart.stepHandle,
          variantPrice: fixedPart.variantPrice
        };
      });
    });

    const validCounts = this.bundleVariantData[this.curProdVariant].totalElementCount;
    const validQuantity = validCounts.includes(this.selectedVariants[this.curProdVariant].length);

    this._initFixedProductData = {
      variants: this.selectedVariants[this.curProdVariant],
      validQuantity: validQuantity
    };
    this.dispatchEvent(new CustomEvent("bundle:variants:replace", {
      bubbles: true,
      detail: this._initFixedProductData
    }));

    /* Enable ATC button if fixed parts already satisfy the minimum quantity */
    if (validQuantity) {
      this._activateSubmitButtons();
    }
  }
  _onProductVariantChanged(event) {
    const newVariantId = event.detail.newVariantId;
    this.curProdVariant = newVariantId;

    this._updateFormInputs(this.selectedVariants[newVariantId], newVariantId);
    
    const validCounts = this.bundleVariantData[this.curProdVariant].totalElementCount;
    const validQuantity = validCounts.includes(this.selectedVariants[this.curProdVariant].length);
    this.dispatchEvent(new CustomEvent("bundle:variants:replace", {
      bubbles: true,
      detail: {
        variants: this.selectedVariants[this.curProdVariant],
        validQuantity: validQuantity
      }
    }));
  }
  _updateFormInputs(variants, productVariantId) {
    this.querySelector("input[name='id']").value = productVariantId;

    const property = {};
    for (let i = 0; i < variants.length; i++) {
      const id = `gid://shopify/ProductVariant/${variants[i].variantId}`;
      if (property[id]) {
        property[id].quantity += variants[i].quantity;
      } else {
        property[id] = {
          quantity: variants[i].quantity
        };
      }
    }

    this.querySelector("input[property]").value = JSON.stringify(property);
  }
  _onTotalQuantityChanged(event) {
    this.totalQuantity = this.totalQuantity + (event.detail.newValue - event.detail.oldValue);
  }
  _onBundleQuantityChanged(event) {
    const quantity = event.detail.newQuantity;
    const delta = event.detail.delta;
    const variantId = event.detail.variantId;
    if (quantity == 0) {
      this.selectedVariants[this.curProdVariant] = this.selectedVariants[this.curProdVariant].filter((variant) => variant.variantId !== variantId);
      this.dispatchEvent(new CustomEvent("bundle:variant:remove", {
        bubbles: true,
        detail: {
          variantId: variantId
        }
      }));
    } else if (delta > 0) {
      for (let i = 0; i < delta; i++) {
        this.selectedVariants[this.curProdVariant].push({
          variantId: variantId,
          quantity: 1,
          imageUrl: event.detail.imageUrl,
          stepHandle: event.detail.stepHandle,
          variantPrice: event.detail.variantPrice,
        });
        this.dispatchEvent(new CustomEvent("bundle:variant:add", {
          bubbles: true,
          detail: {
            variantId: variantId,
            quantity: 1,
            imageUrl: event.detail.imageUrl,
            imageAlt: event.detail.imageAlt,
            stepHandle: event.detail.stepHandle
          }
        }));
      }
    } else {
      let toRemoveCount = Math.abs(delta);
      for (let i = this.selectedVariants[this.curProdVariant].length - 1; i >= 0 && toRemoveCount > 0; i--) {
        if (this.selectedVariants[this.curProdVariant][i].variantId === variantId) {
          this.selectedVariants[this.curProdVariant].splice(i, 1);
          toRemoveCount--;
        }
      }
      this.dispatchEvent(new CustomEvent("bundle:variant:remove", {
        bubbles: true,
        detail: {
          variantId: variantId
        }
      }));
    }

    let validQuantity = this.bundleVariantData[this.curProdVariant].totalElementCount.includes(this.selectedVariants[this.curProdVariant].length);
    if (validQuantity) {
      const stepHeaders = document.querySelectorAll(`.bundle-component-group[variant-id="${this.curProdVariant}"] .bundle-step-header`);
      stepHeaders.forEach((stepHeader) => {
        const validQuantities = stepHeader.getAttribute("allowed-quantities").split(",").map((val) => parseInt(val));
        const stepVariantQuantities = this.selectedVariants[this.curProdVariant].filter((variant) => variant.stepHandle === stepHeader.getAttribute("step-handle")).length;
        if (!validQuantities.includes(stepVariantQuantities)) {
          validQuantity = false;
        }
      });
    }
    
    this.dispatchEvent(new CustomEvent("bundle:variants:changed", {
      bubbles: true,
      detail: {
        variants: this.selectedVariants[this.curProdVariant],
        stepHandle: event.detail.stepHandle,
        validQuantity: validQuantity
      }
    }));

    this._updateFormInputs(this.selectedVariants[this.curProdVariant], this.curProdVariant);

    if (validQuantity) {
      this._activateSubmitButtons();
    } else {
      this._deactivateSubmitButtons();
    }
  }
  _activateSubmitButtons() {
    const formSubmitButton = this.querySelector("button[type='submit']");
    const externalSubmitButtons = document.querySelectorAll(`button[type='submit'][for='${this.formId}']`);
    const submitButtons = [formSubmitButton, ...externalSubmitButtons];

    submitButtons.forEach((button) => {
      button.removeAttribute("disabled");
    });
  }
  _deactivateSubmitButtons() {
    const formSubmitButton = this.querySelector("button[type='submit']");
    const externalSubmitButtons = document.querySelectorAll(`button[type='submit'][for='${this.formId}']`);
    const submitButtons = [formSubmitButton, ...externalSubmitButtons];

    submitButtons.forEach((button) => {
      button.setAttribute("disabled", "disabled");
    });
  }

}
window.customElements.define("bundle-product-form", BundleProductForm, { extends: "form" });

var CookiePopup = class CookiePopup extends ModalContent {
  constructor() {
    super();

    this.acceptBtn = this.querySelector("button[accept]");
    this.configureBtn = this.querySelector("button[config]");
    this.declineBtn = this.querySelector("button[decline]");

    this.consentHandler = this._onConsentReady.bind(this);
    this.initHandler = this._initDialog.bind(this);
    this.acceptHandler = this._accept.bind(this);
    this.declineHandler = this._decline.bind(this);
    this.configureHandler = this._configure.bind(this);
  }
  connectedCallback() {
    super.connectedCallback();

    window.addEventListener('CookiebotOnConsentReady', this.consentHandler);
    window.addEventListener('CookiebotOnDialogDisplay', this.initHandler);
    this.acceptBtn.addEventListener('click', this.acceptHandler);
    this.declineBtn.addEventListener('click', this.declineHandler);
    this.configureBtn.addEventListener('click', this.configureHandler);
  }
  _decline() {
    window.Cookiebot.submitCustomConsent(false, false, false);
  }
  _accept() {
    window.Cookiebot.submitCustomConsent(true, true, true);
  }
  _configure() {
    window.Cookiebot.renew();
  }
  _open() {
    this.open = true;
  }
  _close() {
    this.open = false;
  }
  _initDialog() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const ocs = urlParams.get('openCookieSettings');
    
    if (ocs == null || ocs != "true") {
        window.Cookiebot.hide();
        var ageCookiePopUpBlocker = document.querySelectorAll(".ageCookiePopUpBlocker");
        ageCookiePopUpBlocker.forEach(el => {
            el.hidden = false;
        });
    }
    this._open();
    window.removeEventListener('CookiebotOnDialogDisplay', this.initHandler);
  }
  _onConsentReady() {
    if ("Cookiebot" in window) {
        window.Shopify.customerPrivacy.setTrackingConsent({
          "analytics": Cookiebot.consent.statistics,
          "marketing": Cookiebot.consent.marketing,
          "preferences": Cookiebot.consent.preferences
        });
    }

    this._close();
  }
}
window.customElements.define("cookie-popup", CookiePopup);

// js/custom-element/section/product/selected-variants.js
class SelectedVariants extends HTMLElement {
  constructor() {
    super();

    this.addVariantHandler = this.addSelectedVariant.bind(this);
    this.removeVariantHandler = this.removeSelectedVariant.bind(this);
    this.fireRemoveVariantEventHandler = this.fireRemoveVariantEvent.bind(this);
    this.replaceVariantsHandler = this.replaceSelectedVariants.bind(this);

    this.form = document.querySelector(`#${this.getAttribute("form")}`);

    this.selectedVariants = this.querySelectorAll(".selected-variant");
  }
  connectedCallback() {
    this.selectedVariants.forEach((variant, index) => {
      variant.addEventListener("click", this.fireRemoveVariantEventHandler);
    });
    this._initPositions();

    if (this.form) {
      this.form.addEventListener("bundle:variant:add", this.addVariantHandler);
      this.form.addEventListener("bundle:variant:remove", this.removeVariantHandler);
      this.form.addEventListener("bundle:variants:replace", this.replaceVariantsHandler);
      
      const initFixedProductData = this.form.initFixedProductData;
      if (initFixedProductData) {
        this.replaceSelectedVariants({
          detail: initFixedProductData
        });
      }
    }
  }
  disconnectedCallback() {
    if (this.form) {
      this.form.removeEventListener("bundle:variant:add", this.addVariantHandler);
      this.form.removeEventListener("bundle:variant:remove", this.removeVariantHandler);
      this.form.removeEventListener("bundle:variants:replace", this.replaceVariantsHandler);
    }
    this.selectedVariants.forEach((variant, index) => {
      variant.removeEventListener("click", this.fireRemoveVariantEventHandler);
    });
  }
  _initPositions() {
    this.selectedVariants.forEach((variant, index) => {
      const position = parseInt(variant.getAttribute("data-position"));
      const calculatedPosition = this._calculateElementPosition(position);
      variant.style.gridColumnStart = calculatedPosition.targetColumn;
      variant.style.gridRowStart = calculatedPosition.targetRow;
    });
  }
  _calculateElementPosition(targetPosition) {
    const configuration = [
      { minWidth: 400, columnCount: 8 },
      { minWidth: 300, columnCount: 6 },
    ];
    const availableWidth = 452;
    // const gapWidth = 8;

    const columnCount = configuration.find((config) => availableWidth >= config.minWidth)?.columnCount || 4;
    // const elementWidth = (availableWidth - gapWidth * (columnCount - 1)) / columnCount;

    const targetColumn = targetPosition == columnCount ? columnCount : targetPosition % columnCount || columnCount;
    const targetRow = Math.ceil(targetPosition / columnCount);

    return { targetColumn, targetRow };
  }
  fireRemoveVariantEvent(event) {
    const selectedVariant = event.target.closest(".selected-variant");
    const variantId = selectedVariant.getAttribute("data-variant-id");

    this.form.dispatchEvent(new CustomEvent(`bundle:variant:remove:${variantId}`, {
      bubbles: true,
      detail: {
        variantId: variantId
      }
    }));
  }
  _sortVariantElements(variantElements) {
    return Array.from(variantElements).sort((a, b) => {
      const aPosition = parseInt(a.getAttribute("data-position"));
      const bPosition = parseInt(b.getAttribute("data-position"));
      return aPosition - bPosition;
    });
  }
  _addVariant(element, variant) {
    element.classList.remove("empty");
    element.setAttribute("data-variant-id", variant.variantId);
    element.querySelector(".selected-variant__media").innerHTML = `<img src="${variant.imageUrl}" alt="${variant.imageAlt}" />`;
  }
  _removeVariant(element, setNewPosition = true) {
    const variantElements = this.querySelectorAll(".selected-variant");
    const totalQuantity = variantElements.length;

    element.classList.add("empty");
    element.removeAttribute("data-variant-id");
    element.querySelector(".selected-variant__media").innerHTML = "";

    if (setNewPosition) {
      this._setElementPosition(element, totalQuantity);
    }
  }
  _setElementPosition(element, position) {
    const newPosition = this._calculateElementPosition(position);
    element.style.gridColumnStart = newPosition.targetColumn;
    element.style.gridRowStart = newPosition.targetRow;
    element.setAttribute("data-position", position);
  }
  replaceSelectedVariants(event) {
    const variants = event.detail.variants;

    const variantElements = this.querySelectorAll(".selected-variant");
    const sortedVariantElements = this._sortVariantElements(variantElements);
    for (let i = 0; i < sortedVariantElements.length; i++) {
      const variantElement = sortedVariantElements[i];
      const variant = variants[i];
      if (variant) {
        this._addVariant(variantElement, variant);
      } else {
        this._removeVariant(variantElement, false);        
      }
    }
  }
  addSelectedVariant(event) {
    const variant = event.detail;

    const emptyElements = this.querySelectorAll(".selected-variant.empty");
    const emptyElementsSorted = this._sortVariantElements(emptyElements);
    const firstEmptyElement = emptyElementsSorted[0];
    if (firstEmptyElement) {
      this._addVariant(firstEmptyElement, variant);
    }
  }
  removeSelectedVariant(event) {
    const selectedVariant = event.target.closest(".selected-variant");
    const variantId = event.detail.variantId ? event.detail.variantId : selectedVariant.getAttribute("data-variant-id");
    const variantElement = this.querySelector(`.selected-variant[data-variant-id="${variantId}"]`);
    if (variantElement) {
      const oldPosition = parseInt(variantElement.getAttribute("data-position"));
      this._removeVariant(variantElement, false);

      const totalQuantity = this.querySelectorAll('.selected-variant').length;
      for (let i = oldPosition + 1; i <= totalQuantity; i++) {
        const element = this.querySelector(`.selected-variant[data-position="${i}"]`);
        if (element) {
          this._setElementPosition(element, i - 1);
        }
      }
      this._setElementPosition(variantElement, totalQuantity);
    }
  }
}
window.customElements.define("selected-variants", SelectedVariants);

class BundleComponentGroup extends HTMLElement {
  constructor() {
    super();
    this.toggleHandler = this.toggleOpen.bind(this);
    this.openHandler = this.open.bind(this);
    this.closeHandler = this.close.bind(this);
    this.variantChangedHandler = this.variantChanged.bind(this);
    
    this.variantId = this.getAttribute("variant-id");
    this.stepHandle = this.getAttribute("step-handle");
    this.stepHeader = document.querySelector(`.bundle-step-header[step-handle="${this.stepHandle}"]`);
    this.toggleButtons = document.querySelectorAll(`[toggle-button][step-handle="${this.stepHandle}"]`);
    this.toggleOpenButtons = document.querySelectorAll(`[toggle-open-button][step-handle="${this.stepHandle}"]`);
    this.toggleCloseButtons = document.querySelectorAll(`[toggle-close-button][step-handle="${this.stepHandle}"]`);
    this.form = document.getElementById(this.getAttribute("form-id"));
  }
  connectedCallback() {
    this.toggleButtons.forEach(button => {
      button.addEventListener('click', this.toggleHandler);
    });
    this.toggleOpenButtons.forEach(button => {
      button.addEventListener('click', this.openHandler);
    });
    this.toggleCloseButtons.forEach(button => {
      button.addEventListener('click', this.closeHandler);
    });
    if (this.form) {
      this.form.addEventListener("bundle:step:changed", this.openHandler);
      if (this.variantId) {
        this.form.addEventListener("bundle:product_variant:changed", this.variantChangedHandler);
      }
    }
  }
  disconnectedCallback() {
    this.toggleButtons.forEach(button => {
      button.removeEventListener('click', this.toggleHandler);
    });
    this.toggleOpenButtons.forEach(button => {
      button.removeEventListener('click', this.openHandler);
    });
    this.toggleCloseButtons.forEach(button => {
      button.removeEventListener('click', this.closeHandler);
    });
    if (this.form) {
      this.form.removeEventListener("bundle:step:changed", this.openHandler);
      if (this.variantId) {
        this.form.removeEventListener("bundle:product_variant:changed", this.variantChangedHandler);
      }
    }
  }
  variantChanged(event) {
    const newVariantId = event.detail.newVariantId;

    if (newVariantId == this.variantId) {
      this.hidden = false;
    } else {
      this.hidden = true;
    }
  }
  toggleOpen() {
    const isOpen = this.getAttribute('status') === 'open';
    this.setAttribute('status', isOpen ? 'closed' : 'open');
  }
  open(event) {
    if (event.detail.stepHandle === this.stepHandle) {
      this.setAttribute('status', 'open');
    } else if (!event.detail.stepHandle) {
      this.setAttribute('status', 'open');
    }
  }
  close(event) {
    if (event.detail.stepHandle === this.stepHandle) {
      this.setAttribute('status', 'closed');
    } else if (!event.detail.stepHandle) {
      this.setAttribute('status', 'closed');
    }
  }
}
window.customElements.define('bundle-component-group', BundleComponentGroup);

// js/custom-element/section/product/product-media.js
var ProductMedia = class extends CustomHTMLElement {
  async connectedCallback() {

    this.mainCarousel = this.querySelector("flickity-carousel");
    if (this.hasAttribute("reveal-on-scroll")) {
      this._setupVisibility();
    }
    if (this.mainCarousel.childElementCount === 1) {
      return;
    }
    this.selectedVariantMediaId = null;
    this.viewInSpaceElement = this.querySelector("[data-shopify-model3d-id]");
    this.zoomButton = this.querySelector(".product__zoom-button");
    this.product = await ProductLoader.load(this.getAttribute("product-handle"));
    document.getElementById(this.getAttribute("form-id"))?.addEventListener("variant:changed", this._onVariantChanged.bind(this));
    this.mainCarousel.addEventListener("model:played", () => this.mainCarousel.setDraggable(false));
    this.mainCarousel.addEventListener("model:paused", () => this.mainCarousel.setDraggable(true));
    this.mainCarousel.addEventListener("video:played", () => this.mainCarousel.setDraggable(false));
    this.mainCarousel.addEventListener("video:paused", () => this.mainCarousel.setDraggable(true));
    this.mainCarousel.addEventListener("flickity:ready", this._onFlickityReady.bind(this));
    this.mainCarousel.addEventListener("flickity:slide-changed", this._onFlickityChanged.bind(this));
    this.mainCarousel.addEventListener("flickity:slide-settled", this._onFlickitySettled.bind(this));
    this._onFlickityReady();
  }
  get thumbnailsPosition() {
    return window.matchMedia(window.themeVariables.breakpoints.pocket).matches ? "bottom" : this.getAttribute("thumbnails-position");
  }
  async _setupVisibility() {
    await this.untilVisible();
    const flickityInstance = await this.mainCarousel.flickityInstance, image = flickityInstance ? flickityInstance.selectedElement.querySelector("img") : this.querySelector(".product__media-image-wrapper img"), prefersReducedMotion = MediaFeatures.prefersReducedMotion();
    await imageLoaded(image);
    const animation = new CustomAnimation(new ParallelEffect([
      new CustomKeyframeEffect(image, { opacity: [0, 1], transform: [`scale(${prefersReducedMotion ? 1 : 1.1})`, "scale(1)"] }, { duration: 500, easing: "cubic-bezier(0.65, 0, 0.35, 1)" }),
      new ParallelEffect(Array.from(this.querySelectorAll(".product__thumbnail-item:not(.is-filtered)")).map((item, index) => {
        return new CustomKeyframeEffect(item, {
          opacity: [0, 1],
          transform: this.thumbnailsPosition === "left" ? [`translateY(${prefersReducedMotion ? 0 : "40px"})`, "translateY(0)"] : [`translateX(${prefersReducedMotion ? 0 : "50px"})`, "translateX(0)"]
        }, {
          duration: 250,
          delay: prefersReducedMotion ? 0 : 100 * index,
          easing: "cubic-bezier(0.75, 0, 0.175, 1)"
        });
      }))
    ]));
    this._hasSectionReloaded ? animation.finish() : animation.play();
  }
  async _onVariantChanged(event) {
    const variant = event.detail.newVariant;
    // Metafeld gepflegt: Liquid hat je Variante ihr Startbild aufgeloest
    // (snippets/pt-product-media.liquid). Nur die Startbilder werden gefiltert,
    // die Metafeld-Bilder bleiben immer stehen.
    const startMediaMap = this.getAttribute("start-media-map");
    if (startMediaMap) {
      this._onVariantChangedStartMedia(variant, JSON.parse(startMediaMap));
      return;
    }
    const filteredMediaIds = [];
    let shouldReload = false;
    const mediaWrappers = this.querySelectorAll(".product__media-item");
    mediaWrappers.forEach((media) => {
      const alt = media.getAttribute("data-media-alt");
      const id = media.getAttribute("data-media-id");
      let matchMedia2 = variant["featured_media"] && id === variant["featured_media"]["id"];
      if (alt?.includes("#")) {
        shouldReload = true;
        if (!matchMedia2) {
          const altParts = alt.split("#");
          const secondAltPart = altParts.pop();
          const mediaGroupParts = secondAltPart.split("_");
          if (mediaGroupParts.length !== 2) {
            if (`${variant.id}` != secondAltPart) {
              filteredMediaIds.push(parseInt(id));
            }
          } else {
            this.product["options"].forEach((option) => {
              if (option["name"].toLowerCase() === mediaGroupParts[0].toLowerCase()) {
                if (variant["options"][option["position"] - 1].toLowerCase() !== mediaGroupParts[1].trim().toLowerCase()) {
                  filteredMediaIds.push(parseInt(id));
                }
              }
            });
          }
        }
      }
    });
    // Produktseite, Metafeld nicht gepflegt: Variantenbilder nur bei ihrer
    // Variante - auch das Preview (erstes Medium), wenn es einer anderen
    // Variante gehoert. Ohne eigenes Variantenbild bleibt das Preview als
    // Startbild stehen. Das Startbild rueckt an die erste Stelle.
    if (this.hasAttribute("filter-variant-media")) {
      const previewId = this.product["media"].length ? this.product["media"][0]["id"] : null;
      const selectedFeaturedId = variant["featured_media"] ? variant["featured_media"]["id"] : null;
      this.product["variants"].forEach((otherVariant) => {
        const mediaId = otherVariant["featured_media"] ? otherVariant["featured_media"]["id"] : null;
        if (!mediaId || mediaId === selectedFeaturedId || (mediaId === previewId && !selectedFeaturedId)) {
          return;
        }
        if (!filteredMediaIds.includes(mediaId)) {
          filteredMediaIds.push(mediaId);
        }
      });
      this._moveStartMediaFirst(selectedFeaturedId || previewId);
    }
    const currentlyFilteredIds = [...new Set(Array.from(this.querySelectorAll(".is-filtered[data-media-id]")).map((item) => parseInt(item.getAttribute("data-media-id"))))];
    if (currentlyFilteredIds.some((value) => !filteredMediaIds.includes(value)) || filteredMediaIds.some((value) => !currentlyFilteredIds.includes(value))) {
      const selectedMediaId = variant["featured_media"] ? variant["featured_media"]["id"] : this.product["media"].map((item) => item.id).filter((item) => !filteredMediaIds.includes(item))[0];
      Array.from(this.querySelectorAll("[data-media-id]")).forEach((item) => {
        item.classList.toggle("is-filtered", filteredMediaIds.includes(parseInt(item.getAttribute("data-media-id"))));
        item.classList.toggle("is-selected", selectedMediaId === parseInt(item.getAttribute("data-media-id")));
        item.classList.toggle("is-initial-selected", selectedMediaId === parseInt(item.getAttribute("data-media-id")));
      });
      this.mainCarousel.reload();
    } else {
      if (!event.detail.newVariant["featured_media"] || this.selectedVariantMediaId === event.detail.newVariant["featured_media"]["id"]) {
        return;
      }
      this.mainCarousel.select(`[data-media-id="${event.detail.newVariant["featured_media"]["id"]}"]`);
    }
    this.selectedVariantMediaId = event.detail.newVariant["featured_media"] ? event.detail.newVariant["featured_media"]["id"] : null;
  }
  _moveStartMediaFirst(startMediaId) {
    // Rang je Medium: das Startbild vorne, der Rest in Shopify-Reihenfolge.
    // Die Slides sortiert flickity-carousel beim reload() ueber
    // data-original-position; Thumbnails und Punkte werden hier umgehaengt.
    const ranks = {};
    this.product["media"].forEach((media, index) => {
      ranks[media["id"]] = media["id"] === startMediaId ? -1 : index;
    });
    const rankOf = (item) => {
      const rank = ranks[parseInt(item.getAttribute("data-media-id"))];
      return rank === void 0 ? Number.MAX_SAFE_INTEGER : rank;
    };
    this.mainCarousel.querySelectorAll(".product__media-item[data-media-id]").forEach((item) => {
      item.setAttribute("data-original-position", rankOf(item));
    });
    [".product__thumbnail-list-inner", ".dots-nav"].forEach((selector) => {
      const container = this.querySelector(selector);
      if (!container) {
        return;
      }
      const items = Array.from(container.querySelectorAll(":scope > [data-media-id]"));
      items.sort((a, b) => rankOf(a) - rankOf(b)).forEach((item, index) => {
        container.appendChild(item);
        if (item.dataset.index) {
          item.dataset.index = index + 1;
        }
      });
    });
  }
  _onVariantChangedStartMedia(variant, startMediaMap) {
    const selectedMediaId = variant ? startMediaMap[variant.id] : void 0;
    if (!selectedMediaId || selectedMediaId === this.selectedVariantMediaId) {
      return;
    }
    const startMediaIds = [...new Set(Object.values(startMediaMap))];
    Array.from(this.querySelectorAll("[data-media-id]")).forEach((item) => {
      const id = parseInt(item.getAttribute("data-media-id"));
      if (!startMediaIds.includes(id)) {
        return;
      }
      item.classList.toggle("is-filtered", id !== selectedMediaId);
      item.classList.toggle("is-selected", id === selectedMediaId);
      item.classList.toggle("is-initial-selected", id === selectedMediaId);
    });
    this.selectedVariantMediaId = selectedMediaId;
    this.mainCarousel.reload();
  }
  async _onFlickityReady() {
    const flickityInstance = await this.mainCarousel.flickityInstance;
    if (["video", "external_video"].includes(flickityInstance.selectedElement.getAttribute("data-media-type")) && this.hasAttribute("autoplay-video")) {
      flickityInstance.selectedElement.firstElementChild.play();
    }
  }
  async _onFlickityChanged() {
    const flickityInstance = await this.mainCarousel.flickityInstance;
    flickityInstance.cells.forEach((item) => {
      if (["external_video", "video", "model"].includes(item.element.getAttribute("data-media-type"))) {
        item.element.firstElementChild.pause();
      }
    });
  }
  async _onFlickitySettled() {
    const flickityInstance = await this.mainCarousel.flickityInstance, selectedSlide = flickityInstance.selectedElement;
    if (this.zoomButton) {
      this.zoomButton.hidden = selectedSlide.getAttribute("data-media-type") !== "image";
    }
    if (this.viewInSpaceElement) {
      this.viewInSpaceElement.setAttribute("data-shopify-model3d-id", this.viewInSpaceElement.getAttribute("data-shopify-model3d-default-id"));
    }
    switch (selectedSlide.getAttribute("data-media-type")) {
      case "model":
        this.viewInSpaceElement.setAttribute("data-shopify-model3d-id", selectedSlide.getAttribute("data-media-id"));
        selectedSlide.firstElementChild.play();
        break;
      case "external_video":
      case "video":
        if (this.hasAttribute("autoplay-video")) {
          selectedSlide.firstElementChild.play();
        }
        break;
    }
  }
};
window.customElements.define("product-media", ProductMedia);

// js/helper/currency.js
function formatMoney(cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window.themeVariables.settings.moneyFormat;
  function defaultTo(value2, defaultValue) {
    return value2 == null || value2 !== value2 ? defaultValue : value2;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ",");
    decimal = defaultTo(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    if (precision == 0) {
      if ((number % 100) === 0) {
        number = (number / 100).toFixed(0);
      } else {
        number = (number / 100).toFixed(2);
      }
    } else {
      number = (number / 100).toFixed(2);
    }
    let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }
  let value = "";
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 0, "'");
      break;
  }
  if (formatString.indexOf("with_comma_separator") !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
}

// js/custom-element/section/product/product-meta.js
var ProductMeta = class extends HTMLElement {
  connectedCallback() {
    document.getElementById(this.getAttribute("form-id"))?.addEventListener("variant:changed", this._onVariantChanged.bind(this));
  }
  get priceClass() {
    return this.getAttribute("price-class") || "";
  }
  get unitPriceClass() {
    return this.getAttribute("unit-price-class") || "";
  }
  _onVariantChanged(event) {
    this._updateLabels(event.detail.variant);
    this._updatePrices(event.detail.variant);
    this._updateSku(event.detail.variant);
  }
  _updateLabels(variant) {
    let productLabelList = this.querySelector("[data-product-label-list]");
    if (!productLabelList) {
      return;
    }
    if (!variant) {
      productLabelList.innerHTML = "";
    } else {
      productLabelList.innerHTML = "";
      if (!variant["available"]) {
        productLabelList.innerHTML = `<span class="label label--subdued">${window.themeVariables.strings.collectionSoldOut}</span>`;
      } else if (variant["compare_at_price"] > variant["price"]) {
        let savings = "";
        if (window.themeVariables.settings.discountMode === "percentage") {
          savings = `${Math.round((variant["compare_at_price"] - variant["price"]) * 100 / variant["compare_at_price"])}%`;
        } else {
          savings = formatMoney(variant["compare_at_price"] - variant["price"]);
        }
        productLabelList.innerHTML = `<span class="label label--highlight">${window.themeVariables.strings.collectionDiscount.replace("@savings@", savings)}</span>`;
      }
    }
  }
  _updatePrices(variant) {
    let productPrices = this.querySelector("[data-product-price-list]"), currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;
    if (!productPrices) {
      return;
    }
    if (!variant) {
      productPrices.style.display = "none";
    } else {
      productPrices.innerHTML = "";
      if (variant["compare_at_price"] > variant["price"]) {
        productPrices.innerHTML += `<span class="price price--highlight ${this.priceClass}"><span class="visually-hidden">${window.themeVariables.strings.productSalePrice}</span>${formatMoney(variant["price"], currencyFormat)}</span>`;
        productPrices.innerHTML += `<span class="price price--compare"><span class="visually-hidden">${window.themeVariables.strings.productRegularPrice}</span>${formatMoney(variant["compare_at_price"], currencyFormat)}</span>`;
      } else {
        productPrices.innerHTML += `<span class="price ${this.priceClass}"><span class="visually-hidden">${window.themeVariables.strings.productSalePrice}</span>${formatMoney(variant["price"], currencyFormat)}</span>`;
      }
      if (variant["unit_price_measurement"]) {
        let referenceValue = "";
        if (variant["unit_price_measurement"]["reference_value"] !== 1) {
          referenceValue = `<span class="unit-price-measurement__reference-value">${variant["unit_price_measurement"]["reference_value"]}</span>`;
        }
        productPrices.innerHTML += `
          <div class="price text--subdued ${this.unitPriceClass}">
            <div class="unit-price-measurement">
              <span class="unit-price-measurement__price">${formatMoney(variant["unit_price"])}</span>
              <span class="unit-price-measurement__separator">/</span>
              ${referenceValue}
              <span class="unit-price-measurement__reference-unit">${variant["unit_price_measurement"]["reference_unit"]}</span>
            </div>
          </div>
        `;
      }
      productPrices.style.display = "";
    }
  }
  _updateSku(variant) {
    let productSku = this.querySelector("[data-product-sku-container]");
    if (!productSku) {
      return;
    }
    let productSkuNumber = productSku.querySelector("[data-product-sku-number]");
    if (!variant || !variant["sku"]) {
      productSku.style.display = "none";
    } else {
      productSkuNumber.innerHTML = variant["sku"];
      productSku.style.display = "";
    }
  }
};
window.customElements.define("product-meta", ProductMeta);

// js/custom-element/section/product-list/quick-buy-drawer.js
var QuickBuyDrawer = class extends DrawerContent {
  connectedCallback() {
    super.connectedCallback();
    this.delegate.on("variant:changed", this._onVariantChanged.bind(this));
    this.delegate.on("variant:added", () => this.open = false);
  }
  async _load() {
    await super._load();
    this.imageElement = this.querySelector(".quick-buy-product__image");
    if (window.Shopify && window.Shopify.PaymentButton) {
      window.Shopify.PaymentButton.init();
    }
  }
  _onVariantChanged(event) {
    const variant = event.detail.variant;
    if (variant) {
      Array.from(this.querySelectorAll(`[href*="/products"]`)).forEach((link) => {
        const url = new URL(link.href);
        url.searchParams.set("variant", variant["id"]);
        link.setAttribute("href", url.toString());
      });
    }
    if (!this.imageElement || !variant || !variant["featured_media"]) {
      return;
    }
    const featuredMedia = variant["featured_media"];
    if (featuredMedia["alt"]) {
      this.imageElement.setAttribute("alt", featuredMedia["alt"]);
    }
    this.imageElement.setAttribute("width", featuredMedia["preview_image"]["width"]);
    this.imageElement.setAttribute("height", featuredMedia["preview_image"]["height"]);
    this.imageElement.setAttribute("src", getSizedMediaUrl(featuredMedia, "342x"));
    this.imageElement.setAttribute("srcset", getMediaSrcset(featuredMedia, [114, 228, 342]));
  }
};
window.customElements.define("quick-buy-drawer", QuickBuyDrawer);

// js/custom-element/section/product-list/quick-buy-drawer.js
var QuickViewDrawer = class extends DrawerContent {
  connectedCallback() {
    super.connectedCallback();
    this.delegate.on("variant:changed", this._onVariantChanged.bind(this));
    this.delegate.on("variant:added", () => this.open = false);
  }
  async _load() {
    if (!this.requiresLoading) {
      return;
    }
    triggerNonBubblingEvent(this, "openable-element:load:start");

    const sectionMain = this.getAttribute("data-section-main");
    const sectionTaste = this.getAttribute("data-section-taste");
    const sectionsParam = [sectionMain, sectionTaste].filter(Boolean).join(",");

    const response = await fetch(this.getAttribute("href"));
    const element = document.createElement("div");
    element.innerHTML = await response.text();

    // Parse main product section — extract media and product info
    // const mainDoc = parser.parseFromString(data, "text/html");
    const stickyMedia = element.querySelector("sticky-media.pt-product-media");
    const mediaHTML = stickyMedia ? stickyMedia.innerHTML : "";

    const productInfo = element.querySelector(".pt-product");
    if (productInfo) {
      productInfo.querySelectorAll(".product_info__anchor-links--wrapper").forEach(el => el.remove());
      productInfo.querySelectorAll(".product-section__anchor").forEach(el => el.remove());
      productInfo.querySelectorAll(".pt-product-featured-collection").forEach(el => el.remove());
    }
    const infoHTML = productInfo ? productInfo.innerHTML : "";

    // Parse taste detail section — only include if it contains content
    let tasteHTML = "";
    const tasteSection = element.querySelector(".shopify-section--product-taste-detail");
    if (tasteSection && tasteSection.textContent.trim() != "") {
      tasteHTML = tasteSection.outerHTML;
    }

    // Fill body placeholder with extracted media, info and optional taste detail
    const body = this.querySelector("[data-quick-view-body]");
    const productSection = body.querySelector(".quick-view-drawer__body");
    if (productSection) {
      productSection.innerHTML = `<div class="quick-view-drawer__media pt-product-media">${mediaHTML}</div><div class="quick-view-drawer__info pt-product">${infoHTML}</div>`;
    }
    if (tasteHTML && body) {
      body.innerHTML += tasteHTML;
    }

    this.removeAttribute("href");
    this.imageElement = this.querySelector(".quick-buy-product__image");
    if (window.Shopify && window.Shopify.PaymentButton) {
      window.Shopify.PaymentButton.init();
    }

    ratingSnippet("ruk_rating_snippet", {
      store: "www.paperandtea.de",
      mode: "extended",
      color: "#F8BD0B",
      linebreak: false,
      text: "Bewertungen",
      singularText: "Bewertung",
      lang: "de",
      usePolaris: false,
      showEmptyStars: false,
    });

    triggerNonBubblingEvent(this, "openable-element:load:end");
  }
  _onVariantChanged(event) {
    const variant = event.detail.variant;
    if (variant) {
      Array.from(this.querySelectorAll(`[href*="/products"]`)).forEach((link) => {
        const url = new URL(link.href);
        url.searchParams.set("variant", variant["id"]);
        link.setAttribute("href", url.toString());
      });
    }
    if (!this.imageElement || !variant || !variant["featured_media"]) {
      return;
    }
    const featuredMedia = variant["featured_media"];
    if (featuredMedia["alt"]) {
      this.imageElement.setAttribute("alt", featuredMedia["alt"]);
    }
    this.imageElement.setAttribute("width", featuredMedia["preview_image"]["width"]);
    this.imageElement.setAttribute("height", featuredMedia["preview_image"]["height"]);
    this.imageElement.setAttribute("src", getSizedMediaUrl(featuredMedia, "342x"));
    this.imageElement.setAttribute("srcset", getMediaSrcset(featuredMedia, [114, 228, 342]));
  }
};
window.customElements.define("quick-view-drawer", QuickViewDrawer);

// js/custom-element/section/product-list/quick-add-to-cart.js
var QuickAddToCart = class extends LoaderButton {
  connectedCallback() {
    super.connectedCallback();
    this.addEventListener("click", this._onClick.bind(this));
  }
  get variant_id() {
    return this.getAttribute("variant-id");
  }
  get discount_code() {
    return this.getAttribute("discount-code");
  }
  get discount_url_parameter() {
    return this.getAttribute("discount-url-parameter");
  }
  get discount_url() {
    return this.getAttribute("discount-url");
  }
  get properties() {
    return this.getAttribute("properties");
  }
  get cart_open() {
    return this.getAttribute("cart-open") === "true";
  }
  get inline_feedback() {
    return this.getAttribute("inline-feedback") === "true";
  }
  get product_url() {
    return this.getAttribute("product-url");
  }
  async _onClick() {
    this.setAttribute("aria-busy", "true");
    this.disabled = true;
    const bodyObject = {
      id: this.variant_id,
      quantity: 1,
      sections: ["mini-cart", "cart-notification-popup", "product-recommendations"],
      sections_url: this.product_url
    };
    if (this.properties) {
      bodyObject.properties = JSON.parse(this.properties);
    }
    const response = await fetch(`${window.themeVariables.routes.cartAddUrl}.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(bodyObject)
    });
    if (response.ok) {
      const responseJson = await response.json();
      this.dispatchEvent(new CustomEvent("variant:added", {
        bubbles: true,
        detail: {
          variant: responseJson.hasOwnProperty("items") ? responseJson["items"][0] : responseJson
        }
      }));
      fetch(`${window.themeVariables.routes.cartUrl}.js`).then(async (response2) => {
        const cartContent = await response2.json();
        document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
          bubbles: true,
          detail: {
            cart: cartContent
          }
        }));
        cartContent["sections"] = responseJson["sections"];
        document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
          bubbles: true,
          detail: {
            cart: cartContent,
            openMiniCart: window.themeVariables.settings.cartType === "drawer" && this.closest(".drawer") === null
          }
        }));
      });
      console.log("Variant added to cart:", responseJson, this.discount_code, this.cart_open);
      if (this.cart_open == false && (this.discount_code == null || this.discount_code == "")) {
        document.dispatchEvent(new CustomEvent("cart-notification:show", {
          bubbles: true,
          cancelable: true,
          detail: {
            variant: responseJson.hasOwnProperty("items") ? responseJson["items"][0] : responseJson,
            status: response.ok ? "success" : "error",
            error: responseJson["description"] || ""
          }
        }));
      }
    }
    if (this.inline_feedback) {
      this.setAttribute("aria-busy", "false");
      this.classList.add("button--success");
      // this.innerHTML = this.getAttribute("success-message");
      this.innerHTML = `
        <div class="cart_notification--success__icon">
          <svg width="32" height="14" class="icon icon--check   " viewBox="0 0 24 24" fill="none">
            <path d="M20 6L9 17L4 12" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
        </div>
        <span class="cart_notification--success__message">${window.themeTranslations["cart_notification.successfully_added"]}</span>
      `
    } else if (!this.hasAttribute("one-time")) {
      this.setAttribute("aria-busy", "false");
      this.disabled = false;
    }
    if (this.discount_code) {
      let url = `https://paperandtea.de/discount/${this.discount_code}?redirect=${encodeURIComponent(this.discount_url)}&${this.discount_url_parameter}`;
      if (this.cart_open) {
        url += `&open-cart=true`;
      }
      console.log("Redirecting to discount URL:", url);
      window.location = url;
    }
  }
}
window.customElements.define("quick-add-to-cart", QuickAddToCart, { extends: "button" });

var VariantPopover = class extends PopoverContent {
  async _load() {
    await super._load();
    this.imageElement = this.querySelector(".quick-buy-product__image");

    // Set Height of Element dynamically
    const windowHeight = window.innerHeight;
    // const header = this.querySelector(".variant_selector__header");
    const element = this.querySelector(".variant_selector__popover .variant_selector__icons");
    // const headerHeight = parseInt(window.getComputedStyle(header).getPropertyValue("margin-block-end")) + header.offsetHeight + 16;
    const headerHeight = 0;
    let tempHeightTotal = 0
    const possibleHeights = [];
    const variantSelectors = this.querySelectorAll(".variant_selector__button");
    variantSelectors.forEach((selector) => {
      possibleHeights.push(selector.offsetHeight / 2 + tempHeightTotal + headerHeight);
      tempHeightTotal += selector.offsetHeight + 8;
    });
    if (element) {
      element.style.maxHeight = `0px`;
      const maxHeight = windowHeight - 25 - this.offsetHeight;
      let height = 0;
      for (let i = 0; i < possibleHeights.length; i++) {
        if (possibleHeights[i] < maxHeight) {
          if (i + 1 == possibleHeights.length) {
            height = maxHeight;
          } else {
            height = possibleHeights[i];
          }
        }
      }
      element.style.maxHeight = `${height}px`;
    }

  }
}
window.customElements.define("variant-popover", VariantPopover);

// js/custom-element/section/product-list/quick-buy-popover.js
var QuickBuyPopover = class extends PopoverContent {
  connectedCallback() {
    super.connectedCallback();
    this.delegate.on("variant:changed", this._onVariantChanged.bind(this));
    this.delegate.on("variant:added", () => this.open = false);
  }
  async _load() {
    await super._load();
    this.imageElement = this.querySelector(".quick-buy-product__image");

    // Set Height of Element dynamically
    const windowHeight = window.innerHeight;
    const header = this.querySelector(".variant_selector__header");
    const element = this.querySelector(".quick-buy-popover__product-info");
    const headerHeight = parseInt(window.getComputedStyle(header).getPropertyValue("margin-block-end")) + header.offsetHeight + 16;
    let tempHeightTotal = 0
    const possibleHeights = [];
    const variantSelectors = this.querySelectorAll(".variant_selector__button");
    variantSelectors.forEach((selector) => {
      possibleHeights.push(selector.offsetHeight / 2 + tempHeightTotal + headerHeight);
      tempHeightTotal += selector.offsetHeight + 8;
    });
    if (element) {
      element.style.maxHeight = `0px`;
      const maxHeight = windowHeight - 25 - this.offsetHeight;
      let height = 0;
      for (let i = 0; i < possibleHeights.length; i++) {
        if (possibleHeights[i] < maxHeight) {
          if (i + 1 == possibleHeights.length) {
            height = maxHeight;
          } else {
            height = possibleHeights[i];
          }
        }
      }
      element.style.maxHeight = `${height}px`;
    }

  }
  _onVariantChanged(event) {
    const variant = event.detail.variant;
    if (variant) {
      Array.from(this.querySelectorAll(`[href*="/products"]`)).forEach((link) => {
        const url = new URL(link.href);
        url.searchParams.set("variant", variant["id"]);
        link.setAttribute("href", url.toString());
      });
    }
    if (!this.imageElement || !variant || !variant["featured_media"]) {
      return;
    }
    const featuredMedia = variant["featured_media"];
    if (featuredMedia["alt"]) {
      this.imageElement.setAttribute("alt", featuredMedia["alt"]);
    }
    this.imageElement.setAttribute("width", featuredMedia["preview_image"]["width"]);
    this.imageElement.setAttribute("height", featuredMedia["preview_image"]["height"]);
    this.imageElement.setAttribute("src", getSizedMediaUrl(featuredMedia, "195x"));
    this.imageElement.setAttribute("srcset", getMediaSrcset(featuredMedia, [65, 130, 195]));
  }
};
window.customElements.define("quick-buy-popover", QuickBuyPopover);

// js/custom-element/section/product-list/quick-buy-popover.js
var QrPopover = class extends PopoverContent {
  constructor() {
    super();

    this.accountNavigation = document.querySelector(".account-navigation-wrapper");
    this.pointsElements = this.querySelectorAll("[points]");

    this.onDataLoadedHandler = this._onDataLoaded.bind(this);
  }
  connectedCallback() {
    super.connectedCallback();

    if (this.accountNavigation.customerData == null) {
      this.accountNavigation.addEventListener("customer-data:loaded", this.onDataLoadedHandler);
    } else {
      this._onDataLoaded();
    }
  }
  _onDataLoaded(event = null) {
    let customer;
    if (event == null) {
      customer = this.accountNavigation.customerData?.customer;
    } else {
      customer = event.detail?.customer;
    }

    if (!customer) return;

    this.pointsElements.forEach(el => {
      el.textContent = customer.points_approved;
    });
  }
};
window.customElements.define("qr-popover", QrPopover);

// js/custom-element/section/product/store-pickup.js
var StorePickup = class extends HTMLElement {
  connectedCallback() {
    document.getElementById(this.getAttribute("form-id"))?.addEventListener("variant:changed", this._onVariantChanged.bind(this));
  }
  _onVariantChanged(event) {
    if (!event.detail.variant) {
      this.innerHTML = "";
    } else {
      this._renderForVariant(event.detail.variant["id"]);
    }
  }
  async _renderForVariant(id) {
    const response = await fetch(`${window.themeVariables.routes.rootUrlWithoutSlash}/variants/${id}?section_id=store-availability`), div = document.createElement("div");
    div.innerHTML = await response.text();
    this.innerHTML = div.firstElementChild.innerHTML.trim();
  }
};
window.customElements.define("store-pickup", StorePickup);

// js/custom-element/section/product/variants.js
var ProductVariants = class extends CustomHTMLElement {
  async connectedCallback() {
    this.masterSelector = document.getElementById(this.getAttribute("form-id")).id;
    this.optionSelectors = Array.from(this.querySelectorAll("[data-selector-type]"));
    if (!this.masterSelector) {
      console.warn(`The variant selector for product with handle ${this.productHandle} is not linked to any product form.`);
      return;
    }
    this.product = await ProductLoader.load(this.productHandle);
    this.delegate.on("change", '[name^="option"]', this._onOptionChanged.bind(this));
    this.masterSelector.addEventListener("change", this._onMasterSelectorChanged.bind(this));
    this._updateDisableSelectors();
    this.selectVariant(this.selectedVariant["id"]);
  }
  get selectedVariant() {
    return this._getVariantById(parseInt(this.masterSelector.value));
  }
  get productHandle() {
    return this.getAttribute("handle");
  }
  get hideSoldOutVariants() {
    return this.hasAttribute("hide-sold-out-variants");
  }
  get updateUrl() {
    return this.hasAttribute("update-url");
  }
  /**
   * Select a new variant by its ID
   */
  selectVariant(id) {
    if (!this._isVariantSelectable(this._getVariantById(id))) {
      id = this._getFirstMatchingAvailableOrSelectableVariant()["id"];
    }
    if (this.selectedVariant?.id === id) {
      return;
    }
    this.masterSelector.value = id;
    this.masterSelector.dispatchEvent(new Event("change", { bubbles: true }));
    if (this.updateUrl && history.replaceState) {
      const newUrl = new URL(window.location.href);
      if (id) {
        newUrl.searchParams.set("variant", id);
      } else {
        newUrl.searchParams.delete("variant");
      }
      window.history.replaceState({ path: newUrl.toString() }, "", newUrl.toString());
    }
    this._updateDisableSelectors();
    triggerEvent(this.masterSelector.form, "variant:changed", { variant: this.selectedVariant });
  }
  _onOptionChanged() {
    this.selectVariant(this._getVariantFromOptions()?.id);
  }
  _onMasterSelectorChanged() {
    const options = this.selectedVariant?.options || [];
    options.forEach((value, index) => {
      let input = this.querySelector(`input[name="option${index + 1}"][value="${CSS.escape(value)}"], select[name="option${index + 1}"]`), triggerChangeEvent = false;
      if (input.tagName === "SELECT") {
        triggerChangeEvent = input.value !== value;
        input.value = value;
      } else if (input.tagName === "INPUT") {
        triggerChangeEvent = !input.checked && input.value === value;
        input.checked = input.value === value;
      }
      if (triggerChangeEvent) {
        input.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });
  }
  /**
   * Get the product variant by its ID
   */
  _getVariantById(id) {
    return this.product["variants"].find((variant) => variant["id"] === id);
  }
  /**
   * Get the variant based on the options
   */
  _getVariantFromOptions() {
    const options = this._getSelectedOptionValues();
    return this.product["variants"].find((variant) => {
      return variant["options"].every((value, index) => value === options[index]);
    });
  }
  /**
   * Detect if a specific variant is selectable. This is used when the "hide sold out variant" option is enabled, to allow
   * to return true only if the variant is actually available
   */
  _isVariantSelectable(variant) {
    if (!variant) {
      return false;
    } else {
      return variant["available"] || !this.hideSoldOutVariants && !variant["available"];
    }
  }
  /**
   * This method is used internally to select an available or selectable variant, when the current choice does not
   * match the requirements. For instance, if sold out variants are configured to be hidden, but that the choices end
   * up being a non-valid variant, the theme automatically changes the variant to match the requirements. In the case
   * the customer end up on variant combinations that do not exist, it also switches to a valid combination.
   *
   * The algorithm is as follows: if we have for instance three options "Color", "Size" and "Material", we pop the last
   * option (Material) and try to find the first available variant for the given Color and Size. If none is found we
   * remove the second option (Size) and try to find the first available variant for the selected color. Finally, if none
   * is found we return the first available variant independently of any choice.
   */
  _getFirstMatchingAvailableOrSelectableVariant() {
    let options = this._getSelectedOptionValues(), matchedVariant = null, slicedCount = 0;
    do {
      options.pop();
      slicedCount += 1;
      matchedVariant = this.product["variants"].find((variant) => {
        if (this.hideSoldOutVariants) {
          return variant["available"] && variant["options"].slice(0, variant["options"].length - slicedCount).every((value, index) => value === options[index]);
        } else {
          return variant["options"].slice(0, variant["options"].length - slicedCount).every((value, index) => value === options[index]);
        }
      });
    } while (!matchedVariant && options.length > 0);
    return matchedVariant;
  }
  _getSelectedOptionValues() {
    const options = [];
    Array.from(this.querySelectorAll('input[name^="option"]:checked, select[name^="option"]')).forEach((option) => options.push(option.value));
    return options;
  }
  /**
   * We add specific class to sold out variants based on the selectors
   */
  _updateDisableSelectors() {
    const selectedVariant = this.selectedVariant;
    if (!selectedVariant) {
      return;
    }
    this._updateDisableSelectorsForOptionLevel(0, selectedVariant);
  }
  _updateDisableSelectorsForOptionLevel(level, selectedVariant) {
    if (!this.optionSelectors[level]) {
      return;
    }
    const applyClassToSelector = (selector, valueIndex, available, hasAtLeastOneCombination) => {
      let selectorType = selector.getAttribute("data-selector-type"), cssSelector = "";
      switch (selectorType) {
        case "swatch":
          cssSelector = `.color-swatch:nth-child(${valueIndex + 1})`;
          break;
        case "variant-image":
          cssSelector = `.variant-swatch:nth-child(${valueIndex + 1})`;
          break;
        case "block":
          cssSelector = `.block-swatch:nth-child(${valueIndex + 1})`;
          break;
        case "dropdown":
          cssSelector = `.combo-box__option-item:nth-child(${valueIndex + 1})`;
          break;
      }
      selector.querySelector(cssSelector).toggleAttribute("hidden", !hasAtLeastOneCombination);
      if (this.hideSoldOutVariants) {
        selector.querySelector(cssSelector).toggleAttribute("hidden", !available);
      } else {
        selector.querySelector(cssSelector).classList.toggle("is-disabled", !available);
      }
    };
    const hasCombination = (variant, level2, value, selectedVariant2) => {
      return Array.from({ length: level2 + 1 }, (_, i) => {
        if (i === level2) {
          return variant[`option${level2 + 1}`] === value;
        } else {
          return variant[`option${i + 1}`] === selectedVariant2[`option${i + 1}`];
        }
      }).every((condition) => condition);
    };
    this.product["options"][level]["values"].forEach((value, valueIndex) => {
      const hasAtLeastOneCombination = this.product["variants"].some(
        (variant) => hasCombination(variant, level, value, selectedVariant) && variant
      );
      const hasAvailableVariant = this.product["variants"].some(
        (variant) => hasCombination(variant, level, value, selectedVariant) && variant["available"]
      );
      applyClassToSelector(this.optionSelectors[level], valueIndex, hasAvailableVariant, hasAtLeastOneCombination);
      this._updateDisableSelectorsForOptionLevel(level + 1, selectedVariant);
    });
  }
};
window.customElements.define("product-variants", ProductVariants);

// js/custom-element/section/product-list/product-item.js
var ProductItem = class extends CustomHTMLElement {
  connectedCallback() {
    this.primaryImageList = Array.from(this.querySelectorAll(".product-item__primary-image"));
    this.delegate.on("change", ".product-item-meta__swatch-list .color-swatch__radio", this._onColorSwatchChanged.bind(this));
    this.delegate.on("mouseenter", ".product-item-meta__swatch-list .color-swatch__item", this._onColorSwatchHovered.bind(this), true);
  }
  async _onColorSwatchChanged(event, target) {
    Array.from(this.querySelectorAll(`[href*="/products"]`)).forEach((link) => {
      let url;
      if (link.tagName === "A") {
        url = new URL(link.href);
      } else {
        url = new URL(link.getAttribute("href"), `https://${window.themeVariables.routes.host}`);
      }
      url.searchParams.set("variant", target.getAttribute("data-variant-id"));
      link.setAttribute("href", url.toString());
    });
    if (target.hasAttribute("data-variant-featured-media")) {
      const newImage = this.primaryImageList.find((image) => image.getAttribute("data-media-id") === target.getAttribute("data-variant-featured-media"));
      newImage.setAttribute("loading", "eager");
      const onImageLoaded = newImage.complete ? Promise.resolve() : new Promise((resolve) => newImage.onload = resolve);
      await onImageLoaded;
      newImage.removeAttribute("hidden");
      let properties = {};
      if (Array.from(newImage.parentElement.classList).some((item) => ["aspect-ratio--short", "aspect-ratio--tall", "aspect-ratio--square"].includes(item))) {
        properties = [
          { clipPath: "polygon(0 0, 0 0, 0 100%, 0% 100%)", transform: "translate(calc(-50% - 20px), -50%)", zIndex: 1, offset: 0 },
          { clipPath: "polygon(0 0, 20% 0, 5% 100%, 0 100%)", transform: "translate(calc(-50% - 20px), -50%)", zIndex: 1, offset: 0.3 },
          { clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)", transform: "translate(-50%, -50%)", zIndex: 1, offset: 1 }
        ];
      } else {
        properties = [
          { clipPath: "polygon(0 0, 0 0, 0 100%, 0% 100%)", transform: "translateX(-20px)", zIndex: 1, offset: 0 },
          { clipPath: "polygon(0 0, 20% 0, 5% 100%, 0 100%)", transform: "translateX(-20px)", zIndex: 1, offset: 0.3 },
          { clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)", transform: "translateX(0px)", zIndex: 1, offset: 1 }
        ];
      }
      await newImage.animate(properties, {
        duration: 500,
        easing: "ease-in-out"
      }).finished;
      this.primaryImageList.filter((image) => image.classList.contains("product-item__primary-image") && image !== newImage).forEach((image) => image.setAttribute("hidden", ""));
    }
  }
  _onColorSwatchHovered(event, target) {
    const input = target.previousElementSibling;
    if (input.hasAttribute("data-variant-featured-media")) {
      const newImage = this.primaryImageList.find((image) => image.getAttribute("data-media-id") === input.getAttribute("data-variant-featured-media"));
      newImage.setAttribute("loading", "eager");
    }
  }
};
window.customElements.define("product-item", ProductItem);

// js/custom-element/section/product-facet/product-facet.js
var ProductFacet = class extends CustomHTMLElement {
  connectedCallback() {
    this.delegate.on("pagination:page-changed", this._rerender.bind(this));
    this.delegate.on("infinite-pagination:page-appended", this._initNewPromotionBlocks.bind(this));
    this.delegate.on("facet:criteria-changed", this._rerender.bind(this));
    this.delegate.on("facet:abort-loading", this._abort.bind(this));

    this._initPromotionBlocks();
    this.classList.add("show");
  }
  async _rerender(event) {
    const oldUrl = new URL(window.location);
    let newUrl = event.detail.url;
    if (oldUrl.searchParams.get("q")) {
      const param = `q=${oldUrl.searchParams.get("q")}`;
      if (!newUrl.includes(param)) {
        if (newUrl.includes("?")) {
          newUrl += `&${param}`;
        } else {
          newUrl += `?${param}`;
        }
      }
    }
    if (oldUrl.searchParams.get("type")) {
      const param = `type=${oldUrl.searchParams.get("type")}`;
      if (!newUrl.includes(param)) {
        if (newUrl.includes("?")) {
          newUrl += `&${param}`;
        } else {
          newUrl += `?${param}`;
        }
      }
    }
    const oldPagination = oldUrl.searchParams.get("page") || 1;
    history.replaceState({}, "", newUrl);
    this._abort();
    this.showLoadingBar();
    const url = new URL(window.location);
    url.searchParams.set("section_id", this.getAttribute("section-id"));
    try {
      this.abortController = new AbortController();
      const response = await fetch(url.toString(), { signal: this.abortController.signal });
      const responseAsText = await response.text();
      const fakeDiv = document.createElement("div");
      fakeDiv.innerHTML = responseAsText;

      // Replace Product List
      this.querySelector("#facet-main .product-facet__product-list").innerHTML = fakeDiv.querySelector("#facet-main .product-facet__product-list").innerHTML;

      this.querySelector("#facet-main .pagination").innerHTML = fakeDiv.querySelector("#facet-main .pagination").innerHTML;
      this.querySelector("#facet-main .pagination").hidden = fakeDiv.querySelector("#facet-main .pagination").hidden;

      const filterButtons = fakeDiv.querySelectorAll(".facet-desktop-filters__list-filter .button");
      filterButtons.forEach((button) => {
        const filterId = button.getAttribute("aria-controls");
        const existingButton = document.querySelector(`.facet-desktop-filters__list-filter .button[aria-controls="${filterId}"]`);
        if (existingButton) {
          existingButton.innerHTML = button.innerHTML;
          existingButton.classList = button.classList;
        }
      });

      const filterPopovers = fakeDiv.querySelectorAll(".facet-desktop-filters__list-filter .popover");
      filterPopovers.forEach((popover) => {
        const filterId = popover.getAttribute("id");
        const existingPopover = document.querySelector(`.facet-desktop-filters__list-filter .popover[id="${filterId}"]`);
        if (existingPopover) {
          existingPopover.innerHTML = popover.innerHTML;
          existingPopover.classList = popover.classList;
        }
      });

      const sortingPopover = fakeDiv.querySelectorAll(".facet-desktop-filters__sorting .popover");
      sortingPopover.forEach((popover) => {
        const filterId = popover.getAttribute("id");
        const existingPopover = document.querySelector(`.facet-desktop-filters__sorting .popover[id="${filterId}"]`);
        if (existingPopover) {
          existingPopover.innerHTML = popover.innerHTML;
          existingPopover.classList = popover.classList;
        }
      });

      const mobileSorting = fakeDiv.querySelectorAll(".collapsible-sorting");
      mobileSorting.forEach((popover) => {
        const filterId = popover.getAttribute("id");
        const existingPopover = document.querySelector(`.collapsible-sorting[id="${filterId}"]`);
        if (existingPopover) {
          existingPopover.innerHTML = popover.innerHTML;
          existingPopover.classList = popover.classList;
        }
      });

      const filterInputs = fakeDiv.querySelectorAll(".facet-desktop-filters__input");
      filterInputs.forEach((input) => {
        const filterId = input.getAttribute("id");
        const existingInput = document.querySelector(`.facet-desktop-filters__input[id="${filterId}"]`);
        if (existingInput) {
          existingInput.checked = input.checked;
        }
      });

      const filterClearButton = fakeDiv.querySelector(".facet-desktop-filters__reset-button");
      if (filterClearButton) {
        const existingFilterClearButton = document.querySelector(".facet-desktop-filters__reset-button");
        if (existingFilterClearButton) {
          existingFilterClearButton.hidden = filterClearButton.hidden;
        }
      }

      const filterResetRow = fakeDiv.querySelector(".facet-desktop-filters__reset-row");
      const existingFilterResetRow = document.querySelector(".facet-desktop-filters__reset-row");
      if (filterResetRow && existingFilterResetRow) {
        existingFilterResetRow.hidden = filterResetRow.hidden;
        existingFilterResetRow.innerHTML = filterResetRow.innerHTML;
      }

      const mobileFilterOpenButtons = fakeDiv.querySelector(".facet-mobile-filters");
      if (mobileFilterOpenButtons) {
        const existingMobileFilterOpenButtons = document.querySelector(".facet-mobile-filters");
        if (existingMobileFilterOpenButtons) {
          existingMobileFilterOpenButtons.innerHTML = mobileFilterOpenButtons.innerHTML;
        }
      }

      const mobileFilterButtons = fakeDiv.querySelectorAll(".facet-mobile-accordion__button");
      mobileFilterButtons.forEach((button) => {
        const filterId = button.getAttribute("aria-controls");
        const existingButton = document.querySelector(`.facet-mobile-accordion__button[aria-controls="${filterId}"]`);
        if (existingButton) {
          existingButton.innerHTML = button.innerHTML;
          existingButton.classList = button.classList;
        }
      });

      const mobileFilterPopovers = fakeDiv.querySelectorAll(".facet-mobile-filters__filters .popover");
      mobileFilterPopovers.forEach((popover) => {
        const filterId = popover.getAttribute("id");
        const existingPopover = document.querySelector(`.facet-mobile-filters__filters .popover[id="${filterId}"]`);
        if (existingPopover) {
          existingPopover.innerHTML = popover.innerHTML;
          existingPopover.classList = popover.classList;
        }
      });

      const mobileFilterInputs = fakeDiv.querySelectorAll(".facet-mobile-filters__input");
      mobileFilterInputs.forEach((input) => {
        const filterId = input.getAttribute("id");
        const existingInput = document.querySelector(`.facet-mobile-filters__input[id="${filterId}"]`);
        if (existingInput) {
          existingInput.checked = input.checked;
        }
      });

      this._initPromotionBlocks();
      this.hideLoadingBar();

      const newPagination = url.searchParams.get("page") || 1;
      if (oldPagination !== newPagination) {
        const element = this.querySelector("#facet-main");
        element.scrollIntoView({ behavior: "smooth" });
      }
      if (event.type == "facet:criteria-changed" && event.target.hasAttribute("is", "single-filter-button")) {
        const element = this.querySelector("#facet-main");
        element.scrollIntoView({ behavior: "smooth" });
      }
    } catch (e) {
      // console.log(e);
      if (e.name === "AbortError") {
        return;
      }
    }
  }
  _removeElementAtIndex(list, index) {
    if (index > -1 && index < list.length) {
        list.splice(index, 1);
    } else {
        // console.log('Index out of bounds');
    }
  }
  _removeSpecificElement(list, element) {
    const index = list.indexOf(element);
    if (index > -1) {
        list.splice(index, 1);
        return true; // Element wurde gefunden und entfernt
    } else {
        return false; // Element wurde nicht gefunden
    }
  }
  _createRandomList(sourceList, elementCount) {
    const targetList = [];
    if (sourceList.length == 2) {
      // Choose only the first element randomly. Rest is always the other element.
      const randomIndex = Math.floor(Math.random() * sourceList.length);
      targetList.push(sourceList[randomIndex]);
      let lastIndex = randomIndex;
      for (let i = 1; i < elementCount; i++) {
        const index = lastIndex == 0 ? 1 : 0;
        lastIndex = index;
        targetList.push(sourceList[index]);
      }
    } else {
      for (let i = 0; i < elementCount; i++) {
          const randomElement = this._getRandomElementFromArray(sourceList);
          targetList.push(randomElement);
      }
    }
    return targetList;
  }
  _getRandomElementFromArray(array) {
    const randomIndex = Math.floor(Math.random() * array.length);
    return array[randomIndex];
  }
  _initNewPromotionBlocks() {
    this._initPromotionBlocks(true);
  }
  _initPromotionBlocks(initOnlyHiddenBlocks = false) {
    const productListInner = this.querySelector(".product-list__inner"); 
    const styles = getComputedStyle(productListInner);
    const currentColumnCount = parseInt(styles.getPropertyValue('--section-products-per-row'));
    let promotionBlocks = this.querySelectorAll(".promotion-collection-block");
    let promotionBlockCount = 0;
    promotionBlocks.forEach((block) => promotionBlockCount += parseInt(block.getAttribute("width")));
    const productCards = productListInner.querySelectorAll(".product-card");
    let productCardsCount = productCards.length;
    let currentRowCount = Math.ceil((productCardsCount) / currentColumnCount);
    let currentRowCountTotal = Math.ceil((productCardsCount + promotionBlockCount) / currentColumnCount);

    if (promotionBlockCount > 0 && currentRowCount > 2) {

      // Zeilen zuweisen
      const availableRows = [];
      for (let i = 0; i < currentRowCountTotal; i++) {
        availableRows.push(i + 1);
      }

      // Last and First Row is not allowed for Promotion Blocks
      this._removeElementAtIndex(availableRows, availableRows.length - 1);
      this._removeElementAtIndex(availableRows, 0);

      const choosenRowIndexes = [];
      // Maximale Anzahl an Promotion Blöcken, damit der Abstand zwischen den Blöcken gewährleistet werden kann.
      const maxPromotionBlockCount = Math.floor(currentRowCount / 2);
      const rowsThroughBlocks = Math.floor(availableRows.length / Math.min(promotionBlockCount,maxPromotionBlockCount));
      let rowsModBlocks = availableRows.length % Math.min(promotionBlockCount,maxPromotionBlockCount);

      // First Promotion Block is always in Row 2
      let lastChoosenIndex = 2;
      promotionBlocks[0].style.gridRowStart = 2;
      promotionBlocks[0].style.gridRowEnd = 2 + 1;
      promotionBlocks[0].hidden = false;
      choosenRowIndexes.push(2);

      for (let i = 1; i < Math.min(promotionBlocks.length, maxPromotionBlockCount); i++) {
        const promotionBlock = promotionBlocks[i];
        let mod = 0;
        if (Math.min(promotionBlockCount,maxPromotionBlockCount) - i <= rowsModBlocks && rowsModBlocks > 0) {
          mod = 1;
          rowsModBlocks--;
        }
        const rowIndex = rowsThroughBlocks + lastChoosenIndex + mod;
        lastChoosenIndex = rowIndex;

        let updateBlock = true
        if (initOnlyHiddenBlocks && !promotionBlock.hidden) {
          updateBlock = false;
        }

        if (updateBlock) {
          promotionBlock.style.gridRowStart = rowIndex;
          promotionBlock.style.gridRowEnd = rowIndex + 1;
        }
        choosenRowIndexes.push(rowIndex);
      }
      
      const sourceList = [];
      for (let i = 0; i < currentColumnCount; i++) {
        sourceList.push(i + 1);
      }
      const elementCount = Math.min(choosenRowIndexes.length, promotionBlocks.length);
      const choosenColumnIndexes = this._createRandomList(sourceList, elementCount);
      
      for (let i = 0; i < choosenRowIndexes.length; i++) {
        const promotionBlock = promotionBlocks[i];
        let promotionBlockWidth = parseInt(promotionBlock.getAttribute("width"));
        let columnIndex = choosenColumnIndexes[i];
        if (promotionBlockWidth + columnIndex > currentColumnCount + 1) {
          columnIndex--;
        }

        let updateBlock = true
        if (initOnlyHiddenBlocks && !promotionBlock.hidden) {
          updateBlock = false;
        }

        if (updateBlock) {
          promotionBlock.style.gridColumnStart = columnIndex;
          promotionBlock.style.gridColumnEnd = columnIndex + promotionBlockWidth;
          promotionBlock.hidden = false;
        }
      }
    }
  }
  _abort() {
    if (this.abortController) {
      this.abortController.abort();
    }
  }
};
window.customElements.define("product-facet", ProductFacet);

var HmFilterRange = class extends HTMLElement {
  connectedCallback() {
    this.rangeLowerBound = this.querySelector(".price-range__range-group input:first-child");
    this.rangeHigherBound = this.querySelector(".price-range__range-group input:last-child");
    this.textInputLowerBound = this.querySelector(".price-range__input--lower");
    this.textInputHigherBound = this.querySelector(".price-range__input--higher");

    this.rangeStep = this.rangeLowerBound.step ? parseFloat(this.rangeLowerBound.step) : 1;
    this.maxRange = this.rangeLowerBound.dataset.maxRange;
    this.rangeLowerBoundMin = this.rangeLowerBound.min;

    if(this.rangeLowerBound.dataset.filterType == 'umfang') this._getUrlParamValues();
    this.textInputLowerBound.innerHTML = this.rangeLowerBound.value;
    this.textInputHigherBound.innerHTML = this.rangeHigherBound.value;
    this.dispatchEvent(new CustomEvent("hm-facet-filters:init-form", { bubbles: true }));

    this.rangeLowerBound.addEventListener("input", (event) => {
      triggerEvent(this, "facet:abort-loading");
      event.target.value = Math.min(parseFloat(event.target.value), parseFloat(this.textInputHigherBound.innerHTML || event.target.max) - this.rangeStep);
      event.target.parentElement.style.setProperty("--range-min", `${(parseFloat(event.target.value) - parseFloat(this.rangeLowerBoundMin)) / parseFloat(this.maxRange) * 100}%`);
      this.textInputLowerBound.innerHTML = event.target.value;
    });
    this.rangeHigherBound.addEventListener("input", (event) => {
      triggerEvent(this, "facet:abort-loading");
      event.target.value = Math.max(parseFloat(event.target.value), parseFloat(this.textInputLowerBound.innerHTML || event.target.min) + this.rangeStep);
      event.target.parentElement.style.setProperty("--range-max", `${(parseFloat(event.target.value) - parseFloat(this.rangeLowerBoundMin)) / parseFloat(this.maxRange) * 100}%`);
      this.textInputHigherBound.innerHTML = event.target.value;
    });
  }
  _getUrlParamValues() {
    var currentURL = window.location.href;

    var url = new URL(currentURL);
    var paramMinValues = url.searchParams.getAll('filter.v.m.filter.umfang_min').map(function(value) {
      return parseFloat(value);
    });
    var paramMaxValues = url.searchParams.getAll('filter.v.m.filter.umfang_max').map(function(value) {
      return parseFloat(value);
    });

    var paramMinValue = url.searchParams.get('umfang_min');
    var paramMaxValue = url.searchParams.get('umfang_max');

    this.rangeLowerBound.value = paramMinValue ? paramMinValue : this.rangeLowerBound.value;
    this.rangeHigherBound.value = paramMaxValue ? paramMaxValue : this.rangeHigherBound.value;
    this.rangeLowerBound.parentElement.style.setProperty("--range-min", `${(parseFloat(this.rangeLowerBound.value) - parseFloat(this.rangeLowerBoundMin)) / parseFloat(this.maxRange) * 100}%`);
    this.rangeHigherBound.parentElement.style.setProperty("--range-max", `${(parseFloat(this.rangeHigherBound.value) - parseFloat(this.rangeLowerBoundMin)) / parseFloat(this.maxRange) * 100}%`);
  }
};

if (!window.customElements.get("hm-filter-range")) {
  window.customElements.define("hm-filter-range", HmFilterRange);
}

// js/custom-element/section/facet/facet-filters.js
var FacetFilters = class extends DrawerContent {
  connectedCallback() {
    super.connectedCallback();
    this.delegate.on("change", '[name^="filter."]', this._onFilterChanged.bind(this));
    this.rootDelegate.on("click", '[data-action="clear-filters"]', this._onFiltersCleared.bind(this));
    if (this.alwaysVisible) {
      this.matchMedia = window.matchMedia(window.themeVariables.breakpoints.pocket);
      this.matchMedia.addListener(this._adjustDrawer.bind(this));
      this._adjustDrawer(this.matchMedia);
    }
  }
  get alwaysVisible() {
    return this.hasAttribute("always-visible");
  }
  _onFiltersCleared(event, target) {
    event.preventDefault();
    this.open = false;
    triggerEvent(this, "facet:criteria-changed", { url: target.href });
  }
  _onFilterChanged() {
    const formData = new FormData(this.querySelector("#facet-filters-form"));
    const searchParamsAsString = new URLSearchParams(formData).toString();
    triggerEvent(this, "facet:criteria-changed", { url: `${window.location.pathname}?${searchParamsAsString}` });
  }
  _adjustDrawer(match) {
    this.classList.toggle("drawer", match.matches);
    this.classList.toggle("drawer--from-left", match.matches);
  }
};

window.customElements.define("facet-filters", FacetFilters);
// js/custom-element/section/facet/facet-filters.js
var PTFacetFilters = class extends CustomHTMLElement {
  connectedCallback() {
    // super.connectedCallback();
    this.delegate.on("change", '[name^="sort_by"]', this._onSortChanged.bind(this));
    this.delegate.on("change", '[name^="filter."]', this._onFilterChanged.bind(this));
    this.rootDelegate.on("click", '[data-action="clear-filters"]', this._onFiltersCleared.bind(this));
  }
  get alwaysVisible() {
    return this.hasAttribute("always-visible");
  }
  _onFiltersCleared(event, target) {
    event.preventDefault();
    const mobileFilterPopovers = document.querySelectorAll(".facet-mobile-filters__popover");
    mobileFilterPopovers.forEach((popover) => {
      popover.open = false;
      triggerEvent(popover, "data-action:close", { url: target.href });
    });
    triggerEvent(this, "facet:criteria-changed", { url: target.href });
  }
  _onFilterChanged() {
    const formData = new FormData(this.querySelector("form"));
    const searchParamsAsString = new URLSearchParams(formData).toString();
    triggerEvent(this, "facet:criteria-changed", { url: `${window.location.pathname}?${searchParamsAsString}` });
  }
  _onSortChanged(event) {
    const currentUrl = new URL(location.href);
    currentUrl.searchParams.set("sort_by", event.target.value);
    currentUrl.searchParams.delete("page");
    this.dispatchEvent(new CustomEvent("facet:criteria-changed", {
      bubbles: true,
      detail: {
        url: currentUrl.toString()
      }
    }));
  }
};
window.customElements.define("pt-facet-filters", PTFacetFilters);

var SingleFilterButton = class extends HTMLButtonElement {
  connectedCallback() {
    this.addEventListener("click", this._onClick.bind(this));
  }
  get param_name() {
    return this.getAttribute("param-name");
  }
  get value() {
    return this.getAttribute("value");
  }
  _onClick() {
    const currentUrl = new URL(location.href);
    const currentFilterValues = currentUrl.searchParams.getAll(this.param_name);
    if (currentFilterValues.includes(this.value)) {
      currentUrl.searchParams.delete(this.param_name, this.value);
    } else {
      currentUrl.searchParams.append(this.param_name, this.value);
    }
    const searchParamsAsString = currentUrl.searchParams.toString();
    triggerEvent(this, "facet:criteria-changed", { url: `${window.location.pathname}?${searchParamsAsString}` });
  }
}
window.customElements.define("single-filter-button", SingleFilterButton, { extends: "button" });

// js/custom-element/section/facet/sort-by-popover.js
var SortByPopover = class extends PopoverContent {
  connectedCallback() {
    super.connectedCallback();
    this.delegate.on("change", '[name="sort_by"]', this._onSortChanged.bind(this));
  }
  _onSortChanged(event, target) {
    const currentUrl = new URL(location.href);
    currentUrl.searchParams.set("sort_by", target.value);
    currentUrl.searchParams.delete("page");
    this.open = false;
    this.dispatchEvent(new CustomEvent("facet:criteria-changed", {
      bubbles: true,
      detail: {
        url: currentUrl.toString()
      }
    }));
  }
};
window.customElements.define("sort-by-popover", SortByPopover);

// js/custom-element/section/cart/cart-count.js
var CartCount = class extends CustomHTMLElement {
  connectedCallback() {
    this.rootDelegate.on("cart:updated", (event) => this.innerText = event.detail.cart["item_count"]);
    this.rootDelegate.on("cart:refresh", this._updateCartCount.bind(this));
  }
  _updateCartCount(event) {
    if (event?.detail?.cart) {
      this.innerText = event.detail.cart["item_count"];
      if (event.detail.cart["item_count"] === 0) {
        this.hidden = true;
      } else {
        this.hidden = false;
      }
    } else {
      fetch(Shopify.routes.root + "cart.js").then((response) => {
        response.json().then((responseAsJson) => {
          this.innerText = responseAsJson["item_count"];
          if (responseAsJson["item_count"] === 0) {
            this.hidden = true;
          } else {
            this.hidden = false;
          }
        });
      });
    }
  }
};
window.customElements.define("cart-count", CartCount);

// js/custom-element/section/cart/cart-drawer.js
var CartDrawer = class extends DrawerContent {
  connectedCallback() {
    super.connectedCallback();
    this.nextReplacementDelay = 0;
    this.rootDelegate.on("cart:refresh", this._rerenderCart.bind(this));
    this.addEventListener("variant:added", () => this.nextReplacementDelay = 600);
    document.addEventListener("cart:open", () => this.setAttribute("open", ""));
  }
  async _rerenderCart(event) {
    let cartContent = null, html = "";
    if (event.detail && event.detail["cart"] && event.detail["cart"]["sections"]) {
      cartContent = event.detail["cart"];
      html = event.detail["cart"]["sections"]["mini-cart"];
    } else {
      const response = await fetch(`${window.themeVariables.routes.cartUrl}?section_id=${this.getAttribute("section")}`);
      html = await response.text();
      if (this.dataset.note != undefined && this.dataset.note != "") {
        await fetch(`${window.themeVariables.routes.cartUrl}/update.js`, {
          body: JSON.stringify({ note: this.dataset.note }),
          credentials: "same-origin",
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          }
        });
      }
    }
    const fakeDiv = document.createElement("div");
    fakeDiv.innerHTML = html;
    setTimeout(async () => {
      const previousPosition = this.querySelector(".drawer__content").scrollTop;
      if (cartContent && cartContent["item_count"] === 0) {
        const animation = new CustomAnimation(new ParallelEffect(Array.from(this.querySelectorAll(".drawer__content, .drawer__footer")).map((item) => {
          return new CustomKeyframeEffect(item, { opacity: [1, 0] }, { duration: 250, easing: "ease-in" });
        })));
        animation.play();
        await animation.finished;
      }
      
      this.innerHTML = fakeDiv.querySelector("cart-drawer").innerHTML;
      if (cartContent && cartContent["item_count"] === 0) {
        this.querySelector(".drawer__content").animate({ opacity: [0, 1], transform: ["translateY(40px)", "translateY(0)"] }, { duration: 450, easing: "cubic-bezier(0.33, 1, 0.68, 1)" });
      } else {
        this.querySelector(".drawer__content").scrollTop = previousPosition;
      }
      if (event?.detail?.openMiniCart) {
        this.clientWidth;
        this.open = true;
      }
  
    }, event?.detail?.replacementDelay || this.nextReplacementDelay);
    this.nextReplacementDelay = 0;

  }
  async attributeChangedCallback(name, oldValue, newValue) {
    super.attributeChangedCallback(name, oldValue, newValue);
    switch (name) {
      case "open":
        if (this.open) {
          this.querySelector(".drawer__content").scrollTop = 0;
          if (!MediaFeatures.prefersReducedMotion()) {
            // const lineItems = Array.from(this.querySelectorAll(".line-item")), recommendationsInner = this.querySelector(".mini-cart__recommendations-inner"), bottomBar = this.querySelector(".drawer__footer"), effects = [];
            // if (recommendationsInner && window.matchMedia(window.themeVariables.breakpoints.pocket).matches) {
            //   lineItems.push(recommendationsInner);
            // }
            // lineItems.forEach((item) => item.style.opacity = 0);
            // recommendationsInner ? recommendationsInner.style.opacity = 0 : null;
            // bottomBar ? bottomBar.style.opacity = 0 : null;
            // effects.push(new ParallelEffect(lineItems.map((item, index) => {
            //   return new CustomKeyframeEffect(item, {
            //     opacity: [0, 1],
            //     transform: ["translateX(40px)", "translateX(0)"]
            //   }, {
            //     duration: 400,
            //     delay: 400 + 120 * index - Math.min(2 * index * index, 120 * index),
            //     easing: "cubic-bezier(0.25, 1, 0.5, 1)"
            //   });
            // })));
            // if (bottomBar) {
            //   effects.push(new CustomKeyframeEffect(bottomBar, {
            //     opacity: [0, 1],
            //     transform: ["translateY(100%)", "translateY(0)"]
            //   }, {
            //     duration: 300,
            //     delay: 400,
            //     easing: "cubic-bezier(0.25, 1, 0.5, 1)"
            //   }));
            // }
            // if (recommendationsInner && !window.matchMedia(window.themeVariables.breakpoints.pocket).matches) {
            //   effects.push(new CustomKeyframeEffect(recommendationsInner, {
            //     opacity: [0, 1],
            //     transform: ["translateX(100%)", "translateX(0)"]
            //   }, {
            //     duration: 250,
            //     delay: 400 + Math.max(120 * lineItems.length - 25 * lineItems.length, 25),
            //     easing: "cubic-bezier(0.25, 1, 0.5, 1)"
            //   }));
            // }
            // let animation = new CustomAnimation(new ParallelEffect(effects));
            // animation.play();
          }
        }
    }
  }
};
window.customElements.define("cart-drawer", CartDrawer);

// js/custom-element/section/cart/cart-drawer-recommendations.js
var _CartDrawerRecommendations = class _CartDrawerRecommendations extends HTMLElement {
  async connectedCallback() {
    if (this.fetchRecommendations) {
      if (!_CartDrawerRecommendations.recommendationsCache[this.productId]) {
        _CartDrawerRecommendations.recommendationsCache[this.productId] = fetch(`${window.themeVariables.routes.productRecommendationsUrl}?product_id=${this.productId}&limit=${this.limit}&section_id=${this.sectionId}`);
      }
      const response = await _CartDrawerRecommendations.recommendationsCache[this.productId];
      const div = document.createElement("div");
      div.innerHTML = await response.clone().text();
      const productRecommendationsElement = div.querySelector("cart-drawer-recommendations");
      if (productRecommendationsElement && productRecommendationsElement.hasChildNodes()) {
        this.innerHTML = productRecommendationsElement.innerHTML;
      } else {
        this.hidden = true;
      }
    }
  }
  get productId() {
    return this.getAttribute("product-id");
  }
  get sectionId() {
    return this.getAttribute("section-id");
  }
  get fetchRecommendations() {
    return this.getAttribute("shopify-recom") === "true";
  }
  get limit() {
    return parseInt(this.getAttribute("limit") || 10);
  }
};
__publicField(_CartDrawerRecommendations, "recommendationsCache", {});
var CartDrawerRecommendations = _CartDrawerRecommendations;
window.customElements.define("cart-drawer-recommendations", CartDrawerRecommendations);

// js/custom-element/section/cart/cart-note.js
var CartNote = class extends HTMLTextAreaElement {
  connectedCallback() {
    this.addEventListener("change", this._onNoteChanged.bind(this));
  }
  get ownedToggle() {
    return this.hasAttribute("aria-owns") ? document.getElementById(this.getAttribute("aria-owns")) : null;
  }
  async _onNoteChanged() {
    if (this.ownedToggle) {
      this.ownedToggle.innerHTML = this.value === "" ? window.themeVariables.strings.cartAddOrderNote : window.themeVariables.strings.cartEditOrderNote;
    }
    const response = await fetch(`${window.themeVariables.routes.cartUrl}/update.js`, {
      body: JSON.stringify({ note: this.value }),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      }
    });
    const cartContent = await response.json();
    document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
      bubbles: true,
      detail: {
        cart: cartContent
      }
    }));
  }
};
window.customElements.define("cart-note", CartNote, { extends: "textarea" });

var CartShippingMessage = class extends HTMLElement {
  constructor() {
    super();
    const configWrapper = document.querySelector(`#${this.sectionId} [gift-config]`);
    const configJson = JSON.parse(configWrapper.innerHTML);
    this._config = configJson.filter((item) => {return item.progress_bar_icon == "Shipping"})[0];
    this._calculatedValues = JSON.parse(this.querySelector(`[calculated-values]`).innerHTML);

    this.onUpdateHandler = this._onUpdate.bind(this);

    this._updateState();


  }
  connectedCallback() {
    document.addEventListener("cart-shipping-message:update", this.onUpdateHandler);
  }
  disconnectedCallback() {
    document.removeEventListener("cart-shipping-message:update", this.onUpdateHandler);
  }
  get sectionId() {
    return this.getAttribute("section-id");
  }
  _onUpdate() {
    const configJson = JSON.parse(document.querySelector(`#${this.sectionId} [gift-config]`).innerHTML);
    this._config = configJson.filter((item) => {return item.progress_bar_icon == "Shipping"})[0];
    this._updateState();
  }
  _updateState() {
    const cartTotal = this._calculatedValues.cart_total_free_shipping_items;
    const onlyDigitalProductsInCart = this._calculatedValues.onlyDigitalProductsInCart;
    const messageWrapper = this.querySelector(".shipping__message--text");

    let thresholdReached = false;

    if (onlyDigitalProductsInCart) {  
      thresholdReached = true;
    } else {
      thresholdReached = cartTotal >= parseInt(this._config.warenkorb_wert);
    }

    if (thresholdReached) {
      messageWrapper.innerHTML = this._config.progress_bar_description_after_discount_is_applied;
    } else {
      const remainingValue = parseInt(this._config.warenkorb_wert) - cartTotal;
      const remainingSpan = `<span class='remainingAmount'>${formatMoney(remainingValue, this._calculatedValues.moneyFormat.replace(/\{\{\s*[^}]+\s*\}\}/g, "{{ amount_with_comma_separator }}"))}</span>`;
      messageWrapper.innerHTML = this._config.progress_bar_description_before_discount_is_applied.replaceAll("#X#", remainingSpan);
    }
  }
}
window.customElements.define("cart-shipping-message", CartShippingMessage);

// js/custom-element/section/cart/cart-progress-bar.js
var CartProgressBar = class extends HTMLElement {
  constructor() {
    super();
    const configJson = JSON.parse(this.querySelector("[gift-config]").innerHTML);
    this._config = configJson.filter((item) => {return item.visibility_settings_for_gift.includes("Progress Bar")})
    this._calculatedValues = JSON.parse(this.querySelector("[calculated-values]").innerHTML);
    this._shippingIcon = this.querySelector("[shipping-icon]").innerHTML;
    this._giftIcon = this.querySelector("[gift-icon]").innerHTML;
    this._checkIcon = this.querySelector("[check-icon]").innerHTML;
    this._maxThreshold = Math.max(...this._config.map((element) => parseInt(element.warenkorb_wert)));

    this._fillingElement = this.querySelector(".gwpProgressBar__filling--dynamic");
    this._successMessageWrapper = this.querySelector(".gwpSuccessMessage--wrapper");
    this._progressMessageWrapper = this.querySelector(".gwpProgressMessage--wrapper");

    this._initProgressBar();
    this._updateProgressBarState();
  }
  connectedCallback() {
    document.addEventListener("cart-progress-bar:update", this._reInitProgressBar.bind(this));
  }
  _reInitProgressBar() {
    this._calculateValues();
    this._updateProgressBarState();
  }
  _calculateValues() {
    const configJson = JSON.parse(this.querySelector("[gift-config]").innerHTML);
    this._config = configJson.filter((item) => {return item.visibility_settings_for_gift.includes("Progress Bar")})
    this._calculatedValues = JSON.parse(this.querySelector("[calculated-values]").innerHTML);
    this._shippingIcon = this.querySelector("[shipping-icon]").innerHTML;
    this._giftIcon = this.querySelector("[gift-icon]").innerHTML;
    this._checkIcon = this.querySelector("[check-icon]").innerHTML;
    this._maxThreshold = Math.max(...this._config.map((element) => parseInt(element.warenkorb_wert)));
  }
  _initProgressBar() {    
    this._fillingElement.innerHTML = "";
    this._config.forEach((element, index) => {
      const distanceFromLeft = (parseInt(element.warenkorb_wert) / this._maxThreshold) * 100;
      // if(!(this._calculatedValues.onlyDigitalProductsInCart && element.progress_bar_icon == "Shipping")) {
      //   this._createStepElement(element, index, distanceFromLeft);
      // }
    });
    this._fillingElement.innerHTML += `
      <div class="gwpProgressBar__fillingDynamic"></div>
    `;

    // this._successMessageWrapper.innerHTML = "";
    // this._progressMessageWrapper.innerHTML = "";
    // this._config.forEach((element, index) => {
    //   this._createMessageElement(element, index);
    // });
  }
  _createMessageElement(element, index) {
    const sucessMessageHTML = `
      <div class="gwpMessageDisplay" data-index="${index}" hidden>
        <div class="messageSuccessIcon"></div>
        <div>${element.progress_bar_description_after_discount_is_applied}</div>
      </div>
    `;
    this._successMessageWrapper.innerHTML += sucessMessageHTML;

    const remainingSpan = "<span class='remainingAmount'></span>";
    const progressMessageHTML = `
      <div class="gwpMessageDisplay" data-index="${index}" hidden>
        <div class="gwpProgressIcon"></div>
        <div>${element.progress_bar_description_before_discount_is_applied.replaceAll("#X#", remainingSpan)}</div>
      </div>
    `;
    this._progressMessageWrapper.innerHTML += progressMessageHTML;
  }
  // _createStepElement(element, index, distanceFromLeft) {
  //   // ${element.progress_bar_icon == "Shipping" ? this._shippingIcon : this._giftIcon}
  //   const html = `
  //     <style>
  //       .gwpProgressBar__step[data-index="${index}"] {
  //         left: ${distanceFromLeft}%;
  //       }
  //     </style>
  //     <div class="gwpProgressBar__step" data-index="${index}">
  //       <div class="gwpProgressBar__stepSuccess" hidden>${this._checkIcon}</div>
  //       <div class="gwpProgressBar__stepPrice">ab ${formatMoney(parseInt(element.warenkorb_wert), "{{ amount_no_decimals }} €")}</div>
  //     </div>`;
  //   this._fillingElement.innerHTML += html;
  // }
  _updateProgressBarState() {
    // console.log("Update Progress Bar State");
    const cartTotal = this._calculatedValues.cartTotal_withoutGifts;

    // Calculate the current state of the progress bar elements
    let nextStep = null;
    let nextRemainingValue = null;
    let onlyShippingGifts = true;
    const elementStatuses = [];

    let localMaxThreshold = this._maxThreshold;

    for (let index = 0; index < this._config.length; index++) {
      const el = this._config[index];
      let hideGift = false;
      let tempCartTotal = cartTotal;

      if (el.progress_bar_icon != "Shipping") {
        onlyShippingGifts = false;
      }

      const status = {
        reached: tempCartTotal >= parseInt(el.warenkorb_wert), 
        remainingValue: parseInt(el.warenkorb_wert) - tempCartTotal
      }

      if (this._calculatedValues.onlyDigitalProductsInCart && el.progress_bar_icon == "Shipping") {
        status.reached = true;
      }

      if (!status.reached) {
        // Step not reached
        if (nextStep === null || status.remainingValue < nextStep.remainingValue) {
          nextStep = {
            index: index,
            remainingValue: status.remainingValue
          }
        }
        if (nextRemainingValue === null || status.remainingValue < nextRemainingValue) {
          nextRemainingValue = status.remainingValue;
        }
        if (parseInt(el.warenkorb_wert) < parseInt(localMaxThreshold)) {
          localMaxThreshold = parseInt(el.warenkorb_wert);
        }
      }

      elementStatuses.push(status);
    }

    // Update message elements
    for(let index = 0; index < elementStatuses.length; index++) {
      const status = elementStatuses[index];
      // const successMessage = this.querySelector(`.gwpSuccessMessage--wrapper .gwpMessageDisplay[data-index="${index}"]`);
      // const progressMessage = this.querySelector(`.gwpProgressMessage--wrapper .gwpMessageDisplay[data-index="${index}"]`);
      const step = this.querySelector(`.gwpProgressBar__step[data-index="${index}"]`);
      const stepIcon = this.querySelector(`.gwpProgressBar__step[data-index="${index}"] .gwpProgressBar__stepSuccess`);

      if (step !== null) {
        if (this._calculatedValues.onlyDigitalProductsInCart && this._config[index].progress_bar_icon == "Shipping") {
          // successMessage.hidden = false;
          // progressMessage.hidden = true;
          stepIcon.hidden = false;
          step.classList.add("gwpProgressBar__step--success");
        } else if (status.reached) {
          // successMessage.hidden = false;
          // progressMessage.hidden = true;
          stepIcon.hidden = false;
          step.classList.add("gwpProgressBar__step--success");
        } else if (nextStep != null && nextStep.index == index) {
          // successMessage.hidden = true;
          // progressMessage.hidden = false;
          stepIcon.hidden = true;
          step.classList.remove("gwpProgressBar__step--success");
        } else {
          // successMessage.hidden = true;
          // progressMessage.hidden = true;
          stepIcon.hidden = true;
          step.classList.remove("gwpProgressBar__step--success");
        }
      }

      const remainingSpans = this.querySelectorAll(`.gwpMessageDisplay[data-index="${index}"] .remainingAmount`);
      remainingSpans.forEach((span) => {
        span.innerHTML = formatMoney(status.remainingValue, this._calculatedValues.moneyFormat.replace(/\{\{\s*[^}]+\s*\}\}/g, "{{ amount_with_comma_separator }}"));
      });
    }

    // Calculate the current state of the progress bar filling
    const tempCartTotal = onlyShippingGifts ? this._calculatedValues.cartTotal_freeShippingItems : cartTotal;
    const fillingStart = tempCartTotal > 0;
    const fillingEnd = tempCartTotal >= localMaxThreshold;
    const fillingPercentage = Math.min(tempCartTotal / localMaxThreshold * 100, 100);

    const fillingStartElement = this.querySelector(".gwpProgressBar__filling--start");
    const fillingEndElement = this.querySelector(".gwpProgressBar__filling--end");
    const fillingDynamicElement = this.querySelector(".gwpProgressBar__fillingDynamic");

    if (fillingStart) {
      fillingStartElement.classList.remove("hide");
    }
    if (fillingEnd) {
      fillingEndElement.classList.remove("hide");
    }
    fillingDynamicElement.style.width = `${fillingPercentage}%`;

    const fillingMessage = this.querySelector(".gwpProgressBar__fillingMessage");
    if (fillingMessage) {
      const fillingText = fillingMessage.dataset.textWithoutAmount;
      if (fillingEnd) {
        fillingMessage.style.right = `0px`;
        fillingMessage.innerHTML = fillingMessage.dataset.successText;
      } else if (fillingStart) {
        const left = fillingStartElement.offsetWidth + fillingDynamicElement.offsetWidth - fillingMessage.offsetWidth / 2;
        fillingMessage.style.left = `${Math.max(0, left)}px`;
        fillingMessage.innerHTML = nextRemainingValue ? fillingText.replace("[[amount]]", formatMoney(nextRemainingValue, this._calculatedValues.moneyFormat.replace(/\{\{\s*[^}]+\s*\}\}/g, "{{ amount_no_decimals_with_comma_separator }}"))) : "";
      } else {
        fillingMessage.style.left = `0px`;
        fillingMessage.innerHTML = nextRemainingValue ? fillingText.replace("[[amount]]", formatMoney(nextRemainingValue, this._calculatedValues.moneyFormat.replace(/\{\{\s*[^}]+\s*\}\}/g, "{{ amount_no_decimals_with_comma_separator }}"))) : "";
      }
    }
  }
}
window.customElements.define("cart-progress-bar", CartProgressBar);


// js/custom-element/section/cart/free-shipping-bar.js
var FreeShippingBar = class extends HTMLElement {
  connectedCallback() {
    document.documentElement.addEventListener("cart:updated", this._onCartUpdated.bind(this));
  }
  get threshold() {
    return parseFloat(this.getAttribute("threshold"));
  }
  _onCartUpdated(event) {
    const totalPrice = event.detail["cart"]["items"].filter((item) => item["requires_shipping"]).reduce((sum, item) => sum + item["final_line_price"], 0);
    this.style.setProperty("--progress", Math.min(totalPrice / this.threshold, 1));
  }
};
window.customElements.define("free-shipping-bar", FreeShippingBar);

var LineItemQuantityRemoveButton = class extends HTMLAnchorElement {
  connectedCallback() {
    this.addEventListener("click", this._onClick.bind(this));
  }
  get for() {
    return this.getAttribute("for");
  }
  _onClick(event) {
    event.preventDefault();

    const lineItemQuantity = document.querySelector(`#${this.for}`);
    lineItemQuantity.dispatchEvent(new CustomEvent("remove-link-clicked", {
      bubbles: true,
      detail: {
        href: this.href
      }
    }));
  }
}
window.customElements.define("line-item-quantity-remove-button", LineItemQuantityRemoveButton, { extends: "a" });

// js/custom-element/section/cart/item-quantity.js
var LineItemQuantity = class extends CustomHTMLElement {
  connectedCallback() {
    this.delegate.on("click", "a", this._onQuantityLinkClicked.bind(this));
    this.delegate.on("change", "input", this._onQuantityChanged.bind(this));
    this.delegate.on("remove-link-clicked", this._onRemoveLinkClicked.bind(this));
  }
  _onRemoveLinkClicked(event) {
    event.preventDefault();
    this._updateFromLink(event.detail.href);
  }
  _onQuantityLinkClicked(event, target) {
    event.preventDefault();
    this._updateFromLink(target.href);
  }
  _onQuantityChanged(event, target) {
    this._updateFromLink(`${window.themeVariables.routes.cartChangeUrl}?quantity=${target.value}&line=${target.getAttribute("data-line")}`);
  }
  async _updateFromLink(link) {
    if (window.themeVariables.settings.pageType === "cart") {
      window.location.href = link;
      return;
    }
    const changeUrl = new URL(link, `https://${window.themeVariables.routes.host}`), searchParams = changeUrl.searchParams, line = searchParams.get("line"), id = searchParams.get("id"), quantity = parseInt(searchParams.get("quantity"));
    this.dispatchEvent(new CustomEvent("line-item-quantity:change:start", { bubbles: true, detail: { newLineQuantity: quantity } }));
    const response = await fetch(`${window.themeVariables.routes.cartChangeUrl}.js`, {
      body: JSON.stringify({ line, id, quantity, sections: ["mini-cart"] }),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      }
    });
    if (response.ok) {
      const cartContent = await response.json();
      this.dispatchEvent(new CustomEvent("line-item-quantity:change:end", { bubbles: true, detail: { cart: cartContent, newLineQuantity: quantity } }));
      document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
        bubbles: true,
        detail: {
          cart: cartContent
        }
      }));
      document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
        bubbles: true,
        detail: {
          cart: cartContent,
          replacementDelay: quantity === 0 ? 600 : 750
        }
      }));
    } else {
      this.dispatchEvent(new CustomEvent("line-item-quantity:change:end", { bubbles: true }));
    }
  }
};
window.customElements.define("line-item-quantity", LineItemQuantity);

// js/custom-element/section/cart/line-item.js
var LineItem = class extends HTMLElement {
  connectedCallback() {
    this.lineItemLoader = this.querySelector(".line-item__loader");
    this.addEventListener("line-item-quantity:change:start", this._onQuantityStart.bind(this));
    this.addEventListener("line-item-quantity:change:end", this._onQuantityEnd.bind(this));
  }
  _onQuantityStart() {
    if (!this.lineItemLoader) {
      return;
    }
    this.lineItemLoader.hidden = false;
    this.lineItemLoader.firstElementChild.hidden = false;
    this.lineItemLoader.lastElementChild.hidden = true;
  }
  async _onQuantityEnd(event) {
    if (event?.detail?.cart["item_count"] === 0) {
      return;
    }
    if (this.lineItemLoader) {
      await this.lineItemLoader.firstElementChild.animate({ opacity: [1, 0], transform: ["translateY(0)", "translateY(-10px)"] }, 75).finished;
      this.lineItemLoader.firstElementChild.hidden = true;
      if (event?.detail?.newLineQuantity === 0) {
        await this.animate({ opacity: [1, 0], height: [`${this.clientHeight}px`, 0] }, { duration: 300, easing: "ease" }).finished;
        this.remove();
      } else {
        this.lineItemLoader.lastElementChild.hidden = false;
        await this.lineItemLoader.lastElementChild.animate({ opacity: [0, 1], transform: ["translateY(10px)", "translateY(0)"] }, { duration: 75, endDelay: 300 }).finished;
        this.lineItemLoader.hidden = true;
      }
    }
  }
};
window.customElements.define("line-item", LineItem);

// // js/custom-element/section/cart/notification.js
// var CartNotification = class extends CustomHTMLElement {
//   connectedCallback() {
//     this.rootDelegate.on("cart:open", this._onShow.bind(this), !this.hasAttribute("global"));
//     this.delegate.on("click", '[data-action="close"]', (event) => {
//       event.stopPropagation();
//       this.hidden = true;
//     });
//     this.addEventListener("mouseenter", this.stopTimer.bind(this));
//     this.addEventListener("mouseleave", this.startTimer.bind(this));
//     window.addEventListener("pagehide", () => this.hidden = true);
//   }
//   set hidden(value) {
//     if (!value) {
//       this.startTimer();
//     } else {
//       this.stopTimer();
//     }
//     this.toggleAttribute("hidden", value);
//   }
//   get isInsideDrawer() {
//     return this.classList.contains("cart-notification--drawer");
//   }
//   stopTimer() {
//     clearTimeout(this._timeout);
//   }
//   startTimer() {
//     this._timeout = setTimeout(() => this.hidden = true, 3e3);
//   }
//   _onShow(event) {
//     if (this.isInsideDrawer && !this.closest(".drawer").open) {
//       return;
//     }
//     if (this.hasAttribute("global") && event.detail.status === "success" && window.themeVariables.settings.cartType === "drawer") {
//       return;
//     }
//     event.stopPropagation();
//     let closeButtonHtml = "";
//     if (!this.isInsideDrawer) {
//       closeButtonHtml = `
//         <button class="cart-notification__close tap-area hidden-phone" data-action="close">
//           <span class="visually-hidden">${window.themeVariables.strings.accessibilityClose}</span>
//           <svg focusable="false" width="14" height="14" class="icon icon--close icon--inline" viewBox="0 0 14 14">
//             <path d="M13 13L1 1M13 1L1 13" stroke="currentColor" stroke-width="2" fill="none"></path>
//           </svg>
//         </button>
//       `;
//     }
//     if (event.detail.status === "success") {
//       this.classList.remove("cart-notification--error");
//       this.innerHTML = `
//         <div class="cart-notification__overflow">
//           <div class="container">
//             <div class="cart-notification__wrapper">
//               <svg focusable="false" width="20" height="20" class="icon icon--cart-notification" viewBox="0 0 20 20">
//                 <rect width="20" height="20" rx="10" fill="currentColor"></rect>
//                 <path d="M6 10L9 13L14 7" fill="none" stroke="rgb(var(--success-color))" stroke-width="2"></path>
//               </svg>
              
//               <div class="cart-notification__text-wrapper">
//                 <span class="cart-notification__heading heading hidden-phone">${window.themeVariables.strings.cartItemAdded}</span>
//                 <span class="cart-notification__heading heading hidden-tablet-and-up">${window.themeVariables.strings.cartItemAddedShort}</span>
//                 <a href="${window.themeVariables.routes.cartUrl}" class="cart-notification__view-cart link" data-no-instant>${window.themeVariables.strings.cartViewCart}</a>
//               </div>
              
//               ${closeButtonHtml}
//             </div>
//           </div>
//         </div>
//       `;
//     } else {
//       this.classList.add("cart-notification--error");
//       this.innerHTML = `
//         <div class="cart-notification__overflow">
//           <div class="container">
//             <div class="cart-notification__wrapper">
//               <svg focusable="false" width="20" height="20" class="icon icon--cart-notification" viewBox="0 0 20 20">
//                 <rect width="20" height="20" rx="10" fill="currentColor"></rect>
//                 <path d="M9.6748 13.2798C9.90332 13.0555 10.1763 12.9434 10.4937 12.9434C10.811 12.9434 11.0819 13.0555 11.3062 13.2798C11.5347 13.5041 11.6489 13.7749 11.6489 14.0923C11.6489 14.4097 11.5347 14.6847 11.3062 14.9175C11.0819 15.146 10.811 15.2603 10.4937 15.2603C10.1763 15.2603 9.90332 15.146 9.6748 14.9175C9.45052 14.6847 9.33838 14.4097 9.33838 14.0923C9.33838 13.7749 9.45052 13.5041 9.6748 13.2798ZM9.56689 12.1816V5.19922H11.4141V12.1816H9.56689Z" fill="rgb(var(--error-color))"></path>
//               </svg>
              
//               <div class="cart-notification__text-wrapper">
//                 <span class="cart-notification__heading heading">${event.detail.error}</span>
//               </div>
              
//               ${closeButtonHtml}
//             </div>
//           </div>
//         </div>
//       `;
//     }
//     this.clientHeight;
//     this.hidden = false;
//   }
// };
// window.customElements.define("cart-notification", CartNotification);

var DiscountBar = class extends HTMLElement {
  connectedCallback() {
    if (this.hasDiscount) {
      this.querySelector(`[aria-controls="discount-bar-code-popup"]`).addEventListener("click", this._activateDiscount.bind(this));
    }
  }
  _activateDiscount() {
    fetch(`/discount/${this.discountCode}`);
  }
  get hasDiscount() {
    return this.querySelector(`[aria-controls="discount-bar-code-popup"]`) !== null;
  }
  get discountCode() {
    const codeElement = this.querySelector(`[discount-code]`);
    return codeElement ? codeElement.getAttribute("discount-code") : null;
  }

};
window.customElements.define("discount-bar", DiscountBar);

var CountdownTimer = class extends HTMLElement {
  connectedCallback() {
    this.endTimestamp = new Date(this.endDate + "T" + this.endTime);
    
    this._update();
    setInterval(this._update.bind(this), 60e3);
  }
  _update() {
    const now = new Date();
    const diff = this.endTimestamp - now;

    if (diff <= 0) {
      // If the countdown is over, remove the element
      this.hidden = true;
    } else {
      const daysLeft = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hoursLeft = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutesLeft = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      var countdownEnded = false;

      let daysNumberElement_innerHTML = null;
      let daysTextSingleElement_hidden = null;
      let daysTextMultipleElement_hidden = null;
      let daysWrapperElement_hidden = null;

      if (daysLeft > 0) {
        daysNumberElement_innerHTML = daysLeft;
        if (daysLeft > 1) {
          daysTextMultipleElement_hidden = false;
          daysTextSingleElement_hidden = true;
        } else {
          daysTextMultipleElement_hidden = true;
          daysTextSingleElement_hidden = false;
        }
      } else {
        daysWrapperElement_hidden = true;
      }

      if (daysNumberElement_innerHTML != null && daysNumberElement_innerHTML != this.daysNumberElement.innerHTML) {
        this.daysNumberElement.innerHTML = daysNumberElement_innerHTML;
      }
      if (daysTextSingleElement_hidden != null && daysTextSingleElement_hidden != this.daysTextSingleElement.hidden) {
        this.daysTextSingleElement.hidden = daysTextSingleElement_hidden;
      }
      if (daysTextMultipleElement_hidden != null && daysTextMultipleElement_hidden != this.daysTextMultipleElement.hidden) {
        this.daysTextMultipleElement.hidden = daysTextMultipleElement_hidden;
      }
      if (daysWrapperElement_hidden != null && daysWrapperElement_hidden != this.daysWrapperElement.hidden) {
        this.daysWrapperElement.hidden = daysWrapperElement_hidden;
      }

      let hoursNumberElement_innerHTML = null;
      let hoursTextSingleElement_hidden = null;
      let hoursTextMultipleElement_hidden = null;
      let hoursWrapperElement_hidden = null;

      if (daysLeft > 0 || hoursLeft > 0) {
        hoursNumberElement_innerHTML = hoursLeft;
        if (hoursLeft == 1) {
          hoursTextMultipleElement_hidden = true;
          hoursTextSingleElement_hidden = false;
        } else {
          hoursTextMultipleElement_hidden = false;
          hoursTextSingleElement_hidden = true;
        }
      } else {
        hoursWrapperElement_hidden = true;
      }

      if (hoursNumberElement_innerHTML != null && hoursNumberElement_innerHTML != this.hoursNumberElement.innerHTML) {
        this.hoursNumberElement.innerHTML = hoursNumberElement_innerHTML;
      }
      if (hoursTextSingleElement_hidden != null && hoursTextSingleElement_hidden != this.hoursTextSingleElement.hidden) {
        this.hoursTextSingleElement.hidden = hoursTextSingleElement_hidden;
      }
      if (hoursTextMultipleElement_hidden != null && hoursTextMultipleElement_hidden != this.hoursTextMultipleElement.hidden) {
        this.hoursTextMultipleElement.hidden = hoursTextMultipleElement_hidden;
      }
      if (hoursWrapperElement_hidden != null && hoursWrapperElement_hidden != this.hoursWrapperElement.hidden) {
        this.hoursWrapperElement.hidden = hoursWrapperElement_hidden;
      }

      let minutesNumberElement_innerHTML = null;
      let minutesTextSingleElement_hidden = null;
      let minutesTextMultipleElement_hidden = null;
      let minutesWrapperElement_hidden = null;

      if (daysLeft > 0) {
        minutesWrapperElement_hidden = true;
      } else {
        if (hoursLeft > 0 || minutesLeft > 0) {
          minutesWrapperElement_hidden = false;
          minutesNumberElement_innerHTML = minutesLeft;
          if (minutesLeft == 1) {
            minutesTextMultipleElement_hidden = true;
            minutesTextSingleElement_hidden = false;
          } else {
            minutesTextMultipleElement_hidden = false;
            minutesTextSingleElement_hidden = true;
          }
        } else {
          minutesWrapperElement_hidden = true;
          countdownEnded = true;
        }
      }

      if (countdownEnded) {
        this.closest("section").hidden = true;
      }
    }
  }
  get endDate() {
    return this.getAttribute("end-date");
  }
  get endTime() {
    return this.getAttribute("end-time");
  }
  get daysWrapperElement() {
    return this.querySelector("[days-wrapper]");
  }
  get daysNumberElement() {
    return this.querySelector("[days-number]");
  }
  get daysTextSingleElement() {
    return this.querySelector("[days-text-single]");
  }
  get daysTextMultipleElement() {
    return this.querySelector("[days-text-multiple]");
  }
  get hoursWrapperElement() {
    return this.querySelector("[hours-wrapper]");
  }
  get hoursNumberElement() {
    return this.querySelector("[hours-number]");
  }
  get hoursTextSingleElement() {
    return this.querySelector("[hours-text-single]");
  }
  get hoursTextMultipleElement() {
    return this.querySelector("[hours-text-multiple]");
  }
  get minutesWrapperElement() {
    return this.querySelector("[minutes-wrapper]");
  }
  get minutesNumberElement() {
    return this.querySelector("[minutes-number]");
  }
  get minutesTextSingleElement() {
    return this.querySelector("[minutes-text-single]");
  }
  get minutesTextMultipleElement() {
    return this.querySelector("[minutes-text-multiple]");
  }
}
window.customElements.define("countdown-timer", CountdownTimer);

var CountdownStopwatch = class extends HTMLElement {
  connectedCallback() {
    this.endTimestamp = new Date(this.endDate + "T" + this.endTime);
    
    this._update();
    setInterval(this._update.bind(this), 500);
  }
  _update() {
    const now = new Date();
    const diff = this.endTimestamp - now;

    if (diff <= 0) {
      // If the countdown is over, remove the element
      this.hidden = true;
    } else {
      const daysLeft = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hoursLeft = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutesLeft = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const secondesLeft = Math.floor((diff % (1000 * 60)) / 1000);
      var countdownEnded = false;

      let daysNumberElement_innerHTML = daysLeft < 10 ? "0" + daysLeft : daysLeft;
      if (this.daysNumberElement.innerHTML && daysNumberElement_innerHTML != this.daysNumberElement.innerHTML) {
        this.daysNumberElement.innerHTML = daysNumberElement_innerHTML;
      }
      let hoursNumberElement_innerHTML = hoursLeft < 10 ? "0" + hoursLeft : hoursLeft;
      if (this.hoursNumberElement.innerHTML && hoursNumberElement_innerHTML != this.hoursNumberElement.innerHTML) {
        this.hoursNumberElement.innerHTML = hoursNumberElement_innerHTML;
      }
      let minutesNumberElement_innerHTML = minutesLeft < 10 ? "0" + minutesLeft : minutesLeft;
      if (this.minutesNumberElement.innerHTML && minutesNumberElement_innerHTML != this.minutesNumberElement.innerHTML) {
        this.minutesNumberElement.innerHTML = minutesNumberElement_innerHTML;
      }
      let secondesNumberElement_innerHTML = secondesLeft < 10 ? "0" + secondesLeft : secondesLeft;
      if (this.secondesNumberElement.innerHTML && secondesNumberElement_innerHTML != this.secondesNumberElement.innerHTML) {
        this.secondesNumberElement.innerHTML = secondesNumberElement_innerHTML;
      }

      if (countdownEnded) {
        this.closest("section").hidden = true;
      }
    }
  }
  get endDate() {
    return this.getAttribute("end-date");
  }
  get endTime() {
    return this.getAttribute("end-time");
  }
  get daysWrapperElement() {
    return this.querySelector("[days-wrapper]");
  }
  get daysNumberElement() {
    return this.querySelector("[days-number]");
  }
  get hoursWrapperElement() {
    return this.querySelector("[hours-wrapper]");
  }
  get hoursNumberElement() {
    return this.querySelector("[hours-number]");
  }
  get minutesWrapperElement() {
    return this.querySelector("[minutes-wrapper]");
  }
  get minutesNumberElement() {
    return this.querySelector("[minutes-number]");
  }
  get secondesWrapperElement() {
    return this.querySelector("[secondes-wrapper]");
  }
  get secondesNumberElement() {
    return this.querySelector("[secondes-number]");
  }
}
window.customElements.define("countdown-stopwatch", CountdownStopwatch);

var variantSelector = class extends HTMLElement {
  constructor() {
    super();

    this.variants = JSON.parse(this.querySelector("[variants]").innerHTML)["variants"];

    this.buttonClickHandler = this._onButtonClick.bind(this);
  }
  connectedCallback() {
    this.querySelectorAll("button[variant-id]").forEach((button) => {
      button.addEventListener("click", this.buttonClickHandler);
    });

    this.querySelectorAll("button[variant-id]").forEach((button) => {
      button.addEventListener("mouseenter", (event) => this._onMouseEnter(event, button));
    });

    this.addEventListener("mouseleave", (event) => this._onMouseLeave(event));

    this._init();
  }
  disconnectedCallback() {
    this.querySelectorAll("button[variant-id]").forEach((button) => {
      button.removeEventListener("click", this.buttonClickHandler);
    });
  }
  get form_id() {
    return this.getAttribute("form-id");
  }
  get form() {
    return document.getElementById(this.form_id);
  }
  _onMouseEnter(event, button) {
    const variantTitle = this.querySelector("[variant-title]");
    if (variantTitle) {
      if (!variantTitle.hasAttribute("default")) {
        variantTitle.setAttribute("default", variantTitle.innerHTML);
      }
      variantTitle.innerHTML = button.getAttribute("variant-title");
    }
  }
  _onMouseLeave(event) {
    const variantTitle = this.querySelector("[variant-title]");
    if (variantTitle && variantTitle.hasAttribute("default")) {
      variantTitle.innerHTML = variantTitle.getAttribute("default");
      variantTitle.removeAttribute("default");
    }
  }
  _init() {
    // Sort Variant Buttons by Price
    const variantsOrderedByPrice = this.variants.sort((a, b) => a.price - b.price);

    variantsOrderedByPrice.forEach((variant, index) => {
      const button = this.querySelector(`button[variant-id="${variant.id}"]`);
      if (button) {
        button.setAttribute("rank", index + 1);
      }
    });

    this.classList.add("variant_selector--initialized");
  }
  get input() {
    return this.querySelector('input[name="id"]');
  }
  get title() {
    return this.querySelector(".variant_selector__header_title");
  }
  _onButtonClick(event) {
    const button = event.target.closest("button");
    const variantId = parseInt(button.getAttribute("variant-id"));
    const variant = this.variants.find((variant) => variant.id === variantId);
    const variantButtons = this.querySelectorAll(`.variant_selector__button[variant-id="${variantId}"]`);
    const variantTitle = variantButtons[0].getAttribute("variant-title") || variant.title;

    this.querySelectorAll('button[active="true"]').forEach((button) => {
      button.setAttribute("active", "false");
    });
    variantButtons.forEach((variantButton) => {
      variantButton.setAttribute("active", "true");
    });

    const toggleButtons = this.querySelectorAll(`.variant_selector__button--selected`);
    let variantIsDefault = false;
    for(let i = 0; i < toggleButtons.length; i++) {
      if (toggleButtons[i].getAttribute("variant-id") == variantId.toString() && toggleButtons[i].classList.contains("variant_selector__button--default")) {
        variantIsDefault = true;
      }
    }

    const variantTitleElement = this.querySelector("[variant-title]");
    if (variantTitleElement) {
      variantTitleElement.innerHTML = variantTitle;
      variantTitleElement.removeAttribute("default");
    }

    if (variantIsDefault) {
      const buttonsToRemove = this.querySelectorAll(`.variant_selector__button--selected:not(.variant_selector__button--default)`);
      buttonsToRemove.forEach((button) => {
        button.remove();
      });
    } else {
      const buttonsToReplace = this.querySelectorAll(`.variant_selector__button--selected:not(.variant_selector__button--default)`);
      const lastSelectedButton = this.querySelectorAll(".variant_selector__button--selected");
      if (lastSelectedButton.length > 0) {
        buttonsToReplace.forEach((buttonToReplace) => {
          buttonToReplace.innerHTML = button.innerHTML;
          buttonToReplace.setAttribute("variant-id", variantId);
          buttonToReplace.setAttribute("active", "true");
        });
        if (buttonsToReplace.length == 0) {
          const newButton = document.createElement("button");
          newButton.classList.add("variant_selector__button", "variant_selector__button--selected", "variant_selector__button--no-icon");
          newButton.setAttribute("type", "button");
          newButton.innerHTML = button.innerHTML;
          newButton.setAttribute("active", "true");
          newButton.setAttribute("variant-id", variantId);
          lastSelectedButton[lastSelectedButton.length - 1].after(newButton);
        }
      }
    }

    this.input.value = variantId;

    // this.title.innerHTML = variant.title;

    this.form.dispatchEvent(new CustomEvent("variant:changed", {
      bubbles: true,
      detail: {
        newVariant: variant
      }
    }));
  }
}
window.customElements.define("variant-selector", variantSelector);

var TastingNotes = class extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const width = this.offsetWidth;
    var line_width = width;
    const elements = this.querySelectorAll(".product-card__tasting-note--wrapper");
    for (let i = 0; i < elements.length; i++) {
      if (line_width - elements[i].offsetWidth < 0) {
        if (i > 0) {
          elements[i - 1].classList.add("product-card__tasting-note--wrapper--last");
          line_width = width;
        }
      } else {
        line_width -= elements[i].offsetWidth;
      }
    }
  }
}
window.customElements.define("tasting-notes", TastingNotes);

var NutritionTable = class extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this._init();
  }
  get nutritionInfo() {
    return JSON.parse(this.querySelector("[nutrition-info]").innerHTML);
  }
  _init() {
    const unit = "g";

    const data_unit = this.querySelector("[data-unit]");
    if (data_unit) {
      data_unit.innerHTML = this.nutritionInfo.unit;
    }

    const data_energy = this.querySelector("[data-energy]");
    if (data_energy) {
      data_energy.innerHTML = `${this.nutritionInfo.energy_kj}kJ / ${this.nutritionInfo.energy_kcal}kcal`
    }

    const data_fat = this.querySelector("[data-fat]");
    if (data_fat) {
      data_fat.innerHTML = `${this.nutritionInfo.fat_total}${unit}`;
    }

    const data_saturated_fat = this.querySelector("[data-saturated-fat]");
    if (data_saturated_fat) {
      data_saturated_fat.innerHTML = `${this.nutritionInfo.fat_saturated}${unit}`;
    }

    const data_carbohydrates = this.querySelector("[data-carbohydrates]");
    if (data_carbohydrates) {
      data_carbohydrates.innerHTML = `${this.nutritionInfo.carbohydrates}${unit}`;
    }

    const data_sugar = this.querySelector("[data-sugar]");
    if (data_sugar) {
      data_sugar.innerHTML = `${this.nutritionInfo.sugar}${unit}`;
    }

    const data_protein = this.querySelector("[data-protein]");
    if (data_protein) {
      data_protein.innerHTML = `${this.nutritionInfo.protein}${unit}`;
    }

    const data_salt = this.querySelector("[data-salt]");
    if (data_salt) {
      data_salt.innerHTML = `${this.nutritionInfo.salt}${unit}`;
    }
  }
}
window.customElements.define("nutrition-table", NutritionTable);

var ProductPrice = class extends HTMLElement {
  constructor() {
    super();

    this.price = this.querySelector(".product_price");
    this.compareAtPrice = this.querySelector(".product_compareAtPrice");
    this.compareAtPriceInput = this.querySelector("[name='properties[__compare_at_price]']");
    this.unitPrice = this.querySelector(".product_unitPrice");
    this.omnibusPrice = this.querySelector(".product_omnibusPrice");

    /*
    * =========
    * START: AB-Test
    * PT-31
    * ========= 
    */
    // Hinweis auf neuen niedrigen Preis (AB-Test PT-31)
    this.newLowestPriceMessage = this.querySelector('.product_info__new_price');
    this.aromaBagVariantId = this.newLowestPriceMessage ? parseInt(this.newLowestPriceMessage.getAttribute('aromabag-id')) : null;
    /*
    * =========
    * END: AB-Test
    * PT-31
    * ========= 
    */
    
    this.onVariantChangeHandler = this._onVariantChanged.bind(this);
    
    this.variantPrices = JSON.parse(this.querySelector("[variant-prices]").innerHTML);

    this.form = document.getElementById(this.getAttribute("form-id"));
  }
  connectedCallback() {
    // document.addEventListener("variant:changed", this.onVariantChangeHandler);
    if (this.form) {
      this.form.addEventListener("variant:changed", this.onVariantChangeHandler);
    }
  }
  disconnectedCallback() {
    // document.removeEventListener("variant:changed", this.onVariantChangeHandler);
    if (this.form) {
      document.getElementById(this.getAttribute("form-id")).removeEventListener("variant:changed", this.onVariantChangeHandler);
    }
  }
  _onVariantChanged(event) {
    const variant = event.detail.newVariant;
    const variantPriceInfo = this.variantPrices[variant.id];
    const currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;

    
    if (!variant) {
      return;
    }
    
    if (this.price) {
      this.price.innerHTML = formatMoney(variantPriceInfo.price, currencyFormat);
    }

    const pricePerCupElement = this.querySelector(".product_info__price--price-per-cup");
    if (pricePerCupElement) {
      const pricePerCup = formatMoney(variantPriceInfo.price / variantPriceInfo.amount_of_cups, currencyFormat);
      pricePerCupElement.innerHTML = variantPriceInfo.price_per_cup_label.replace("{{ price }}", pricePerCup);
    }

    if (this.compareAtPrice) {
      this.compareAtPrice.innerHTML = formatMoney(variantPriceInfo.compare_at_price, currencyFormat);

      if (variantPriceInfo.compare_at_price) {
        this.compareAtPrice.hidden = variantPriceInfo.compare_at_price <= variantPriceInfo.price;
        if (variantPriceInfo.compare_at_price > variantPriceInfo.price) {
          this.price.classList.add("price--highlight");
        } else {
          this.price.classList.remove("price--highlight");
        }
      } else {
        this.compareAtPrice.hidden = true;
        this.price.classList.remove("price--highlight");
      }
    } else {
      this.price.classList.remove("price--highlight");
    }

    if (this.compareAtPriceInput) {
      this.compareAtPriceInput.value = formatMoney(variantPriceInfo.compare_at_price, currencyFormat); 
    }

    if (this.unitPrice) {
      this.unitPrice.innerHTML = formatMoney(variantPriceInfo.unit_price, currencyFormat);
    }

    if (this.omnibusPrice) {
      this.omnibusPrice.innerHTML = `${variantPriceInfo.omnibusprice_label} ${formatMoney(variantPriceInfo.omnibusprice, currencyFormat)}`;
    }

    if (variantPriceInfo.compare_at_price > variantPriceInfo.price) {
      this.classList.add("product_info__price--on-sale");
    } else {
      this.classList.remove("product_info__price--on-sale");
    }

    /*
    * =========
    * START: AB-Test
    * PT-31
    * ========= 
    */
    if (this.newLowestPriceMessage && this.aromaBagVariantId) {
      this.newLowestPriceMessage.hidden = variant.id === this.aromaBagVariantId;
    }
    /*
    * =========
    * END: AB-Test
    * PT-31
    * ========= 
    */
  }
}
window.customElements.define("product-price", ProductPrice);

var ProductShippingInfo = class extends HTMLElement {
  constructor() {
    super();

    this.config = JSON.parse(this.querySelector("[config]").innerHTML);

    this.onVariantChangeHandler = this._onVariantChanged.bind(this);
  }
  connectedCallback() {
    // document.addEventListener("variant:changed", this.onVariantChangeHandler);
    document.getElementById(this.getAttribute("form-id")).addEventListener("variant:changed", this.onVariantChangeHandler);
  }
  disconnectedCallback() {
    // document.removeEventListener("variant:changed", this.onVariantChangeHandler);
    document.getElementById(this.getAttribute("form-id")).removeEventListener("variant:changed", this.onVariantChangeHandler);
  }
  _addStockInfo(text, stock) {
    const regex = /§§(.*?)§§/;
    const match = text.match(regex);

    if (match) {
      if (match[1].includes("§")) {
        const temp_split = match[1].split("§");
        const stock_delta = parseInt(temp_split[1]);
        stock = stock - stock_delta;
      }
      text = text.replace(/§§.*?§§/, stock);
    }

    return text;
  }
  _onVariantChanged(event) {
    const variant = event.detail.newVariant;
    const variantInfo = this.config.variants[variant.id];
    const textElement = this.querySelector(".product_info__shipping--text");

    this.classList.remove("product_info__shipping--sold-out");
    this.classList.remove("product_info__shipping--low-inventory");
    this.classList.remove("product_info__shipping--available");

    if (variantInfo.available == false) {
      this.classList.add("product_info__shipping--sold-out");
      textElement.innerHTML = this.config.text_content.sold_out;
    } else if (variantInfo.inventory_quantity <= this.config.low_inventory_threshold && variantInfo.inventory_policy == "deny" && variantInfo.inventory_management != "nil") {
      this.classList.add("product_info__shipping--low-inventory");
      if (this.config.product_is_digital) {
        textElement.innerHTML = `${this._addStockInfo(this.config.text_content.low_inventory, variantInfo.inventory_quantity)}, ${this.config.text_content.digital_delivery_time}`;
      } else {
        textElement.innerHTML = `${this._addStockInfo(this.config.text_content.low_inventory, variantInfo.inventory_quantity)}, ${this.config.text_content.delivery_time}`;
      }
    } else {
      this.classList.add("product_info__shipping--available");
      if (this.config.product_is_digital) {
        textElement.innerHTML = `${this._addStockInfo(this.config.text_content.available, variantInfo.inventory_quantity)}, ${this.config.text_content.digital_delivery_time}`;
      } else {
        textElement.innerHTML = `${this._addStockInfo(this.config.text_content.available, variantInfo.inventory_quantity)}, ${this.config.text_content.delivery_time}`;
      }
    }
  }
}
window.customElements.define("product-shipping-info", ProductShippingInfo);

// js/custom-element/section/cart/shipping-estimator.js
var ShippingEstimator = class extends HTMLElement {
  connectedCallback() {
    this.submitButton = this.querySelector('[type="button"]');
    this.submitButton.addEventListener("click", this._estimateShipping.bind(this));
  }
  /**
   * @doc https://shopify.dev/docs/themes/ajax-api/reference/cart#generate-shipping-rates
   */
  async _estimateShipping() {
    const zip = this.querySelector('[name="shipping-estimator[zip]"]').value, country = this.querySelector('[name="shipping-estimator[country]"]').value, province = this.querySelector('[name="shipping-estimator[province]"]').value;
    this.submitButton.setAttribute("aria-busy", "true");
    const prepareResponse = await fetch(`${window.themeVariables.routes.cartUrl}/prepare_shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`, { method: "POST" });
    if (prepareResponse.ok) {
      const shippingRates = await this._getAsyncShippingRates(zip, country, province);
      this._formatShippingRates(shippingRates);
    } else {
      const jsonError = await prepareResponse.json();
      this._formatError(jsonError);
    }
    this.submitButton.removeAttribute("aria-busy");
  }
  async _getAsyncShippingRates(zip, country, province) {
    const response = await fetch(`${window.themeVariables.routes.cartUrl}/async_shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`);
    const responseAsText = await response.text();
    if (responseAsText === "null") {
      return this._getAsyncShippingRates(zip, country, province);
    } else {
      return JSON.parse(responseAsText)["shipping_rates"];
    }
  }
  _formatShippingRates(shippingRates) {
    this.querySelector(".shipping-estimator__results")?.remove();
    let formattedShippingRates = "";
    shippingRates.forEach((shippingRate) => {
      formattedShippingRates += `<li>${shippingRate["presentment_name"]}: ${formatMoney(parseFloat(shippingRate["price"]) * 100)}</li>`;
    });
    const html = `
      <div class="shipping-estimator__results">
        <p>${shippingRates.length === 0 ? window.themeVariables.strings.shippingEstimatorNoResults : shippingRates.length === 1 ? window.themeVariables.strings.shippingEstimatorOneResult : window.themeVariables.strings.shippingEstimatorMultipleResults}</p>
        ${formattedShippingRates === "" ? "" : `<ul class="unordered-list">${formattedShippingRates}</ul>`}
      </div>
    `;
    this.insertAdjacentHTML("beforeend", html);
  }
  _formatError(errors) {
    this.querySelector(".shipping-estimator__results")?.remove();
    let formattedShippingRates = "";
    Object.keys(errors).forEach((errorKey) => {
      formattedShippingRates += `<li>${errorKey} ${errors[errorKey]}</li>`;
    });
    const html = `
      <div class="shipping-estimator__results">
        <p>${window.themeVariables.strings.shippingEstimatorError}</p>
        <ul class="unordered-list">${formattedShippingRates}</ul>
      </div>
    `;
    this.insertAdjacentHTML("beforeend", html);
  }
};
window.customElements.define("shipping-estimator", ShippingEstimator);

var ScrollToLink = class extends HTMLAnchorElement {
  constructor() {
    super();
    this.addEventListener("click", this._onClick.bind(this));
  }
  _onClick(event) {
    event.preventDefault();

  }
}

// js/custom-element/section/product/review-link.js
var ReviewLink = class extends HTMLAnchorElement {
  constructor() {
    super();
    this.addEventListener("click", this._onClick.bind(this));
  }
  _onClick() {
    const shopifyReviewsElement = document.getElementById("shopify-product-reviews");
    if (!shopifyReviewsElement) {
      return;
    }
    if (window.matchMedia(window.themeVariables.breakpoints.pocket).matches) {
      shopifyReviewsElement.closest("collapsible-content").open = true;
    } else {
      document.querySelector(`[aria-controls="${shopifyReviewsElement.closest(".product-tabs__tab-item-wrapper").id}"]`).click();
    }
  }
};
window.customElements.define("review-link", ReviewLink, { extends: "a" });

// js/custom-element/section/product/sticky-form.js
var PtStickyProductForm = class extends HTMLElement {
  connectedCallback() {
    this._setupVisibilityObservers();
  }
  disconnectedCallback() {
    this.intersectionObserver.disconnect();
  }
  set hidden(value) {
    this.toggleAttribute("hidden", value);
  }
  _setupVisibilityObservers() {
    const paymentContainerElement = document.getElementById(this.getAttribute("payment-container-id")), footerElement = document.querySelector(".shopify-section--footer"), stickyHeaderOffset = getStickyHeaderOffset();
    this._isFooterVisible = this._isPaymentContainerPassed = false;
    this.intersectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.target === footerElement) {
          this._isFooterVisible = entry.intersectionRatio > 0;
        }
        if (entry.target === paymentContainerElement) {
          const boundingRect = paymentContainerElement.getBoundingClientRect();
          this._isPaymentContainerPassed = entry.intersectionRatio === 0 && boundingRect.top + boundingRect.height <= stickyHeaderOffset;
        }
      });
      if (window.matchMedia(window.themeVariables.breakpoints.pocket).matches) {
        this.hidden = !this._isPaymentContainerPassed || this._isFooterVisible;
      } else {
        this.hidden = !this._isPaymentContainerPassed;
      }
    }, { rootMargin: `-${stickyHeaderOffset}px 0px 0px 0px` });
    this.intersectionObserver.observe(paymentContainerElement);
    this.intersectionObserver.observe(footerElement);
  }
}
window.customElements.define("pt-sticky-product-form", PtStickyProductForm);

// js/custom-element/section/product/sticky-form.js
var ProductStickyForm = class extends HTMLElement {
  connectedCallback() {
    document.getElementById(this.getAttribute("form-id"))?.addEventListener("variant:changed", this._onVariantChanged.bind(this));
    this.imageElement = this.querySelector(".product-sticky-form__image");
    this.priceElement = this.querySelector(".product-sticky-form__price");
    this.unitPriceElement = this.querySelector(".product-sticky-form__unit-price");
    this._setupVisibilityObservers();
  }
  disconnectedCallback() {
    this.intersectionObserver.disconnect();
  }
  set hidden(value) {
    this.toggleAttribute("hidden", value);
    if (value) {
      document.documentElement.style.removeProperty("--cart-notification-offset");
    } else {
      document.documentElement.style.setProperty("--cart-notification-offset", `${this.clientHeight}px`);
    }
  }
  _onVariantChanged(event) {
    const variant = event.detail.variant, currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;
    if (!variant) {
      return;
    }
    if (this.priceElement) {
      this.priceElement.innerHTML = formatMoney(variant["price"], currencyFormat);
    }
    if (this.unitPriceElement) {
      this.unitPriceElement.style.display = variant["unit_price_measurement"] ? "block" : "none";
      if (variant["unit_price_measurement"]) {
        let referenceValue = "";
        if (variant["unit_price_measurement"]["reference_value"] !== 1) {
          referenceValue = `<span class="unit-price-measurement__reference-value">${variant["unit_price_measurement"]["reference_value"]}</span>`;
        }
        this.unitPriceElement.innerHTML = `
          <div class="unit-price-measurement">
            <span class="unit-price-measurement__price">${formatMoney(variant["unit_price"])}</span>
            <span class="unit-price-measurement__separator">/</span>
            ${referenceValue}
            <span class="unit-price-measurement__reference-unit">${variant["unit_price_measurement"]["reference_unit"]}</span>
          </div>
        `;
      }
    }
    if (!this.imageElement || !variant || !variant["featured_media"]) {
      return;
    }
    const featuredMedia = variant["featured_media"];
    if (featuredMedia["alt"]) {
      this.imageElement.setAttribute("alt", featuredMedia["alt"]);
    }
    this.imageElement.setAttribute("width", featuredMedia["preview_image"]["width"]);
    this.imageElement.setAttribute("height", featuredMedia["preview_image"]["height"]);
    this.imageElement.setAttribute("src", getSizedMediaUrl(featuredMedia, "165x"));
    this.imageElement.setAttribute("srcset", getMediaSrcset(featuredMedia, [55, 110, 165]));
  }
  _setupVisibilityObservers() {
    const paymentContainerElement = document.getElementById("MainPaymentContainer"), footerElement = document.querySelector(".shopify-section--footer"), stickyHeaderOffset = getStickyHeaderOffset();
    this._isFooterVisible = this._isPaymentContainerPassed = false;
    this.intersectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.target === footerElement) {
          this._isFooterVisible = entry.intersectionRatio > 0;
        }
        if (entry.target === paymentContainerElement) {
          const boundingRect = paymentContainerElement.getBoundingClientRect();
          this._isPaymentContainerPassed = entry.intersectionRatio === 0 && boundingRect.top + boundingRect.height <= stickyHeaderOffset;
        }
      });
      if (window.matchMedia(window.themeVariables.breakpoints.pocket).matches) {
        this.hidden = !this._isPaymentContainerPassed || this._isFooterVisible;
      } else {
        this.hidden = !this._isPaymentContainerPassed;
      }
    }, { rootMargin: `-${stickyHeaderOffset}px 0px 0px 0px` });
    this.intersectionObserver.observe(paymentContainerElement);
    this.intersectionObserver.observe(footerElement);
  }
};
window.customElements.define("product-sticky-form", ProductStickyForm);

// js/theme.js
(() => {
  new InputBindingManager();
})();
(() => {
  if (Shopify.designMode) {
    document.addEventListener("shopify:section:load", () => {
      if (window.SPR) {
        window.SPR.initDomEls();
        window.SPR.loadProducts();
      }
    });
  }
  window.SPRCallbacks = {
    onFormSuccess: (event, info) => {
      document.getElementById(`form_${info.id}`).classList.add("spr-form--success");
    }
  };
})();
(() => {
  let previousClientWidth = window.visualViewport ? window.visualViewport.width : document.documentElement.clientWidth;
  let setViewportProperty = () => {
    const clientWidth = window.visualViewport ? window.visualViewport.width : document.documentElement.clientWidth, clientHeight = window.visualViewport ? window.visualViewport.height : document.documentElement.clientHeight;
    if (clientWidth === previousClientWidth) {
      return;
    }
    requestAnimationFrame(() => {
      document.documentElement.style.setProperty("--window-height", clientHeight + "px");
      previousClientWidth = clientWidth;
    });
  };
  setViewportProperty();
  if (window.visualViewport) {
    window.visualViewport.addEventListener("resize", setViewportProperty);
  } else {
    window.addEventListener("resize", setViewportProperty);
  }
})();
(() => {
  let documentDelegate = new main_default(document.body);
  documentDelegate.on("change", 'input:not([type="checkbox"]):not([type="radio"]), textarea', (event, target) => {
    target.classList.toggle("is-filled", target.value !== "");
  });
  documentDelegate.on("change", "select", (event, target) => {
    target.parentNode.classList.toggle("is-filled", target.value !== "");
  });
})();
(() => {
  document.querySelectorAll(".rte table").forEach((table) => {
    table.outerHTML = '<div class="table-wrapper">' + table.outerHTML + "</div>";
  });
  document.querySelectorAll(".rte iframe").forEach((iframe) => {
    if (iframe.src.indexOf("youtube") !== -1 || iframe.src.indexOf("youtu.be") !== -1 || iframe.src.indexOf("vimeo") !== -1) {
      iframe.outerHTML = '<div class="video-wrapper">' + iframe.outerHTML + "</div>";
    }
  });
})();
(() => {
  let documentDelegate = new main_default(document.documentElement);
  documentDelegate.on("click", "[data-smooth-scroll]", (event, target) => {
    const elementToScroll = document.querySelector(target.getAttribute("href"));
    if (elementToScroll) {
      event.preventDefault();
      const elementScrollPosition = elementToScroll.getBoundingClientRect().top + window.scrollY;
      const headerHeight = document.querySelector(".header")?.clientHeight || 0;
      window.scrollTo({ top: elementScrollPosition - headerHeight - 32, behavior: "smooth" });
      // elementToScroll.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  });
})();
(() => {
  document.addEventListener("keyup", function(event) {
    if (event.key === "Tab") {
      document.body.classList.remove("no-focus-outline");
      document.body.classList.add("focus-outline");
    }
  });
})();
/*! Bundled license information:

tabbable/dist/index.esm.js:
  (*!
  * tabbable 6.2.0
  * @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
  *)

focus-trap/dist/focus-trap.esm.js:
  (*!
  * focus-trap 7.5.4
  * @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
  *)
*/

// js/sections/impact-text.js
var ImpactText = class extends HTMLElement {
  constructor() {
    super();
    this.observer = new IntersectionObserver(this.handleIntersection.bind(this), {
      root: null,
      threshold: 1
    });
  }

  connectedCallback() {
    this.digitsWrapper = this.querySelector(".impact-text__number-digits");

    this.originalString = this.digitsWrapper.innerHTML;
    this.targetValue = parseInt(this.digitsWrapper.textContent, 10) || 0;
    this.duration = parseInt(this.getAttribute("duration")) || 2000; // Standard: 2000ms
    
    this.startTime = null;
    this.lastUpdate = 0;
    this.frameRate = 1000 / 60; // Ziel-FPS auf 60 setzen
    this.observer.observe(this);
  }

  handleIntersection(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        this.startCounting();
        this.observer.unobserve(this); // Nach dem Starten der Animation nicht erneut beobachten
      }
    });
  }

  async startCounting() {        
    const matches = this.originalString.trim().match(/\d+(?:[,. ]\d+)*/);
    
    const targetDigit = matches[0].replace(/[,\. ]+/, "");
    const charactersMatches = [...matches[0].matchAll(/[,\. ]+/g)];
    
    if (targetDigit.toString().length > 1) {
      this.startValue = "";
      for (let i = 0; i < (targetDigit.toString().length); i++) {
        if (i == 0) {
          this.startValue += "1";
        } else {
          this.startValue += "0";
        }
      }

      let tempStartValueNumber = parseInt(this.startValue);
      if (targetDigit - parseInt(this.startValue) < 100) {
        tempStartValueNumber = tempStartValueNumber / 10;
        this.startValue = ` ${tempStartValueNumber}`
      }
    } else {
      this.startValue = "0";
    }

    const startValueSplit = this.startValue.split('');
    let startValueIndex = -1;
    const digitSpans = matches[0].split('').map((digit) => {
      if (digit.match(/\d/) || digit === " ") {
        startValueIndex++;
        return `<span>${startValueSplit[startValueIndex]}</span>`;
      } else {
        return digit;
      }
    }).join('');
    this.digitsWrapper.innerHTML = this.originalString.replace(matches[0], digitSpans);
    this.digitsWrapper.hidden = false;
    this.startValue = parseInt(this.startValue);
    const numberSpans = this.digitsWrapper.querySelectorAll("span");

    await this.animateNumber(numberSpans, parseInt(targetDigit), this.startValue, this.originalString, charactersMatches);
  }

  animateNumber(elements, targetValue, startValue, originalString, characterMatches) {
    return new Promise(resolve => {
      let startTime = null;
      const easing = (t) => 1 - Math.pow(1 - t, 3); // Easing für sanfte Verlangsamung
      const durationMs = this.duration;

      const update = (timestamp) => {
        if (!startTime) startTime = timestamp;
        const elapsed = timestamp - startTime;
        const progress = Math.min(elapsed / durationMs, 1);
        const easedProgress = easing(progress);
        
        let currentValue = Math.round(startValue + (targetValue - startValue) * easedProgress).toString();
        
        characterMatches.forEach((character) => {
          if (currentValue.length >= originalString.length - character.index) {
            currentValue = currentValue.slice(0, character.index) + character[0] + currentValue.slice(character.index);
          }
        });

        const currentValueSplitLength = currentValue.split('').length;
        const targetValueSplitLength = targetValue.toString().split('').length;
        const delta = targetValueSplitLength - currentValueSplitLength;

        for (let i = 0; i < currentValueSplitLength; i++) {
          if (elements[i + delta]) {
            elements[i + delta].textContent = currentValue.split('')[i];
          }
        }
        
        if (progress < 1) {
          requestAnimationFrame(update);
        } else {
          resolve();
        }
      };
      requestAnimationFrame(update);
    });
  }
};
if (!window.customElements.get("impact-text")) {
  window.customElements.define("impact-text", ImpactText);
}

// js/sections/impact-text.js
var BundleProductComponent = class extends HTMLElement {
  constructor() {
    super();

    this.isFixedPart = this.hasAttribute("fixed-part");

    this.variantId = this.getAttribute("variant-id");
    this.imageUrl = this.getAttribute("image-url");
    this.imageAlt = this.getAttribute("image-alt");
    this.stepHandle = this.getAttribute("step-handle");
    this.variantPrice = parseInt(this.getAttribute("variant-price"));

    this.stepHeaderElement = document.querySelector(`bundle-step-header[step-handle="${this.stepHandle}"]`);
    this.inputElement = this.querySelector("input");
    this.plusButtons = this.querySelectorAll("[plus-button]");
    this.minusButtons = this.querySelectorAll("[minus-button]");
    this.bundleForm = document.getElementById(this.getAttribute("form-id"));

    this.onPlusButtonClickHandler = this._onPlusButtonClick.bind(this);
    this.onMinusButtonClickHandler = this._onMinusButtonClick.bind(this);
    this.onInputChangeHandler = this._onInputChange.bind(this);
    this.onStepCompletedHandler = this._onStepCompleted.bind(this);
    this.onStepNotCompletedHandler = this._onStepNotCompleted.bind(this);
  }
  connectedCallback() {
    if (!this.isFixedPart) {
      this.plusButtons.forEach((button) => {
        button.addEventListener("click", this.onPlusButtonClickHandler);
      });
      this.minusButtons.forEach((button) => {
        button.addEventListener("click", this.onMinusButtonClickHandler);
      });
      if (this.inputElement) {
        this.inputElement.addEventListener("change", this.onInputChangeHandler);
      }
      if (this.stepHeaderElement) {
        this.stepHeaderElement.addEventListener("bundle:step:completed", this.onStepCompletedHandler);
        this.stepHeaderElement.addEventListener("bundle:step:not-completed", this.onStepNotCompletedHandler);
      }
      if (this.bundleForm) {
        this.bundleForm.addEventListener(`bundle:variant:remove:${this.variantId}`, this.onMinusButtonClickHandler);
      }
    }

    this._init();
  }
  disconnectedCallback() {
    if (!this.isFixedPart) {
      this.plusButtons.forEach((button) => {
        button.removeEventListener("click", this.onPlusButtonClickHandler);
      });
      this.minusButtons.forEach((button) => {
        button.removeEventListener("click", this.onMinusButtonClickHandler);
      });
      if (this.inputElement) {
        this.inputElement.removeEventListener("change", this.onInputChangeHandler); 
      }
      if (this.stepHeaderElement) {
        this.stepHeaderElement.removeEventListener("bundle:step:completed", this.onStepCompletedHandler);
        this.stepHeaderElement.removeEventListener("bundle:step:not-completed", this.onStepNotCompletedHandler);
      }
      if (this.bundleForm) {
        this.bundleForm.removeEventListener(`bundle:variant:remove:${this.variantId}`, this.onMinusButtonClickHandler);
      }
    }
  }
  get quantity() {
    return this.getAttribute("quantity");
  }
  set quantity(value) {
    const oldQuantity = this.quantity;
    this.setAttribute("quantity", value);
    this.inputElement.value = value;

    if (!this.isFixedPart) {
      if (value > 0) {
        this.classList.add("active");
      } else {
        this.classList.remove("active");
      }
      this.bundleForm.dispatchEvent(new CustomEvent("bundle:quantity:changed", {
        bubbles: true,
        detail: {
          newQuantity: value,
          delta: value - oldQuantity,
          variantId: this.variantId,
          imageUrl: this.imageUrl,
          imageAlt: this.imageAlt,
          stepHandle: this.stepHandle,
          variantPrice: this.variantPrice
        }
      }));
    }
  }
  get maxInputQuantity() {
    if (this.stepHeaderElement) {
      return parseInt(this.stepHeaderElement.getAttribute("max-input-quantity"));
    }
    return 0;
  }
  get singleSelectionStep() {
    if (this.getAttribute("single-selection-step") == "true") {
      return true;
    } else {
      return false;
    }
  }
  _init() {
    this.quantity = parseInt(this.quantity);
    if (this.quantity > 0) {
      this._disableMinus(false);
    } else {
      this._disableMinus(true);
    }
  }
  _disablePlus(state) {
    if (this.singleSelectionStep && this.quantity != 1) {
      state = false;
    }

    this.plusButtons.forEach((button) => {
      if (state) {
        button.setAttribute("disabled", "true");
      } else {
        button.removeAttribute("disabled");
      }
    });
  }
  _disableMinus(state) {
    this.minusButtons.forEach((button) => {
      if (state) {
        button.setAttribute("disabled", "true");
      } else {
        button.removeAttribute("disabled");
      }
    });
  }
  _onStepCompleted(event) {
    this._disablePlus(true);
  }
  _onStepNotCompleted(event) {
    this._disablePlus(false);
  }
  _onPlusButtonClick(event) {
    event.preventDefault();

    if (this.singleSelectionStep) {
      const selectedComponent = this.parentElement.querySelector(`.bundle-product-component[quantity="1"]`);
      if (selectedComponent) {
        const variantId = selectedComponent.getAttribute("variant-id");
        this.bundleForm.dispatchEvent(new CustomEvent(`bundle:variant:remove:${variantId}`, {
          bubbles: true,
          detail: {
            variantId: variantId
          }
        }));
      }
    } else {
      if (this.plusButtons[0].hasAttribute("disabled")) {
        return;
      }
    }

    this.quantity = parseInt(this.quantity) + 1;
    this._disableMinus(false);
  }
  _onMinusButtonClick(event) {
    event.preventDefault();

    this.quantity = parseInt(this.quantity) - 1;
    if (this.quantity <= 0) {
      this.quantity = 0;
      this._disableMinus(true);
    }
  }
  _onInputChange(event) {
    event.preventDefault();

    const oldValue = this.inputElement.value;
    const value = parseInt(this.inputElement.value);
    if (isNaN(value) || value < 0) {
      this.quantity = 0;
      this._disableMinus(true);
    } else if (value > this.maxInputQuantity) {
      this.quantity = this.maxInputQuantity;
      this._disablePlus(true);
    } else if (value > 0) {
      this.quantity = value;
      this._disableMinus(false);
    } else {
      this.quantity = value;
    }
  }
};
if (!window.customElements.get("bundle-product-component")) {
  window.customElements.define("bundle-product-component", BundleProductComponent);
}

var BundleStepHeader = class extends HTMLElement {
  constructor() {
    super();

    this.form = document.getElementById(this.getAttribute("form-id"));
    this.progressBar = this.querySelector(".bundle-step-progress-bar");
    this.progressBarFilling = this.querySelector(".bundle-step-progress-bar__filled");

    this.allowedQuantities = this.getAttribute("allowed-quantities") ? this.getAttribute("allowed-quantities").split(",").map((quantity) => parseInt(quantity)) : [];
    this.maxAllowedQuantity = this.allowedQuantities.length > 0 ? Math.max(...this.allowedQuantities) : 0;
    this.stepHandle = this.getAttribute("step-handle");


    this.onBundleQuantityChangedHandler = this._onBundleQuantityChanged.bind(this);
  }
  connectedCallback() {
    this.form.addEventListener("bundle:variants:changed", this.onBundleQuantityChangedHandler);
    this.maxInputQuantity = this.maxAllowedQuantity;
  }
  disconnectedCallback() {
    this.form.removeEventListener("bundle:variants:changed", this.onBundleQuantityChangedHandler);
  }
  get nextStep() {
    return this.getAttribute("next-step");
  }
  set nextStep(value) {
    const oldValue = parseInt(this.nextStep);
    if (oldValue !== value) {
      this.form.dispatchEvent(new CustomEvent("bundle:step:changed", {
        bubbles: true,
        detail: {
          oldValue: oldValue,
          newValue: value,
          stepHandle: this.stepHandle
        }
      }));
      this.setAttribute("next-step", value);
    }
  }
  set maxInputQuantity(value) {
    this.setAttribute("max-input-quantity", value);
  }
  _checkQuantity(quantity) {
    let result = {
      valid: false,
      itemsLeftForNextStep: 0,
      completed: false,
      nextStepCount: 0,
      currentReachedStepCount: 0
    }
    if (this.allowedQuantities.length > 0) {
      for (let i = 0; i < this.allowedQuantities.length; i++) {
        if (this.allowedQuantities[i] == quantity) {
          result.valid = true;
          result.currentReachedStepCount = this.allowedQuantities[i];
          if (i == this.allowedQuantities.length - 1) {
            result.completed = true;
          } else {
            result.itemsLeftForNextStep = this.allowedQuantities[i + 1] - quantity;
          }
        } else if (this.allowedQuantities[i] > quantity) {
          result.itemsLeftForNextStep = this.allowedQuantities[i] - quantity;
          result.nextStepCount = this.allowedQuantities[i];
          break;
        } 
      }
    }
    return result;
  }
  _onBundleQuantityChanged(event) {
    if (event.detail.stepHandle !== this.stepHandle) {
      return;
    }

    const variants = event.detail.variants;

    const variantCount = variants.reduce((acc, variant) => {
      if (variant.quantity > 0 && variant.stepHandle === this.stepHandle) {
        return acc + 1;
      }
      return acc;
    }, 0);

    const quantityValidation = this._checkQuantity(variantCount);
    if (quantityValidation.completed) {
      this.classList.add("completed");
      this.classList.add("valid");
      this._updateProgressBar(quantityValidation.nextStepCount, quantityValidation.currentReachedStepCount);
      this.dispatchEvent(new CustomEvent("bundle:step:completed", {
        bubbles: true,
        detail: {
          stepHandle: this.stepHandle
        }
      }));
    } else {
      this.nextStep = quantityValidation.nextStepCount;
      this.dispatchEvent(new CustomEvent("bundle:step:not-completed", {
        bubbles: true,
        detail: {
          stepHandle: this.stepHandle
        }
      }));
      this.classList.remove("completed");
      if (quantityValidation.valid) {
        this.classList.add("valid");
      } else {
        this.classList.remove("valid");
      }
      this._updateProgressBar(quantityValidation.itemsLeftForNextStep, quantityValidation.nextStepCount);
    }
    this.form.dispatchEvent(new CustomEvent("bundle:step:changed", {
      bubbles: true,
      detail: {
        stepHandle: this.stepHandle
      }
    }));
    this.maxInputQuantity = this.maxAllowedQuantity - variantCount;

  }
  _updateProgressBar(itemsLeft, maxItems) {
    if (this.progressBarFilling) {
      const progress = (maxItems - itemsLeft) / maxItems * 100;
      this.progressBarFilling.style.width = `${progress}%`;
    }
  }
}

if (!window.customElements.get("bundle-step-header")) {
  window.customElements.define("bundle-step-header", BundleStepHeader);
}

var BundleVariantSelector = class extends HTMLElement {
  constructor() {
    super();

    this.form = document.getElementById(this.getAttribute("form-id"));
    this.stepHandle = this.getAttribute("step-handle");
    this.buttons = document.querySelectorAll(`.bundle-variant-selector__button[step-handle="${this.stepHandle}"]`);

    this.onButtonClickHandler = this._onButtonClick.bind(this);
  }
  connectedCallback() {
    this.buttons.forEach((button) => {
      button.addEventListener("click", this.onButtonClickHandler);
    });
  }
  disconnectedCallback() {
    this.buttons.forEach((button) => {
      button.removeEventListener("click", this.onButtonClickHandler);
    });
  }
  _onButtonClick(event) {
    event.preventDefault();

    const button = event.currentTarget.closest(".bundle-variant-selector__button");
    const variantId = button.getAttribute("variant-id");

    this.buttons.forEach((button) => {
      if (button.getAttribute("variant-id") !== variantId) {
        button.removeAttribute("active");
      } else {
        button.setAttribute("active", "true");
      }
    });

    this.form.dispatchEvent(new CustomEvent("bundle:product_variant:changed", {
      bubbles: true,
      detail: {
        newVariantId: variantId,
      }
    }));

    const prevNextButtons = this.parentElement.parentElement.querySelectorAll(".product-list__prev-next");
    prevNextButtons.forEach((button) => {
      button.dispatchEvent(new CustomEvent("prev-next:init", {}));
    });
  }

}

if (!window.customElements.get("bundle-variant-selector")) {
  window.customElements.define("bundle-variant-selector", BundleVariantSelector);
}

class StickyBundleBuilderSummary extends HTMLElement {
  constructor() {
    super();
    this._onBundleVariantsChanged = this._onBundleVariantsChanged.bind(this);
    this._onScroll = this._onScroll.bind(this);
    this.hasVariants = false;
    this.formId = null;
    this.bundleForm = null;
    this.observer = null;
  }

  connectedCallback() {
    // Find the associated bundle form by attribute or closest form
    this.formId = this.getAttribute('form-id');
    this.bundleForm = document.getElementById(this.formId);

    if (this.bundleForm) {
      this.bundleForm.addEventListener('bundle:variants:changed', this._onBundleVariantsChanged);
    }

    // Listen to scroll and resize
    window.addEventListener('scroll', this._onScroll, { passive: true });
    window.addEventListener('resize', this._onScroll);

    // Initial state
    this._onScroll();
  }

  disconnectedCallback() {
    if (this.bundleForm) {
      this.bundleForm.removeEventListener('bundle:variants:changed', this._onBundleVariantsChanged);
    }
    window.removeEventListener('scroll', this._onScroll);
    window.removeEventListener('resize', this._onScroll);
  }

  _onBundleVariantsChanged(event) {
    const variants = event.detail.variants || [];
    this.hasVariants = variants.length > 0;
    this._onScroll();
  }

  _onScroll() {
    if (!this.hasVariants) {
      this.setAttribute('hidden', '');
      return;
    }
    // Hide if bundle-product-form is in (or near) viewport
    if (!this.bundleForm) {
      this.removeAttribute('hidden');
      return;
    }
    const rect = this.bundleForm.getBoundingClientRect();
    const threshold = 120; // px, adjust as needed for "near"
    const inView =
      rect.top < window.innerHeight - threshold;

    if (inView) {
      this.setAttribute('hidden', '');
    } else {
      this.removeAttribute('hidden');
    }
  }
}

window.customElements.define('sticky-bundle-builder-summary', StickyBundleBuilderSummary);

class BundlePriceList extends HTMLElement {
  constructor() {
    super();

    this.currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;

    this.form = document.getElementById(this.getAttribute("form"));
    this.taxInfo = this.querySelector(".product-meta__taxes-included");
    this.savingsInput = this.form.querySelector("input[name='properties[__savings]']");
    this.bundlePriceInput = this.form.querySelector("input[name='properties[__bundle_price]']");

    this.data = this.form.bundleData;

    this.dynamicPricing = this.getAttribute("dynamic-pricing") === "true";
    this.noPriceMessage = this.getAttribute("no-price-message");
    this.ariaLabel = this.getAttribute("aria-label");
    this.savingMessage = this.getAttribute("saving-message");
    this.fromPriceLabel = this.getAttribute("from-price-label");
    this.priceList = this.querySelector(".price-list");

    this.variantsChangedHandler = this._onBundleVariantsChanged.bind(this);

    if (this.data) {
      this._init();
    }
  }

  connectedCallback() {
    if (this.form && this.dynamicPricing) {
      this.form.addEventListener("bundle:variants:changed", this.variantsChangedHandler);
      this.form.addEventListener("bundle:variants:replace", this.variantsChangedHandler);
    }

    this.form.addEventListener("bundle-data-ready", () => {
      this.data = this.form.bundleData;
      this._init();
    });
  }
  disconnectedCallback() {
    if (this.form && this.dynamicPricing) {
      this.form.removeEventListener("bundle:variants:changed", this.variantsChangedHandler);
      this.form.removeEventListener("bundle:variants:replace", this.variantsChangedHandler);
    }
  }
  _init() {
    const variantData = this.data[this.data.firstVariantId];
    const pricing = variantData.pricing;

    if (pricing.dynamicPricing) {
      /* Case 1: All steps optional + has fixed parts → show fixed parts total */
      if (variantData.allStepsOptional && variantData.fixedParts.hasFixedParts && variantData.fixedPartsTotal > 0) {
        const fixedTotal = variantData.fixedPartsTotal;
        const discount = this._getDiscountForQuantity(pricing.discount, variantData.fixedParts.items.length);
        const discountedPrice = fixedTotal - (fixedTotal * discount / 100);

        this.priceList.innerHTML = `
          <span class="price price--highlight product_price">
            <span class="visually-hidden">${this.ariaLabel}</span>
            ${formatMoney(discountedPrice, this.currencyFormat)}
          </span>`;
        if (discount > 0) {
          this.priceList.innerHTML += `
            <span class="price product_compareAtPrice product_price">
              <span class="visually-hidden">${this.ariaLabel}</span>
              ${formatMoney(fixedTotal, this.currencyFormat)}
            </span>`;
        }
        this.taxInfo.hidden = false;
      /* Case 2: Has required steps → show "ab" price */
      } else if (!variantData.allStepsOptional) {
        const minPrice = this._calculateMinPrice([], variantData);
        this._renderFromPrice(minPrice);
        this.taxInfo.hidden = false;
      } else {
        this.priceList.innerHTML = `<span class="noPriceMessage">${this.noPriceMessage}</span>`;
      }
    } else {
      this.priceList.innerHTML = `<span class="price price--large">${formatMoney(pricing.fixPriceValue, this.currencyFormat)}</span>`;
      if (pricing.worthOfGoods) {
        this.priceList.innerHTML += `
          <span class="bundle-badge">
            ${this.savingMessage.replace("[saving]", formatMoney((pricing.worthOfGoods - pricing.fixPriceValue), this.currencyFormat))}
          </span>
        `;
        if (this.savingsInput) {
          this.savingsInput.value = formatMoney((pricing.worthOfGoods - pricing.fixPriceValue), this.currencyFormat);
        }
        if (this.bundlePriceInput) {
          this.bundlePriceInput.value = pricing.fixPriceValue;
        }
      }
      this.taxInfo.hidden = false;
    }
  }

  /**
   * Renders the "ab [price]" label with an animated span for the prefix.
   * Shows a strikethrough compare-at price when a discount applies.
   */
  _renderFromPrice(priceData) {
    // console.log("Rendering from price with data :", priceData);
    const { discounted, undiscounted } = priceData;
    const formattedPrice = formatMoney(discounted, this.currencyFormat);
    const labelHtml = this.fromPriceLabel.replace("[price]", "");
    const hasDiscount = undiscounted > discounted;

    let html = `
      <span class="price price--highlight product_price">
        <span class="visually-hidden">${this.ariaLabel}</span>
        ${labelHtml} ${formattedPrice}
      </span>`;

    if (hasDiscount) {
      html += `
        <span class="price product_compareAtPrice product_price">
          <span class="visually-hidden">${this.ariaLabel}</span>
          ${formatMoney(undiscounted, this.currencyFormat)}
        </span>`;
    }

    this.priceList.innerHTML = html;
    this.classList.remove("bundle-price-list--valid");
  }

  /**
   * Renders the final price without "ab" prefix, with animation class.
   */
  _renderFinalPrice(bundlePrice, worthOfGoods) {
    this.priceList.innerHTML = `
      <span class="price price--highlight product_price">
        <span class="visually-hidden">${this.ariaLabel}</span>
        ${formatMoney(bundlePrice, this.currencyFormat)}
      </span>`;
    if (bundlePrice < worthOfGoods) {
      this.priceList.innerHTML += `
      <span class="price product_compareAtPrice product_price">
        <span class="visually-hidden">${this.ariaLabel}</span>
        ${formatMoney(worthOfGoods, this.currencyFormat)}
      </span>`;
    }
    this.classList.add("bundle-price-list--valid");
  }

  /**
   * Returns the applicable discount percentage for a given quantity.
   */
  _getDiscountForQuantity(discountTiers, quantity) {
    let discount = 0;
    for (let i = 0; i < discountTiers.length; i++) {
      if (quantity >= discountTiers[i].min_quantity) {
        discount = discountTiers[i].value;
      }
    }
    return discount;
  }

  /**
   * Calculates the minimum possible price based on current selections
   * and the cheapest options for remaining required steps.
   */
  _calculateMinPrice(currentVariants, variantData) {
    const pricing = variantData.pricing;
    const groups = variantData.componentGroups || [];
    let totalMinQuantity = currentVariants.length;

    /* Sum of prices from currently selected variants */
    let currentTotal = currentVariants.reduce((acc, v) => {
      return acc + (v.variantPrice * (v.quantity || 1));
    }, 0);

    // Catches edge case if selected items are not initialized yet
    if (variantData.fixedPartsTotal > 0 && currentTotal == 0) {
      currentTotal = variantData.fixedPartsTotal;
      totalMinQuantity = variantData.fixedParts.items.length;
    }

    /* Count how many items are selected per step */
    const selectedPerStep = {};
    currentVariants.forEach((v) => {
      if (!selectedPerStep[v.stepHandle]) {
        selectedPerStep[v.stepHandle] = 0;
      }
      selectedPerStep[v.stepHandle] += (v.quantity || 1);
    });

    /* For each required, non-fixed step that is not yet fulfilled: add cheapest option */
    groups.forEach((group) => {
      if (group.isFixedParts) return;
      if (group.isOptional) return;

      const currentlySelected = selectedPerStep[group.stepHandle] || 0;
      const remaining = Math.max(0, group.minRequiredQuantity - currentlySelected);

      if (remaining > 0 && group.cheapestAvailableVariantPrice > 0) {
        currentTotal += group.cheapestAvailableVariantPrice * remaining;
        totalMinQuantity += remaining;
      }
    });

    /* Apply discount for the projected minimum total quantity */
    const discount = this._getDiscountForQuantity(pricing.discount, totalMinQuantity);
    return {
      discounted: currentTotal - (currentTotal * discount / 100),
      undiscounted: currentTotal
    };
  }

  _onBundleVariantsChanged(event) {
    const variants = event.detail.variants || [];
    if (!this.data) {
      return;
    }
    const variantData = this.data[this.form.curProdVariant];
    const pricing = variantData.pricing;

    const curDiscount = this._getDiscountForQuantity(pricing.discount, variants.length);

    if (event.detail.validQuantity) {
      if (pricing.dynamicPricing) {
        const worthOfGoods = variants.reduce((acc, variant) => {
          if (variant.quantity > 0) {
            return acc + (variant.variantPrice * variant.quantity);
          }
          return acc;
        }, 0);
        const bundlePrice = worthOfGoods - (worthOfGoods * curDiscount / 100);

        this._renderFinalPrice(bundlePrice, worthOfGoods);

        if (this.savingsInput) {
          this.savingsInput.value = formatMoney((worthOfGoods - bundlePrice), this.currencyFormat);
        }
        if (this.bundlePriceInput) {
          this.bundlePriceInput.value = bundlePrice;
        }
        this.taxInfo.hidden = false;
      }
    } else {
      if (pricing.dynamicPricing) {
        /* Show "ab" price based on current selections + cheapest remaining */
        const minPrice = this._calculateMinPrice(variants, variantData);
        this._renderFromPrice(minPrice);
        this.taxInfo.hidden = false;
      } else if (pricing.dynamicPricing && variantData.allStepsOptional && variantData.fixedParts.hasFixedParts && variantData.fixedPartsTotal > 0) {
        /* All optional + fixed parts but no extra items selected → show fixed total */
        const fixedTotal = variantData.fixedPartsTotal;
        const discount = this._getDiscountForQuantity(pricing.discount, variantData.fixedParts.items.length);
        const discountedPrice = fixedTotal - (fixedTotal * discount / 100);

        this.priceList.innerHTML = `
          <span class="price price--highlight product_price">
            <span class="visually-hidden">${this.ariaLabel}</span>
            ${formatMoney(discountedPrice, this.currencyFormat)}
          </span>`;
        if (discount > 0) {
          this.priceList.innerHTML += `
            <span class="price product_compareAtPrice product_price">
              <span class="visually-hidden">${this.ariaLabel}</span>
              ${formatMoney(fixedTotal, this.currencyFormat)}
            </span>`;
        }
        this.taxInfo.hidden = false;
      } else {
        this.priceList.innerHTML = `<span class="noPriceMessage">${this.noPriceMessage}</span>`;
        this.taxInfo.hidden = true;
      }
    }
  }
};

window.customElements.define('bundle-price-list', BundlePriceList);

// js/custom-element/behavior/collapsible-content.js
var BundleProductInfoComponent = class extends OpenableElement {
  constructor() {
    super();
    this.ignoreNextTransition = this.open;

    this.stepComponents = document.querySelectorAll(`.bundle-product-info-component[step-handle="${this.getAttribute("step-handle")}"]`);

    this.addEventListener("shopify:block:select", () => this.open = true);
    this.addEventListener("shopify:block:deselect", () => this.open = false);
  }
  get animateItems() {
    return this.hasAttribute("animate-items");
  }

  attributeChangedCallback(name) {
    switch (name) {
      case "open":
        if (this.open) {
          this.stepComponents.forEach((component) => {
            if (component.hasAttribute("open") && component.id != this.id) {
              component.removeAttribute("open");
            }
          });
        }
        triggerEvent(this, this.open ? "openable-element:open" : "openable-element:close");
    }
  }
};
window.customElements.define("bundle-product-info-component", BundleProductInfoComponent);

var CartNotification = class extends PopoverContent {
  constructor() {
    super();
  }
  /*
  * =========
  * START: AB-Test PT-39
  * =========
  */
 get abTestVariant() {
   return this.getAttribute("ab-test-variant");
  }
  /*
  * =========
  * END: AB-Test PT-39
  * =========
  */
  connectedCallback() {
    super.connectedCallback();

    document.addEventListener("cart-notification:show", async (event) => {
      /*
      * =========
      * AB-Test PT-39
      * Added Conditional Statement
      * =========
      */
      if (this.abTestVariant == "control") {
        document.dispatchEvent(new CustomEvent("cart:open", {
          detail: {
            variant: event.detail.variant,
            abTestVariant: this.abTestVariant
          }
        }));
      } else {
        await this.before_open(event.detail.variant);
        this.open = true;
      }

    });
    document.addEventListener("cart-notification:hide", () => this.open = false);
  }
  disconnectedCallback() {
    document.removeEventListener("cart-notification:show", () => {
      this.open = true;
    });
    document.removeEventListener("cart-notification:hide", () => this.open = false);
  }
  attributeChangedCallback(name, oldValue, newValue) {
    super.attributeChangedCallback(name, oldValue, newValue);
    switch (name) {
      case "open":
        document.documentElement.classList.toggle("lock-all", this.open);
    }
  }
  async before_open(variant) {
    const fakeDiv = document.createElement("div");
    fakeDiv.innerHTML = variant.sections["product-recommendations"];
    // fakeDiv.innerHTML = variant.sections["cart-notification-popup"];
    const crossSell = fakeDiv.querySelector(`[cart-notification-template="${variant.id}"]`);

    const crossSellEl = this.querySelector(".cart_notification--cross-sell");
    if (crossSell != null) {
      crossSellEl.innerHTML = crossSell.innerHTML;
      crossSellEl.hidden = false;
    } else {
      // Erst die ergänzenden Produkte zeigen. Bleibt dafür keine Karte übrig, kommen wie bisher die ähnlichen.
      let template = await this.fetch_cross_sell_template(variant, "complementary");
      if (template == null || template.querySelector(".line-item__content-wrapper") == null) {
        template = await this.fetch_cross_sell_template(variant, "related");
      }

      if (template == null) {
        return;
      }

      crossSellEl.innerHTML = template.innerHTML;
      crossSellEl.hidden = false;
    }
  }
  async fetch_cross_sell_template(variant, intent) {
    const url = `${window.themeVariables.routes.productRecommendationsUrl}?product_id=${variant.product_id}&limit=9&section_id=cart-notification-popup&intent=${intent}`;
    const response = await fetch(url);

    if (!response.ok) {
      console.error("Failed to fetch recommendations", response);
      return null;
    }

    const div = document.createElement("div");
    div.innerHTML = await response.text();
    return div.querySelector(`[cart-notification-template="${variant.id}"]`);
  }
};
window.customElements.define("cart-notification", CartNotification);

var ProductIngredients = class extends HTMLElement {
  constructor() {
    super();

    this.onVariantChangeHandler = this._onVariantChanged.bind(this);
  }
  get changeIngredients() {
    return this.hasAttribute("no-change") ? false : true;
  }
  connectedCallback() {
    if (this.changeIngredients) {
      document.getElementById(this.getAttribute("form-id"))?.addEventListener("variant:changed", this.onVariantChangeHandler);
    }
  }
  disconnectedCallback() {
    if (this.changeIngredients) {
      document.getElementById(this.getAttribute("form-id"))?.removeEventListener("variant:changed", this.onVariantChangeHandler);
    }
  }
  _onVariantChanged(event) {
    const variantId = event.detail.newVariant.id;
    const variantIngredientWrapper = this.querySelector(`[variant-id="${variantId}"]`);
    const defaultIngredientWrapper = this.querySelector(`[variant-id="default"]`);

    this.querySelectorAll("[variant-id]").forEach((wrapper) => {
      wrapper.hidden = true;
    });

    if (variantIngredientWrapper) {
      variantIngredientWrapper.hidden = false;
    } else if (defaultIngredientWrapper) {
      defaultIngredientWrapper.hidden = false;
    }
  }
};
window.customElements.define("product-ingredients", ProductIngredients);

var PagePaginationInfinity = class extends HTMLElement {
  static get observedAttributes() { return ["hidden"]; }

  constructor() {
    super();

    this._containerSelector = this.getAttribute("data-container-selector") || ".product-facet";
    this._prefetchEnabled = this.getAttribute("data-prefetch") === "true";
    this._hasNext = this.getAttribute("data-has-next") === "true";
    this._nextUrl = this.getAttribute("data-initial-next-url") || "";
    this._loading = false;
    this._aborted = false;

    // UI elements (spinner + retry)
    this.$loader = this.querySelector(".pagination__loader");
    this.$retry = this.querySelector(".pagination__retry");
    if (this.$retry) {
      this.$retry.addEventListener("click", () => this._loadMore());
    }
  }

  connectedCallback() {
    if (this.hasAttribute("hidden")) return;

    // If no more pages, hide and bail.
    if (!this._hasNext || !this._nextUrl) {
      this.setAttribute("hidden", "");
      return;
    }

    // Prepare observer as a scroll-hint sentinel.
    this._observer = new IntersectionObserver((entries) => {
      const entry = entries[0];
      if (entry.isIntersecting) {
        this._loadMore();
      }
    }, { root: null, rootMargin: "600px 0px", threshold: 0 });

    this._observer.observe(this);

    // Optional prefetch of the next page
    this._maybePrefetch(this._nextUrl);
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name !== "hidden" || oldValue === newValue) return;

    const isHidden = newValue !== null;
    if (isHidden) {
      // Wenn hidden gesetzt ist, alles pausieren
      this._observer?.disconnect();
      this._observer = null;
      this._controller?.abort();
      this._controller = null;
    } else {
      // Wenn hidden entfernt wird, reaktivieren
      if (!this._observer && this._hasNext && this._nextUrl) {
        this._observer = new IntersectionObserver((entries) => {
          const entry = entries[0];
          if (entry.isIntersecting) {
            this._loadMore();
          }
        }, { root: null, rootMargin: "600px 0px", threshold: 0 });
        this._observer.observe(this);
        this._maybePrefetch(this._nextUrl);
      }
    }
  }

  disconnectedCallback() {
    this._observer?.disconnect();
    this._controller?.abort();
  }

  _getContainer() {
    return document.querySelector(this._containerSelector);
  }

  async _loadMore() {
    if (this._loading || !this._hasNext || !this._nextUrl) return;

    const container = this._getContainer();
    if (!container) return;

    this._setLoading(true);
    this._aborted = false;

    // Use AbortController to guard against quick navigations
    this._controller?.abort();
    this._controller = new AbortController();

    try {
      const response = await this._fetchWithTimeout(this._nextUrl, { signal: this._controller.signal });
      // const response = await this._fetchWithTimeout("hkjl", { signal: this._controller.signal });
      if (!response.ok) throw new Error("HTTP " + response.status);
      const html = await response.text();

      const { itemsFragment, nextUrl } = this._extractFromHTML(html);

      if (itemsFragment) {
        // Append products to the grid
        container.appendChild(itemsFragment);
        // Fire a custom event in case analytics hooks want to listen later on
        triggerEvent(container, "infinite-pagination:page-appended", { url: this._nextUrl });
      }

      // Update pagination state
      if (nextUrl) {
        this._nextUrl = nextUrl;
        this._hasNext = true;
        this._maybePrefetch(this._nextUrl);
      } else {
        this._nextUrl = "";
        this._hasNext = false;
        this._observer?.disconnect();
        this.setAttribute("hidden", "");
      }
    } catch (err) {
      if (err.name === "AbortError") {
        this._aborted = true;
      } else {
        this.querySelector(".normal-pagination").hidden = false;
        this.querySelector(".pagination__hint").hidden = true;

        triggerEvent(this, "infinite-pagination:error", { error: String(err) });
      }
    } finally {
      this._setLoading(false);
    }
  }

  _setLoading(isLoading) {
    this._loading = isLoading;
    if (this.$loader) this.$loader.hidden = !isLoading;
  }

  async _fetchWithTimeout(url, opts = {}) {
    const controller = opts.signal ? null : new AbortController();
    const signal = opts.signal || controller.signal;
    const timeout = setTimeout(() => {
      if (!signal.aborted) {
        if (controller) controller.abort();
      }
    }, 12000); // 12s timeout

    try {
      return await fetch(url, { credentials: "same-origin", headers: { "X-Requested-With": "XMLHttpRequest" }, signal });
    } finally {
      clearTimeout(timeout);
    }
  }

  _extractFromHTML(html) {
    // Parse response into a detached DOM
    const wrapper = document.createElement("div");
    wrapper.innerHTML = html;

    // 1) Grab new product cards
    const newInner = wrapper.querySelector(this._containerSelector);
    let itemsFragment = null;
    if (newInner) {
      itemsFragment = document.createDocumentFragment();
      // Only append product cards (avoid duplicating container wrappers)
      newInner.querySelectorAll(".product-card").forEach((el) => itemsFragment.appendChild(el));
    }

    // 2) Find the next URL. Prefer the new infinite component on the response,
    //    otherwise fall back to a rel="next" link if present.
    let nextUrl = "";
    const nextComponent = wrapper.querySelector("page-pagination-infinity");
    if (nextComponent && nextComponent.getAttribute("data-has-next") === "true") {
      nextUrl = nextComponent.getAttribute("data-initial-next-url") || "";
    }
    if (!nextUrl) {
      const relNext = wrapper.querySelector('a[rel="next"]');
      if (relNext) nextUrl = relNext.getAttribute("href") || "";
    }

    return { itemsFragment, nextUrl };
  }

  _maybePrefetch(url) {
    if (!this._prefetchEnabled || !url) return;
    // Avoid duplicating prefetch links
    if (document.querySelector('link[rel="prefetch"][href="' + url + '"]')) return;
    const link = document.createElement("link");
    link.setAttribute("rel", "prefetch");
    link.setAttribute("href", url);
    document.head.appendChild(link);
  }
};
window.customElements.define("page-pagination-infinity", PagePaginationInfinity);

var CustomerAccountNavigation = class extends HTMLElement {
  constructor() {
    super();

    this._onHashChange = this._onHashChange.bind(this);
    this._onPopState = this._onPopState.bind(this);
    this._onUrlChange = this._onUrlChange.bind(this);

    this.content = this.querySelector(".content");
    this.customerDataWrapper = this.querySelector("[customer-data]");
    this.activeHandle = "";

    // this._unpatchHistory = null;

    this._replaceContentVariables();
  }
  _replaceContentVariables() {
    const variableMap = {
      '[vorname]': this.dataset.customerFirstName || '',
      '[nachname]': this.dataset.customerLastName || '',
      '[email]': this.dataset.customerEmail || ''
    };

    const walker = document.createTreeWalker(this, NodeFilter.SHOW_TEXT);
    const textNodes = [];
    while (walker.nextNode()) textNodes.push(walker.currentNode);

    for (const node of textNodes) {
      let text = node.nodeValue;
      let changed = false;
      for (const [placeholder, value] of Object.entries(variableMap)) {
        if (text.includes(placeholder)) {
          text = text.replaceAll(placeholder, value);
          changed = true;
        }
      }
      if (changed) node.nodeValue = text;
    }
  }
  connectedCallback() {
    // Initial auslesen
    this._onUrlChange();

    window.addEventListener("hashchange", this._onHashChange);
    window.addEventListener("popstate", this._onPopState);

    // Optional: pushState/replaceState hooken, damit SPA-Navigation auch erkannt wird
    // this._unpatchHistory = this._patchHistory();

    // Mobile menu toggle
    const toggles = document.querySelectorAll(".header [mobile-nav-toggle]");
    toggles.forEach(toggle => {
      toggle.addEventListener("click", () => {
        this._toggleMobileMenu();
      });
    });

    // Overlay click closes menu
    this.querySelector("[mobile-nav-overlay]")?.addEventListener("click", () => {
      this._closeMobileMenu();
    });

    this.fetchCustomerData();
    this._initStickySidebar();
    this._initMobileNavigation();
  }
  _initMobileNavigation() {
    const desktopNavigation = this.querySelector(".navigation-sidebar");
    const mobileNavigations = document.querySelectorAll(".header .navigation-sidebar");
    if (!desktopNavigation || !mobileNavigations.length) return;
    mobileNavigations.forEach(mobileNavigation => {
      mobileNavigation.innerHTML = desktopNavigation.innerHTML;
    });
  }
  _toggleMobileMenu() {
    const toggleBtns = document.querySelectorAll(".header [mobile-nav-toggle]");
    let expanded;
    
    if (!toggleBtns.length) return;
    
    toggleBtns.forEach(toggleBtn => {
      const navSidebar = document.querySelector(`.header [section-id="${toggleBtn.getAttribute("section-id")}"].navigation-sidebar`);
      expanded = navSidebar.classList.toggle("is-expanded");
      toggleBtn.setAttribute("aria-expanded", String(expanded));

      const iconOpen = toggleBtn.querySelector("[menu-icon-open]");
      const iconClose = toggleBtn.querySelector("[menu-icon-close]");
      const label = toggleBtn.querySelector("[menu-label]");

      if (iconOpen) iconOpen.hidden = expanded;
      if (iconClose) iconClose.hidden = !expanded;
      if (label) label.textContent = expanded ? label.getAttribute("label-close") : label.getAttribute("label-default");
    });

    const overlay = this.querySelector("[mobile-nav-overlay]");
    if (overlay) {
      overlay.hidden = !expanded;
      requestAnimationFrame(() => {
        overlay.classList.toggle("is-visible", expanded);
      });
    }
  }
  _closeMobileMenu() {
    const toggleBtns = document.querySelectorAll(".header [mobile-nav-toggle]");

    // if (navSidebar) navSidebar.classList.remove("is-expanded");
    if (toggleBtns.length) {
      toggleBtns.forEach(toggleBtn => {
        const navSidebar = document.querySelector(`.header [section-id="${toggleBtn.getAttribute("section-id")}"].navigation-sidebar`);
        if (navSidebar) navSidebar.classList.remove("is-expanded");
        toggleBtn.setAttribute("aria-expanded", "false");
        const iconOpen = toggleBtn.querySelector("[menu-icon-open]");
        const iconClose = toggleBtn.querySelector("[menu-icon-close]");
        const label = toggleBtn.querySelector("[menu-label]");
        if (iconOpen) iconOpen.hidden = false;
        if (iconClose) iconClose.hidden = true;
        if (label) label.textContent = "Menü";
      });
    }

    const overlay = this.querySelector("[mobile-nav-overlay]");
    if (overlay && overlay.classList.contains("is-visible")) {
      overlay.classList.remove("is-visible");
      overlay.addEventListener("transitionend", () => { overlay.hidden = true; }, { once: true });
    } else if (overlay) {
      overlay.classList.remove("is-visible");
      overlay.hidden = true;
    }
  }
  _initStickySidebar() {
    const sidebar = this.querySelector(".account-sidebar");
    if (!sidebar || window.innerWidth <= 740) return;

    const initialTop = sidebar.getBoundingClientRect().top;
    sidebar.style.top = `${initialTop}px`;
  }
  disconnectedCallback() {
    window.removeEventListener("hashchange", this._onHashChange);
    window.removeEventListener("popstate", this._onPopState);
    if (this._unpatchHistory) this._unpatchHistory();
  }
  get pages() {
    return this.querySelectorAll(".account-page[page-handle]");
  }
  get customerId() {
    return this.getAttribute("customer-id");
  }
  get customerData() {
    const rawData = this.customerDataWrapper.innerHTML;
    if (!rawData || rawData.length === 0) {
      return null;
    }
    return JSON.parse(rawData);
  }
  set customerData(customerData) {
    this.customerDataWrapper.innerHTML = JSON.stringify(customerData);
  }
  async fetchCustomerData() {

    // this.loyaltySiteId = 49623; // DEV-Store
    this.loyaltySiteId = 25281; // DE-Store
    // this.loyaltyMerchantId = 7788604031314; // DEV-Store
    this.loyaltyMerchantId = this.customerId; // DE-Store

    const options = {method: 'GET', headers: {Authorization: 'Bearer ' + window.loyaltylionSessionToken}};
    const response = await fetch(`https://api.loyaltylion.com/headless/2025-06/${this.loyaltySiteId}/customers/${this.loyaltyMerchantId}?channel=web&language=${document.documentElement.lang}`, options);

    if (response.ok) {
      const data = await response.json();
      // console.log("customer data", data);

      this.dispatchEvent(new CustomEvent("customer-data:loaded", {
        bubbles: true,
        detail: data
      }));
    }
  }
  getCurrentRouteInfo() {
    const { pathname, hash } = window.location;

    // hash ist entweder "" oder "#anker"
    const anchor = hash && hash.length > 1 ? hash.slice(1) : null;

    // Remove trailing slash from pathname for consistency
    const normalizedPathname = pathname.endsWith("/") && pathname.length > 1 ? pathname.slice(0, -1) : pathname;

    return {
      pathname: normalizedPathname,     // z.B. "/account/orders"
      hasHash: !!anchor,
      anchor,       // z.B. "section-2" oder null
      rawHash: hash // z.B. "#section-2" oder ""
    };
  }
  _onUrlChange() {
    const info = this.getCurrentRouteInfo();
    const previousHandle = this.activeHandle;

    const selector = `.navigation-item[path="${info.pathname}"][anchor="${info.anchor || ""}"]`;
    const activeElement = this.querySelector(selector);
    const previouslyActive = this.querySelector(`.navigation-item.active`);
    if (previouslyActive && previouslyActive !== activeElement) {
      previouslyActive.classList.remove("active");
    }
    if (activeElement && !activeElement.classList.contains("active")) {
      this.activeHandle = activeElement.getAttribute("page-handle");
      activeElement.classList.add("active");
    }

    // Sync active state to mobile navigation in header
    const mobileNav = document.querySelector(".header .navigation-sidebar");
    if (mobileNav) {
      const mobileActive = mobileNav.querySelector(".navigation-item.active");
      if (mobileActive) mobileActive.classList.remove("active");

      const mobileTarget = mobileNav.querySelector(selector);
      if (mobileTarget) mobileTarget.classList.add("active");
    }

    if (this.content.hidden) {
      this.content.hidden = false;
    }
    this.pages.forEach((page) => {
      const handle = page.getAttribute("page-handle");
      if (handle === this.activeHandle) {
        page.hidden = false;
      } else {
        page.hidden = true;
      }
    });

    requestAnimationFrame(() => {
      const visiblePage = this.querySelector('.account-page:not([hidden])');
      if (visiblePage) {
        visiblePage.querySelectorAll('prev-next-buttons').forEach((el) => {
          el.dispatchEvent(new CustomEvent('prev-next:init'));
        });
      }
    });

    // Mobile view state
    const isOverview = activeElement && activeElement.hasAttribute("data-is-start");
    this.setAttribute("data-mobile-view", isOverview ? "overview" : "subpage");
    if (isOverview) {
      document.body.classList.remove("customer-account-subpage");
    } else {
      document.body.classList.add("customer-account-subpage");
    }

    // Collapse mobile menu on navigation
    this._closeMobileMenu();

    // Scroll to top when navigating to a different page
    if (previousHandle && previousHandle !== this.activeHandle) {
      window.scrollTo({ top: 0 });
    }
  }
  _onHashChange() {
    this._onUrlChange();
  }
  _onPopState() {
    this._onUrlChange();
  }
  // _patchHistory() {
  //   const originalPushState = history.pushState;
  //   const originalReplaceState = history.replaceState;

  //   const trigger = () => this._onUrlChange();

  //   history.pushState = function (...args) {
  //     const res = originalPushState.apply(this, args);
  //     trigger();
  //     return res;
  //   };

  //   history.replaceState = function (...args) {
  //     const res = originalReplaceState.apply(this, args);
  //     trigger();
  //     return res;
  //   };

  //   // Unpatch-Funktion zurückgeben
  //   return () => {
  //     history.pushState = originalPushState;
  //     history.replaceState = originalReplaceState;
  //   };
  // }
};
window.customElements.define("customer-account-navigation", CustomerAccountNavigation);
var CollectPoints = class extends HTMLElement {
  constructor() {
    super();
    this.onDataLoadedHandler = this._onDataLoaded.bind(this);
    const extraDataWrapper = this.querySelector("[extra-data]");
    this.extraData = extraDataWrapper ? JSON.parse(extraDataWrapper.innerHTML) : {};
  }

  connectedCallback() {
    document.addEventListener("customer-data:loaded", this.onDataLoadedHandler);
    this._setupBirthdayPopup();
    this._setupNewsletterPopup();
  }

  disconnectedCallback() {
    document.removeEventListener("customer-data:loaded", this.onDataLoadedHandler);
  }

  /* Übersetzbaren Text aus data-Attribut lesen */
  _t(key, replacements) {
    let text = this.getAttribute('data-label-' + key) || key;
    if (replacements) {
      Object.keys(replacements).forEach((k) => {
        text = text.replace('__' + k.toUpperCase() + '__', replacements[k]);
      });
    }
    return text;
  }

  /* Loyalty-API-Credentials von CustomerAccountNavigation lesen */
  get _navEl() {
    return document.querySelector('customer-account-navigation');
  }

  /* POST-Helper für Kunden-Endpoints: /customers/{merchantId}/... */
  async _loyaltyCustomerPost(path, body) {
    const nav = this._navEl;
    if (!nav) return { ok: false };

    const url = `https://api.loyaltylion.com/headless/2025-06/${nav.loyaltySiteId}/customers/${nav.loyaltyMerchantId}${path}?channel=web&language=${document.documentElement.lang}`;
    const options = {
      method: 'POST',
      headers: {
        'Authorization': 'Bearer ' + window.loyaltylionSessionToken,
        'Content-Type': 'application/json'
      }
    };
    if (body) {
      options.body = JSON.stringify(body);
    }
    return fetch(url, options);
  }

  /* POST-Helper für Rule-Completion: /rules/{kind}/complete */
  async _loyaltyCompleteRule(ruleKind, ruleId) {
    const nav = this._navEl;
    if (!nav) return { ok: false };

    const url = `https://api.loyaltylion.com/headless/2025-06/${nav.loyaltySiteId}/rules/${ruleKind}/complete?channel=web&language=${document.documentElement.lang}`;
    return fetch(url, {
      method: 'POST',
      headers: {
        'Authorization': 'Bearer ' + window.loyaltylionSessionToken,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        rule_id: ruleId,
        customer_merchant_id: String(nav.loyaltyMerchantId)
      })
    });
  }

  /* Rule-Element als erledigt markieren */
  _markRuleCompleted(ruleEl) {
    ruleEl.dataset.completed = '';
    const button = ruleEl.querySelector('.collect-points__rule-button');
    if (button) {
      const checkIcon = button.querySelector('.collect-points__rule-icon-check');
      const textEl = button.querySelector('.collect-points__rule-button-text');
      if (checkIcon) checkIcon.hidden = false;
      if (textEl) textEl.textContent = this._t('completed');
      button.disabled = true;
      button.hidden = false;
    }
  }

  /* Geburtstag aus Customer-Daten auslesen (Format variiert je nach API) */
  _getCustomerBirthday(customer) {
    const b = customer.birthday;
    if (!b) return null;
    if (b.year && b.month && b.day) return b;
    if (typeof b === 'string' && b.includes('-')) {
      const [year, month, day] = b.split('-').map(Number);
      return { year, month, day };
    }
    return null;
  }

  /* Tage bis zum nächsten Geburtstag berechnen */
  _daysUntilBirthday(birthday) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    let nextBirthday = new Date(today.getFullYear(), birthday.month - 1, birthday.day);
    if (nextBirthday < today) {
      nextBirthday = new Date(today.getFullYear() + 1, birthday.month - 1, birthday.day);
    }
    const diffMs = nextBirthday - today;
    return Math.ceil(diffMs / (1000 * 60 * 60 * 24));
  }

  /* Countdown-Text für Geburtstag (Singular/Plural) */
  _birthdayCountdownText(days) {
    const key = days === 1 ? 'birthday-countdown-one' : 'birthday-countdown-other';
    return this._t(key, { count: days });
  }

  _onDataLoaded(event) {
    const customer = event.detail?.customer;
    const rules = customer?.available_rules;
    if (!rules || rules.length === 0) return;

    console.log(customer, rules);

    const template = document.querySelector('template[collect-rule]');
    const list = this.querySelector('.collect-points__rules-list');
    if (!template || !list) return;

    const customerBirthday = this._getCustomerBirthday(customer);
    const customerTierId = customer.tier_membership?.tier_id;

    rules.forEach((rule) => {
      /* Tier-Filterung: Rule nur anzeigen wenn Tier passt */
      if (rule.tier_id && customerTierId && rule.tier_id !== customerTierId) return;

      const isCompleted = rule.context?.completion_limit?.state === 'limit_reached_forever';
      const ruleData = this.extraData[rule.id] || this.extraData[rule.kind] || {};

      const clone = template.content.cloneNode(true);
      const li = clone.querySelector('.collect-points__rule');
      const button = clone.querySelector('.collect-points__rule-button');

      /* Titel und Badge setzen */
      clone.querySelector('.collect-points__rule-name').textContent = rule.variant.title;
      const shortText = rule.variant.result_short_text;
      const pointsEl = clone.querySelector('.collect-points__rule-points');
      const completedLabel = clone.querySelector('.collect-points__rule-completed-label');
      pointsEl.textContent = shortText || '';

      /* Bild setzen falls in extraData vorhanden */
      const ruleImage = clone.querySelector('.collect-points__rule-image');
      if (ruleImage) {
        if (ruleData.image) {
          ruleImage.setAttribute('src', ruleData.image);
          ruleImage.hidden = false;
          li.classList.add('has-image');
        } else {
          ruleImage.remove();
        }
      }

      /* Button konfigurieren je nach Regeltyp */
      if (isCompleted) {
        li.dataset.completed = '';
        completedLabel.textContent = shortText || this._t('points-received');
        const checkIcon = button.querySelector('.collect-points__rule-icon-check');
        const textEl = button.querySelector('.collect-points__rule-button-text');
        if (checkIcon) checkIcon.hidden = false;
        if (textEl) textEl.textContent = this._t('completed');
        button.disabled = true;
        button.hidden = false;
      } else if (rule.kind === 'birthday') {
        this._configureBirthdayButton(button, li, customerBirthday);
      } else if (rule.kind === 'newsletter_signup') {
        const textEl = button.querySelector('.collect-points__rule-button-text');
        if (textEl) textEl.textContent = this._t('newsletter');
        button.hidden = false;
        button.addEventListener('click', () => {
          const popup = document.getElementById('collect-newsletter-popup');
          if (popup) {
            this._currentNewsletterRuleEl = li;
            popup.open = true;
          }
        });
      } else if (rule.kind === 'instagram_follow') {
        this._configureInstagramButton(button, li, rule);
      } else if (rule.kind === 'clickthrough') {
        this._configureClickthroughButton(button, li, rule, ruleData);
      } else {
        this._configureLinkButton(button, li, ruleData);
      }

      list.appendChild(clone);
    });
  }

  /* Birthday-Button: Popup öffnen oder Countdown anzeigen */
  _configureBirthdayButton(button, li, customerBirthday) {
    if (customerBirthday) {
      const days = this._daysUntilBirthday(customerBirthday);
      const clockIcon = button.querySelector('.collect-points__rule-icon-clock');
      const textEl = button.querySelector('.collect-points__rule-button-text');
      if (clockIcon) clockIcon.hidden = false;
      if (textEl) textEl.textContent = this._birthdayCountdownText(days);
      button.disabled = true;
      button.hidden = false;
    } else {
      const textEl = button.querySelector('.collect-points__rule-button-text');
      if (textEl) textEl.textContent = this._t('enter-birthday');
      button.hidden = false;
      button.addEventListener('click', () => {
        const popup = document.getElementById('collect-birthday-popup');
        if (popup) {
          this._currentBirthdayRuleEl = li;
          popup.open = true;
        }
      });
    }
  }

  /* Instagram-Button: Link mit fire-and-forget API-Call */
  _configureInstagramButton(button, li, rule) {
    const instagramUrl = this.getAttribute('data-instagram-url');
    if (!instagramUrl) {
      button.hidden = true;
      return;
    }
    const link = document.createElement('a');
    link.className = button.className;
    link.href = instagramUrl;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    link.textContent = this._t('follow-instagram');
    link.hidden = false;
    link.addEventListener('click', () => {
      this._loyaltyCompleteRule('instagram_follow', rule.id).catch(() => {});
    });
    button.replaceWith(link);
  }

  /* Clickthrough-Button: Link-Button mit URL aus API-Response */
  _configureClickthroughButton(button, li, rule, ruleData) {
    const destinationUrl = rule.properties?.destination_url;
    if (!destinationUrl) {
      button.remove();
      return;
    }
    const link = document.createElement('a');
    link.className = button.className;
    link.href = destinationUrl;
    const buttonText = ruleData.button_text && ruleData.button_text !== 'null'
      ? ruleData.button_text
      : rule.variant?.title;
    link.textContent = buttonText || '';
    link.hidden = false;
    button.replaceWith(link);
  }

  /* Link-Button für purchase, referral und andere Regeln */
  _configureLinkButton(button, li, ruleData) {
    if (ruleData.button_text && ruleData.button_text !== 'null' && ruleData.url && ruleData.url !== 'null') {
      const link = document.createElement('a');
      link.className = button.className;
      link.href = ruleData.url;
      link.textContent = ruleData.button_text;
      link.hidden = false;
      button.replaceWith(link);
    } else {
      button.remove();
    }
  }

  /* Birthday-Popup: Formular-Handler einrichten */
  _setupBirthdayPopup() {
    const popup = document.getElementById('collect-birthday-popup');
    if (!popup) return;

    const form = popup.querySelector('.collect-points__birthday-form');
    const message = popup.querySelector('.collect-points-popup__message');
    if (!form) return;

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const submitBtn = form.querySelector('button[type="submit"]');
      const birthdayValue = form.querySelector('input[name="birthday"]').value;
      if (!birthdayValue) return;

      submitBtn.setAttribute('aria-busy', 'true');
      message.hidden = true;

      try {
        const [year, month, day] = birthdayValue.split('-').map(Number);
        const response = await this._loyaltyCustomerPost('/birthday', { birthday: { year, month, day } });

        if (response.ok) {
          popup.open = false;
          const ruleEl = this._currentBirthdayRuleEl;
          if (ruleEl) {
            const button = ruleEl.querySelector('.collect-points__rule-button');
            if (button) {
              const days = this._daysUntilBirthday({ year, month, day });
              const clockIcon = button.querySelector('.collect-points__rule-icon-clock');
              const textEl = button.querySelector('.collect-points__rule-button-text');
              if (clockIcon) clockIcon.hidden = false;
              if (textEl) textEl.textContent = this._birthdayCountdownText(days);
              button.disabled = true;
            }
          }
          form.reset();
        } else {
          message.textContent = this._t('birthday-error');
          message.hidden = false;
        }
      } catch (error) {
        message.textContent = this._t('birthday-error');
        message.hidden = false;
      } finally {
        submitBtn.removeAttribute('aria-busy');
      }
    });
  }

  /* Newsletter-Popup: Button-Handler einrichten */
  _setupNewsletterPopup() {
    const popup = document.getElementById('collect-newsletter-popup');
    if (!popup) return;

    const button = popup.querySelector('.collect-points__newsletter-btn');
    const message = popup.querySelector('.collect-points-popup__message');
    if (!button) return;

    button.addEventListener('click', async () => {
      button.setAttribute('aria-busy', 'true');
      button.disabled = true;
      message.hidden = true;

      try {
        const response = await this._loyaltyCustomerPost('/email_marketing/subscribe');

        if (response.ok) {
          message.textContent = this._t('newsletter-success');
          message.hidden = false;
          button.hidden = true;
          const ruleEl = this._currentNewsletterRuleEl;
          if (ruleEl) {
            this._markRuleCompleted(ruleEl);
          }
          setTimeout(() => { popup.open = false; }, 1500);
        } else {
          message.textContent = this._t('newsletter-error');
          message.hidden = false;
          button.disabled = false;
        }
      } catch (error) {
        message.textContent = this._t('newsletter-error');
        message.hidden = false;
        button.disabled = false;
      } finally {
        button.removeAttribute('aria-busy');
      }
    });
  }
};
window.customElements.define("collect-points", CollectPoints);

var RedeemPoints = class extends HTMLElement {
  constructor() {
    super();
    this.customerId = null;
    this.onDataLoadedHandler = this._onDataLoaded.bind(this);
  }

  connectedCallback() {
    document.addEventListener("customer-data:loaded", this.onDataLoadedHandler);
  }

  disconnectedCallback() {
    document.removeEventListener("customer-data:loaded", this.onDataLoadedHandler);
  }

  /* Loyalty-API-Credentials von CustomerAccountNavigation lesen */
  get _navEl() {
    return document.querySelector('customer-account-navigation');
  }

  get _popup() {
    return document.getElementById('redeem-popup');
  }

  // Voucher-Typen haben keinen eigenen Produktbild-URL – SVG-Placeholder verwenden
  _isVoucherKind(kind) {
    return ['cart_discount_voucher', 'free_shipping_voucher', 'collection_discount_voucher', 'product_discount_voucher', 'gift_card', 'active_subscription_discount_voucher'].includes(kind);
  }

  // Konfigurierte Reward-Bilder (nach Reward-ID) aus dem JSON-Script-Tag laden
  _getRewardImageMap() {
    if (this._rewardImageMap) return this._rewardImageMap;
    const script = this.querySelector('script[data-reward-images]');
    if (!script) return {};
    try {
      const entries = JSON.parse(script.textContent);
      this._rewardImageMap = {};
      entries.forEach(entry => {
        // IDs als String-Keys, da reward.id numerisch sein kann
        this._rewardImageMap[String(entry.id)] = {
          image: entry.image,
          srcset: entry.srcset || ''
        };
      });
    } catch (e) {
      this._rewardImageMap = {};
    }
    return this._rewardImageMap;
  }

  /* Warenkorb-Daten aus serverseitigen Data-Attributen lesen */
  get _cart() {
    const totalPrice = parseInt(this.dataset.cartTotalPrice, 10);
    const itemCount = parseInt(this.dataset.cartItemCount, 10);
    if (isNaN(totalPrice) && isNaN(itemCount)) return null;
    return {
      total_price: totalPrice || 0,
      item_count: itemCount || 0,
      currency: this.dataset.cartCurrency || 'EUR'
    };
  }

  /* Warenkorb-Bedingung eines Rewards prüfen und Hinweistext setzen */
  _updateRequirement(requirementEl, reward) {
    // console.log("Checking requirements for reward", reward.id, reward.variant.title, reward);
    const requirements = reward.properties?.cart_requirements;
    const minimumSpend = reward.properties?.minimum_spend;
    if (!requirements && !minimumSpend) return;

    const minCartTotal = minimumSpend ? minimumSpend : requirements.minimum_cart_total;
    const minLineItemCount = requirements ? requirements.minimum_line_item_count : null;

    // console.log(requirementEl, minCartTotal, minLineItemCount);

    if (!minCartTotal && !minLineItemCount) return;

    const cart = this._cart;
    if (!cart) return;

    if (minCartTotal) {
      const requiredCents = minCartTotal.amount * 100;

      // if (cart.total_price < requiredCents) {
        const diffCents = requiredCents - cart.total_price;
        const requiredCentsFormatted = (requiredCents / 100).toLocaleString('de-DE', { style: 'currency', currency: cart.currency });
        // const diffFormatted = (diffCents / 100).toLocaleString('de-DE', { style: 'currency', currency: cart.currency });
        requirementEl.textContent = this.dataset.cartTotalNotMet.replace('{{ amount }}', requiredCentsFormatted);
        requirementEl.hidden = false;
      // }
    } else if (minLineItemCount) {
      const requiredCount = minLineItemCount;

      requirementEl.textContent = this.dataset.lineItemNotMet.replace('{{ count }}', requiredCount);
      requirementEl.hidden = false;
    }
  }

  /* Bestimmt die Bild-URL und srcset für einen Reward */
  _getRewardImage(reward) {
    const placeholderSvg = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 540" fill="none"%3E%3Crect width="400" height="540" fill="%23F0EDE6"/%3E%3Crect x="80" y="160" width="240" height="220" rx="12" fill="%23e0ddd8"/%3E%3Ccircle cx="200" cy="220" r="36" fill="%23c8c4be"/%3E%3Crect x="110" y="275" width="180" height="16" rx="8" fill="%23c8c4be"/%3E%3Crect x="140" y="305" width="120" height="12" rx="6" fill="%23d4d0cb"/%3E%3C/svg%3E';
    const imageUrl = reward.properties?.product?.image_url || reward.properties?.image_url || '';

    // Custom-Bild nach Reward-ID hat Vorrang und überschreibt das Default-Bild
    const rewardMap = this._getRewardImageMap();
    const rewardMatch = rewardMap[String(reward.id)];
    if (rewardMatch) return { src: rewardMatch.image, srcset: rewardMatch.srcset || '' };

    return { src: imageUrl || placeholderSvg, srcset: '' };
  }

  _onDataLoaded(event) {
    const customer = event.detail?.customer;
    if (!customer) return;

    this.customerId = customer.merchant_id;
    const customerPoints = customer.points_approved || 0;

    const rewards = customer.available_rewards || [];
    if (rewards.length === 0) return;

    const template = document.querySelector('template[redeem-card]');
    const grid = this.querySelector('.product-list__inner');
    if (!template || !grid) return;

    rewards.forEach(reward => {

      if (reward.kind == 'cart_variable_discount_voucher') {
        return; // Aktuell nicht unterstützter Reward-Typ
      }

      const clone = template.content.cloneNode(true);
      const title = reward.variant?.title || '';
      let canRedeem = ['redeemable', 'unknown'].includes(reward.context?.can_redeem?.state);
      const costPoints = reward.variant?.cost?.points || 0;

      // Referenzen vor appendChild sichern – DocumentFragment leert sich beim Einfügen
      const redeemButton = clone.querySelector('.redeem-card__redeem-button');
      const requirementEl = clone.querySelector('.redeem-card__requirement');

      const missing = costPoints - customerPoints;
      if (missing > 0) {
        canRedeem = false;
        redeemButton.querySelector('.button__text').textContent = this.dataset.pointsMissing.replace('{{ count }}', missing);
        const progress = Math.min(customerPoints / costPoints, 0.99);
        redeemButton.style.setProperty('--progress', `${(progress * 100).toFixed(1)}%`);
        redeemButton.setAttribute('data-progress', '');
      }

      // Bild setzen
      const img = clone.querySelector('.redeem-card__image');
      const imageData = this._getRewardImage(reward);
      img.src = imageData.src;
      if (imageData.srcset) {
        img.srcset = imageData.srcset;
        img.sizes = '(max-width: 740px) calc(50vw - 24px), auto';
      }
      img.loading = 'lazy';
      img.alt = title;

      // Punkte-Kosten
      clone.querySelector('.redeem-card__points-value').textContent =
        reward.variant?.cost_text || costPoints || '';

      // Titel
      clone.querySelector('.redeem-card__title').textContent = title;

      // Beschreibung: Feld existiert in der Headless API nicht – Element ausblenden
      clone.querySelector('.redeem-card__description').hidden = true;

      if (!canRedeem) {
        redeemButton.disabled = true;
      } else {
        redeemButton.addEventListener('click', () => this._openPopup(reward));
      }

      // Warenkorb-Bedingung prüfen und anzeigen
      this._updateRequirement(requirementEl, reward);

      grid.appendChild(clone);
    });
  }

  /* Popup mit Reward-Daten befüllen und öffnen */
  _openPopup(reward) {
    const popup = this._popup;
    if (!popup) return;

    const title = reward.variant?.title || '';
    const costText = reward.variant?.cost_text || reward.variant?.cost?.points || '';
    const imageData = this._getRewardImage(reward);

    // Phase 1 anzeigen, Phase 2 verstecken
    const confirmPhase = popup.querySelector('[data-phase="confirm"]');
    const successPhase = popup.querySelector('[data-phase="success"]');
    confirmPhase.hidden = false;
    successPhase.hidden = true;

    // Popup-Inhalte setzen
    popup.querySelector('[data-popup-heading]').textContent = this.dataset.popupHeading;
    popup.querySelector('[data-popup-title]').textContent = title;
    popup.querySelector('[data-popup-points]').textContent =
      this.dataset.popupPointsCost.replace('{{ count }}', costText);

    const popupImg = popup.querySelector('[data-popup-image]');
    popupImg.srcset = imageData.srcset || '';
    popupImg.src = imageData.src;
    popupImg.alt = title;

    // Requirement anzeigen (Mindestbestellwert etc.)
    const popupRequirement = popup.querySelector('[data-popup-requirement]');
    popupRequirement.hidden = true;
    popupRequirement.textContent = '';
    this._updateRequirement(popupRequirement, reward);

    // Confirm-Button vorbereiten
    const confirmBtn = popup.querySelector('.redeem-popup__confirm-button');
    confirmBtn.disabled = false;
    confirmBtn.removeAttribute('aria-busy');

    // Alten Listener entfernen, neuen setzen
    const newBtn = confirmBtn.cloneNode(true);
    confirmBtn.replaceWith(newBtn);
    newBtn.addEventListener('click', () => this._redeemFromPopup(reward, newBtn));

    // Popup öffnen
    popup.open = true;
  }

  /* API-Call aus dem Popup und Phasen-Wechsel */
  async _redeemFromPopup(reward, button) {
    const nav = this._navEl;
    const popup = this._popup;
    if (!nav || !popup) return;

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    try {
      const body = {
        reward_id: reward.id,
        customer_merchant_id: this.customerId
      };

      // Product Rewards benötigen variant_id und cart_id (Storefront API GID-Format)
      if (!this._isVoucherKind(reward.kind)) {
        const variantId = String(reward.properties?.product?.variants?.[0]?.id || '');
        const cartResponse = await fetch(`${window.themeVariables.routes.cartUrl}.js`);
        const cartData = await cartResponse.json();

        if (variantId) body.variant_id = variantId;
        if (cartData.token) body.cart_id = `gid://shopify/Cart/${cartData.token}`;
      }

      const response = await fetch(
        `https://api.loyaltylion.com/headless/2025-06/${nav.loyaltySiteId}/rewards/${reward.kind}/redeem?channel=web&language=${document.documentElement.lang}`,
        {
          method: 'POST',
          headers: {
            'Authorization': 'Bearer ' + window.loyaltylionSessionToken,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(body)
        }
      );

      if (!response.ok) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        return;
      }

      const data = await response.json();
      const code = data.claimed_reward?.redeemable?.code;
      const isVoucher = this._isVoucherKind(reward.kind);

      // Phase wechseln
      popup.querySelector('[data-phase="confirm"]').hidden = true;
      const successPhase = popup.querySelector('[data-phase="success"]');
      successPhase.hidden = false;

      // Erfolgs-Überschrift
      popup.querySelector('[data-success-heading]').textContent = this.dataset.successHeading;

      // Code anzeigen (bei Gutscheinen)
      const codeDisplay = popup.querySelector('[data-success-code]');
      if (code) {
        codeDisplay.hidden = false;
        popup.querySelector('[data-success-code-label]').textContent = this.dataset.successCodeLabel;
        popup.querySelector('[data-code-value]').textContent = code;

        const copyBtn = popup.querySelector('.redeem-popup__copy-button');
        const copyLabel = popup.querySelector('.redeem-popup__copy-label');
        const newCopyBtn = copyBtn.cloneNode(true);
        copyBtn.replaceWith(newCopyBtn);
        const newCopyLabel = newCopyBtn.querySelector('.redeem-popup__copy-label');
        newCopyBtn.addEventListener('click', () => {
          navigator.clipboard.writeText(code).then(() => {
            newCopyLabel.hidden = false;
            setTimeout(() => { newCopyLabel.hidden = true; }, 2000);
          });
        });
      } else {
        codeDisplay.hidden = true;
      }

      // Anleitung anzeigen (je nach Typ)
      const voucherInstructions = popup.querySelector('[data-success-instructions-voucher]');
      const productInstructions = popup.querySelector('[data-success-instructions-product]');
      if (voucherInstructions) voucherInstructions.hidden = !isVoucher;
      if (productInstructions) productInstructions.hidden = isVoucher;

      // Product Reward: "In den Warenkorb"-Button anzeigen, Schließen-Button verstecken
      const addToCartBtn = popup.querySelector('[data-add-to-cart]');
      const doneBtn = popup.querySelector('.redeem-popup__done-button');
      // console.log('[RedeemPoints] isVoucher:', isVoucher, '| addToCartBtn found:', !!addToCartBtn);
      if (!isVoucher && addToCartBtn) {
        addToCartBtn.hidden = false;
        doneBtn.hidden = true;

        const claimedReward = data.claimed_reward;
        const variantId = reward.properties?.product?.variants?.[0]?.id;
        // console.log('[RedeemPoints] Product reward setup – variantId:', variantId, '| claimedReward:', claimedReward);

        // Alten Listener entfernen, neuen setzen
        const newAddBtn = addToCartBtn.cloneNode(true);
        addToCartBtn.replaceWith(newAddBtn);
        newAddBtn.addEventListener('click', () => {
          // console.log('[RedeemPoints] Add-to-cart button clicked');
          this._addRewardToCart(newAddBtn, variantId, claimedReward);
        });
      } else {
        if (addToCartBtn) addToCartBtn.hidden = true;
        if (doneBtn) doneBtn.hidden = false;
      }

      // Konfetti auslösen
      const confettiWrapper = popup.querySelector('pt-confetti-wrapper');
      if (confettiWrapper) {
        confettiWrapper.fire(popup.querySelector('[data-success-heading]'));
      }

      // Einlöse-Button auf der Card zurücksetzen (wieder einlösbar machen)
      this._resetCardButton(reward);
    } catch {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  }

  /* Den Einlöse-Button auf der Card nach erfolgreicher Einlösung in den Default State zurücksetzen */
  _resetCardButton(reward) {
    const cards = this.querySelectorAll('.redeem-card');
    const template = document.querySelector('template[redeem-card]');
    const defaultText = template?.content.querySelector('.redeem-card__redeem-button .button__text')?.textContent || '';

    cards.forEach(card => {
      const titleEl = card.querySelector('.redeem-card__title');
      if (titleEl && titleEl.textContent === (reward.variant?.title || '')) {
        const oldBtn = card.querySelector('.redeem-card__redeem-button');
        if (oldBtn) {
          const newBtn = oldBtn.cloneNode(true);
          newBtn.disabled = false;
          newBtn.removeAttribute('data-progress');
          newBtn.style.removeProperty('--progress');
          newBtn.querySelector('.button__text').textContent = defaultText;
          oldBtn.replaceWith(newBtn);
          newBtn.addEventListener('click', () => this._openPopup(reward));
        }
      }
    });
  }

  /* Eingelöstes Produkt mit LoyaltyLion-Properties in den Warenkorb legen */
  async _addRewardToCart(button, variantId, claimedReward) {
    // console.log('[RedeemPoints] _addRewardToCart called – variantId:', variantId, '| claimedReward:', claimedReward);

    if (!variantId) {
      console.warn('[RedeemPoints] Abbruch: variantId ist falsy:', variantId);
      return;
    }

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    // Properties aus der LoyaltyLion-Response übernehmen
    const properties = {
      __lion_sfp_id: claimedReward?.redeemable.cart_line_identifier || '',
    };
    const redeemable = claimedReward?.redeemable;
    // console.log('[RedeemPoints] redeemable Objekt:', redeemable);
    // if (redeemable) {
    //   Object.entries(redeemable).forEach(([key, value]) => {
    //     if (value != null && key !== 'code') {
    //       properties[key] = String(value);
    //     }
    //   });
    // }

    const cartAddBody = {
      id: variantId,
      quantity: 1,
      properties
    };
    // console.log('[RedeemPoints] Cart-Add Request Body:', JSON.stringify(cartAddBody));

    try {
      const response = await fetch(`${window.themeVariables.routes.cartAddUrl}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(cartAddBody)
      });

      // console.log('[RedeemPoints] Cart-Add Response Status:', response.status, response.statusText);

      if (!response.ok) {
        const errorText = await response.text();
        console.error('[RedeemPoints] Cart-Add fehlgeschlagen:', errorText);
        return;
      }

      const responseJson = await response.json();
      // console.log('[RedeemPoints] Cart-Add Erfolg:', responseJson);

      // Cart-Events auslösen (bestehendes Pattern)
      document.documentElement.dispatchEvent(new CustomEvent('variant:added', {
        bubbles: true,
        detail: {
          variant: responseJson.hasOwnProperty('items') ? responseJson['items'][0] : responseJson
        }
      }));

      const cartResponse = await fetch(`${window.themeVariables.routes.cartUrl}.js`);
      const cartContent = await cartResponse.json();
      document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
        bubbles: true,
        detail: { cart: cartContent }
      }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: { cart: cartContent }
      }));

      document.dispatchEvent(new CustomEvent("cart:open", {
        detail: {
          variant: responseJson.hasOwnProperty('items') ? responseJson['items'][0] : responseJson
        }
      }));
      // console.log('[RedeemPoints] Cart-Events dispatched, Popup wird geschlossen');

      // Popup schließen
      const popup = this._popup;
      if (popup) popup.open = false;
    } catch (err) {
      console.error('[RedeemPoints] _addRewardToCart Fehler:', err);
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  }
};
window.customElements.define("redeem-points", RedeemPoints);

var OrderHistory = class extends HTMLElement {
  constructor() {
    super();
    this._onTriggerClick = this._onTriggerClick.bind(this);
    this._onBackClick = this._onBackClick.bind(this);
  }

  connectedCallback() {
    this.listView = this.querySelector('.order-history__list-view');
    this.detailViews = this.querySelectorAll('.order-history__detail-view');

    /* Klick auf eine Bestellung in der Liste */
    this.querySelectorAll('[data-order-detail-trigger]').forEach(button => {
      button.addEventListener('click', this._onTriggerClick);
    });

    /* Zurück-Button in der Detailansicht */
    this.querySelectorAll('[data-order-back]').forEach(button => {
      button.addEventListener('click', this._onBackClick);
    });
  }

  _onTriggerClick(event) {
    const orderId = event.currentTarget.dataset.orderDetailTrigger;
    this._showDetail(orderId);
  }

  _onBackClick() {
    this._showList();
  }

  _showDetail(orderId) {
    /* Liste ausblenden */
    this.listView.hidden = true;

    /* Alle Detail-Views verstecken, nur den passenden anzeigen */
    this.detailViews.forEach(view => {
      view.hidden = view.dataset.orderDetail !== orderId;
    });
  }

  _showList() {
    /* Alle Detail-Views verstecken */
    this.detailViews.forEach(view => {
      view.hidden = true;
    });

    /* Liste wieder einblenden */
    this.listView.hidden = false;
  }
};
window.customElements.define("order-history", OrderHistory);

var MemberCard = class extends HTMLElement {
  constructor() {
    super();

    this.accountNavigation = document.querySelector(".account-navigation-wrapper");
    this.pointsElements = this.querySelectorAll("[points]");

    this.onDataLoadedHandler = this._onDataLoaded.bind(this);
  }
  connectedCallback() {
    if (this.accountNavigation.customerData == null) {
      this.accountNavigation.addEventListener("customer-data:loaded", this.onDataLoadedHandler);
    } else {
      this._onDataLoaded();
    }

    this._initWalletButton();
  }
  _onDataLoaded(event = null) {
    let customer;
    if (event == null) {
      customer = this.accountNavigation.customerData?.customer;
    } else {
      customer = event.detail?.customer;
    }

    if (!customer) return;

    this.pointsElements.forEach(el => {
      el.textContent = customer.points_approved;
    });
  }
  _initWalletButton() {
    var userAgent = navigator.userAgent;
    var platform;
    if (/iPhone|iPod/i.test(userAgent)) {
      platform = "apple";
    } else if (/Android/i.test(userAgent)) {
      platform = "google";
    } else {
      /* Alle anderen Geraete inkl. Mac, Windows, Linux */
      platform = "generic";
    }

    var walletContainer = document.querySelector(".account-navigation-wrapper .wallet-buttons");
    if (!walletContainer) return;

    var buttonSelectors = {
      apple: "[apple-wallet-btn]",
      google: "[google-wallet-btn]",
      generic: ".wallet-button"
    };

    var walletBtn = walletContainer.querySelectorAll(buttonSelectors[platform]);
    console.log("walletBtn", walletBtn, "platform", platform, "userAgent", userAgent);
    if (walletBtn.length === 0) return;

    walletContainer.hidden = false;
    walletBtn.forEach(btn => btn.hidden = false);

    walletBtn.forEach(btn => {
      btn.addEventListener("click", () => this._getAppleWalletPass(btn));
    });
  }
  async _getAppleWalletPass(button) {
    if (button.disabled) return;

    button.disabled = true;
    const parent = button.closest(".wallet-buttons");
    parent.setAttribute("aria-busy", "true");
    var customerId = this.accountNavigation.getAttribute("customer-id");

    try {
      var response = await fetch("https://us-central1-shopify-giftcard-migration.cloudfunctions.net/get_wallet_pass_for_customer", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          customerId: customerId
        })
      });

      if (!response.ok) {
        var error = await response.text();
        console.error("Apple Wallet Pass error:", error.error);
        return;
      }

      const json = await response.json();

      window.open(json.shareUrl, '_blank').focus();
    } catch (err) {
      console.error("Apple Wallet Pass error:", err);
    } finally {
      button.disabled = false;
      parent.removeAttribute("aria-busy");
    }
  }
}

window.customElements.define("member-card", MemberCard);

var TierProgress = class extends HTMLElement {
  constructor() {
    super();
    this.accountNavigation = document.querySelector(".account-navigation-wrapper");
    this.statusEl = this.querySelector("[tier-status]");
    this.fillEl = this.querySelector("[tier-fill]");
    this.trackEl = this.querySelector("[tier-track]");
    this.labelsEl = this.querySelector("[tier-labels]");
    this.onDataLoadedHandler = this._onDataLoaded.bind(this);
  }

  connectedCallback() {
    if (this.accountNavigation.customerData == null) {
      this.accountNavigation.addEventListener("customer-data:loaded", this.onDataLoadedHandler);
    } else {
      this._onDataLoaded();
    }
  }

  _onDataLoaded(event = null) {
    let data;
    if (event == null) {
      data = this.accountNavigation.customerData;
    } else {
      data = event.detail;
    }

    if (!data?.customer || !data?.configuration?.tier_configuration) return;

    const customer = data.customer;
    const tierConfig = data.configuration.tier_configuration;
    const membership = customer.tier_membership;

    if (!membership) return;

    /* Only spend-based tiers with boundaries (filters out "Not My Dear Club" etc.) */
    const spendTiers = tierConfig.tiers
      .filter(t => t.kind === "spend" && t.lower_bound != null)
      .sort((a, b) => a.position - b.position);

    if (spendTiers.length === 0) return;

    const currentTierId = membership.tier_id;
    const highestTier = spendTiers[spendTiers.length - 1];
    const maxValue = highestTier.lower_bound.amount;
    const currentSpend = membership.progress?.tier_spend?.now?.amount || 0;

    /* Fill percentage: 0% to 100% across the full tier range */
    const fillPercent = maxValue > 0 ? Math.min((currentSpend / maxValue) * 100, 100) : 0;
    this.fillEl.style.width = fillPercent + "%";

    /* Status text */
    const progress = membership.progress;
    if (progress?.spend_needed_for_upgrade) {
      const nextTier = spendTiers.find(t => t.id === progress.upgrade_tier_id);
      const tierName = nextTier?.name || this.dataset.nextTierFallback || "next tier";
      const template = this.dataset.spendRemainingTemplate || "{{ amount }} until {{ tier_name }}";
      this.statusEl.textContent = template
        .replace("{{ amount }}", progress.spend_needed_for_upgrade.formatted)
        .replace("{{ tier_name }}", tierName);
    } else {
      const currentTier = spendTiers.find(t => t.id === currentTierId);
      const tierName = currentTier?.name || this.dataset.highestTierFallback || "Highest tier";
      const template = this.dataset.tierReachedTemplate || "{{ tier_name }} reached";
      this.statusEl.textContent = template.replace("{{ tier_name }}", tierName);
    }

    /* Tier markers on the track + labels below */
    spendTiers.forEach(tier => {
      const position = maxValue > 0 ? (tier.lower_bound.amount / maxValue) * 100 : 0;
      const isReached = currentSpend >= tier.lower_bound.amount;
      const isActive = tier.id === currentTierId;

      /* Marker dot on the track */
      const marker = document.createElement("span");
      marker.className = "tier-progress-marker";
      if (isReached) marker.classList.add("tier-progress-marker--reached");
      if (isActive) marker.classList.add("tier-progress-marker--active");
      marker.style.left = position + "%";
      this.trackEl.appendChild(marker);

      /* Label below the track */
      const label = document.createElement("span");
      label.className = "tier-label";
      if (isActive) label.classList.add("tier-label--active");
      label.style.left = position + "%";
      label.textContent = tier.name;
      this.labelsEl.appendChild(label);
    });

    this.hidden = false;
  }
};

window.customElements.define("tier-progress", TierProgress);

/* ------------------------------------------------------------------ */
/*  Activity History                                                   */
/* ------------------------------------------------------------------ */

var ActivityHistory = class extends HTMLElement {
  constructor() {
    super();
    this.onDataLoadedHandler = this._onDataLoaded.bind(this);
  }

  connectedCallback() {
    document.addEventListener("customer-data:loaded", this.onDataLoadedHandler);
  }

  disconnectedCallback() {
    document.removeEventListener("customer-data:loaded", this.onDataLoadedHandler);
  }

  /* Kind-Label aus data-kind-* Attributen lesen */
  _kindLabel(kind) {
    const key = 'kind' + kind.split('_').map(w => w[0].toUpperCase() + w.slice(1)).join('');
    return this.dataset[key] || kind;
  }

  /* State-Label aus data-state-* Attributen lesen */
  _stateLabel(state) {
    const key = 'state' + state[0].toUpperCase() + state.slice(1);
    return this.dataset[key] || state;
  }

  _formatDate(isoString) {
    const d = new Date(isoString);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    return `${day}.${month}.${year}`;
  }

  _badgeModifier(state) {
    switch (state) {
      case 'approved': return 'activity-history__badge--approved';
      case 'pending': return 'activity-history__badge--pending';
      case 'void':
      case 'declined': return 'activity-history__badge--declined';
      default: return '';
    }
  }

  /* Filtert Einträge nach Kind und Aktionstext gemäß data-filter-* Attributen */
  _filterEntries(entries) {
    const filterKind = this.dataset.filterKind || 'all';
    const filterTerms = (this.dataset.filterText || '')
      .split(',')
      .map(t => t.trim().toLowerCase())
      .filter(t => t.length > 0);

    return entries.filter(entry => {
      /* Kind-Filter */
      if (filterKind === 'rewards') {
        if (!['redeemed_points_for_reward', 'received_reward'].includes(entry.kind)) return false;
      } else if (filterKind === 'activities') {
        if (entry.kind !== 'earned_points_from_rule') return false;
      }

      /* Textfilter auf Aktionsspalte – mind. ein Begriff muss enthalten sein */
      if (filterTerms.length > 0) {
        const ruleKind = entry.rule?.kind || '';
        if (!filterTerms.some(term => ruleKind.toLowerCase().includes(term))) return false;
      }

      return true;
    });
  }

  _onDataLoaded(event) {
    const customer = event.detail?.customer;
    if (!customer) return;

    const history = customer.history || [];

    /* Neueste zuerst */
    const sorted = [...history].sort((a, b) => new Date(b.date) - new Date(a.date));
    const filtered = this._filterEntries(sorted);

    const tbody = this.querySelector('tbody');
    const emptyState = this.querySelector('.activity-history__empty-state');
    if (!tbody) return;

    if (filtered.length === 0) {
      const table = this.querySelector('.activity-history__table');
      if (table) table.setAttribute('hidden', '');
      if (emptyState) emptyState.removeAttribute('hidden');
      return;
    }

    filtered.forEach(entry => {
      const tr = document.createElement('tr');

      /* Datum */
      const tdDate = document.createElement('td');
      tdDate.textContent = this._formatDate(entry.date);
      tr.appendChild(tdDate);

      /* Typ */
      const tdType = document.createElement('td');
      tdType.textContent = this._kindLabel(entry.kind);
      tr.appendChild(tdType);

      /* Aktion */
      const tdAction = document.createElement('td');
      tdAction.textContent = entry.label || '';

      const claimed_reward = customer.claimed_rewards.filter((reward) => reward.id == entry.claimed_reward_id);
      if (claimed_reward.length > 0) {
        if (claimed_reward[0].redeemable?.code) {
          const codeWrapper = document.createElement('span');
          codeWrapper.className = 'activity-history__coupon-code';
          const codeLabel = document.createElement('span');
          codeLabel.className = 'activity-history__coupon-code-label';
          codeLabel.textContent = this.dataset.labelCouponCode + ' ';
          const codeValue = document.createElement('code');
          codeValue.textContent = claimed_reward[0].redeemable?.code;
          codeWrapper.appendChild(codeLabel);
          codeWrapper.appendChild(codeValue);
          tdAction.appendChild(codeWrapper);
        }
      }

      tr.appendChild(tdAction);

      /* Teeblätter */
      const tdPoints = document.createElement('td');
      if (entry.points_text) {
        tdPoints.textContent = entry.points_text;
      } else if (entry.points != null) {
        tdPoints.textContent = (entry.points > 0 ? '+' : '') + entry.points;
      }
      tr.appendChild(tdPoints);

      /* Status */
      const tdStatus = document.createElement('td');
      if (entry.state) {
        const badge = document.createElement('span');
        badge.className = 'activity-history__badge ' + this._badgeModifier(entry.state);
        badge.textContent = this._stateLabel(entry.state);
        tdStatus.appendChild(badge);
      }
      tr.appendChild(tdStatus);

      tbody.appendChild(tr);
    });
  }
};
window.customElements.define("activity-history", ActivityHistory);

/* ------------------------------------------------------------------ */
/*  Tier Benefits Table                                                */
/* ------------------------------------------------------------------ */

var TierBenefitsTable = class extends HTMLElement {
  constructor() {
    super();
    this._onDataLoaded = this._onDataLoaded.bind(this);
  }

  connectedCallback() {
    this._fetchData();
  }

  get _tierNames() {
    const raw = this.dataset.tierNames || "";
    return raw.split(",").map(n => n.trim()).filter(n => n.length > 0);
  }

  async _fetchData() {
    // this.loyaltySiteId = 49623; // DEV-Store
    const loyaltySiteId = 25281; // DE-Store
    

    const options = { method: 'GET', headers: { Authorization: 'Bearer ' + window.loyaltylionSessionToken } };
    const customerId = this.dataset.customerId;

    let url;
    if (customerId) {
      /* Eingeloggter Kunde: Customer-Daten inkl. Tier-Membership abrufen */
      url = `https://api.loyaltylion.com/headless/2025-06/${loyaltySiteId}/customers/${customerId}?channel=web&language=${document.documentElement.lang}`;
    } else {
      /* Gast: Nur Store-Konfiguration ohne Customer-Daten abrufen */
      url = `https://api.loyaltylion.com/headless/2025-06/${loyaltySiteId}/configuration?channel=web&language=${document.documentElement.lang}`;
    }

    const response = await fetch(url, options);
    // console.log("res", response);
    if (!response.ok) return;

    const data = await response.json();

    // console.log("data", data);
    this._onDataLoaded(data);
  }

  _onDataLoaded(data) {
    let tierConfig = null;
    if (data?.configuration?.tier_configuration) {
      tierConfig = data.configuration.tier_configuration;
    } else if (data?.tier_configuration) {
      tierConfig = data.tier_configuration;
    } else {
      return;
    }

    const allTiers = tierConfig.tiers || [];
    const allBenefits = tierConfig.tier_benefits || [];
    const requestedNames = this._tierNames;

    if (requestedNames.length === 0 || allBenefits.length === 0) return;

    // console.log("")

    /* Resolve the requested tiers by name (case-insensitive) in settings order */
    const tiers = requestedNames
      .map(name => allTiers.find(t => t.name.toLowerCase().replace(/[ ]+/g,'-') === name.toLowerCase().replace(/[ ]+/g,'-')))
      .filter(Boolean);

    if (tiers.length === 0) return;

    /* Determine current tier for highlighting */
    const customer = data.customer;
    const currentTierId = customer?.tier_membership?.tier_id;

    /* Find the column index of the current tier (0-based within tiers array) */
    const currentColIndex = currentTierId
      ? tiers.findIndex(t => t.id === currentTierId)
      : -1;

    /* Fill column headers with tier names */
    tiers.forEach((tier, i) => {
      const th = this.querySelector(`[tier-col-${i + 1}]`);
      if (th) {
        const fullSpan = document.createElement("span");
        fullSpan.className = "tier-benefits__name-full";
        fullSpan.textContent = tier.name;

        const abbrevSpan = document.createElement("span");
        abbrevSpan.className = "tier-benefits__name-abbrev";
        abbrevSpan.textContent = tier.name.charAt(0).toUpperCase();

        th.textContent = "";
        th.appendChild(fullSpan);
        th.appendChild(abbrevSpan);
        if (i === currentColIndex) {
          th.classList.add("tier-benefits__col--current");
        }
      }
    });

    /* Hide unused tier columns */
    for (let i = tiers.length; i < 3; i++) {
      const th = this.querySelector(`[tier-col-${i + 1}]`);
      if (th) th.hidden = true;
    }

    /* Filter out secret benefits and sort by tier coverage (most tiers first) */
    const visibleBenefits = allBenefits.filter(b => !b.secret);

    visibleBenefits.sort((a, b) => {
      const countA = tiers.filter(t => t.benefit_ids && t.benefit_ids.includes(a.id)).length;
      const countB = tiers.filter(t => t.benefit_ids && t.benefit_ids.includes(b.id)).length;
      return countB - countA;
    });

    /* Build table rows */
    const tbody = this.querySelector("tbody");
    if (!tbody) return;

    const checkLabel = this.dataset.checkLabel || "Included";
    const notIncludedLabel = this.dataset.notIncludedLabel || "–";

    visibleBenefits.forEach(benefit => {
      const tr = document.createElement("tr");
      tr.className = "tier-benefits__benefit-row";

      /* Benefit label */
      const tdLabel = document.createElement("td");
      tdLabel.textContent = benefit.label;
      tr.appendChild(tdLabel);

      /* One cell per configured tier */
      tiers.forEach(() => {
        const td = document.createElement("td");
        td.hidden = false;
        tr.appendChild(td);
      });

      /* Fill in check marks and mark current tier column */
      tiers.forEach((tier, i) => {
        const td = tr.children[i + 1];
        const hasBenefit = tier.benefit_ids && tier.benefit_ids.includes(benefit.id);

        if (i === currentColIndex) {
          td.classList.add("tier-benefits__col--current");
        }

        if (hasBenefit) {
          td.innerHTML = '<span class="tier-benefits__check" aria-label="' + checkLabel + '"><svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M20 6L9 17L4 12" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';
        } else {
          td.innerHTML = '<span class="tier-benefits__dash" aria-label="' + notIncludedLabel + '">–</span>';
        }
      });

      /* Hide unused columns */
      for (let i = tiers.length; i < 3; i++) {
        const extraTd = document.createElement("td");
        extraTd.hidden = true;
        tr.appendChild(extraTd);
      }

      tbody.appendChild(tr);
    });

    /* Progress row: only if current tier is highlighted and upgrade is possible */
    if (currentColIndex >= 0 && customer?.tier_membership?.progress?.spend_needed_for_upgrade) {
      const progress = customer.tier_membership.progress;
      const nextTier = allTiers.find(t => t.id === progress.upgrade_tier_id);
      const template = this.dataset.spendRemainingTemplate || "Noch {{ amount }} bis {{ tier_name }}";
      const text = template
        .replace("{{ amount }}", progress.spend_needed_for_upgrade.formatted)
        .replace("{{ tier_name }}", nextTier?.name || "");

      const progressRow = document.createElement("tr");
      const progressRowMobile = document.createElement("tr");
      progressRow.className = "tier-benefits__progress-row tier-benefits__progress-row--desktop";
      progressRowMobile.className = "tier-benefits__progress-row tier-benefits__progress-row--mobile";

      /* Empty label cell */
      const tdEmpty = document.createElement("td");
      progressRow.appendChild(tdEmpty);
      progressRowMobile.appendChild(tdEmpty.cloneNode());

      /* One cell per tier – only the current tier gets the text */
      tiers.forEach((tier, i) => {
        const td = document.createElement("td");
        if (i === currentColIndex) {
          td.classList.add("tier-benefits__col--current");
          td.innerHTML = '<span class="tier-benefits__progress-text">' + text + '</span>';

          const mobile_td = progressRowMobile.querySelector("td");
          mobile_td.setAttribute("colspan", "4");
          mobile_td.classList.add("tier-benefits__col--mobile-progress-text");
          mobile_td.innerHTML = '<span class="tier-benefits__progress-text">' + text + '</span>';
        }
        progressRow.appendChild(td);
      });

      /* Hidden cells for unused columns */
      for (let i = tiers.length; i < 3; i++) {
        const extraTd = document.createElement("td");
        extraTd.hidden = true;
        progressRow.appendChild(extraTd);
      }

      tbody.insertBefore(progressRow, tbody.firstChild);
      tbody.lastChild.after(progressRowMobile);
    }
  }
};
window.customElements.define("tier-benefits-table", TierBenefitsTable);
/* =========================================
 * Scrolling USP Bar
 * ========================================= */
class ScrollingUspBar extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.scrolling-usp-bar__track');
    if (!this.track || this.track.children.length === 0) return;

    this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.autoScroll = this.hasAttribute('auto-scroll');

    /* Keep the server-rendered items only once, so a re-connect never clones already cloned items */
    if (this._originalHTML === undefined) {
      this._originalHTML = this.track.innerHTML;
    }

    this._onMotionChange = this._onMotionChange || this._applyAnimation.bind(this);
    this.prefersReducedMotion.addEventListener('change', this._onMotionChange);

    this._lastWidth = 0;
    this._onResize();
    this._resizeObserver = new ResizeObserver(() => this._onResize());
    this._resizeObserver.observe(this);
  }

  disconnectedCallback() {
    this._resizeObserver?.disconnect();
    this._resizeObserver = null;
    this.prefersReducedMotion?.removeEventListener('change', this._onMotionChange);
  }

  /**
   * Called initially (as soon as the bar has a measurable width, regardless of font loading or
   * consent-blocked rendering) and whenever the bar width changes, e.g. on resize or rotation.
   */
  _onResize() {
    const width = this.clientWidth;
    if (width <= 0 || width === this._lastWidth) return;

    this._lastWidth = width;
    this._build();
  }

  /**
   * The track contains two identical halves and is moved by exactly one half (-50%) per cycle, so the
   * loop restarts at a pixel-identical position. Each half is made of as many item sets as needed
   * to cover the bar width.
   */
  _build() {
    this.track.innerHTML = this._originalHTML;

    const setWidth = this.track.scrollWidth;
    if (setWidth <= 0) return;

    const setsPerHalf = Math.max(1, Math.ceil(this.clientWidth / setWidth));
    this.track.innerHTML = this._originalHTML.repeat(setsPerHalf * 2);
    this._applyAnimation();
  }

  _applyAnimation() {
    this.track.classList.toggle(
      'scrolling-usp-bar__track--animate',
      this.autoScroll && !this.prefersReducedMotion.matches
    );
  }
}
 
if (!customElements.get('scrolling-usp-bar')) {
  window.customElements.define('scrolling-usp-bar', ScrollingUspBar);
}
class ArticleContentEnhancer extends HTMLElement {
  connectedCallback() {
    /* Index all <template data-pattern="..."> children by their pattern name */
    const templateElements = this.querySelectorAll(':scope > template[data-pattern]');
    if (templateElements.length === 0) return;

    const templates = {};
    templateElements.forEach((tpl) => {
      templates[tpl.dataset.pattern] = tpl;
    });

    /* Collect text nodes that contain [[ ... ]] — do not mutate during walk */
    const textNodes = [];
    const walker = document.createTreeWalker(
      this,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode(node) {
          /* Skip text inside <template> elements */
          if (node.parentElement?.closest('template')) {
            return NodeFilter.FILTER_REJECT;
          }
          if (node.textContent.includes('[[')) {
            return NodeFilter.FILTER_ACCEPT;
          }
          return NodeFilter.FILTER_SKIP;
        }
      }
    );

    let node;
    while ((node = walker.nextNode())) {
      textNodes.push(node);
    }

    textNodes.forEach((textNode) => {
      this._processTextNode(textNode, templates);
    });
  }

  _processTextNode(textNode, templates) {
    const pattern = /\[\[\s*([\w\s]+?)(?::\s*([\s\S]*?))?\s*\]\]/;
    const match = textNode.textContent.match(pattern);
    if (!match) return;

    /* Normalize pattern name: trim, lowercase, spaces → hyphens */
    const patternName = match[1].trim().toLowerCase().replace(/\s+/g, '-');
    const template = templates[patternName];
    if (!template) return;

    const clone = template.content.cloneNode(true);
    if (match[2] !== undefined && clone.firstElementChild) {
      clone.firstElementChild.textContent = match[2].trim();
    }

    const parent = textNode.parentElement;

    /* Replace full parent element if it contains only the pattern text */
    if (parent && parent.textContent.trim() === match[0].trim()) {
      parent.replaceWith(clone);
    } else {
      textNode.replaceWith(clone);
    }
  }
}

if (!customElements.get('article-content-enhancer')) {
  window.customElements.define('article-content-enhancer', ArticleContentEnhancer);
}

class ArticleImageZoom extends HTMLElement {
  connectedCallback() {
    const triggerTemplate = this.querySelector(':scope > template[data-pattern="image-zoom-trigger"]');
    if (!triggerTemplate) return;

    this._modal = this.querySelector('modal-content');
    if (!this._modal) return;

    this._image = this._modal.querySelector('.article-image-zoom__image');
    this._zoomLevel = this._modal.querySelector('.article-image-zoom__zoom-level');
    this._zoomInBtn = this._modal.querySelector('[data-action="zoom-in"]');
    this._zoomOutBtn = this._modal.querySelector('[data-action="zoom-out"]');

    /* State */
    this._currentScale = 1;
    this._panX = 0;
    this._panY = 0;
    this._maxScale = 4;
    this._zoomStep = 0.25;
    this._activeTriggerImg = null;

    /* Find and wrap all article images */
    const contentArea = this.closest('.article__content');
    if (!contentArea) return;

    const images = Array.from(contentArea.querySelectorAll('.rte img')).filter((img) => {
      return !img.closest('.article-product-slider') && !img.closest('.article-image-zoom__trigger');
    });

    images.forEach((img) => {
      const wrapper = document.createElement('div');
      wrapper.className = 'article-image-zoom__trigger';
      const triggerBtn = triggerTemplate.content.cloneNode(true);
      img.parentNode.insertBefore(wrapper, img);
      wrapper.appendChild(img);
      wrapper.appendChild(triggerBtn);
      wrapper.addEventListener('click', () => this._openLightbox(img));
    });

    /* Zoom button events on modal */
    this._modal.addEventListener('click', (e) => {
      const action = e.target.closest('[data-action]')?.dataset.action;
      if (action === 'zoom-in') {
        e.stopPropagation();
        this._changeScale(this._zoomStep);
      } else if (action === 'zoom-out') {
        e.stopPropagation();
        this._changeScale(-this._zoomStep);
      }
    });

    /* Close modal when clicking on the image wrapper (outside the image or controls) */
    const imageWrapper = this._modal.querySelector('.article-image-zoom__image-wrapper');
    if (imageWrapper) {
      imageWrapper.addEventListener('click', (e) => {
        if (!e.target.closest('.article-image-zoom__image') && !e.target.closest('.article-image-zoom__controls')) {
          this._modal.open = false;
        }
      });
    }

    /* Reset state when modal closes */
    this._modal.addEventListener('openable-element:close', () => this._resetState());

    /* Keyboard shortcuts when lightbox is open */
    this._keyHandler = (e) => {
      if (!this._modal.open) return;
      if (e.key === '+' || e.key === '=') this._changeScale(this._zoomStep);
      if (e.key === '-') this._changeScale(-this._zoomStep);
    };
    document.addEventListener('keydown', this._keyHandler);

    this._setupPan();
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this._keyHandler);
  }

  _openLightbox(img) {
    this._activeTriggerImg = img;

    /* Reset state before opening */
    this._currentScale = 1;
    this._panX = 0;
    this._panY = 0;
    this._maxScale = 4;
    this._applyTransform();
    this._updateZoomDisplay();

    /* Set high-res image source from Shopify CDN */
    const desiredWidth = img.naturalWidth ? Math.min(img.naturalWidth * window.devicePixelRatio * 3, 3000) : 3000;
    this._image.src = this._buildHighResSrc(img.src, desiredWidth);
    this._image.alt = img.alt;

    /* Recalculate max scale once high-res image has loaded */
    this._image.onload = () => {
      const containerWidth = this._image.parentElement ? this._image.parentElement.offsetWidth : window.innerWidth * 0.9;
      if (containerWidth > 0 && this._image.naturalWidth > 0) {
        this._maxScale = Math.max(1, this._image.naturalWidth / containerWidth);
      }
      this._updateButtonStates();
    };

    this._modal.open = true;
  }

  _resetState() {
    this._currentScale = 1;
    this._panX = 0;
    this._panY = 0;
    this._applyTransform();
    this._updateZoomDisplay();

    if (this._activeTriggerImg) {
      const wrapper = this._activeTriggerImg.closest('.article-image-zoom__trigger');
      if (wrapper) wrapper.focus();
    }
  }

  _setScale(newScale) {
    const min = 1;
    const max = this._maxScale || 4;
    this._currentScale = Math.min(max, Math.max(min, newScale));
    this._clampPan();
    this._applyTransform();
    this._updateZoomDisplay();
    this._updateButtonStates();
  }

  _changeScale(delta) {
    this._setScale(this._currentScale + delta);
  }

  _applyTransform() {
    this._image.style.transform = `translate(${this._panX}px, ${this._panY}px) scale(${this._currentScale})`;
  }

  _updateZoomDisplay() {
    this._zoomLevel.textContent = `${Math.round(this._currentScale * 100)}%`;
  }

  _updateButtonStates() {
    const max = this._maxScale || 4;
    this._zoomOutBtn.disabled = this._currentScale <= 1;
    this._zoomInBtn.disabled = this._currentScale >= max;
  }

  _clampPan() {
    const maxPanX = (this._image.offsetWidth * (this._currentScale - 1)) / 2;
    const maxPanY = (this._image.offsetHeight * (this._currentScale - 1)) / 2;
    this._panX = Math.min(maxPanX, Math.max(-maxPanX, this._panX));
    this._panY = Math.min(maxPanY, Math.max(-maxPanY, this._panY));
  }

  _setupPan() {
    let startX = 0;
    let startY = 0;
    let startPanX = 0;
    let startPanY = 0;
    let isDragging = false;

    this._image.addEventListener('pointerdown', (e) => {
      if (!this._modal.open) return;
      e.preventDefault();
      this._image.setPointerCapture(e.pointerId);
      startX = e.clientX;
      startY = e.clientY;
      startPanX = this._panX;
      startPanY = this._panY;
      isDragging = true;
      this._image.classList.add('is-grabbing');
    });

    this._image.addEventListener('pointermove', (e) => {
      if (!isDragging) return;
      this._panX = startPanX + (e.clientX - startX);
      this._panY = startPanY + (e.clientY - startY);
      this._clampPan();
      this._applyTransform();
    });

    this._image.addEventListener('pointerup', () => {
      isDragging = false;
      this._image.classList.remove('is-grabbing');
    });

    this._image.addEventListener('pointercancel', () => {
      isDragging = false;
      this._image.classList.remove('is-grabbing');
    });
  }

  _buildHighResSrc(src, desiredWidth) {
    const width = Math.min(Math.round(desiredWidth), 3000);
    if (!src.includes('cdn.shopify.com')) return src;
    return src.replace(/(_\d+x\d*)?(\.(?:jpg|jpeg|png|gif|webp))(\?.*)?$/i, `_${width}x$2$3`);
  }
}

if (!customElements.get('article-image-zoom')) {
  window.customElements.define('article-image-zoom', ArticleImageZoom);
}

class ArticleCardLink extends HTMLElement {
  connectedCallback() {
    this._handleClick = this._onClick.bind(this);
    this.addEventListener('click', this._handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this._handleClick);
  }

  _onClick(event) {
    // Autor-Bereich ausschließen
    if (event.target.closest('.article-item__author-info')) return;

    // Klicks auf Links und Buttons normal behandeln lassen
    if (event.target.closest('a') || event.target.closest('button')) return;

    const url = this.dataset.url;
    if (url) {
      window.location.href = url;
    }
  }
}

if (!customElements.get('article-card-link')) {
  window.customElements.define('article-card-link', ArticleCardLink);
}
